/* WinnersForge — The Shade (live theme 3.0.0) */
var WFA=function(f){var m=window.WF_ASSETS;return (m&&m[f])||f};

window.WF_FLAGS = {"strikes":true,"library":true,"faqOwnership":false,"snapchat":false,"monthlyReport":true,"reels":false,"commentsDMs":true,"footerH2":false,"poolLine":false,"colophon":false}; window.WF_VARIANT = {"id":"a","name":"الظل · THE SHADE"};
/* ==========================================================================
   core.js — window.WF (foundation). SPEC §4 and §5.3; round 2: SPEC-V2 §3 (M0).
   Round 2 removed: client work (WF.work, STORE.work/clients/related, CLEARED), the viewer, the
   'work' touch kind, the work:open event, and every synthesised SFX API. Added: WF.FLAGS, WF.VARIANT,
   WF.inc(), the Seal's tempo, the event/accent gold sweep. See review/foundation-v2-api.md.
   M0-EXT (SPEC-CD §3.1): the variant-only 'art' slot (root #wf, inits last), the 'variant' touch
   kind (one at a time, with a render()), the WF.hooks registry, flags.poolLine.
   Motion is Web Animations + rAF only. GSAP is never required; SplitText,
   when present, only splits RISE targets into lines for the animation.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('wf');
  if (!root) { console.error('[wf] #wf root missing'); return; }
  var doc = document.documentElement;
  var $ = function (sel, scope) { return (scope || root).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var frame = function () { return new Promise(function (r) { requestAnimationFrame(function () { r(); }); }); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var WF = window.WF = {};
  WF.version = '2.0.0';
  WF.root = root;
  WF.booted = false;
  WF.autoSized = false;
  WF.entrancesDone = false;   // true when a late boot found the content already shown (g1-07)

  /* ── tokens (mirror of base.css §2.6) ─────────────────────────────────── */
  var EASE = {
    lift: 'cubic-bezier(.25,.8,.35,1)', drop: 'cubic-bezier(.64,0,.78,0)', strike: 'cubic-bezier(.16,1,.3,1)',
    rise: 'cubic-bezier(.22,.9,.28,1)', sink: 'cubic-bezier(.55,0,1,.45)', glide: 'cubic-bezier(.76,0,.24,1)',
    slide: 'cubic-bezier(.22,1,.36,1)', linear: 'linear',
  };
  var T = WF.T = {
    lift: 350, near: 90, nearTurn: 150, drop: 160, dropTurn: 180, land: 460, impact: 500, hold: 240, ret: 480,
    rise: 620, riseM: 520, riseStagger: 90, sink: 220, liftc: 540, liftStagger: 60,
    drawMark: 720, draw: 120, drawStagger: 50, mirror: 700, drawerIn: 380, drawerOut: 280, scrim: 200,
    grow: 480, shrink: 320, count: 320, press: 80, quick: 120, fade: 160, hover: 200, hoverHold: 180,
    liftTau: 380, nearRise: 4, nearMax: 600, impactPx: 3, impactGap: 90, mobileLift: 0.7,
    liftPx: { hero: 56, services: 40, restrike: 24, quote: 64, drawer: 72, turn: 80 },
    ease: EASE,
  };
  // JS easing functions for rAF tweens (same curves as the CSS tokens)
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    var sx = function (t) { return ((ax * t + bx) * t + cx) * t; };
    var sy = function (t) { return ((ay * t + by) * t + cy) * t; };
    var dx = function (t) { return (3 * ax * t + 2 * bx) * t + cx; };
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var t = x, i, e, d;
      for (i = 0; i < 8; i++) { e = sx(t) - x; if (Math.abs(e) < 1e-6) return sy(t); d = dx(t); if (Math.abs(d) < 1e-6) break; t -= e / d; }
      var lo = 0, hi = 1; t = x;
      for (i = 0; i < 30; i++) { if (sx(t) < x) lo = t; else hi = t; t = (lo + hi) / 2; }
      return sy(t);
    };
  }
  var EZ = {
    lift: bezier(.25, .8, .35, 1), drop: bezier(.64, 0, .78, 0), strike: bezier(.16, 1, .3, 1), rise: bezier(.22, .9, .28, 1),
    sink: bezier(.55, 0, 1, .45), glide: bezier(.76, 0, .24, 1), slide: bezier(.22, 1, .36, 1), linear: function (x) { return x; },
  };
  T.fn = EZ;

  /* ── events ───────────────────────────────────────────────────────────── */
  var handlers = {};
  var readyEmitted = false;
  WF.on = function (evt, fn) {
    (handlers[evt] = handlers[evt] || []).push(fn);
    if (evt === 'ready' && readyEmitted) Promise.resolve().then(function () { if ((handlers.ready || []).indexOf(fn) > -1) safe(fn, undefined, 'ready'); });
    return function () { WF.off(evt, fn); };
  };
  WF.off = function (evt, fn) { var l = handlers[evt]; if (!l) return; var i = l.indexOf(fn); if (i > -1) l.splice(i, 1); };
  WF.once = function (evt, fn) { var off = WF.on(evt, function (d) { off(); fn(d); }); return off; };
  function safe(fn, d, evt) { try { fn(d); } catch (e) { console.error('[wf:event ' + evt + ']', e); } }
  WF.emit = function (evt, detail) { var l = handlers[evt]; if (!l) return; l.slice().forEach(function (fn) { safe(fn, detail, evt); }); };

  /* ── environment ──────────────────────────────────────────────────────── */
  var mqR = matchMedia('(prefers-reduced-motion: reduce)');
  var mqM = matchMedia('(max-width: 767px)');
  WF.reduced = mqR.matches;
  WF.mobile = mqM.matches;
  function onEnv() { WF.reduced = mqR.matches; WF.mobile = mqM.matches; WF.emit('env', { reduced: WF.reduced, mobile: WF.mobile }); }
  (mqR.addEventListener ? mqR.addEventListener('change', onEnv) : mqR.addListener(onEnv));
  (mqM.addEventListener ? mqM.addEventListener('change', onEnv) : mqM.addListener(onEnv));
  // gsap/SplitText load async (build.mjs injects them non-blocking), so these are live reads, never
  // cached at boot. Matter is set by WF.load.
  WF.has = { matter: !!window.Matter };
  Object.defineProperty(WF.has, 'gsap', { enumerable: true, get: function () { return !!window.gsap; } });
  Object.defineProperty(WF.has, 'splitText', { enumerable: true, get: function () { return !!window.SplitText; } });
  // founder switches (src/flags.json merged with the variant's flags by build.mjs). Read-only at runtime.
  WF.FLAGS = Object.freeze(Object.assign({ strikes: true, library: true, faqOwnership: false, snapchat: false,
    monthlyReport: true, reels: false, commentsDMs: true, footerH2: true, poolLine: false }, window.WF_FLAGS || {}));
  WF.VARIANT = Object.freeze(Object.assign({ id: root.getAttribute('data-variant') || 'a', name: '' }, window.WF_VARIANT || {}));

  /* ── storage (the only localStorage access on the page) ───────────────── */
  WF.ls = {
    get: function (k, fb) { try { var v = window.localStorage.getItem(k); return v == null ? fb : JSON.parse(v); } catch (e) { return fb; } },
    set: function (k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode / sandbox */ } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { /* ignore */ } },
  };

  /* ── i18n ─────────────────────────────────────────────────────────────── */
  var DICT = { ar: {}, en: {} };
  try { DICT = JSON.parse(document.getElementById('wf-i18n').textContent); } catch (e) { console.error('[wf] i18n dictionary missing or invalid', e); }
  WF.dict = DICT;
  WF.lang = root.getAttribute('lang') === 'en' ? 'en' : 'ar';
  var missing = {};
  function lookup(key) {
    var d = DICT[WF.lang] || {};
    if (Object.prototype.hasOwnProperty.call(d, key)) return d[key];
    if (!missing[key]) { missing[key] = 1; console.error('[wf] missing i18n key: ' + key); }
    return null;
  }
  WF.t = function (key, vars) {
    var s = lookup(key); if (s == null) return key;
    return vars ? s.replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m; }) : s;
  };
  WF.tHTML = function (key, vars) {  // value is HTML; interpolated vars are escaped
    var s = lookup(key); if (s == null) return esc(key);
    return vars ? s.replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(vars, k) ? esc(vars[k]) : m; }) : s;
  };
  WF.i18n = {
    apply: function (scope) {
      scope = scope || root;
      var other = WF.lang === 'ar' ? 'en' : 'ar';
      var pick = function (sel) { var l = $$(sel, scope); if (scope.matches && scope.matches(sel)) l.unshift(scope); return l; };
      pick('[data-i18n]').forEach(function (el) { var v = WF.t(el.getAttribute('data-i18n')); if (el.textContent !== v) el.textContent = v; });
      pick('[data-i18n-html]').forEach(function (el) { var v = WF.tHTML(el.getAttribute('data-i18n-html')); if (el.innerHTML !== v) el.innerHTML = v; });
      pick('[data-i18n-attr]').forEach(function (el) {
        el.getAttribute('data-i18n-attr').split(';').forEach(function (p) {
          var i = p.indexOf(':'); if (i < 1) return;
          var a = p.slice(0, i).trim(), k = p.slice(i + 1).trim(); if (a && k) el.setAttribute(a, WF.t(k));
        });
      });
      pick('.kicker,[data-lang-other]').forEach(function (el) { el.setAttribute('lang', other); });
    },
  };

  /* ── formatting ───────────────────────────────────────────────────────── */
  var NF = new Intl.NumberFormat('en-US');
  WF.fmt = {
    num: function (n) { return NF.format(n); },
    priceParts: function (id, variant) {
      var p = priceInfo(id, variant); if (!p) return null;
      var sar = WF.t('core.u.sar'), mo = WF.t('core.u.month'), from = WF.t('core.u.from'), quote = WF.t('core.u.quote');
      var n = p.n != null ? NF.format(p.n) : '';
      // was: the anchor (pre-discount) price as a formatted number, or '' — render it struck through via WF.fmt.was
      var was = p.was && WF.FLAGS.strikes ? NF.format(p.was) : '';
      if (p.kind === 'quote') return { kind: 'quote', pre: '', num: '', unit: quote, was: '' };
      if (WF.lang === 'ar') return p.kind === 'monthly' ? { kind: 'monthly', pre: '', num: n, unit: sar + ' / ' + mo, was: was } : { kind: 'from', pre: from, num: n, unit: sar, was: was };
      return p.kind === 'monthly' ? { kind: 'monthly', pre: sar, num: n, unit: '/ ' + mo, was: was } : { kind: 'from', pre: from + ' ' + sar, num: n, unit: '', was: was };
    },
    price: function (id, variant) {
      var p = WF.fmt.priceParts(id, variant); if (!p) return '';
      if (p.kind === 'quote') return esc(p.unit);
      return [p.pre ? esc(p.pre) : '', '<bdi class="num">' + p.num + '</bdi>', p.unit ? esc(p.unit) : ''].filter(Boolean).join(' ');
    },
    // The struck anchor price as HTML ("" when the service has none or is by quote). The visible number is
    // struck in taupe (brand: struck prices only); screen readers hear "before discount: 3,360".
    was: function (id, variant) {
      var p = WF.fmt.priceParts(id, variant); if (!p || !p.was) return '';
      return '<s class="was"><span class="sr-only">' + esc(WF.t('core.u.was')) + ' </span><bdi class="num">' + p.was + '</bdi></s>';
    },
    // Whole-percent saving shown by the anchor (e.g. 25), or 0.
    off: function (id, variant) {
      var p = priceInfo(id, variant); if (!p || !p.was || !p.n || !WF.FLAGS.strikes) return 0;
      return Math.round((1 - p.n / p.was) * 100);
    },
    priceText: function (id, variant) {
      var p = WF.fmt.priceParts(id, variant); if (!p) return '';
      return [p.pre, p.num, p.unit].filter(Boolean).join(' ');
    },
    variant: function (id, variant) {
      if (!variant) return '';
      if (id === 'launch') return WF.t('core.platform.' + variant);
      if (id === 'custom') return WF.t('core.need.' + variant);
      return '';
    },
    date: function (d) {
      d = d || new Date();
      var loc = WF.lang === 'ar' ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-GB';
      try { return new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long', year: 'numeric' }).format(d).replace(/[‎‏؜]/g, ''); }
      catch (e) { return d.toISOString().slice(0, 10); }
    },
  };

  /* ── shared data ──────────────────────────────────────────────────────── */
  WF.STORE = {
    services: [
      { id: 'manage', cadence: 'monthly', price: 2349, was: 3360, exKeys: ['ads', 'subs', 'photo'], covers: ['ops'], glyph: 'monthly' },
      { id: 'launch', cadence: 'oneoff', price: 2099, was: 2999, from: true, glyph: 'launch', exKeys: ['ads', 'subs', 'paid'],
        variants: ['salla', 'zid', 'shopify'], defaultVariant: 'salla', quoteVariants: ['zid', 'shopify'] },
      { id: 'social', cadence: 'monthly', price: 1549, was: 2220, exKeys: ['photo', 'ads', 'ops'], glyph: 'monthly' },
      { id: 'custom', cadence: 'quote', price: null, exKeys: [], glyph: 'custom',
        variants: ['identity', 'migration', 'campaign', 'build'], defaultVariant: null },
    ],
    exOrder: ['ads', 'subs', 'paid', 'photo', 'ops'],
    where: { running: 'manage', zero: 'launch', content: 'social' },
    get: function (id) { for (var i = 0; i < WF.STORE.services.length; i++) if (WF.STORE.services[i].id === id) return WF.STORE.services[i]; return null; },
  };
  var svc = WF.STORE.get;
  function priceInfo(id, variant) {
    var s = svc(id); if (!s) return null;
    if (s.cadence === 'quote') return { kind: 'quote' };
    if (s.cadence === 'oneoff') {
      var v = variant || s.defaultVariant;
      if (s.quoteVariants && s.quoteVariants.indexOf(v) > -1) return { kind: 'quote' };
      return { kind: 'from', n: s.price, was: s.was || null };
    }
    return { kind: 'monthly', n: s.price, was: s.was || null };
  }

  // A service's include keys, in order, without the ones a founder switch dropped (the build sets a
  // dropped line to '' and swaps a rewritten one, e.g. flags.reels:false → the no-reels wording).
  WF.inc = function (id) {
    var out = [], d = DICT.ar || {};
    for (var i = 1; i < 10; i++) {
      var k = 'core.svc.' + id + '.inc.' + i;
      if (!Object.prototype.hasOwnProperty.call(d, k)) break;
      if (String(d[k]).trim()) out.push(k);
    }
    return out;
  };

  /* ── state: where are you? ────────────────────────────────────────────── */
  WF.state = { where: null };
  WF.setWhere = function (id) {
    if (id !== null && !Object.prototype.hasOwnProperty.call(WF.STORE.where, id)) { console.error('[wf] setWhere: unknown id ' + id); return; }
    if (WF.state.where === id) return;
    WF.state.where = id;
    WF.emit('where:change', { where: id });
  };

  /* ── the cart (§4.2) ──────────────────────────────────────────────────── */
  var cartItems = [];
  var dismissed = {};
  function validVariant(id, v) {
    var s = svc(id); if (!s) return false;
    if (v == null) return true;   // no variant: custom (none chosen yet) or a plain service
    return !!(s.variants && s.variants.indexOf(v) > -1);
  }
  function normVariant(id, v) {
    var s = svc(id);
    if (v == null) return s.variants ? (s.defaultVariant || null) : null;
    return v;
  }
  function saveCart() { WF.ls.set('wf.cart.v1', cartItems.map(function (i) { return { id: i.id, variant: i.variant }; })); }
  function emitCart(reason, id, source) { WF.emit('cart:change', { items: WF.cart.items(), reason: reason, id: id, source: source || null }); }
  WF.cart = {
    items: function () { return cartItems.map(function (i) { return { id: i.id, variant: i.variant }; }); },
    has: function (id) { return cartItems.some(function (i) { return i.id === id; }); },
    get: function (id) { for (var i = 0; i < cartItems.length; i++) if (cartItems[i].id === id) return { id: id, variant: cartItems[i].variant }; return null; },
    count: function () { return cartItems.length; },
    add: function (id, o) {
      o = o || {};
      if (!svc(id)) { console.error('[wf] cart.add: unknown service ' + id); return false; }
      var existing = cartItems.filter(function (i) { return i.id === id; })[0];
      if (existing) {
        if (o.variant !== undefined && o.variant !== existing.variant && validVariant(id, o.variant)) return WF.cart.setVariant(id, o.variant, o);
        return false;
      }
      var v = normVariant(id, o.variant);
      if (!validVariant(id, v)) { console.error('[wf] cart.add: invalid variant ' + v + ' for ' + id); return false; }
      cartItems.push({ id: id, variant: v });
      saveCart(); emitCart('add', id, o.source);
      return true;
    },
    remove: function (id, o) {
      var i = cartItems.findIndex(function (x) { return x.id === id; }); if (i < 0) return false;
      cartItems.splice(i, 1); saveCart(); emitCart('remove', id, (o || {}).source);
      return true;
    },
    setVariant: function (id, variant, o) {
      var it = cartItems.filter(function (i) { return i.id === id; })[0];
      if (!it || it.variant === variant || !validVariant(id, variant)) return false;
      it.variant = variant; saveCart(); emitCart('variant', id, (o || {}).source);
      return true;
    },
    totals: function () {
      var monthly = 0, oneOff = null, quote = [];
      cartItems.forEach(function (i) {
        var p = priceInfo(i.id, i.variant);
        if (p.kind === 'monthly') monthly += p.n;
        else if (p.kind === 'from') oneOff = { from: p.n };
        else quote.push({ id: i.id, variant: i.variant });
      });
      return { monthly: monthly, oneOff: oneOff, quote: quote };
    },
    exclusions: function () {
      var keys = {}, covered = {};
      cartItems.forEach(function (i) { var s = svc(i.id); s.exKeys.forEach(function (k) { keys[k] = 1; }); (s.covers || []).forEach(function (k) { covered[k] = 1; }); });
      return WF.STORE.exOrder.filter(function (k) { return keys[k] && !covered[k]; });
    },
    overlaps: function () {
      var out = [];
      if (WF.cart.has('manage') && WF.cart.has('social') && !dismissed.ms) out.push('ms');
      if (WF.cart.has('launch') && WF.cart.has('manage')) out.push('lm');
      return out;
    },
    dismiss: function (key) { dismissed[key] = true; },
  };
  function loadCart() {
    var raw = WF.ls.get('wf.cart.v1', []);
    if (!Array.isArray(raw)) raw = [];
    var seen = {};
    cartItems = raw.filter(function (i) {
      if (!i || !svc(i.id) || seen[i.id]) return false;
      var v = i.variant === undefined ? null : i.variant;
      if (v != null && !validVariant(i.id, v)) return false;
      seen[i.id] = 1; return true;
    }).map(function (i) { return { id: i.id, variant: normVariant(i.id, i.variant == null ? null : i.variant) }; });
  }

  /* ── touch registry (§4.7) ────────────────────────────────────────────── */
  // kinds: booklet · service · variant (SPEC-CD §3.1 item 3: a variant's own visit object — one at a
  // time, the latest replaces the last; render() returns the face markup and is called by the bench on
  // spawn and on every language swap).
  var touches = [], variantSeq = 0;
  WF.touch = {
    add: function (o) {
      o = o || {};
      if (['booklet', 'service', 'variant'].indexOf(o.kind) < 0 || !o.id) { console.error('[wf] touch.add: bad entry', o); return; }
      if (o.kind === 'variant' && typeof o.render !== 'function') { console.error('[wf] touch.add: a variant entry needs render()', o); return; }
      touches = touches.filter(function (t) { return !(t.kind === o.kind && (t.id === o.id || o.kind === 'variant')); });
      var e = { kind: o.kind, id: o.id, source: o.source || 'page' };
      if (o.kind === 'variant') { e.render = o.render; e.seq = ++variantSeq; }
      touches.unshift(e);
      WF.emit('touch:add', Object.assign({}, e));
    },
    list: function () { return touches.map(function (t) { return Object.assign({}, t); }); },
  };

  /* ── WhatsApp (§4.4) ──────────────────────────────────────────────────── */
  function rlm(line) {
    if (WF.lang !== 'ar') return line;
    var m = /[A-Za-zÀ-ɏ֐-ࣿﭐ-﻿]/.exec(line);
    return m && /[A-Za-zÀ-ɏ]/.test(m[0]) ? '‏' + line : line;
  }
  function cap(s, n) { s = String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n) : s; }
  function itemLine(it) {
    var name = WF.t('core.svc.' + it.id + '.name');
    var v = WF.fmt.variant(it.id, it.variant);
    var p = WF.fmt.priceText(it.id, it.variant);
    if (WF.lang === 'en' && /^(From|By) /.test(p)) p = p.charAt(0).toLowerCase() + p.slice(1);
    return '• ' + name + (v ? ' · ' + v : '') + ' — ' + p;
  }
  WF.wa = {
    number: '966507678863',
    display: '+966 50 767 8863',
    href: function (text) { return 'https://wa.me/966507678863?text=' + encodeURIComponent(text || ''); },
    msg: function (kind, data) {
      data = data || {};
      var lines = [];
      if (kind === 'desk') {
        var items = data.items || WF.cart.items();
        var where = data.where !== undefined ? data.where : WF.state.where;
        var link = cap(data.link, 200), need = cap(data.need, 280), name = cap(data.name, 60);
        // g1-11: a person introduces themselves first, so a given name opens the message
        // (core.wa.desk.openNamed) and there is no trailing «الاسم:» line.
        lines.push(name ? WF.t('core.wa.desk.openNamed', { name: name }) : WF.t('core.wa.desk.open'));
        items.forEach(function (it) { lines.push(itemLine(it)); });
        if (where) lines.push(WF.t('core.wa.where', { v: WF.t('core.where.' + where) }));
        if (link) lines.push(WF.t('core.wa.link', { v: link }));
        if (need) lines.push(WF.t('core.wa.need', { v: need }));
        lines.push(WF.t('core.wa.desk.close'));
      } else if (kind === 'start') {
        var sname = data.name || WF.t('core.svc.' + (data.id || 'manage') + '.name');
        var w = data.where !== undefined ? data.where : WF.state.where;
        lines.push(w ? WF.t('core.wa.startWhere', { where: WF.t('core.where.' + w), name: sname }) : WF.t('core.wa.start', { name: sname }));
      } else if (kind === 'ask') {
        lines.push(WF.t('core.wa.ask', { name: data.name || WF.t('core.svc.' + data.id + '.name') }));
      } else if (kind === 'hello' || kind === 'faq') {
        lines.push(WF.t('core.wa.' + kind));
      } else { console.error('[wf] wa.msg: unknown kind ' + kind); return ''; }
      return lines.filter(Boolean).map(rlm).join('\n');
    },
    link: function (kind, data) { return WF.wa.href(WF.wa.msg(kind, data)); },
  };

  /* ── live region ──────────────────────────────────────────────────────── */
  WF.live = function (message) {
    var el = document.getElementById('wf-live'); if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = message; }, 40);
  };

  /* ── observers ────────────────────────────────────────────────────────── */
  var TH = [0, .01, .02, .04, .06, .08, .1, .15, .2, .25, .3, .4, .5, .6, .7, .8, .9, 1];
  WF.io = {
    once: function (el, fn, o) {
      o = o || {};
      var th = o.threshold == null ? 0.2 : o.threshold;
      if (!el) return function () {};
      if (!('IntersectionObserver' in window)) { fn(null); return function () {}; }
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (fired || !e.isIntersecting) return;
          var tall = e.intersectionRect.height >= innerHeight * 0.35;
          if (e.intersectionRatio + 1e-3 >= th || tall) { fired = true; io.disconnect(); fn(e); }
        });
      }, { threshold: TH.filter(function (t) { return t <= th; }).concat(th), rootMargin: o.rootMargin || '0px' });
      io.observe(el);
      return function () { io.disconnect(); };
    },
    watch: function (el, fn, o) {
      if (!el || !('IntersectionObserver' in window)) return function () {};
      o = o || {};
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { fn(e); }); },
        { threshold: o.threshold == null ? TH : o.threshold, rootMargin: o.rootMargin || '0px' });
      io.observe(el);
      return function () { io.disconnect(); };
    },
    inView: function (el, margin) {
      if (!el) return false; margin = margin || 0;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > -margin && r.top < innerHeight + margin && r.right > -margin && r.left < innerWidth + margin;
    },
  };

  /* ── motion primitives (WAAPI; every one honours WF.reduced) ──────────── */
  var sinks = new WeakMap(), lastImpact = new WeakMap(), liveSplits = [];
  function arr(els) {
    if (!els) return [];
    if (els instanceof Element) return [els];
    return Array.prototype.slice.call(els).filter(function (e) { return e instanceof Element; });
  }
  function fin(list) { return Promise.all(list.map(function (a) { return a.finished.catch(function () {}); })).then(function () {}); }
  function markIn(el) { el.classList.add('is-in'); }
  // g1-07: when the 4s failsafe (or a late boot) already showed the content, the entrance must not
  // replay over it. boot() marks every [data-rise|lift|draw] in and remembers it here; rise/lift/draw
  // then skip such an element once (resolved promise, final state kept) unless {force:true}.
  var shownEarly = new WeakSet();
  function entering(els, o) {
    if (o && o.force) return els;
    return els.filter(function (el) {
      if (!shownEarly.has(el)) return true;
      shownEarly.delete(el);
      if (!el.classList.contains('is-in')) return true;
      cancelSink(el);
      return false;
    });
  }
  function dirOf(el) { var d = el && el.closest && el.closest('[dir]'); return d ? d.getAttribute('dir') : 'rtl'; }
  function cancelSink(el) { var a = sinks.get(el); if (a) { a.cancel(); sinks.delete(el); } }
  function splitLines(el) {
    if (!window.SplitText || el.hasAttribute('data-nosplit')) return { targets: [el] };
    var cs = getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight); if (!lh) lh = parseFloat(cs.fontSize) * 1.28;
    if (el.clientHeight < lh * 1.6) return { targets: [el] };
    try {
      var st = new window.SplitText(el, { type: 'lines', linesClass: 'rl-line', mask: 'lines' });
      var lines = (st.lines || []).slice();
      if (lines.length < 2) { st.revert(); return { targets: [el] }; }
      lines.forEach(function (l) { if (l.parentElement && l.parentElement !== el) l.parentElement.classList.add('rl-mask'); });
      var rec = { el: el, st: st, anims: [] };
      liveSplits.push(rec);
      return { targets: lines, rec: rec };
    } catch (e) { return { targets: [el] }; }
  }
  function revertSplit(rec) {
    var i = liveSplits.indexOf(rec); if (i < 0) return;
    liveSplits.splice(i, 1);
    rec.anims.forEach(function (a) { try { a.cancel(); } catch (e) { /* ignore */ } });
    try { rec.st.revert(); } catch (e) { /* ignore */ }
  }
  WF.motion = {
    rise: function (els, o) {
      o = o || {}; els = entering(arr(els), o);
      if (!els.length) return Promise.resolve();
      if (WF.reduced) { els.forEach(function (el) { cancelSink(el); markIn(el); }); return Promise.resolve(); }
      var dur = WF.mobile ? T.riseM : T.rise, delay = o.delay || 0, stagger = o.stagger == null ? T.riseStagger : o.stagger;
      var i = 0, all = [];
      els.forEach(function (el) {
        markIn(el);
        var sp = splitLines(el);
        var mine = sp.targets.map(function (t) {
          return t.animate([{ transform: 'translateY(112%)' }, { transform: 'translateY(0)' }],
            { duration: dur, delay: delay + (i++) * stagger, easing: EASE.rise, fill: 'backwards', composite: 'add' });
        });
        cancelSink(el);
        all = all.concat(mine);
        if (sp.rec) { sp.rec.anims = mine; fin(mine).then(function () { revertSplit(sp.rec); }); }
      });
      return fin(all);
    },
    sink: function (els) {
      els = arr(els).filter(function (el) { return el.classList.contains('is-in'); });
      if (!els.length || WF.reduced) return Promise.resolve();
      return fin(els.map(function (el) {
        var a = el.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(112%)' }], { duration: T.sink, easing: EASE.sink, fill: 'forwards' });
        sinks.set(el, a); return a;
      }));
    },
    lift: function (els, o) {
      o = o || {}; els = entering(arr(els), o);
      if (!els.length) return Promise.resolve();
      if (WF.reduced) { els.forEach(markIn); return Promise.resolve(); }
      var delay = o.delay || 0, stagger = o.stagger == null ? T.liftStagger : o.stagger, list = [];
      els.forEach(function (el, i) {
        markIn(el);
        var timing = { duration: T.liftc, delay: delay + i * stagger, easing: EASE.rise, fill: 'backwards' };
        list.push(el.animate([{ transform: 'translateY(14px)' }, { transform: 'translateY(0)' }], Object.assign({ composite: 'add' }, timing)));
        list.push(el.animate([{ opacity: 0 }, { opacity: 1 }], timing));
      });
      return fin(list);
    },
    draw: function (els, o) {
      o = o || {}; els = entering(arr(els), o);
      if (!els.length) return Promise.resolve();
      if (WF.reduced) { els.forEach(markIn); return Promise.resolve(); }
      var delay = o.delay || 0, stagger = o.stagger == null ? T.drawStagger : o.stagger, list = [];
      els.forEach(function (el, i) {
        markIn(el);
        if (o.mark) {
          list.push(el.animate([{ clipPath: 'polygon(-30% 0,-8% 0,-30% 100%,-52% 100%)' }, { clipPath: 'polygon(-30% 0,168% 0,146% 100%,-52% 100%)' }],
            { duration: T.drawMark, delay: delay + i * stagger, easing: EASE.rise, fill: 'backwards' }));
        } else {
          el.style.transformOrigin = (dirOf(el) === 'rtl' ? 'right' : 'left') + ' center';
          list.push(el.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
            { duration: T.draw, delay: delay + i * stagger, easing: EASE.rise, fill: 'backwards' }));
        }
      });
      return fin(list);
    },
    impact: function (el) {
      if (!el || WF.reduced) return Promise.resolve();
      var now = performance.now(), last = lastImpact.get(el) || -1e9;
      if (now - last < T.impactGap) return Promise.resolve();
      lastImpact.set(el, now);
      var a = el.animate([
        { transform: 'translateY(0)', offset: 0 }, { transform: 'translateY(3px)', offset: 0.08 },
        { transform: 'translateY(0)', offset: 0.26 }, { transform: 'translateY(0)', offset: 1 },
      ], { duration: T.impact, easing: 'linear', composite: 'add' });
      return a.finished.catch(function () {});
    },
    land: function (el) {
      if (!el) return Promise.resolve();
      var t = el.classList.contains('seal') ? (el.querySelector('.seal__body') || el) : el;
      if (WF.reduced) { t.style.opacity = ''; return Promise.resolve(); }
      return t.animate([
        { transform: 'scale(1.16) rotate(-8deg)', opacity: 0 }, { opacity: 1, offset: 0.4 },
        { transform: 'scale(1) rotate(-2deg)', opacity: 1 },
      ], { duration: T.land, easing: EASE.strike }).finished.catch(function () {});
    },
    fade: function (el, to, ms) {
      if (!el) return Promise.resolve();
      var from = getComputedStyle(el).opacity;
      if (WF.reduced || ms === 0) { el.style.opacity = String(to); return Promise.resolve(); }
      var a = el.animate([{ opacity: from }, { opacity: to }], { duration: ms == null ? T.fade : ms, easing: 'linear', fill: 'forwards' });
      return a.finished.then(function () { el.style.opacity = String(to); a.cancel(); }).catch(function () {});
    },
    flip: function (els, mutate, o) {
      els = arr(els); o = o || {};
      if (WF.reduced) { if (mutate) mutate(); return Promise.resolve(); }
      var first = els.map(function (el) { return el.getBoundingClientRect(); });
      if (mutate) mutate();
      var list = [];
      els.forEach(function (el, i) {
        if (!el.isConnected) return;
        var a = first[i], b = el.getBoundingClientRect();
        var dx = a.left - b.left, dy = a.top - b.top;
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;
        list.push(el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'translate(0,0)' }],
          { duration: o.ms || 240, easing: EASE.slide, composite: 'add' }));
      });
      return fin(list);
    },
    reveal: function (section, o) {
      if (!section) return Promise.resolve();
      o = o || {};
      var rises = $$('[data-rise]', section), lifts = $$('[data-lift]', section), draws = $$('[data-draw]', section);
      if (WF.reduced || WF.autoSized) { rises.concat(lifts, draws).forEach(markIn); return Promise.resolve(); }
      return new Promise(function (res) {
        WF.io.once(section, function () {
          var r = rises.filter(function (e) { return !e.classList.contains('is-in'); });
          var l = lifts.filter(function (e) { return !e.classList.contains('is-in'); });
          var d = draws.filter(function (e) { return !e.classList.contains('is-in'); });
          Promise.all([
            WF.motion.rise(r, { delay: o.riseDelay || 0 }),
            WF.motion.lift(l, { delay: o.liftDelay == null ? 200 : o.liftDelay }),
            WF.motion.draw(d, { delay: o.drawDelay == null ? 360 : o.drawDelay }),
          ]).then(res);
        }, { threshold: o.threshold == null ? 0.2 : o.threshold });
      });
    },
    settle: function () { liveSplits.slice().forEach(revertSplit); },  // used before a language swap
  };

  /* ── scroll lock, inert, focus trap ───────────────────────────────────── */
  var lockDepth = 0, savedOverflow = '', savedGutter = '';
  function lockScroll() {
    if (lockDepth++) return;
    var sbw = innerWidth - doc.clientWidth;   // a real, space-taking scrollbar?
    savedOverflow = doc.style.overflow; savedGutter = doc.style.scrollbarGutter;
    if (sbw > 0) doc.style.scrollbarGutter = 'stable';
    doc.style.overflow = 'hidden';
  }
  function unlockScroll() { if (--lockDepth > 0) return; lockDepth = 0; doc.style.overflow = savedOverflow; doc.style.scrollbarGutter = savedGutter; }
  var inertSet = [];
  function setInert(keep) {
    clearInert();
    Array.prototype.forEach.call(root.children, function (c) {
      if (keep.indexOf(c) > -1 || c.id === 'wf-live' || c.tagName === 'SCRIPT' || c.tagName === 'STYLE' || c.inert) return;
      c.inert = true; inertSet.push(c);
    });
  }
  function clearInert() { inertSet.forEach(function (c) { c.inert = false; }); inertSet = []; }
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"]),[contenteditable="true"]';
  function focusables(container) {
    var l = $$(FOCUSABLE, container);
    if (container.matches && container.matches(FOCUSABLE)) l.unshift(container);
    return l.filter(function (el) {
      if (el.closest('[hidden],[inert]')) return false;
      if (!el.getClientRects().length) return false;
      var cs = getComputedStyle(el); return cs.visibility !== 'hidden' && cs.display !== 'none';
    });
  }
  function trapTab(e, containers) {
    if (e.key !== 'Tab') return;
    var f = [];
    containers.forEach(function (c) { f = f.concat(focusables(c)); });
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    var inside = f.indexOf(a) > -1 || containers.some(function (c) { return c === a; });
    if (e.shiftKey) { if (a === first || !inside || containers.indexOf(a) > -1) { e.preventDefault(); last.focus(); } }
    else if (a === last || !inside) { e.preventDefault(); first.focus(); }
  }
  WF.focusables = focusables;

  /* ── overlays (one at a time) ─────────────────────────────────────────── */
  var cur = null;
  var overlaysEl = document.getElementById('wf-overlays');
  var scrim = overlaysEl ? overlaysEl.querySelector('.scrim') : null;
  var scrimAnim = null;
  function scrimShow() {
    if (!scrim) return;
    if (scrimAnim) { scrimAnim.cancel(); scrimAnim = null; }
    scrim.hidden = false;
    if (!WF.reduced) scrimAnim = scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: T.scrim, easing: 'linear' });
  }
  // ms: fade length (default --t-scrim). after: a promise the scrim also waits for before it hides
  // (g1-08: a custom leave keeps the page dimmed until its last frame).
  function scrimHide(ms, after) {
    if (!scrim) return Promise.resolve();
    if (scrimAnim) { scrimAnim.cancel(); scrimAnim = null; }
    if (WF.reduced) { scrim.hidden = true; return Promise.resolve(); }
    var a = scrimAnim = scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: ms || T.scrim, easing: 'linear', fill: 'forwards' });
    return Promise.all([a.finished, after || null]).then(function () { if (scrimAnim === a) { scrim.hidden = true; a.cancel(); scrimAnim = null; } }).catch(function () {});
  }
  // g1-09: in a host-sized frame (WF.autoSized) the viewport is the whole document, so fixed/vh
  // overlays open at the top of a 10,000px+ page. Put them where the visitor is instead.
  var lastTapY = null;   // document y of the visitor's last pointer/focus: the fallback anchor
  document.addEventListener('pointerdown', function (e) { lastTapY = e.clientY + window.scrollY; }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target; if (!t || !t.getBoundingClientRect || t === document.body || t.closest && t.closest('#wf-overlays')) return;
    var b = t.getBoundingClientRect(); if (b.width || b.height) lastTapY = b.top + window.scrollY;
  }, true);
  function placeInFrame(el, opener) {
    if (!WF.autoSized || !el) return;
    var real = opener && opener.getBoundingClientRect && opener !== document.body && opener !== doc && opener !== root &&
      document.contains(opener) && !(opener.closest && opener.closest('#wf-overlays'));
    var ob = real ? opener.getBoundingClientRect() : null;
    var docTop = ob && (ob.width || ob.height) ? ob.top + window.scrollY : (lastTapY != null ? lastTapY : window.scrollY);
    el.style.position = 'absolute';
    el.style.bottom = 'auto';
    el.style.height = '900px';
    el.style.overflow = 'hidden';   // nothing inside (a 100vh sheet) may grow the host-sized document
    var cb = el.offsetParent || root;
    var cbTop = cb.getBoundingClientRect().top + window.scrollY + (cb.clientTop || 0);
    el.style.top = Math.max(0, Math.round(docTop - 24 - cbTop)) + 'px';
  }
  function onOverlayKey(e) {
    if (!cur) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); WF.overlay.close(cur.el); return; }
    trapTab(e, [cur.el]);
  }
  if (scrim) scrim.addEventListener('click', function () { if (cur && cur.scrimClose) WF.overlay.close(cur.el); });
  WF.overlay = {
    top: function () { return cur ? cur.el : null; },
    open: function (el, o) {
      o = o || {};
      if (!el) return Promise.resolve();
      if (cur && cur.el === el) return Promise.resolve();
      var opener = o.opener || document.activeElement;
      var pre = cur ? WF.overlay.close(cur.el, { returnFocus: false, instant: true }) : Promise.resolve();
      if (menuState.open) closeMenu({ instant: true, restoreFocus: false });
      return pre.then(function () {
        cur = { el: el, opener: opener, onClose: o.onClose, scrimClose: o.scrimClose !== false, leave: o.leave, scrimOut: o.scrimOut };
        el.hidden = false;
        placeInFrame(el, opener);
        scrimShow();
        setInert([overlaysEl]);
        lockScroll();
        document.addEventListener('keydown', onOverlayKey, true);
        if (o.onOpen) { try { o.onOpen(el); } catch (e) { console.error('[wf:overlay onOpen]', e); } }
        WF.emit('overlay:open', { id: el.id });
        var target = o.initialFocus || el.querySelector('[data-autofocus]') || (el.hasAttribute('tabindex') ? el : focusables(el)[0]) || el;
        if (target === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
        if (WF.autoSized) { try { el.scrollIntoView({ block: 'nearest' }); } catch (e) { /* ignore */ } }
        if (o.enter && !WF.reduced) return Promise.resolve(o.enter(el)).catch(function () {});
        if (!WF.reduced && !o.enter) return el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: T.scrim, easing: 'linear' }).finished.catch(function () {});
      });
    },
    close: function (el, o) {
      o = o || {};
      if (!cur || (el && cur.el !== el)) return Promise.resolve();
      var c = cur; cur = null;
      document.removeEventListener('keydown', onOverlayKey, true);
      var animLeave = !o.instant && !WF.reduced && c.leave;
      var sh, leave;
      if (animLeave && c.scrimOut > 0) {
        // g1-08: the scrim fades over scrimOut ms on the same frame the leave starts, and hides
        // only when both are done.
        leave = Promise.resolve(c.leave(c.el)).catch(function () {});
        sh = scrimHide(c.scrimOut, leave);
      } else {
        sh = scrimHide();
        leave = animLeave ? Promise.resolve(c.leave(c.el)).catch(function () {}) : Promise.resolve();
      }
      return leave.then(function () {
        if (cur && cur.el === c.el) return;   // re-opened meanwhile
        c.el.hidden = true;
        clearInert();
        unlockScroll();
        if (o.returnFocus !== false && c.opener && document.contains(c.opener) && c.opener.focus) {
          try { c.opener.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
        }
        if (c.onClose) { try { c.onClose(); } catch (e) { console.error('[wf:overlay onClose]', e); } }
        WF.emit('overlay:close', { id: c.el.id });
        return o.instant ? undefined : sh;
      });
    },
  };

  /* ── the cart drawer shell (§3.6a) ────────────────────────────────────── */
  var drawerEl = document.getElementById('cart');
  function drawerFrom() {
    if (WF.mobile) return 'translateY(100%)';
    return WF.lang === 'ar' ? 'translateX(-100%)' : 'translateX(100%)';
  }
  WF.drawer = {
    open: function (step) {
      step = step || 1;
      if (!drawerEl) return Promise.resolve();
      var dateEl = document.getElementById('cart-date');
      if (dateEl) { var now = new Date(); dateEl.textContent = WF.fmt.date(now); dateEl.setAttribute('datetime', now.toISOString().slice(0, 10)); }
      drawerEl.setAttribute('data-step', String(step));
      if (cur && cur.el === drawerEl) { WF.emit('drawer:open', { step: step }); return Promise.resolve(); }
      return WF.overlay.open(drawerEl, {
        onOpen: function () { WF.emit('drawer:open', { step: step }); },
        enter: function (el) { return el.animate([{ transform: drawerFrom() }, { transform: 'none' }], { duration: T.drawerIn, easing: EASE.slide }).finished; },
        leave: function (el) { return el.animate([{ transform: 'none' }, { transform: drawerFrom() }], { duration: T.drawerOut, easing: EASE.slide, fill: 'forwards' }).finished.then(function (a) { return a; }); },
        onClose: function () { drawerEl.getAnimations().forEach(function (a) { a.cancel(); }); WF.emit('drawer:close'); },
      });
    },
    close: function () { return WF.overlay.close(drawerEl); },
    isOpen: function () { return !!(cur && cur.el === drawerEl); },
  };
  if (drawerEl) {
    var dclose = drawerEl.querySelector('.drawer__close');
    if (dclose) dclose.addEventListener('click', function () { WF.drawer.close(); });
  }

  /* ── the Seal (§1.3, §2.6 STRIKE): one implementation of the strike ───── */
  var rigs = new WeakMap(), presses = new WeakMap();
  function rigOf(seal, layer) {
    var r = rigs.get(seal);
    if (!r) {
      r = { el: seal, body: seal.querySelector('.seal__body') || seal, layer: null, rest: null, cur: null, busy: false, queue: null, tween: null, h: 0, hw: 0 };
      rigs.set(seal, r);
    }
    if (layer) r.layer = layer;
    if (!r.layer) r.layer = seal.offsetParent || seal.parentElement;
    if (!r.rest) {
      var w = seal.offsetWidth, h = seal.offsetHeight;
      r.rest = { x: seal.offsetLeft + w / 2, y: seal.offsetTop + h / 2 };
      r.cur = { x: r.rest.x, y: r.rest.y, rot: -2, sc: 1 };
    }
    return r;
  }
  function toLayer(layer, cx, cy) {
    var b = layer.getBoundingClientRect();
    return { x: cx - b.left - layer.clientLeft + layer.scrollLeft, y: cy - b.top - layer.clientTop + layer.scrollTop };
  }
  function resolvePoint(r, target) {
    if (target == null || target === 'rest') return { x: r.rest.x, y: r.rest.y };
    if (typeof target === 'function') target = target();
    if (target instanceof Element) target = { el: target };
    if (target.el) {
      var b = target.el.getBoundingClientRect();
      var ax = target.ax == null ? 0.5 : target.ax, ay = target.ay == null ? 0.5 : target.ay;
      return toLayer(r.layer, b.left + b.width * ax + (target.dx || 0), b.top + b.height * ay + (target.dy || 0));
    }
    return { x: +target.x, y: +target.y };
  }
  function render(r) {
    var dx = r.cur.x - r.rest.x, dy = r.cur.y - r.rest.y;
    r.el.style.transform = (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) ? '' : 'translate3d(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px,0)';
    r.body.style.transform = 'rotate(' + r.cur.rot.toFixed(3) + 'deg) scale(' + r.cur.sc.toFixed(4) + ')';
    // g1-17: --h = how high the Seal is (0 at rest … 1 at a full lift); the ::before shadow reads it
    var h = clamp(r.h || 0, 0, 1.2);
    if (Math.abs(h - (r.hw || 0)) > 0.0005 || (h === 0 && r.hw)) {
      r.hw = h;
      if (h < 0.001) r.el.style.removeProperty('--h'); else r.el.style.setProperty('--h', h.toFixed(3));
    }
  }
  function commit(r, p) {   // the one allowed left/top write: a new resting position, no transition
    var w = r.el.offsetWidth, h = r.el.offsetHeight;
    r.rest = { x: p.x, y: p.y };
    r.cur.x = p.x; r.cur.y = p.y;
    r.el.style.left = (p.x - w / 2).toFixed(2) + 'px';
    r.el.style.top = (p.y - h / 2).toFixed(2) + 'px';
    render(r);
  }
  function rest(r) {
    r.cur.rot = -2; r.cur.sc = 1; r.h = 0; r.hw = 0;
    r.body.style.transform = ''; r.el.style.transform = ''; r.el.style.willChange = '';
    r.el.style.removeProperty('--h');
    r.el.classList.remove('is-lifted');
  }
  function tween(r, ms, step, end) {
    return new Promise(function (resolve) {
      var t0 = null, raf = 0, dead = false;
      var tw = { cancel: function () { if (dead) return; dead = true; cancelAnimationFrame(raf); if (r.tween === tw) r.tween = null; resolve(false); } };
      r.tween = tw;
      var loop = function (ts) {
        if (dead) return;
        if (t0 === null) t0 = ts;
        var p = ms <= 0 ? 1 : Math.min(1, (ts - t0) / ms);
        step(p);
        if (p >= 1) { dead = true; if (r.tween === tw) r.tween = null; if (end) end(); resolve(true); return; }
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    });
  }
  function liftPx(o) { return (o.lift == null ? 40 : o.lift) * (WF.mobile ? T.mobileLift : 1); }
  function beginLift(r, o) {
    r.el.style.willChange = 'transform';
    r.el.classList.add('is-lifted');
    if (o.onLift) { try { o.onLift(); } catch (e) { console.error('[wf:seal onLift]', e); } }
  }
  // g1-03: the travel scales with the distance. d = |target − where the Seal is now|.
  //   lift/travel = clamp(200 + 0.4·d, 260, 650) ms; an in-place re-strike (d < 40): lift 200,
  //   near 60, drop 120. Explicit o.near / o.drop from a caller (the bench turn) still win.
  // SPEC-V2 §3.6 tempo (default 1): multiplies lift/travel, near and hold; the drop takes
  //   min(tempo, 1.6) so it stays a fast, accelerating drop. Landing and IMPACT never change.
  function tempoOf(o) { var k = +(o && o.tempo); return k > 0 ? k : 1; }
  function timing(r, P, o) {
    var d = Math.hypot(P.x - r.cur.x, P.y - r.cur.y), L = liftPx(o), k = tempoOf(o), kd = Math.min(k, 1.6);
    if (d < 40) return { d: d, L: L, k: k, lift: 200 * k, near: 60 * k, drop: 120 * kd };
    return { d: d, L: L, k: k, lift: clamp(200 + 0.4 * d, 260, 650) * k, near: null, drop: null };
  }
  // g1-02: a lift always goes UP first. Two parts, both only ever upward:
  //   travel: from the ground under the Seal up to `top` = the higher of (that ground, the target),
  //           on the lift ease, done within the travel time (so the Seal is never below the target);
  //   lift:   L above that, on the lift ease (auto) or the resisted hold curve 1−e^(−t/380).
  // The horizontal travel runs on --ease-glide (slow start), so the Seal rises, then crosses, and
  // the near-stop sits above the target: apex = min(ground, target) − L.
  function snap(r) { return { x: r.cur.x, y: r.cur.y, rot: r.cur.rot, sc: r.cur.sc, h: r.h || 0 }; }
  function liftGeo(s, P, L) { var g = s.y + (s.h || 0) * L; return { g: g, top: Math.min(g, P.y) }; }
  function liftY(G, s, L, eT, pV) { return lerp(G.g, G.top, eT) - L * lerp(s.h, 1, pV); }
  // auto lift: rises while it travels to above the target
  function liftAuto(r, P, L, ms) {
    var s = snap(r), G = liftGeo(s, P, L);
    return tween(r, ms || T.lift, function (p) {
      var eV = EZ.lift(p), eH = EZ.glide(p);
      r.cur.x = lerp(s.x, P.x, eH); r.cur.y = liftY(G, s, L, eV, eV);
      r.cur.rot = lerp(s.rot, -8, eV); r.cur.sc = lerp(s.sc, 1.06, eV); r.h = lerp(s.h, 1, eV); render(r);
    });
  }
  // hold-driven lift: height = L·(1−e^(−t/380)); the travel (across, and up to a higher target)
  // completes in `ms`
  function liftHold(r, P, L, ms) {
    var s = snap(r), G = liftGeo(s, P, L), t0 = performance.now(), raf = 0;
    ms = ms || T.lift;
    var h = { t: 0, s: s, G: G, ms: ms, stopped: false, stop: function () { h.stopped = true; cancelAnimationFrame(raf); } };
    var loop = function () {
      if (h.stopped) return;
      var t = h.t = performance.now() - t0, k = Math.min(1, t / ms);
      var pH = EZ.glide(k), eT = EZ.lift(k), pV = 1 - Math.exp(-t / T.liftTau);
      r.cur.x = lerp(s.x, P.x, pH); r.cur.y = liftY(G, s, L, eT, pV);
      r.cur.rot = lerp(s.rot, -8, pV); r.cur.sc = lerp(s.sc, 1.06, pV); r.h = lerp(s.h, 1, pV); render(r);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return h;
  }
  // released early: finish the minimum lift (and the travel) from where the hold left it
  function liftFinish(r, h, P, L) {
    var t = h.t, ms = h.ms;
    if (t >= ms) return Promise.resolve();
    var s = h.s, rem = ms - t, pV0 = 1 - Math.exp(-t / T.liftTau);
    return tween(r, rem, function (p) {
      var k = (t + rem * p) / ms, pH = EZ.glide(k), eT = EZ.lift(k), pV = pV0 + (1 - pV0) * EZ.lift(p);
      r.cur.x = lerp(s.x, P.x, pH); r.cur.y = liftY(h.G, s, L, eT, pV);
      r.cur.rot = lerp(s.rot, -8, pV); r.cur.sc = lerp(s.sc, 1.06, pV); r.h = lerp(s.h, 1, pV); render(r);
    });
  }
  // g1-16: the way home travels lifted: a low arc (0.4·L at mid-glide), scale 1→1.03→1, 480ms on
  // --ease-glide, and it simply sets down (commit + rest, no IMPACT). From a lifted start (a
  // cancelled hold) the height blends down from where it was.
  function glideHome(r, R, L, k) {
    var g0 = snap(r), gy = g0.y + g0.h * L;   // the ground under the Seal
    r.el.style.willChange = 'transform';
    r.el.classList.add('is-lifted');
    return tween(r, T.ret * (k || 1), function (p) {
      var e = EZ.glide(p), arc = Math.sin(Math.PI * p), hh = g0.h * (1 - e) + 0.4 * arc * (1 - Math.min(1, g0.h));
      r.cur.x = lerp(g0.x, R.x, e); r.cur.y = lerp(gy, R.y, e) - L * hh;
      r.cur.rot = lerp(g0.rot, -2, e); r.cur.sc = lerp(g0.sc, 1, e) + 0.03 * arc; r.h = hh; render(r);
    }, function () { commit(r, R); rest(r); });
  }
  var dropShort = bezier(.5, 0, .75, 0);   // g1-03: a drop under 40px starts less flat
  // near-stop → drop → contact (same frame) → HOLD → optional glide home
  function strikeTail(r, o, P, hooks, tm) {
    hooks = hooks || {}; tm = tm || {};
    var k = tm.k || tempoOf(o), kd = Math.min(k, 1.6);
    var near = o.near != null ? o.near * k : (tm.near != null ? tm.near : T.near * k);
    var drop = o.drop != null ? o.drop * kd : (tm.drop != null ? tm.drop : T.drop * kd);
    var hold = (o.hold == null ? T.hold : o.hold) * k, L = tm.L || liftPx(o);
    var n0 = snap(r);
    var ready = true, readyP = null;
    if (o.until) {
      try { var u = o.until(); if (u && typeof u.then === 'function') { ready = false; readyP = u.then(function () { ready = true; }, function () { ready = true; }); } else ready = !!u || u === undefined; } catch (e) { ready = true; }
    }
    return tween(r, near, function (p) { var k = EZ.slide(p); r.cur.y = n0.y - T.nearRise * k; r.h = n0.h + (T.nearRise / L) * k; render(r); })
      .then(function () {
        if (ready || !readyP) return;
        return Promise.race([readyP, wait(Math.max(0, T.nearMax - near))]);
      })
      .then(function () {
        var d0 = snap(r), ez = Math.hypot(P.x - d0.x, P.y - d0.y) < 40 ? dropShort : EZ.drop;
        return tween(r, drop, function (p) {
          var e = ez(p);
          r.cur.x = lerp(d0.x, P.x, e); r.cur.y = lerp(d0.y, P.y, e);
          r.cur.rot = lerp(d0.rot, -2, e); r.cur.sc = lerp(d0.sc, 1, e); r.h = lerp(d0.h, 0, e); render(r);
        }, function () {
          // ── CONTACT FRAME ── (the shadow snaps under the Seal: no opacity transition this frame)
          r.el.classList.add('is-struck');
          commit(r, P); rest(r);
          requestAnimationFrame(function () { requestAnimationFrame(function () { r.el.classList.remove('is-struck'); }); });
          if (hooks.contact) hooks.contact();
          if (o.onContact) { try { o.onContact(); } catch (e) { console.error('[wf:seal onContact]', e); } }
          if (o.impactEl) arr(o.impactEl).forEach(function (el) { WF.motion.impact(el); });
        });
      })
      .then(function () { return wait(hold); })
      .then(function () {
        if (o.returnTo == null) return;
        var R = resolvePoint(r, o.returnTo === 'rest' ? hooks.home : o.returnTo);
        if (hooks.returning) hooks.returning();
        return glideHome(r, R, L, k);
      });
  }
  function instantStrike(r, o, P, hooks) {
    hooks = hooks || {};
    commit(r, P); rest(r);
    if (hooks.contact) hooks.contact();
    if (o.onContact) { try { o.onContact(); } catch (e) { console.error('[wf:seal onContact]', e); } }
    if (o.returnTo != null) { commit(r, resolvePoint(r, o.returnTo === 'rest' ? hooks.home : o.returnTo)); rest(r); }
    return frame();
  }
  function freeRig(r) {
    r.busy = false;
    if (r.queue) { var q = r.queue; r.queue = null; runStrike(r, q.o).then(q.resolve); }
  }
  function runStrike(r, o, hooks) {
    if (r.tween) r.tween.cancel();   // a glideFromOffset yields to a strike (g1-18)
    r.busy = true;
    var P = resolvePoint(r, o.target);
    var home = { x: r.rest.x, y: r.rest.y };
    hooks = Object.assign({ home: home }, hooks || {});
    var p;
    if (WF.reduced) p = instantStrike(r, o, P, hooks);
    else {
      var tm = timing(r, P, o);
      beginLift(r, o);
      p = liftAuto(r, P, tm.L, tm.lift).then(function () { return strikeTail(r, o, P, hooks, tm); });
    }
    return p.then(function () { freeRig(r); return { contact: true }; }, function (e) { console.error('[wf:seal]', e); rest(r); freeRig(r); return { contact: false }; });
  }

  WF.seal = {
    make: function (o) {
      o = o || {};
      var face = o.face || 'mark', tag = o.tag || 'div';
      var el = document.createElement(tag);
      el.className = 'seal' + (face === 'mark' ? ' seal--mark' : '') + (o.className ? ' ' + o.className : '');
      if (tag === 'button') el.type = 'button'; else el.setAttribute('aria-hidden', 'true');
      // SPEC-V2 §3.10: a Seal is a gold EVENT (the sweep counts it once); {gold:false} for a cooled/ink one
      if (o.gold !== false) el.setAttribute('data-gold', 'event');
      if (o.label) el.setAttribute('aria-label', o.label);
      var body = document.createElement('span'); body.className = 'seal__body';
      var f = document.createElement('span'); f.className = 'seal__face';
      if (face === 'mark') {
        var img = document.createElement('img');
        img.src = WFA('mark-ink.svg'); img.alt = ''; img.width = 60; img.height = 42; img.draggable = false; img.decoding = 'async';
        f.appendChild(img);
      } else if (o.html != null) f.innerHTML = o.html;
      else f.textContent = o.text || '';
      var size = o.size;
      if (typeof size === 'number') { el.style.setProperty('--seal-w', size + 'px'); el.style.setProperty('--seal-h', size + 'px'); }
      else if (size && typeof size === 'object') {
        if (size.w) el.style.setProperty('--seal-w', size.w + 'px');
        if (size.h) el.style.setProperty('--seal-h', size.h + 'px');
      }
      body.appendChild(f); el.appendChild(body);
      return el;
    },
    face: function (seal, o) {  // replace the face content (text or html), keeps size rules
      var f = seal.querySelector('.seal__face'); if (!f) return;
      if (o && o.html != null) f.innerHTML = o.html; else f.textContent = (o && o.text) || '';
    },
    place: function (seal, target, o) {
      o = o || {};
      var r = rigOf(seal, o.layer);
      if (r.tween) r.tween.cancel();
      var P = resolvePoint(r, target);
      commit(r, P); rest(r);
      return P;
    },
    center: function (seal) { var r = rigs.get(seal); return r ? { x: r.rest.x, y: r.rest.y } : null; },
    busy: function (seal) { var r = rigs.get(seal); return !!(r && r.busy); },
    // g1-18: after a rest change (WF.seal.place on a language swap, a relayout), start the Seal at
    // rest + (dx, dy) and glide it home on the rig's own tween. Any strike or press cancels it
    // (the strike then starts from wherever the glide had got to). Resolves true if it finished.
    glideFromOffset: function (seal, dx, dy, ms, ease) {
      var r = rigs.get(seal);
      if (!r || !r.rest || r.busy || WF.reduced) return Promise.resolve(false);
      dx = +dx || 0; dy = +dy || 0;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return Promise.resolve(false);
      if (r.tween) r.tween.cancel();
      var fn = typeof ease === 'function' ? ease : (EZ[ease] || EZ.glide);
      ms = ms == null ? T.mirror : ms;
      var R = { x: r.rest.x, y: r.rest.y };
      r.cur.x = R.x + dx; r.cur.y = R.y + dy; render(r);
      var g0 = { x: r.cur.x, y: r.cur.y };
      r.el.style.willChange = 'transform';
      return tween(r, ms, function (p) {
        var e = fn(p); r.cur.x = lerp(g0.x, R.x, e); r.cur.y = lerp(g0.y, R.y, e); render(r);
      }, function () { r.cur.x = R.x; r.cur.y = R.y; rest(r); });
    },
    strike: function (seal, o) {
      o = o || {};
      var r = rigOf(seal, o.layer);
      if (r.busy) {
        if (r.queue) r.queue.resolve({ contact: false, skipped: true });
        return new Promise(function (res) { r.queue = { o: o, resolve: res }; });
      }
      return runStrike(r, o);
    },
    press: function (seal, o) {
      o = o || {};
      var r = rigOf(seal, o.layer);
      var triggers = (o.triggers || [seal]).filter(Boolean);
      var ctl = { state: 'idle', contacts: 0, last: Promise.resolve({ contact: false }), queued: false };
      var hold = null, P = null, L = 0, tm = null, keyDown = false, pointer = null, home = null, pend = null;
      var hooks = function () {
        return {
          home: home,
          contact: function () { ctl.contacts++; },
          returning: function () { ctl.state = 'returning'; },
        };
      };
      function done() { ctl.state = 'idle'; freeRig(r); if (ctl.queued) { ctl.queued = false; ctl.strikeAuto(); } }
      function begin() {
        if (ctl.state === 'striking' || ctl.state === 'holding' || ctl.state === 'cancelling') return false;
        if (ctl.state === 'returning' && r.tween) r.tween.cancel();
        else if (r.busy) return false;
        else if (r.tween) r.tween.cancel();   // a glideFromOffset yields to the press (g1-18)
        r.busy = true;
        ctl.state = 'holding';
        home = o.returnTo != null && o.returnTo !== 'rest' ? o.returnTo : { x: r.rest.x, y: r.rest.y };
        P = resolvePoint(r, o.target);
        tm = timing(r, P, o);
        L = tm.L;
        if (WF.reduced) return true;
        beginLift(r, o);
        hold = liftHold(r, P, L, tm.lift);
        return true;
      }
      function release() {
        if (ctl.state !== 'holding') return;
        ctl.state = 'striking';
        var h = hooks();
        var oo = Object.assign({}, o, { returnTo: o.returnTo == null ? null : 'rest' });
        if (WF.reduced) { ctl.last = instantStrike(r, oo, P, h).then(function () { done(); return { contact: true }; }); return; }
        hold.stop();
        ctl.last = liftFinish(r, hold, P, L)
          .then(function () { return strikeTail(r, oo, P, h, tm); })
          .then(function () { done(); return { contact: true }; }, function (e) { console.error('[wf:seal press]', e); rest(r); done(); return { contact: false }; });
      }
      function cancel() {
        if (ctl.state !== 'holding') return;
        ctl.state = 'cancelling';
        if (hold) hold.stop();
        if (WF.reduced) { done(); return; }
        var R = resolvePoint(r, home);
        ctl.last = glideHome(r, R, L).then(function () { done(); return { contact: false, cancelled: true }; });
      }
      ctl.strikeAuto = function () {
        if (ctl.state === 'holding' || ctl.state === 'striking' || ctl.state === 'cancelling') { ctl.queued = true; return ctl.last; }
        if (ctl.state === 'returning' && r.tween) r.tween.cancel();
        else if (r.busy) { ctl.queued = true; return ctl.last; }
        else if (r.tween) r.tween.cancel();   // a glideFromOffset yields (g1-18)
        ctl.state = 'striking';
        home = o.returnTo != null && o.returnTo !== 'rest' ? o.returnTo : { x: r.rest.x, y: r.rest.y };
        var oo = Object.assign({}, o, { returnTo: o.returnTo == null ? null : 'rest' });
        r.busy = true;
        var PP = resolvePoint(r, o.target), h = hooks(), tt = timing(r, PP, o);
        var p = WF.reduced ? instantStrike(r, oo, PP, h)
          : (beginLift(r, oo), liftAuto(r, PP, tt.L, tt.lift).then(function () { return strikeTail(r, oo, PP, h, tt); }));
        ctl.last = p.then(function () { done(); return { contact: true }; }, function (e) { console.error('[wf:seal auto]', e); rest(r); done(); return { contact: false }; });
        return ctl.last;
      };
      ctl.settled = function () { return ctl.last; };
      // ── input wiring ──
      // g1-01: with o.touchHoldDelay (ms), a touch that starts on a trigger other than the Seal waits
      // before it lifts. Moving > 8px or a pointercancel (the page scrolling) before then forgets
      // it; still after the delay → the hold begins; lifted before it without moving → a tap, so the
      // auto strike runs. Mouse, pen, keys and touches on the Seal itself are unchanged.
      var holdDelay = +o.touchHoldDelay || 0;
      function unpend() {
        if (!pend) return;
        clearTimeout(pend.timer);
        window.removeEventListener('pointermove', onPendMove, true);
        pend = null;
      }
      var onPendMove = function (e) {
        if (!pend || e.pointerId !== pend.id) return;
        if (Math.hypot(e.clientX - pend.x, e.clientY - pend.y) > 8) unpend();
      };
      var onDown = function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (pointer !== null || pend) return;
        if (holdDelay > 0 && e.pointerType === 'touch' && e.currentTarget !== seal) {
          var el = e.currentTarget;
          pend = { id: e.pointerId, x: e.clientX, y: e.clientY };
          pend.timer = setTimeout(function () {
            var pp = pend; unpend();
            if (!pp || !begin()) return;
            pointer = pp.id;
            try { el.setPointerCapture(pp.id); } catch (err) { /* the touch already ended */ }
          }, holdDelay);
          window.addEventListener('pointermove', onPendMove, true);
          return;
        }
        if (!begin()) return;
        pointer = e.pointerId;
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* synthetic pointer */ }
      };
      var onUp = function (e) {
        if (pend && e.pointerId === pend.id) { unpend(); ctl.strikeAuto(); return; }   // a tap on the plate still prints
        if (pointer === null || e.pointerId !== pointer) return; pointer = null; release();
      };
      var onCancel = function (e) {
        if (pend && e.pointerId === pend.id) { unpend(); return; }                     // a scroll: nothing lifts
        if (pointer === null || e.pointerId !== pointer) return; pointer = null; cancel();
      };
      var isKey = function (e) { return e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar'; };
      var onKeyDown = function (e) { if (!isKey(e)) return; e.preventDefault(); if (e.repeat || keyDown) return; if (begin()) keyDown = true; };
      var onKeyUp = function (e) { if (!isKey(e)) return; e.preventDefault(); if (!keyDown) return; keyDown = false; release(); };
      var onBlur = function () { if (keyDown) { keyDown = false; cancel(); } };
      var onClick = function (e) { if (e.detail === 0 && !keyDown && pointer === null && !pend) ctl.strikeAuto(); };
      var onMenu = function (e) { e.preventDefault(); };
      triggers.forEach(function (t) {
        t.addEventListener('pointerdown', onDown);
        t.addEventListener('keydown', onKeyDown);
        t.addEventListener('keyup', onKeyUp);
        t.addEventListener('blur', onBlur);
        t.addEventListener('click', onClick);
        t.addEventListener('contextmenu', onMenu);
        presses.set(t, ctl);
      });
      window.addEventListener('pointerup', onUp, true);
      window.addEventListener('pointercancel', onCancel, true);
      ctl.destroy = function () {
        unpend();
        triggers.forEach(function (t) {
          t.removeEventListener('pointerdown', onDown); t.removeEventListener('keydown', onKeyDown); t.removeEventListener('keyup', onKeyUp);
          t.removeEventListener('blur', onBlur); t.removeEventListener('click', onClick); t.removeEventListener('contextmenu', onMenu);
          presses.delete(t);
        });
        window.removeEventListener('pointerup', onUp, true);
        window.removeEventListener('pointercancel', onCancel, true);
      };
      return ctl;
    },
  };

  /* ── lazy loader: Matter.js only ──────────────────────────────────────── */
  var MATTER = 'https://cdnjs.cloudflare.com/ajax/libs/matter-js/0.20.0/matter.min.js';
  var loading = {};
  WF.load = function (name) {
    if (name !== 'matter') return Promise.resolve(false);
    if (window.Matter) { WF.has.matter = true; return Promise.resolve(true); }
    if (window.WF_NO_CDN) { WF.has.matter = false; return Promise.resolve(false); }
    if (loading[name]) return loading[name];
    loading[name] = new Promise(function (res) {
      var s = document.createElement('script'), settled = false, timer;
      var end = function (ok) { if (settled) return; settled = true; clearTimeout(timer); WF.has.matter = !!(ok && window.Matter); res(WF.has.matter); };
      s.src = MATTER; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = function () { end(true); }; s.onerror = function () { end(false); };
      timer = setTimeout(function () { end(false); }, 8000);
      (document.head || root).appendChild(s);
    });
    return loading[name];
  };

  /* ── fitLine: largest font-size ≤ max at which el fits its parent on one line ─ */
  WF.fitLine = function (el, o) {
    if (!el || !el.parentElement) return 0;
    o = o || {};
    var min = o.min || 24, max = o.max || 160, parent = el.parentElement;
    var pcs = getComputedStyle(parent);
    var avail = parent.clientWidth - parseFloat(pcs.paddingLeft) - parseFloat(pcs.paddingRight);
    el.style.whiteSpace = 'nowrap';
    var lo = min, hi = max;
    for (var i = 0; i < 18; i++) {
      var mid = (lo + hi) / 2; el.style.fontSize = mid + 'px';
      if (el.scrollWidth <= avail + 0.5) lo = mid; else hi = mid;
    }
    var size = Math.floor(lo * 10) / 10;
    el.style.fontSize = size + 'px';
    return size;
  };

  /* ── hook registry (M0-EXT, SPEC-CD §3.1 item 4) ──────────────────────────
     WF.hooks.add(name, fn) → off. WF.hooks.run(name, ctx, timeoutMs) → Promise that resolves when every
     hook has resolved, or at the timeout, whichever comes first ({ran, timedOut, ms}). A hook may return
     a value or a promise; a throw / rejection is logged "[wf:hook name]" and counts as resolved.
     With no hook registered, run() resolves at once (callers may test WF.hooks.count(name) and stay
     synchronous). Used: bench.js awaits 'bench:preturn' {line, pieces:{mo, sadfa, najah}, reduced}
     (viewport rects) for ≤ 1400ms just before the turn's Seal lifts. */
  var hookReg = {}, hookLast = {};
  WF.hooks = {
    add: function (name, fn) {
      if (typeof fn !== 'function') { console.error('[wf] hooks.add: not a function', name); return function () {}; }
      (hookReg[name] = hookReg[name] || []).push(fn);
      return function () { var l = hookReg[name] || [], i = l.indexOf(fn); if (i > -1) l.splice(i, 1); };
    },
    count: function (name) { return (hookReg[name] || []).length; },
    run: function (name, ctx, timeoutMs) {
      var list = (hookReg[name] || []).slice(), t0 = performance.now();
      var note = function (r) { r.ms = Math.round(performance.now() - t0); hookLast[name] = r; return r; };
      if (!list.length) return Promise.resolve(note({ ran: 0, timedOut: false }));
      return new Promise(function (resolve) {
        var left = list.length, done = false, timer = 0;
        var fin = function (timedOut) { if (done) return; done = true; clearTimeout(timer); resolve(note({ ran: list.length, timedOut: timedOut })); };
        var one = function () { if (--left <= 0) fin(false); };
        var fail = function (e) { console.error('[wf:hook ' + name + ']', e); one(); };
        if (timeoutMs > 0) timer = setTimeout(function () { fin(true); }, timeoutMs);
        list.forEach(function (fn) {
          var r;
          try { r = fn(ctx); } catch (e) { fail(e); return; }
          Promise.resolve(r).then(one, fail);
        });
      });
    },
    last: function (name) { return hookLast[name] ? Object.assign({}, hookLast[name]) : null; },
  };

  /* ── module registry & isolation (§4.8) ───────────────────────────────── */
  // 'art' (variant-only, SPEC-CD §3.1 item 1) inits last, with root #wf
  var SLOT_ORDER = ['hero', 'ambient', 'feature', 'services', 'start', 'library', 'faq', 'footer', 'bench', 'detail', 'cart', 'cartbar', 'art'];
  var SLOT_ROOT = { cart: 'cart-body', ambient: 'hero-ambient', art: 'wf' };
  var modules = {}, moduleOrder = [];
  function runModule(id) {
    var el = document.getElementById(SLOT_ROOT[id] || id);
    var init = modules[id];
    if (!init || init.ran) return;
    init.ran = true;
    try { init.fn(el); } catch (e) {
      console.error('[wf:' + id + ']', e);
      if (el) el.setAttribute('data-failed', '');
      if (el) $$('[data-rise],[data-lift],[data-draw]', el).forEach(markIn);
    }
  }
  WF.module = function (id, fn) {
    if (modules[id]) { console.error('[wf] module registered twice: ' + id); return; }
    modules[id] = { fn: fn, ran: false };
    moduleOrder.push(id);
    if (WF.booted) runModule(id);
  };

  /* ── the Mirror: AR ⇄ EN (§4.1) ───────────────────────────────────────── */
  var langBusy = null;
  function headerH() { var h = document.getElementById('wf-header'); return h ? h.getBoundingClientRect().bottom : 0; }
  WF.setLang = function (to, o) {
    o = o || {};
    if (to !== 'ar' && to !== 'en') return Promise.resolve();
    if (langBusy) return langBusy.then(function () { return WF.setLang(to, o); });
    if (to === WF.lang) return Promise.resolve();
    var from = WF.lang;
    var animated = o.animate !== false && !WF.reduced && !WF.mobile && WF.booted;
    WF.emit('lang:before', { from: from, to: to });
    var hh = headerH();
    var anchor = $$('.section').filter(function (s) { return s.getBoundingClientRect().bottom > hh + 1; })[0] || null;
    var anchorTop = anchor ? anchor.getBoundingClientRect().top : 0;
    var vh = innerHeight;
    var near = function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > -100 && r.top < vh + 100; };
    var flips = animated ? $$('[data-flip]').filter(function (el) { return !el.closest('#wf-overlays') && near(el); }).slice(0, 40) : [];
    var before = flips.map(function (el) { return el.getBoundingClientRect(); });
    // g1-21: MONOLITH crops glide too (translate only; the mark itself is never mirrored)
    var monos = animated ? $$('.monolith img').filter(function (el) { return !el.closest('#wf-overlays,[hidden]') && near(el); }) : [];
    var monoBefore = monos.map(function (el) { return el.getBoundingClientRect(); });
    var sinkEls = animated ? $$('[data-rise].is-in').filter(function (el) { return !el.closest('#wf-overlays,[hidden]') && WF.io.inView(el); }) : [];
    langBusy = (animated && sinkEls.length ? WF.motion.sink(sinkEls) : Promise.resolve()).then(function () {
      WF.motion.settle();
      // ── swap (one frame) ──
      root.setAttribute('lang', to); root.setAttribute('dir', to === 'en' ? 'ltr' : 'rtl');
      try { doc.setAttribute('lang', to); doc.setAttribute('dir', to === 'en' ? 'ltr' : 'rtl'); } catch (e) { /* host may forbid */ }
      WF.lang = to;
      WF.i18n.apply(root);
      WF.emit('lang', { lang: to });
      WF.ls.set('wf.lang', to);
      // ── restore the anchor ──
      if (anchor) {
        var d = anchor.getBoundingClientRect().top - anchorTop;
        if (Math.abs(d) > 0.5) window.scrollTo({ top: window.scrollY + d, behavior: 'instant' });
      }
      var rises = $$('[data-rise]').filter(function (el) { return !el.closest('#wf-overlays,[hidden]') && WF.io.inView(el); });
      var anims = [];
      if (animated) {
        var deltas = new Map();
        var glide = function (el, dx, dy) {
          anims.push(el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'translate(0,0)' }],
            { duration: T.mirror, easing: EASE.glide, composite: 'add' }).finished.catch(function () {}));
        };
        // measure every new rect before any animation exists (a started FLIP moves its descendants)
        var after = flips.map(function (el) { return el.getBoundingClientRect(); });
        var monoAfter = monos.map(function (el) { return el.getBoundingClientRect(); });
        flips.forEach(function (el, i) {
          var a = before[i], b = after[i];
          var dx = (a.left + a.width / 2) - (b.left + b.width / 2), dy = (a.top + a.height / 2) - (b.top + b.height / 2);
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          deltas.set(el, { dx: dx, dy: dy });
          glide(el, dx, dy);
          // g1-04: the nav would cross the logo and the actions text-over-text in the always-visible
          // bar. It keeps its glide but is gone for the middle of it (out by 35%, back from 65%).
          if (el.classList.contains('hdr__nav')) {
            anims.push(el.animate([{ opacity: 1, offset: 0 }, { opacity: 0, offset: 0.35 }, { opacity: 0, offset: 0.65 }, { opacity: 1, offset: 1 }],
              { duration: T.mirror, easing: 'linear' }).finished.catch(function () {}));
          }
        });
        monos.forEach(function (el, i) {
          var a = monoBefore[i], b = monoAfter[i];
          var dx = (a.left + a.width / 2) - (b.left + b.width / 2), dy = (a.top + a.height / 2) - (b.top + b.height / 2);
          var host = el.parentElement && el.parentElement.closest('[data-flip]'), hd = host && deltas.get(host);
          if (hd) { dx -= hd.dx; dy -= hd.dy; }   // its plate already carries the shared part
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          glide(el, dx, dy);
        });
        anims.push(WF.motion.rise(rises, { delay: 120, force: true }));
        var lifts = $$('[data-lift].is-in').filter(function (el) { return !el.closest('#wf-overlays,[hidden]') && WF.io.inView(el); });
        anims.push(WF.motion.lift(lifts, { delay: 200, force: true }));
      } else if (!WF.reduced && WF.booted) {
        anims.push(WF.motion.rise(rises, { force: true }));
      } else {
        rises.forEach(markIn);
      }
      WF.live(WF.t('core.lang.done'));
      WF.emit('lang:after', { lang: to });
      return Promise.all(anims);
    }).then(function () { langBusy = null; }, function (e) { langBusy = null; console.error('[wf:lang]', e); });
    return langBusy;
  };

  /* ── header (§3.0) ────────────────────────────────────────────────────── */
  var langBtn = document.getElementById('wf-lang');
  var cartBtn = document.getElementById('wf-cart-btn');
  var menuBtn = document.getElementById('wf-menu-btn');
  var menuEl = document.getElementById('wf-menu');
  var headerEl = document.getElementById('wf-header');
  var menuState = { open: false, anim: null };

  function updateCount(reason) {
    if (!cartBtn) return;
    var n = WF.cart.count();
    var numEl = cartBtn.querySelector('.hdr__count .num');
    if (numEl && numEl.textContent !== String(n)) numEl.textContent = String(n);
    cartBtn.setAttribute('data-i18n-attr', 'aria-label:core.cart.aria.' + Math.min(n, 4));
    cartBtn.setAttribute('aria-label', WF.t('core.cart.aria.' + Math.min(n, 4)));
    if (reason === 'add' && WF.booted && !WF.reduced) {
      WF.motion.impact(cartBtn);
      if (numEl) numEl.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: T.count, easing: EASE.rise });
    }
  }
  WF.on('cart:change', function (d) { updateCount(d.reason); });

  if (langBtn) {
    langBtn.addEventListener('click', function () { WF.setLang(WF.lang === 'ar' ? 'en' : 'ar'); });
    WF.on('lang', function () {
      var face = langBtn.querySelector('.hdr__langface');
      if (face && WF.booted && !WF.reduced) face.animate([{ transform: 'translateY(120%)' }, { transform: 'translateY(0)' }], { duration: T.count, delay: 120, easing: EASE.rise, fill: 'backwards' });
    });
  }
  if (cartBtn) cartBtn.addEventListener('click', function () { WF.drawer.open(1); });

  // the CTA «اطلب عرض سعر» (any a[data-cta="start"]) → #start-where + focus its heading (never WhatsApp directly)
  function goStart(e) {
    var target = document.getElementById('start-where');
    if (!target) return;
    e.preventDefault();
    if (menuState.open) closeMenu({ instant: true, restoreFocus: false });
    target.scrollIntoView({ behavior: WF.reduced ? 'auto' : 'smooth', block: 'start' });
    var h = target.querySelector('h2,h3,h4,[data-focus]') || target;
    if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
    try { h.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-cta="start"],a[href="#start-where"]');
    if (a && root.contains(a)) goStart(e);
  });

  // nav: the section in view (instant, no animation)
  function initNav() {
    var links = $$('.hdr__nav a[data-nav]');
    var secs = links.map(function (a) { return document.getElementById(a.getAttribute('data-nav')); }).filter(Boolean);
    if (!secs.length || !('IntersectionObserver' in window)) return;
    var vis = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { vis[e.target.id] = e.isIntersecting; });
      var on = secs.filter(function (s) { return vis[s.id]; })[0];
      links.forEach(function (a) {
        if (on && a.getAttribute('data-nav') === on.id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }, { rootMargin: '-45% 0px -54% 0px', threshold: 0 });
    secs.forEach(function (s) { io.observe(s); });
  }

  // menu sheet (≤1099px)
  // g1-15: while the sheet is open, Tab cycles the header actions that stay live above it
  // (EN, the cart, the menu button) and the sheet itself, in that order, both directions.
  function menuScope() {
    return [langBtn, cartBtn, menuBtn].filter(function (b) { return b && focusables(b).length; }).concat(focusables(menuEl));
  }
  function onMenuKey(e) {
    if (!menuState.open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeMenu(); return; }
    if (e.key !== 'Tab') return;
    var f = menuScope(); if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    e.preventDefault();
    var n = i < 0 ? (e.shiftKey ? f.length - 1 : 0) : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length;
    try { f[n].focus(); } catch (err) { /* ignore */ }
  }
  function setMenuLabel(open) {
    var span = menuBtn && menuBtn.querySelector('span'); if (!span) return;
    span.setAttribute('data-i18n', open ? 'core.menu.close' : 'core.menu');
    span.textContent = WF.t(open ? 'core.menu.close' : 'core.menu');
  }
  function openMenu() {
    if (!menuEl || menuState.open || WF.overlay.top()) return;
    menuState.open = true;
    if (menuState.anim) { menuState.anim.cancel(); menuState.anim = null; }
    menuEl.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    setMenuLabel(true);
    setInert([headerEl, menuEl]);
    lockScroll();
    document.addEventListener('keydown', onMenuKey, true);
    if (!WF.reduced) {
      menuState.anim = menuEl.animate([{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }], { duration: T.drawerIn, easing: EASE.slide });
      var items = $$('.menu__txt', menuEl);
      items.forEach(function (el) { el.classList.remove('is-in'); });
      WF.motion.rise(items, { delay: 120, stagger: T.liftStagger });
      WF.motion.lift($$('.menu__idx,.menu__foot', menuEl), { delay: 260 });
    }
    var first = menuEl.querySelector('.menu__link');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  function closeMenu(o) {
    o = o || {};
    if (!menuEl || !menuState.open) return Promise.resolve();
    menuState.open = false;
    menuBtn.setAttribute('aria-expanded', 'false');
    setMenuLabel(false);
    document.removeEventListener('keydown', onMenuKey, true);
    clearInert();
    unlockScroll();
    if (o.restoreFocus !== false) { try { menuBtn.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    if (menuState.anim) { menuState.anim.cancel(); menuState.anim = null; }
    if (o.instant || WF.reduced) { menuEl.hidden = true; return Promise.resolve(); }
    var a = menuState.anim = menuEl.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], { duration: T.drawerOut, easing: EASE.slide, fill: 'forwards' });
    return a.finished.then(function () { if (!menuState.open) menuEl.hidden = true; a.cancel(); if (menuState.anim === a) menuState.anim = null; }).catch(function () {});
  }
  WF.menu = { open: openMenu, close: closeMenu, isOpen: function () { return menuState.open; } };
  if (menuEl) $$('.menu__idx', menuEl).forEach(function (el, i) { el.textContent = (i < 9 ? '0' : '') + (i + 1); });
  // g1-13: the sheet's WhatsApp number is a real link (the number stays selectable text inside it)
  var menuWa = menuEl ? menuEl.querySelector('a.menu__wa') : null;
  function setMenuWa() { if (menuWa) menuWa.setAttribute('href', WF.wa.link('hello')); }
  setMenuWa();
  WF.on('lang', setMenuWa);
  if (menuBtn && menuEl) {
    menuBtn.addEventListener('click', function () { if (menuState.open) closeMenu(); else openMenu(); });
    menuEl.addEventListener('click', function (e) {
      var a = e.target.closest('a.menu__link');
      if (!a) return;
      var id = (a.getAttribute('href') || '').slice(1);
      var target = id && document.getElementById(id);
      e.preventDefault();
      closeMenu({ instant: true, restoreFocus: false });
      if (!target) return;
      target.scrollIntoView({ behavior: WF.reduced ? 'auto' : 'smooth', block: 'start' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
    });
    matchMedia('(min-width: 1100px)').addEventListener('change', function (m) { if (m.matches && menuState.open) closeMenu({ instant: true }); });
  }

  /* ── verification helpers (acceptance S4–S7) ──────────────────────────── */
  var exposed = {};
  var GOLD = 'rgb(198, 164, 90)', GOLD_DEEP = 'rgb(140, 106, 34)';
  // the painted ground under an element: the first ancestor (itself included) with an opaque background
  function groundOf(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var c = getComputedStyle(n).backgroundColor, m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(c);
      if (m && (m[4] === undefined || +m[4] > 0.5)) return [+m[1], +m[2], +m[3]];
    }
    return [41, 31, 21];   // #wf paints espresso
  }
  function paleGround(el) {
    var g = groundOf(el.parentElement && getComputedStyle(el).backgroundColor === GOLD ? el.parentElement : el);
    var near = function (c) { return Math.abs(g[0] - c[0]) + Math.abs(g[1] - c[1]) + Math.abs(g[2] - c[2]) <= 24; };
    return near([244, 242, 238]) || near([233, 225, 210]);   // bone, sand
  }
  function effOpacity(el) { var o = 1; for (var n = el; n && n.nodeType === 1; n = n.parentElement) { o *= parseFloat(getComputedStyle(n).opacity); if (o <= 0.05) break; } return o; }
  function ownText(el) { for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.textContent.trim()) return true; return false; }
  function clipped(el, r) {
    var x1 = r.left, y1 = r.top, x2 = r.right, y2 = r.bottom;
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.overflow !== 'visible' || cs.clipPath !== 'none' && cs.clipPath) {
        var b = n.getBoundingClientRect();
        x1 = Math.max(x1, b.left); y1 = Math.max(y1, b.top); x2 = Math.min(x2, b.right); y2 = Math.min(y2, b.bottom);
        if (x2 - x1 < 1 || y2 - y1 < 1) return true;
      }
    }
    return false;
  }
  function describe(el) {
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    if (el.classList.length) s += '.' + Array.prototype.slice.call(el.classList, 0, 3).join('.');
    var t = (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 30);
    return t ? s + ' "' + t + '"' : s;
  }
  function accName(el) {
    var n = (el.getAttribute('aria-label') || '').trim();
    if (n) return n;
    var lb = el.getAttribute('aria-labelledby');
    if (lb) { n = lb.split(/\s+/).map(function (id) { var x = document.getElementById(id); return x ? x.textContent : ''; }).join(' ').trim(); if (n) return n; }
    n = (el.textContent || '').trim(); if (n) return n;
    var img = el.querySelector('img[alt]'); if (img && img.alt.trim()) return img.alt.trim();
    return (el.getAttribute('title') || '').trim();
  }
  WF.debug = {
    expose: function (slot, fn) { exposed[slot] = fn; },
    state: function () {
      var s = { lang: WF.lang, cart: WF.cart.items(), touches: WF.touch.list(), where: WF.state.where, reduced: WF.reduced, mobile: WF.mobile, autoSized: WF.autoSized, has: Object.assign({}, WF.has) };
      Object.keys(exposed).forEach(function (k) { try { s[k] = exposed[k](); } catch (e) { s[k] = { error: String(e) }; } });
      return s;
    },
    // SPEC-V2 §3.10 / §5.3: two gold classes, tagged in markup.
    //   events  [data-gold="event"]  a solid gold field (CTA, Seal, stamp)        max 1 per viewport
    //   accents [data-gold="accent"] gold text ≤ 14px or a gold rule ≤ 2px        max 2 per viewport, never on bone/sand
    // Untagged gold paint is still found and counted (bg → event, or accent when ≤ 2.5px thick; text,
    // border and svg fill → accent) and listed in `untagged`. Fails: > 1 event, > 2 accents, an accent
    // whose painted ground is bone or sand, any gold text on bone/sand, gold-deep text < 24px.
    // Anything inside [data-gold-exempt] (the ambient canvases) is skipped here; tools/check-v2.mjs
    // --gold adds the pixel pass.
    gold: function () {
      var vw = innerWidth, vh = innerHeight;
      var events = [], accents = [], untagged = [], fails = [], seen = [];
      var tagged = function (el) { return el.closest('[data-gold]'); };
      var visible = function (el) {
        var cs = getComputedStyle(el);
        if (cs.visibility !== 'visible' || cs.display === 'none') return null;
        var r = el.getBoundingClientRect();
        if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) return null;
        if (effOpacity(el) <= 0.05 || clipped(el, r)) return null;
        return r;
      };
      // tagged roots
      $$('[data-gold]').forEach(function (el) {
        if (el.closest('[inert],[data-gold-exempt]')) return;
        if (el.parentElement && el.parentElement.closest('[data-gold]')) return;   // count the outermost tag once
        var r = visible(el); if (!r) return;
        var kind = el.getAttribute('data-gold') === 'accent' ? 'accent' : 'event';
        (kind === 'event' ? events : accents).push(describe(el));
        seen.push(el);
        if (kind === 'accent' && paleGround(el)) fails.push('accent on bone/sand: ' + describe(el));
      });
      // untagged gold paint + the text rules
      $$('*').forEach(function (el) {
        if (el.tagName === 'VIDEO' || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'CANVAS') return;
        if (el.closest('[inert],[data-gold-exempt]')) return;
        var cs = getComputedStyle(el);
        var txt = ownText(el);
        var bg = cs.backgroundColor === GOLD, tx = cs.color === GOLD && txt, deep = cs.color === GOLD_DEEP && txt;
        var bd = ['Top', 'Right', 'Bottom', 'Left'].some(function (s) { return cs['border' + s + 'Color'] === GOLD && parseFloat(cs['border' + s + 'Width']) > 0 && cs['border' + s + 'Style'] !== 'none'; });
        var fill = el instanceof SVGElement && (cs.fill === GOLD || cs.stroke === GOLD);
        if (!bg && !tx && !deep && !bd && !fill) return;
        var r = visible(el); if (!r) return;
        if ((tx || deep) && paleGround(el)) {
          if (tx) fails.push('gold text on bone/sand: ' + describe(el));
          else if (parseFloat(cs.fontSize) < 24) fails.push('gold-deep text under 24px: ' + describe(el));
        }
        if (deep && !bg && !tx && !bd && !fill) return;   // gold-deep display type is not UI gold
        if (tagged(el)) return;
        if (seen.some(function (h) { return h.contains(el); })) return;
        seen.push(el);
        var thin = Math.min(r.width, r.height) <= 2.5;
        var kind = bg && !thin ? 'event' : 'accent';
        (kind === 'event' ? events : accents).push(describe(el));
        untagged.push(kind + ': ' + describe(el));
        if (kind === 'accent' && paleGround(el)) fails.push('accent on bone/sand: ' + describe(el));
      });
      if (events.length > 1) fails.push(events.length + ' gold events in one viewport');
      if (accents.length > 2) fails.push(accents.length + ' gold accents in one viewport');
      return { count: events.length, events: events, accents: accents, untagged: untagged, fails: fails, els: events };
    },
    // o.step: px between samples (default half a viewport; QA uses 300). Restores the scroll.
    goldSweep: function (o) {
      o = o || {};
      var y0 = window.scrollY, out = [], mE = 0, mA = 0, allFails = [], untag = [];
      var maxY = Math.max(0, doc.scrollHeight - innerHeight), step = Math.max(1, Math.round(o.step || innerHeight / 2));
      var y = 0;
      var next = function () {
        var yy = Math.min(y, maxY);
        window.scrollTo({ top: yy, behavior: 'instant' });
        return frame().then(frame).then(function () { return wait(40); }).then(function () {
          var g = WF.debug.gold();
          mE = Math.max(mE, g.events.length); mA = Math.max(mA, g.accents.length);
          g.untagged.forEach(function (u) { if (untag.indexOf(u) < 0) untag.push(u); });
          if (g.fails.length) {
            out.push({ y: yy, events: g.events, accents: g.accents, fails: g.fails });
            g.fails.forEach(function (f) { if (allFails.indexOf(f) < 0) allFails.push(f); });
          }
          if (yy >= maxY) {
            window.scrollTo({ top: y0, behavior: 'instant' });
            return { ok: !allFails.length, max: mE, maxEvents: mE, maxAccents: mA, fails: allFails, untagged: untag, offending: out };
          }
          y += step; return next();
        });
      };
      return next();
    },
    hold: function (selector, ms) {
      ms = ms == null ? 900 : ms;
      var el = typeof selector === 'string' ? document.querySelector(selector) : selector;
      if (!el) return Promise.resolve({ error: 'not found: ' + selector });
      var ctl = presses.get(el) || (el.closest('.seal') && presses.get(el.closest('.seal')));
      if (!ctl) { var inner = el.querySelector && el.querySelector('.seal'); if (inner && presses.get(inner)) { el = inner; ctl = presses.get(inner); } }
      var r = el.getBoundingClientRect();
      var init = { bubbles: true, cancelable: true, composed: true, pointerId: 91, pointerType: 'mouse', isPrimary: true, button: 0, buttons: 1, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
      el.dispatchEvent(new PointerEvent('pointerdown', init));
      return wait(ms).then(function () {
        el.dispatchEvent(new PointerEvent('pointerup', Object.assign({}, init, { buttons: 0 })));
        return ctl ? ctl.settled() : wait(T.lift + T.near + T.drop + T.hold);
      }).then(function (res) { return { ok: true, result: res || null, contacts: ctl ? ctl.contacts : null, state: ctl ? ctl.state : null }; });
    },
    anims: function () {
      return document.getAnimations().filter(function (a) {
        if (a.playState !== 'running') return false;
        var t = a.effect && a.effect.target;
        return !(t && t.closest && t.closest('video'));
      }).length;
    },
    a11y: function (selector) {
      var scope = selector ? document.querySelector(selector) : root;
      var out = { unnamedButtons: [], imgsWithoutAlt: [], smallTargets: [], badHrefs: [] };
      if (!scope) { out.error = 'not found: ' + selector; return out; }
      var list = function (sel) { var l = $$(sel, scope); if (scope.matches(sel)) l.unshift(scope); return l; };
      var shown = function (el) { if (el.closest('[hidden]')) return false; var rr = el.getClientRects(); return rr.length > 0; };
      list('button,[role="button"],a[href],[role="radio"],[role="checkbox"],summary').forEach(function (el) {
        if (!shown(el)) return;
        if (!accName(el)) out.unnamedButtons.push(describe(el));
      });
      list('img').forEach(function (el) { if (!el.hasAttribute('alt')) out.imgsWithoutAlt.push(el.getAttribute('src') || describe(el)); });
      list('a[href],button,input:not([type="hidden"]),select,textarea,summary,[role="button"],[role="radio"],[tabindex]:not([tabindex="-1"])').forEach(function (el) {
        if (!shown(el) || el.closest('[aria-hidden="true"]') || el.classList.contains('sr-only') || el.classList.contains('skip')) return;
        var cs = getComputedStyle(el);
        if (cs.visibility === 'hidden' || cs.position === 'fixed' && el.closest('[hidden]')) return;
        if (el.tagName === 'A' && cs.display === 'inline') {
          var p = el.parentElement; if (p && (p.textContent || '').trim().length > (el.textContent || '').trim().length + 2) return; // inline link in a sentence
        }
        var b = el.getBoundingClientRect();
        if (b.width < 43.5 || b.height < 43.5) out.smallTargets.push(describe(el) + ' ' + Math.round(b.width) + '×' + Math.round(b.height));
      });
      list('a').forEach(function (el) {
        var h = el.getAttribute('href');
        if (h == null) { if (!el.hasAttribute('name')) out.badHrefs.push(describe(el) + ' (no href)'); return; }
        if (h === '' || h === '#' || /^javascript:/i.test(h)) { out.badHrefs.push(describe(el) + ' ' + h); return; }
        if (h[0] === '#' && !document.getElementById(h.slice(1))) out.badHrefs.push(describe(el) + ' ' + h + ' (missing target)');
        if (/=/.test(h.split('#')[1] || '')) out.badHrefs.push(describe(el) + ' ' + h + ' (#key=value hash)');
        if (el.getAttribute('target') === '_blank' && !/noopener/.test(el.getAttribute('rel') || '')) out.badHrefs.push(describe(el) + ' (target=_blank without noopener)');
      });
      return out;
    },
    untranslated: function () {
      if (WF.lang !== 'en') return [];
      var out = [], nrm = function (s) { return String(s).replace(/\s+/g, ' ').trim(); };
      $$('[data-i18n],[data-i18n-html]').forEach(function (el) {
        var k = el.getAttribute('data-i18n') || el.getAttribute('data-i18n-html');
        if (DICT.ar[k] === DICT.en[k]) return;
        var curv = el.hasAttribute('data-i18n') ? el.textContent : el.innerHTML;
        if (nrm(curv) === nrm(DICT.ar[k])) out.push(k);
      });
      $$('[data-i18n-attr]').forEach(function (el) {
        el.getAttribute('data-i18n-attr').split(';').forEach(function (p) {
          var i = p.indexOf(':'); if (i < 1) return;
          var a = p.slice(0, i).trim(), k = p.slice(i + 1).trim();
          if (DICT.ar[k] !== DICT.en[k] && nrm(el.getAttribute(a) || '') === nrm(DICT.ar[k])) out.push(k + ' @' + a);
        });
      });
      return out;
    },
    arabicLeft: function () {  // extra: visible Arabic text nodes in EN that are not inside a [lang="ar"] element
      if (WF.lang !== 'en') return [];
      var out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      for (var n = w.nextNode(); n; n = w.nextNode()) {
        if (!/[؀-ۿ]/.test(n.textContent)) continue;
        var p = n.parentElement;
        if (!p || p.closest('script,style,[hidden],[lang="ar"],[aria-hidden="true"]')) continue;
        if (!p.getClientRects().length) continue;
        out.push(describe(p));
      }
      return out;
    },
  };

  /* ── boot ─────────────────────────────────────────────────────────────── */
  var FACES = ['700 20px "Noto Kufi Arabic"', '400 16px "Almarai"', '700 16px "Almarai"', '800 16px "Almarai"', '500 16px "Archivo"', '700 16px "Archivo"'];
  var resolveReady;
  WF.ready = new Promise(function (r) { resolveReady = r; });
  // §4.8 auto-sized frame. The host may size the frame to the content only after boot (a race at
  // desktop widths), so it is re-checked on resize; a late detection adds the class and emits
  // 'env' with autoSized:true (an extra field; reduced/mobile unchanged).
  function checkAutoSize() {
    if (WF.autoSized) return;
    if (doc.scrollHeight <= innerHeight + 2 && root.offsetHeight > 2000) {
      WF.autoSized = true; root.classList.add('is-autosized');
      if (WF.booted) WF.emit('env', { reduced: WF.reduced, mobile: WF.mobile, autoSized: true });
    }
  }
  var asRaf = 0;
  window.addEventListener('resize', function () {
    if (WF.autoSized || !WF.booted || asRaf) return;
    asRaf = requestAnimationFrame(function () { asRaf = 0; checkAutoSize(); });
  });
  function boot() {
    try { document.body.style.background = '#291F15'; } catch (e) { /* ignore */ }
    try { doc.setAttribute('lang', WF.lang); doc.setAttribute('dir', WF.lang === 'en' ? 'ltr' : 'rtl'); } catch (e) { /* ignore */ }
    WF.i18n.apply(root);
    loadCart();
    updateCount('load');
    initNav();
    var fonts = document.fonts ? Promise.all([document.fonts.ready].concat(FACES.map(function (f) { return document.fonts.load(f).catch(function () {}); }))) : Promise.resolve();
    Promise.race([fonts, wait(3500)]).then(function () {
      checkAutoSize();
      WF.booted = true;
      root.classList.add('is-booted');
      // g1-07: the bootstrap's 4s failsafe removed .js, so the page is already showing its final
      // state. Keep it: mark every reveal target in (the entrances then skip them), then put .js back.
      if (!root.classList.contains('js')) {
        WF.entrancesDone = true;
        $$('[data-rise],[data-lift],[data-draw]').forEach(function (el) { markIn(el); shownEarly.add(el); });
        root.classList.add('js');
      }
      SLOT_ORDER.forEach(runModule);
      moduleOrder.forEach(runModule);   // test / extra modules after the slots
      readyEmitted = true;
      WF.emit('ready');
      resolveReady();
      WF.emit('cart:change', { items: WF.cart.items(), reason: 'load', id: null, source: 'load' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ── hero ── */
;(function(){
/* ==========================================================================
   hero.js — the static base hero both variants share (SPEC-V2 §3.5). Module "hero" (owner: M4).

   1. Entrance: eyebrow LIFT, H1 RISE, sub + actions LIFT (round-1 motion).
   2. The hand-off to the ambient: the moment the H1 lands, #hero gets data-landed="<ms>" (the
      performance.now() of the landing) and dispatches a DOM event "wf:hero-landed" on itself
      ({detail:{t}}). The ambient starts its sun 200ms after that (HOLD, then light). Reduced motion /
      auto-sized frames land at once. This is a DOM signal on the hero element, not a WF event (the
      WF event list stays closed). An ambient that inits later just reads the attribute:
        var h = document.getElementById('hero');
        if (h.hasAttribute('data-landed')) go(); else h.addEventListener('wf:hero-landed', go, {once:true});
   3. The eyebrow tail: on phones < 400px, if the eyebrow runs past two lines the «· سلة، زد، Shopify»
      tail steps out (.is-short). The span is rebuilt after every language swap (core's i18n writes
      textContent into [data-i18n]).
   4. Gold tags follow the paint (M0-EXT, SPEC-CD §3.1 item 5): the eyebrow keeps data-gold="accent" only
      while its computed colour is gold, the CTA keeps data-gold="event" only while its computed
      background is gold (a variant that dresses them in ink/espresso drops the tags). Re-checked at
      init, on ready and on lang:after. The markup ships both tags (the no-JS page and A/B are gold).
   ========================================================================== */
WF.module('hero', function (root) {
  'use strict';
  var q = function (s) { return root.querySelector(s); };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var markIn = function (el) { if (el) el.classList.add('is-in'); };
  var eyebrow = q('.hero__eyebrow'), h1 = q('.hero__h1'), sub = q('.hero__sub'), actions = q('.hero__actions');
  var landedAt = null;

  /* ── the eyebrow tail ─────────────────────────────────────────────────── */
  var SEP = ' · ';
  function splitEyebrow() {
    if (!eyebrow) return;
    var txt = WF.t('hero.eyebrow');
    var i = txt.lastIndexOf(SEP);
    if (i < 0) { eyebrow.textContent = txt; return; }
    eyebrow.textContent = txt.slice(0, i);
    var tail = document.createElement('span');
    tail.className = 'hero__eb-tail';
    tail.textContent = txt.slice(i);
    eyebrow.appendChild(tail);
  }
  function fitEyebrow() {
    if (!eyebrow) return;
    eyebrow.classList.remove('is-short');
    if (window.innerWidth >= 400) return;
    var lh = parseFloat(getComputedStyle(eyebrow).lineHeight) || 22;
    if (eyebrow.getBoundingClientRect().height > lh * 2.5) eyebrow.classList.add('is-short');
  }
  splitEyebrow();
  fitEyebrow();
  WF.on('lang', function () { splitEyebrow(); fitEyebrow(); });
  var rz = 0;
  window.addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(fitEyebrow); }, { passive: true });

  /* ── gold tags follow the computed paint ──────────────────────────────── */
  var cta = q('.hero__cta');
  function isGold(c) {
    var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(c || '');
    var k = !m && /color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+))?\)/.exec(c || '');   // color-mix() results
    if (k) m = [k[0], k[1] * 255, k[2] * 255, k[3] * 255, k[4]];
    if (!m || (m[4] !== undefined && +m[4] < .5)) return false;
    return Math.abs(m[1] - 198) + Math.abs(m[2] - 164) + Math.abs(m[3] - 90) <= 12;
  }
  function syncGold() {
    if (eyebrow) { if (isGold(getComputedStyle(eyebrow).color)) eyebrow.setAttribute('data-gold', 'accent'); else eyebrow.removeAttribute('data-gold'); }
    if (cta) { if (isGold(getComputedStyle(cta).backgroundColor)) cta.setAttribute('data-gold', 'event'); else cta.removeAttribute('data-gold'); }
  }
  syncGold();
  WF.on('ready', syncGold);
  WF.on('lang:after', syncGold);

  /* ── the landing signal ───────────────────────────────────────────────── */
  function landed() {
    if (landedAt !== null) return;
    landedAt = performance.now();
    root.setAttribute('data-landed', String(Math.round(landedAt)));
    try { root.dispatchEvent(new CustomEvent('wf:hero-landed', { detail: { t: landedAt } })); } catch (e) { /* ignore */ }
  }

  /* ── entrance ─────────────────────────────────────────────────────────── */
  function entrance() {
    fitEyebrow();
    if (WF.reduced || WF.autoSized) { [eyebrow, h1, sub, actions].forEach(markIn); landed(); return; }
    WF.motion.lift(eyebrow, { delay: 0 });
    WF.motion.rise(h1, { delay: 80 }).then(landed, landed);
    WF.motion.lift(sub, { delay: 360 });
    WF.motion.lift(actions, { delay: 440 });
  }
  // SplitText measures lines: wait for the FontFaceSet to settle (bounded)
  function fontsSettled() {
    var fs = document.fonts;
    if (!fs || fs.status !== 'loading') return Promise.resolve();
    return Promise.race([fs.ready, wait(400)]);
  }
  WF.on('ready', function () { fontsSettled().then(entrance); });

  WF.debug.expose('hero', function () {
    return { landed: landedAt !== null, landedAt: landedAt, eyebrowShort: !!(eyebrow && eyebrow.classList.contains('is-short')),
      gold: { eyebrow: eyebrow ? eyebrow.getAttribute('data-gold') : null, cta: cta ? cta.getAttribute('data-gold') : null } };
  });
});

})();
/* ── ambient ── */
;(function(){
/* ambient.js — Concept A «ظل النخلة», the palm shade (SPEC-V2 §1.3). Owner: A-HERO.
   Ported from v2/hero-lab/wild/palm.js (wind model, sun arrival, guards, quality ladder, SwiftShader
   detection, IO + visibilitychange pause, init after fonts + first paint), then refined:

   · A date palm stands just off the page at the inline-end edge, its crown on the hero/desk seam.
     Its fronds sway in a wind that never repeats: a slow breeze (incommensurate noise octaves) plus
     real GUST EVENTS every 8–20 s (random phase on every visit) that push the fronds over, swing them
     back and ring down, travelling across the tree, with a ripple of flutter running out to the leaflet
     tips (round 2: frond angle p95 ≈ 3°).
   · HERO (espresso wall in shade): one WebGL2 canvas covering the hero only, ending on the seam row.
     It outputs ALPHA: colour only inside a soft, curved pool of sun on the inline-end side, and
     transparent everywhere else, so the hero's own espresso and the DOM MONOLITH show through.
     The shader never draws the mark (no "shelf"), and nothing is lifted towards grey: a pixel in
     full shade inside the pool is espresso (plus at most a warm, saturated bounce).
   · The pool's copy-side edge is the shadow edge of an unseen far occluder:
       x_edge(y) = x0 + 0.18·W·(y/H) + bow + 28px·n(y/420 + 0.011·t)
     with a 160px (phone 90px) penumbra, a feathered top and no horizontal edge anywhere.
     JS evaluates the edge on 33 rows per frame and hands them to the shader, so the probes below
     measure exactly what is drawn.
   · Fronds: fewer (6 near / 4 far; phone 5 / 3), date-palm proportions (short stiff leaflets from
     ~17% of the frond, spines below), 12% skipped leaflets and ±35% pitch jitter, fanned so two near
     fronds only meet near the crown. (Geometry is frozen: A-ART's art.js copies it.)
   · DEPTH (round 2): penumbra grows with distance. A near frond is two mask layers: a crisp CORE (the rachis and
     the inner 58% of every leaflet; disc radius ≈ 2–4px) and the WHOLE frond (soft; ≈ 9–12px at the tips); both
     radii grow with the distance from the crown. The far palm is a third, very soft layer (12px at weight .5).
   · THE POOL IS LIGHT (round 2): a creamier core deep inside the pool and a deeper rust towards its edge, a
     static plaster relief (mottle + trowel sweeps + grain, at most ±3% of the lit luminance, only where the sun
     is, never animated), a lift of the light on the last rows so it gathers at the seam. The dither is static.
   · ONE LIGHT ACROSS THE SEAM (round 2): the desk's frond shade is as dark as the wall's right at the seam and
     eases to today's softness by 300px; the pool's light pours over the edge as a warm wash whose edge keeps the
     pool's heading; together the L* jump across the seam inside the pool is ≈ 10 (it was ≈ 43).
   · DESK (sand, in full sun): the same fronds drawn as shade into a 2D overlay canvas inside
     #feature [data-shade-host] (band 560px, phone 420px), at 0.4× (phone 0.35×) plus a CSS blur,
     multiplied over the desk. It fades out downward and towards inline-start, and withdraws to .35
     on desk:clear (the wind calms with it); desk:reset brings it back.
   · One rAF loop while the hero OR the band is in view (hero out → overlay only); cancelled when both
     are out or the tab is hidden. Quality ladder q0…q3 steps down on slow frames; past the last
     rung a still frame. Phone/coarse pointer: q1 at 30 fps. SwiftShader: q3 at 30 fps.
   · No WebGL2 / ?nogl / GL failure / a context lost for 4 s → the poster path (a still rendered from
     the GPU path, background of #hero-ambient.amb-poster) and one static desk frame.
   · prefers-reduced-motion: one composed frame at t = 437.25 with the sun up; no loop.
   · EN mirrors everything about the vertical centre (the palm stands at the right).

   Coordinates: "u" is the distance from the hero's inline-end edge (u = x in RTL, W − x in LTR),
   y is down from the hero's top. The mask, the fronds and the pool all live in u-space; only the
   final canvases are mirrored for EN.
   Debug surface (harmless, kept in the build): window.__ambient. */
WF.module('ambient', function (root) {
  'use strict';
  if (!root) return;
  var hero = document.getElementById('hero');
  if (!hero) return;
  var feature = document.getElementById('feature');
  var host = feature ? feature.querySelector('[data-shade-host]') : null;

  var SEARCH = String(location.search || '');
  var FORCE_POSTER = /[?&]nogl(?:[=&]|$)/.test(SEARCH);
  var POSTER_MODE = /[?&]poster=1(?:&|$)/.test(SEARCH);
  var Q_FORCE = /[?&]q=([0-3])(?:&|$)/.exec(SEARCH);

  var REDUCED_T = 437.25;                    // the composed moment (reduced motion, posters, the static desk)
  // [canvas scale, mask width, blur taps, fps cap]
  var LADDER = [[0.6, 1000, 20, 60], [0.45, 720, 16, 60], [0.34, 560, 12, 30], [0.25, 420, 8, 30]];
  var EDGE_N = 33;                           // rows the pool edge is evaluated on (JS → shader)
  // DEPTH (round 2): shader blur radii in css px: [core at the crown, core at the tips, whole frond at the crown, whole
  // frond at the tips] (desktop, phone), the far palm's radius, and how dark each layer is (core, whole frond)
  var RAD = [[1.6, 4.2, 7.6, 12.5], [1.3, 3.0, 5.6, 9.0]], FAR_R = [12, 9], OCC_W = [0.96, 0.88, 0.50];
  var PLASTER_K = 0.03;                      // the plaster relief: at most ±3% of the lit luminance, static, only where the sun is
  var SEAM_LIFT = 0.20, SEAM_FROM = 0.86;    // the wall's light lifts a little on its last rows, towards the desk
  var PHONE_GAP = 8, PHONE_X0 = 0.60;       // phone: the light starts this far under the CTA row; its edge sits at this share of the width
  // the desk's frond shade (multiply colours): today's soft values are the *_N ends; the *_D ends are the shade right at the
  // seam, as dark as the wall's own fronds read there, easing to *_N over DESK_RAMP px so the silhouettes continue across
  var NEAR_N = [222, 217, 207], FAR_N = [234, 230, 222], NEAR_D = [98, 80, 60], FAR_D = [156, 138, 116], DESK_RAMP = 300;
  var SAND = [233, 225, 210], BONE = [244, 242, 238], INK = [17, 17, 17], ESP = [41, 31, 21];
  var GLYPH = [0.0536, 0.0776, 0.9464, 0.9230];   // the W's path box inside mark-bone.svg's viewBox
  // HERO-3, the spill: the pool's light pours over the seam onto the sand. It is a multiply colour chosen so the sand
  // under the brightest column reads ≈ #B2845C right at the seam (umber light, never a gold field: its channel gap to
  // #C6A45A is 32), fading to nothing by SPILL_DEPTH below it. SPILL_K is the one strength constant: lower it and the
  // light gets quieter.
  var SPILL_TARGET = [178, 132, 92], SPILL_K = 1, SPILL_DEPTH = [200, 140];
  var SPILL_C = SPILL_TARGET.map(function (v, i) { return Math.min(255, Math.round(v / [233, 225, 210][i] * 255)); });
  // HERO-4, the light arrives top-down: the sun on row y is clamp01(arr·(1+d) − d·y/H); d = 0.5 (phone .35).
  // At arr = 1 every row is 1: the steady state is untouched.
  var ARR_D = [0.5, 0.35];

  var mqNarrow = matchMedia('(max-width: 767px)');
  var mqStacked = matchMedia('(max-width: 767px), (max-width: 1099px) and (orientation: portrait)');
  var mqCoarse = matchMedia('(pointer: coarse)');

  /* ── noise: 1D gradient noise; sums of incommensurate octaves never realign ─────────── */
  function h1(n) { var s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); }
  function noise(x) {
    var i = Math.floor(x), f = x - i, u = f * f * (3 - 2 * f);
    var g0 = h1(i) * 2 - 1, g1 = h1(i + 1) * 2 - 1;
    return (g0 * f * (1 - u) + g1 * (f - 1) * u) * 2.2;
  }
  function rnd(seed) { seed = seed % 2147483647; if (seed <= 0) seed += 2147483646; return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function sstep(a, b, x) { var t = clamp01((x - a) / (b - a)); return t * t * (3 - 2 * t); }
  function wind(t) { return 0.62 * noise(t * 0.13) + 0.28 * noise(t * 0.29 + 5.3) + 0.10 * noise(t * 0.61 + 1.9); }
  /* WIND THAT LIVES (round 2). A slow base breeze (incommensurate octaves, never repeats) plus real GUST EVENTS:
     one every 8–20 s (a 14 s grid, each event jittered ±3 s and given its own strength), at absolute wind time t, and
     t starts somewhere random on every visit (tOffset), so the first gust lands at a different moment each time.
     A gust pushes a frond over, swings it back past rest and rings down over ~9 s (a damped swing), arriving at each
     frond a little later the further it is from the crown (the gust travels across the tree); the leaflets flutter
     harder while it passes (gr.e is the envelope). WIND_BASE / WIND_GUST are the two amplitude constants (radians). */
  var GUST_P = 14, GUST_J = 3, WIND_BASE = 0.062, WIND_GUST = 0.090;
  function gustAt(k) { return { T: k * GUST_P + (h1(k * 1.713 + 0.37) * 2 - 1) * GUST_J + 5, A: 0.65 + 0.35 * h1(k * 2.931 + 4.2) }; }
  var GR = { r: 0, e: 0 };
  function gustResp(t, fk) {      // r: the swing (−1…1 scale, signed), e: the envelope 0…1; both summed over the 3 nearest events
    var k0 = Math.floor(t / GUST_P), r = 0, e = 0;
    for (var k = k0 - 1; k <= k0 + 1; k++) {
      var ev = gustAt(k), tau = t - ev.T + 0.4;
      if (tau <= 0) continue;
      r += ev.A * sstep(0, 1.1, tau) * Math.exp(-tau / 3.0) * Math.sin(6.2832 * tau / (3.4 * fk));
      e += ev.A * sstep(0, 0.9, tau) * Math.exp(-Math.max(0, tau - 0.9) / 3.6);
    }
    GR.r = 0.70 * Math.tanh(r / 0.70); GR.e = e > 1 ? 1 : e; return GR;     // two gusts overlapping never add up to a lurch
  }

  /* ── state ─────────────────────────────────────────────────────────────────────── */
  var G = { W: 0, H: 0, band: 0, featOff: 0, rtl: true, narrow: false, stacked: false, coarse: false,
    x0: 0, slant: 0, bow: 0, amp: 0, pen: 0, walk: 0, y0: 0, y1: 0, guards: [], caps: [], guardEls: [], mono: null };
  var palms = [];
  var edges = new Float32Array(EDGE_N);
  var reduced = !!WF.reduced;
  var software = false, renderer = '';
  var q = 0;
  var fixedT = null;                         // a still moment (reduced / poster / frozen)
  var posterOn = false, posterLocked = false, frozen = false;
  var T0 = performance.now();
  var tOffset = 400 + (Date.now() / 1000) % 900;   // every visit starts somewhere else in the wind
  var sunStart = null;                       // set 200ms after the H1 lands
  var calm = { from: 0, to: 0, t0: 0, ms: 0 }, dim = { from: 1, to: 1, t0: 0, ms: 0 };
  var st = { frames: 0, glFrames: 0, ovFrames: 0, work: 0, workN: 0, dts: [], lost: 0, restored: 0, steps: [] };

  /* ── canvases ──────────────────────────────────────────────────────────────────── */
  var cv = null, gl = null, glOK = false, P = null;
  // 'gl' (hardware WebGL2) or '2d' (software GL: SwiftShader & co. A WebGL canvas displayed on a software
  // compositor is read back every frame and Chrome logs "GPU stall due to ReadPixels"; the q3 tier
  // therefore draws the same pool with Canvas2D and never shows a WebGL canvas.)
  var mode = 'gl', pctx = null, nearC = null, nearX = null, coreC = null, coreX = null, farC = null, farX = null, poolImg = null, poolAge = 1e9, poolRows = null;
  function heroReady() { return mode === 'gl' ? glOK : !!pctx; }
  var mask = document.createElement('canvas');
  var mctx = null, ms = 1;                   // mask px per css px
  var maskH = 0;                             // css px covered by the mask (hero + a margin for the blur)
  var ov = null, octx = null, os = 0.4, OVPAD = 8, ovGrad = null, ovGradK = -1;
  var ovFronds = true;                                  // debug: false draws the desk overlay without fronds (spill alone)
  var ovFronds = true;                                  // debug: false draws the desk overlay without fronds (the spill alone)
  var spC = null, spX = null, spVG = null, spVK = '', spPK = '';   // the spill layer (HERO-3), same size as the overlay

  /* ── measure: hero, band, guards, MONOLITH, pool ───────────────────────────────── */
  function textColours(block) {
    // every text colour inside a guarded block that sits on the wall (skip text on its own field: the gold CTA)
    var out = [];
    var walk = document.createTreeWalker(block, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walk.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      var el = n.parentElement; if (!el) continue;
      var onField = false;
      for (var p = el; p && p !== block.parentElement; p = p.parentElement) {
        var bg = getComputedStyle(p).backgroundColor;
        var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(bg);
        if (m && (m[4] === undefined || +m[4] > 0.05)) { onField = true; break; }
      }
      if (onField) continue;
      var c = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(getComputedStyle(el).color);
      if (c) out.push([+c[1], +c[2], +c[3], c[4] === undefined ? 1 : +c[4]]);
    }
    return out;
  }
  function lin(v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
  function srgb8(c) { c = Math.max(0, c); return 255 * (c <= 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 1 / 2.4) - 0.055); }
  function lum(c) { return 0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]); }
  function over(fg, bg) { var a = fg[3] == null ? 1 : fg[3]; return [fg[0] * a + bg[0] * (1 - a), fg[1] * a + bg[1] * (1 - a), fg[2] * a + bg[2] * (1 - a)]; }
  function contrast(a, b) { var la = lum(a), lb = lum(b); return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05); }
  var E_LIN = [lin(41), lin(31), lin(21)], SUNC = [1, 0.76, 0.44];
  function litColour(k) { return [srgb8(E_LIN[0] * (1 + SUNC[0] * k)), srgb8(E_LIN[1] * (1 + SUNC[1] * k)), srgb8(E_LIN[2] * (1 + SUNC[2] * k))]; }
  function capFor(cols) {
    // the brightest wall luminance (linear Y) under which every colour keeps ≥ 4.8:1 (margin over 4.5)
    if (!cols.length) return 1;
    var lo = 0, hi = 40;
    for (var i = 0; i < 28; i++) {
      var k = (lo + hi) / 2, bg = litColour(k), ok = true;
      for (var j = 0; j < cols.length; j++) if (contrast(over(cols[j], bg), bg) < 4.8) { ok = false; break; }
      if (ok) lo = k; else hi = k;
    }
    return lum(litColour(lo));
  }
  function measureGuards() {
    var hr = hero.getBoundingClientRect();
    G.guards = []; G.caps = []; G.guardEls = [];
    var els = hero.querySelectorAll('[data-guard]');
    for (var i = 0; i < els.length && G.guards.length < 6; i++) {
      var r = els[i].getBoundingClientRect(); if (!r.width || !r.height) continue;
      var x0 = r.left - hr.left, x1 = r.right - hr.left;
      var u0 = G.rtl ? x0 : G.W - x1, u1 = G.rtl ? x1 : G.W - x0;
      G.guards.push([u0 - 14, r.top - hr.top - 10, u1 + 14, r.bottom - hr.top + 12]);
      G.caps.push(capFor(textColours(els[i])));
      G.guardEls.push(els[i]);
    }
  }
  function monoBox() {
    var img = hero.querySelector('.hero__mono');
    if (!img) return null;
    var r = img.getBoundingClientRect(), hr = hero.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    var gx0 = Math.max(r.left + r.width * GLYPH[0], hr.left), gx1 = Math.min(r.left + r.width * GLYPH[2], hr.right);
    var gy0 = Math.max(r.top + r.height * GLYPH[1], hr.top), gy1 = Math.min(r.top + r.height * GLYPH[3], hr.bottom);
    if (gx1 <= gx0 || gy1 <= gy0) return null;
    var x0 = gx0 - hr.left, x1 = gx1 - hr.left;
    return { u0: G.rtl ? x0 : G.W - x1, u1: G.rtl ? x1 : G.W - x0, y0: gy0 - hr.top, y1: gy1 - hr.top };
  }
  function edgeShape(s) { return G.slant * s + G.bow * Math.sin(Math.PI * Math.pow(s, 1.4)); }
  function measurePool() {
    var W = G.W, H = G.H;
    G.pen = (G.narrow ? 90 : 160) / 0.608 / 2;     // half-span of a smoothstep whose 10→90% width is the penumbra
    G.amp = G.narrow ? 16 : 28;
    G.bow = G.narrow ? 40 : 96;           // strong enough that the noise can never straighten the edge (RMS ≥ 10px at every moment)
    G.slant = 0.18 * W;
    G.walk = 0.02 * W;
    G.mono = monoBox();
    var shapeMax = 0; for (var i = 0; i <= 40; i++) shapeMax = Math.max(shapeMax, edgeShape(i / 40));
    if (G.stacked) {
      // phones / portrait tablets: the light lives below the H1, and below the MONOLITH's glyph
      var h1 = hero.querySelector('.hero__h1, h1'), hr = hero.getBoundingClientRect();
      var yb = h1 ? h1.getBoundingClientRect().bottom - hr.top : 0.45 * H;
      G.y0 = Math.min(0.7 * H, yb + 0.02 * H);
      G.x0 = 0.40 * W;
      // QA-A: on a phone the pool's top used to depend on when the MONOLITH image box (and the lifting text boxes) were
      // first measured, and landed at one of three heights (about 330 / 410 / 500) from load to load. The approved look is
      // the pool just under the CTA row, so phones pin it
      // there from layout offsets only (never from a transformed box). The MONOLITH sits far above; they never meet.
      if (G.narrow) {
        // the CTA row's bottom from layout offsets (immune to the lift transform); the pool starts 45px under it in both languages (500 on a 390 phone in Arabic)
        var act = hero.querySelector('.hero__actions'), ab = 0, an = act;
        while (an && an !== hero) { ab += an.offsetTop; an = an.offsetParent; }
        G.y0 = act && an === hero ? Math.min(0.8 * H, Math.max(0.3 * H, ab + act.offsetHeight + PHONE_GAP)) : 0.7 * H;
      } else if (G.mono && G.mono.u0 < G.x0 + shapeMax + G.amp + G.walk + G.pen + 8) G.y0 = Math.max(G.y0, G.mono.y1 + 8);
      G.y1 = Math.min(H - 8, G.y0 + (G.narrow ? 0.11 : 0.24) * H);
      if (G.narrow) G.x0 = PHONE_X0 * W;
    } else {
      G.y0 = 0.08 * H; G.y1 = 0.42 * H;
      var x0 = 0.26 * W;
      if (G.mono && G.mono.y1 > G.y0 && G.mono.y0 < H) x0 = Math.min(x0, G.mono.u0 - shapeMax - G.amp - G.walk - G.pen - 12);
      G.x0 = Math.max(0.12 * W, x0);
    }
  }
  function measure() {
    var hr = hero.getBoundingClientRect();
    G.W = Math.max(2, Math.round(hr.width)); G.H = Math.max(2, Math.round(hr.height));
    G.rtl = WF.lang !== 'en';
    G.narrow = mqNarrow.matches; G.stacked = mqStacked.matches; G.coarse = mqCoarse.matches;
    G.band = parseFloat(getComputedStyle(WF.root).getPropertyValue('--amb-band')) || (G.narrow ? 420 : 560);
    G.featOff = feature ? Math.round(feature.getBoundingClientRect().top - hr.top) : G.H;
    measureGuards();
    measurePool();
    buildPalms();
    sizeTargets();
  }

  /* ── the palm (u-space) ────────────────────────────────────────────────────────── */
  function buildPalms() {
    var R = rnd(20260924), W = G.W, H = G.H, n = G.narrow;
    palms = [];
    // near palm: crown just past the inline-end edge, on the seam; fronds reach up into the pool and
    // down across the desk. Fanned evenly so neighbours only meet near the crown.
    var nearN = n ? 5 : 6, farN = n ? 3 : 4;
    var crownA = n ? { x: -0.12 * W, y: H * 0.80 } : { x: -0.15 * W, y: H * 0.97 };
    var scale = n ? Math.max(W * 1.40, 420) : Math.min(W, 1600) * 0.7;
    var a0 = -1.30, a1 = 0.90, fr = [];
    for (var i = 0; i < nearN; i++) {
      var a = a0 + (i / (nearN - 1)) * (a1 - a0) + (R() - 0.5) * 0.06;
      fr.push({ ang: a, len: scale * (0.80 + R() * 0.22) * (1 - Math.abs(a - 0.1) * 0.10), arch: 0.05 + R() * 0.04,
        droop: 0.12 + R() * 0.07, seed: R() * 100, lean: (R() - 0.5) * 0.04, nL: n ? 40 : 56, width: 1, far: false });
    }
    G.lref = scale * 0.9;
    palms.push({ crown: crownA, fronds: fr, far: false });
    // far palm: taller, further out; crown above the inline-end top of the hero, fronds hang through the pool
    var crownB = n ? { x: 0.18 * W, y: -0.10 * H } : { x: 0.07 * W, y: -0.30 * H };
    var frB = [];
    for (var j = 0; j < farN; j++) {
      var b = 0.55 + (j / (farN - 1)) * 1.5 + (R() - 0.5) * 0.2;
      frB.push({ ang: b, len: scale * (0.62 + R() * 0.25), arch: 0.04 + R() * 0.04, droop: 0.16 + R() * 0.08,
        seed: R() * 100 + 50, lean: (R() - 0.5) * 0.08, nL: n ? 30 : 40, width: 1.25, far: true });
    }
    palms.push({ crown: crownB, fronds: frB, far: true });
    palms.forEach(function (p) { p.fronds.forEach(function (f) { f.iseed = Math.floor(f.seed * 1000) + 7; }); });
  }

  // one frond's geometry (css px, u-space) → PATH (rachis polygon + leaflet quads) and its bbox
  var PATH = new Float32Array(8 * 260), RL = new Float32Array(2 * 32), RR = new Float32Array(2 * 32);
  var geo = { n: 0, rn: 0, bb: [0, 0, 0, 0] };
  function bz(a, b, c, t) { var u = 1 - t; return u * u * a + 2 * u * t * b + t * t * c; }
  function bzd(a, b, c, t) { var u = 1 - t; return 2 * u * (b - a) + 2 * t * (c - b); }
  function frondGeom(crown, f, t, amp, calmV) {
    var dist = (crown.x + Math.cos(f.ang) * f.len * 0.5) / Math.max(G.W, 1);
    var tlag = t - dist * 2.4;                                // the wind reaches this frond a little later than the crown
    var gr = gustResp(tlag, 0.9 + 0.2 * h1(f.seed * 3.7));    // each frond rings at its own pace
    var g = 0.28 + 0.72 * gr.e; g = g + (0.12 - g) * calmV;   // how hard the leaflets work right now (desk:clear calms the tree)
    var sway = (WIND_BASE * (wind(tlag) * 0.9 + noise(t * 0.17 + f.seed) * 0.45) * (0.4 + 0.6 * g) + WIND_GUST * gr.r * (1 - 0.85 * calmV)) * amp;
    var bob = (noise(t * 0.11 + f.seed * 1.3) * 0.03 * g + 0.010 * gr.r * (1 - 0.85 * calmV)) * amp;
    var a = f.ang + f.lean + sway, L = f.len;
    var dx = Math.cos(a), dy = Math.sin(a), px = -dy, py = dx;
    var p0x = crown.x, p0y = crown.y;
    var p1x = crown.x + dx * L * 0.52, p1y = crown.y + dy * L * 0.52 - L * f.arch;
    var tip = sway * L * 0.35;
    var p2x = crown.x + dx * L + px * tip, p2y = crown.y + dy * L + py * tip + L * (f.droop + bob);
    geo.p2x = p2x; geo.p2y = p2y;
    var bb = geo.bb; bb[0] = bb[1] = 1e9; bb[2] = bb[3] = -1e9;
    // rachis: a tapered polygon (both edges), one fill with the leaflets
    var N = 14;
    for (var k = 0; k <= N; k++) {
      var tt = k / N, x = bz(p0x, p1x, p2x, tt), y = bz(p0y, p1y, p2y, tt);
      var tx = bzd(p0x, p1x, p2x, tt), ty = bzd(p0y, p1y, p2y, tt), tl = Math.hypot(tx, ty) || 1;
      var hw = Math.max(0.6, (9 - 7.5 * tt) * f.width) / 2, nx = -ty / tl * hw, ny = tx / tl * hw;
      RL[2 * k] = x + nx; RL[2 * k + 1] = y + ny; RR[2 * k] = x - nx; RR[2 * k + 1] = y - ny;
      if (x < bb[0]) bb[0] = x; if (x > bb[2]) bb[2] = x; if (y < bb[1]) bb[1] = y; if (y > bb[3]) bb[3] = y;
    }
    geo.rn = N + 1;
    // leaflets: two ranks (the V-fold projects them at different angles), date-palm proportions
    var n = f.nL, R = rnd(f.iseed), c = 0;
    for (var i = 0; i < n; i++) {
      var rj = R(), rsk = R(), rpl = R(), rl1 = R(), rl2 = R(), rf1 = R(), rf2 = R(), rp1 = R(), rp2 = R();
      if (rsk < 0.12) continue;                                  // 12% missing: no regular comb survives
      var tpos = 0.08 + 0.90 * (i + 0.5 + (rj - 0.5) * 0.7) / n;  // ±35% pitch jitter
      var s0 = (tpos - 0.17) / 0.81, spine = s0 <= 0;
      var shape = spine ? 0 : Math.pow(Math.sin(Math.PI * Math.pow(Math.min(1, s0), 0.72)), 0.75);
      var pos0 = bz(p0x, p1x, p2x, tpos), pos1 = bz(p0y, p1y, p2y, tpos);
      var d0 = bzd(p0x, p1x, p2x, tpos), d1 = bzd(p0y, p1y, p2y, tpos), dl = Math.hypot(d0, d1) || 1;
      d0 /= dl; d1 /= dl;
      for (var side = -1; side <= 1; side += 2) {
        var rl = side > 0 ? rl1 : rl2, rf = side > 0 ? rf1 : rf2, rp = side > 0 ? rp1 : rp2;
        var len, phi, wd;
        if (spine) { len = L * 0.03 * (0.6 + 0.4 * rl); phi = 0.95 + (rp - 0.5) * 0.2; wd = 0.12; }
        else {
          len = L * 0.155 * shape * (0.80 + rl * 0.35) * (side > 0 ? 1 : 0.9);
          phi = (side > 0 ? 0.52 : 0.76) + (rpl - 0.5) * 0.30 + (rp - 0.5) * 0.12;   // leaflets sit in 2–3 planes
          wd = 0.075;
        }
        if (len < 2) continue;
        // leaflet-tip flutter: a ripple that runs from the rachis out to the tips (the phase slides with the leaflet's
        // position) mixed with a little independent noise; tips work hardest, the bases barely move; gusts feed it
        var fl = (0.55 * Math.sin(6.2832 * (0.55 * tlag * (0.8 + 0.4 * rf) - 1.15 * tpos) + rf * 5.0) +
          0.45 * noise(t * (0.55 + rf * 0.5) + i * 1.7 + side * 3.3 + f.seed)) * (0.018 + 0.060 * g) * (0.25 + 0.75 * tpos * tpos) * amp;
        var tw = noise(t * 0.8 + i * 0.93 + side * 7.1 + f.seed * 2.0) * g * amp;   // twist → edge-on shimmer
        var ang = side * (phi + fl), ca = Math.cos(ang), sa = Math.sin(ang);
        var lx = d0 * ca - d1 * sa, ly = d0 * sa + d1 * ca;
        var w = len * wd * f.width * (0.45 + 0.55 * Math.abs(Math.cos(tw * 1.2)));
        var tipx = pos0 + lx * len, tipy = pos1 + ly * len + len * 0.06;
        var cx = pos0 + lx * len * 0.5, cy = pos1 + ly * len * 0.5 + len * 0.015;
        var nx2 = -ly * w, ny2 = lx * w;
        if (c + 8 > PATH.length) break;
        PATH[c++] = pos0; PATH[c++] = pos1; PATH[c++] = cx + nx2; PATH[c++] = cy + ny2;
        PATH[c++] = tipx; PATH[c++] = tipy; PATH[c++] = cx - nx2; PATH[c++] = cy - ny2;
        if (tipx < bb[0]) bb[0] = tipx; if (tipx > bb[2]) bb[2] = tipx; if (tipy < bb[1]) bb[1] = tipy; if (tipy > bb[3]) bb[3] = tipy;
      }
    }
    geo.n = c;
  }
  // DEPTH: a near frond is painted twice. `core` = the rachis and the inner 58% of every leaflet (88% as wide):
  // it is the part of the frond close to the wall, so its shade is crisp. The full frond is the soft layer: the
  // leaflet tips droop away from the wall, so their penumbra is wide. The shader blurs the two by different radii.
  var CORE_L = 0.58, CORE_W = 0.88;
  function paintGeom(c, core) {
    // the frond as ONE nonzero fill: overlapping leaflets never double-darken inside a layer
    c.beginPath();
    c.moveTo(RL[0], RL[1]);
    for (var k = 1; k < geo.rn; k++) c.lineTo(RL[2 * k], RL[2 * k + 1]);
    for (k = geo.rn - 1; k >= 0; k--) c.lineTo(RR[2 * k], RR[2 * k + 1]);
    c.closePath();
    for (var i = 0; i < geo.n; i += 8) {
      var bx = PATH[i], by = PATH[i + 1];
      c.moveTo(bx, by);
      if (core) {
        var tx = PATH[i + 4] - bx, ty = PATH[i + 5] - by, tn = Math.hypot(tx, ty) || 1, ax = tx / tn, ay = ty / tn;
        var v1x = PATH[i + 2] - bx, v1y = PATH[i + 3] - by, a1 = (v1x * ax + v1y * ay) * CORE_L, n1 = (-v1x * ay + v1y * ax) * CORE_W;
        var v2x = PATH[i + 6] - bx, v2y = PATH[i + 7] - by, a2 = (v2x * ax + v2y * ay) * CORE_L, n2 = (-v2x * ay + v2y * ax) * CORE_W;
        c.quadraticCurveTo(bx + a1 * ax - n1 * ay, by + a1 * ay + n1 * ax, bx + tx * CORE_L, by + ty * CORE_L);
        c.quadraticCurveTo(bx + a2 * ax - n2 * ay, by + a2 * ay + n2 * ax, bx, by);
      } else {
        c.quadraticCurveTo(PATH[i + 2], PATH[i + 3], PATH[i + 4], PATH[i + 5]);
        c.quadraticCurveTo(PATH[i + 6], PATH[i + 7], bx, by);
      }
    }
    c.fill();
  }

  /* ── sizes ─────────────────────────────────────────────────────────────────────── */
  function canvasScale() {
    var s = LADDER[q][0] * Math.min(window.devicePixelRatio || 1, 2);
    if (G.narrow) s = Math.min(s, 0.9);
    if (POSTER_MODE) s = Math.min(window.devicePixelRatio || 1, 2);
    return s;
  }
  function sizeTargets() {
    var L = LADDER[q];
    var mw = Math.min(L[1], Math.round(G.W * 0.8));
    if (POSTER_MODE) mw = Math.min(1024, G.W);
    ms = mw / G.W;
    maskH = G.H + 32;
    if (mask.width !== mw) mask.width = mw;
    var mh = Math.max(2, Math.round(maskH * ms)); if (mask.height !== mh) mask.height = mh;
    if (cv) {
      var s = canvasScale(), cw = Math.max(2, Math.round(G.W * s)), ch = Math.max(2, Math.round(G.H * s));
      if (cv.width !== cw) cv.width = cw;
      if (cv.height !== ch) cv.height = ch;
      if (mode === '2d') {
        [nearC, coreC, farC].forEach(function (c) { if (c.width !== cw) c.width = cw; if (c.height !== ch) c.height = ch; });
        if (!poolImg || poolImg.width !== cw || poolImg.height !== ch) poolImg = pctx.createImageData(cw, ch);
        poolAge = 1e9;
      }
    }
    if (ov) {
      os = G.narrow ? 0.35 : 0.4;
      var ow = Math.max(2, Math.round((G.W + 2 * OVPAD) * os)), oh = Math.max(2, Math.round((G.band + OVPAD) * os));
      if (ov.width !== ow) ov.width = ow;
      if (ov.height !== oh) ov.height = oh;
      if (spC) { if (spC.width !== ow) spC.width = ow; if (spC.height !== oh) spC.height = oh; }
      ovGradK = -1; spVK = ''; spPK = '';
    }
  }

  /* ── the pool edge (JS evaluates it; the shader interpolates these rows) ─────────── */
  function edgesAt(t) {
    var walk = noise(t * 0.009 + 2.2) * G.walk;         // the sun walks, over minutes
    for (var k = 0; k < EDGE_N; k++) {
      var s = k / (EDGE_N - 1), y = s * G.H;
      edges[k] = G.x0 + walk + edgeShape(s) + G.amp * noise(y / 420 + 0.011 * t);
    }
    return edges;
  }
  function edgeAtY(y) { var f = clamp01(y / G.H) * (EDGE_N - 1), i = Math.min(EDGE_N - 2, Math.floor(f)); return edges[i] + (edges[i + 1] - edges[i]) * (f - i); }
  function beamAt(u, y) { var xe = edgeAtY(y); return (1 - sstep(xe - G.pen, xe + G.pen, u)) * sstep(G.y0, G.y1, y); }

  /* ── GL ────────────────────────────────────────────────────────────────────────── */
  var VS = '#version 300 es\nin vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var FS = [
    '#version 300 es',
    'precision highp float;',
    'uniform sampler2D uMask;',
    'uniform vec2 uRes; uniform vec2 uCss; uniform float uMaskH; uniform float uMs; uniform float uRtl; uniform float uSun; uniform float uArr; uniform float uD;',
    'uniform float uEdge[' + EDGE_N + ']; uniform float uPen; uniform vec2 uFeather; uniform float uNoOcc;',
    'uniform vec4 uG[6]; uniform float uCap[6]; uniform int uGN;',
    'uniform ivec3 uTaps; uniform float uBB; uniform vec4 uRad; uniform vec2 uCrown; uniform float uLref; uniform vec3 uOccW;',
    'uniform float uWarm; uniform float uPl; uniform float uCoreD; uniform vec2 uSeam;',
    'out vec4 o;',
    'vec3 srgb(vec3 c){c=max(c,0.);return mix(c*12.92,1.055*pow(c,vec3(1./2.4))-.055,step(vec3(.0031308),c));}',
    'float h2(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}',
    'float rectMask(vec2 p,vec4 r,float s){vec2 a=smoothstep(r.xy-s,r.xy,p)*(1.-smoothstep(r.zw,r.zw+s,p));return a.x*a.y;}',
    // static plaster: an integer hash (the same one runs in JS for the software tier), value noise, a few octaves
    'uint lb(uint x){x^=x>>16u;x*=0x7feb352du;x^=x>>15u;x*=0x846ca68bu;x^=x>>16u;return x;}',
    'float hv(ivec2 i){return float(lb(uint(i.x)*0x9e3779b1u^lb(uint(i.y)+0x85ebca6bu))&0xffffu)*(1./65535.);}',
    'float vn(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);ivec2 q=ivec2(i);return mix(mix(hv(q),hv(q+ivec2(1,0)),f.x),mix(hv(q+ivec2(0,1)),hv(q+ivec2(1,1)),f.x),f.y);}',
    'float plaster(vec2 p){',
    '  return .36*vn(p*vec2(1./170.,1./105.)+vec2(3.7,9.1))+.34*vn(p*vec2(1./46.,1./23.)+vec2(17.3,5.2))+.18*vn(p*vec2(1./21.,1./11.)+vec2(41.1,27.7))+.12*vn(p*(1./3.4)+vec2(11.9,2.3));',
    '}',
    'void main(){',
    '  vec2 px=vec2(gl_FragCoord.x,uRes.y-gl_FragCoord.y)*(uCss/uRes);',
    '  float u=uRtl>.5?px.x:uCss.x-px.x;',
    '  float s=clamp(px.y/uCss.y,0.,1.);',
    '  float fe=s*float(' + (EDGE_N - 1) + '); int ie=min(int(floor(fe)),' + (EDGE_N - 2) + ');',
    '  float xe=mix(uEdge[ie],uEdge[ie+1],fe-float(ie));',
    // the soft, curved pool: a penumbra on the copy side, a feathered top, no horizontal edge
    '  float beam=(1.-smoothstep(xe-uPen,xe+uPen,u))*smoothstep(uFeather.x,uFeather.y,px.y);',
    '  if(beam<.002){o=vec4(0.);return;}',
    '  vec2 uv=vec2(u/uCss.x,px.y/uMaskH), k=vec2(1./uCss.x,1./uMaskH);',
    // DEPTH. The near palm is two layers in the mask: R = the crisp core (rachis + inner leaflets), B = the whole frond.
    // The core is blurred by a small disc, the whole frond by a wide one, and both radii grow with the distance from the
    // crown, so the shade is crisp where the frond is near the wall and drifts out of focus towards the tips. The far
    // palm (G) stays very soft. Disc blur = golden-angle spiral, each sampled from the mip that matches its radius.
    '  float rho=length(vec2(u,px.y)-uCrown)/uLref;',
    '  float rs=smoothstep(.15,.95,rho);',
    '  float rc=mix(uRad.x,uRad.y,rs), rw=mix(uRad.z,uRad.w,rs);',
    '  float lc=max(0.,log2(max(1.,rc*uMs*1.77/sqrt(float(uTaps.x)))));',
    '  float lw=max(0.,log2(max(1.,rw*uMs*1.77/sqrt(float(uTaps.y)))));',
    '  float lg=max(0.,log2(max(1.,uBB*uMs*1.77/sqrt(float(uTaps.z)))));',
    '  float a=0.,c=0.,b=0.;',
    '  for(int i=0;i<32;i++){ if(i>=uTaps.x) break;',
    '    float fi=float(i)+.5; float th=fi*2.39996; vec2 d=vec2(cos(th),sin(th))*sqrt(fi/float(uTaps.x));',
    '    a+=textureLod(uMask,uv+d*rc*k,lc).r; }',
    '  for(int i=0;i<32;i++){ if(i>=uTaps.y) break;',
    '    float fi=float(i)+.5; float th=fi*2.39996; vec2 d=vec2(cos(th),sin(th))*sqrt(fi/float(uTaps.y));',
    '    c+=textureLod(uMask,uv+d*rw*k,lw).b; }',
    '  for(int i=0;i<32;i++){ if(i>=uTaps.z) break;',
    '    float fi=float(i)+.5; float th=fi*2.39996; vec2 d=vec2(cos(th),sin(th))*sqrt(fi/float(uTaps.z));',
    '    b+=textureLod(uMask,uv+d*uBB*k,lg).g; }',
    '  a/=float(uTaps.x); c/=float(uTaps.y); b/=float(uTaps.z);',
    '  float occ=(1.-(1.-a*uOccW.x)*(1.-c*uOccW.y)*(1.-b*uOccW.z))*(1.-uNoOcc);',
    '  vec4 wm=textureLod(uMask,uv,5.);',
    '  float wide=clamp(wm.b*.8+wm.g*.35,0.,1.)*(1.-uNoOcc);',
    // the light gathers towards the seam (and lifts a little more on the last rows), handing itself to the desk
    '  float ramp=mix(.70,1.08,smoothstep(0.,1.,s))+uSeam.x*smoothstep(uSeam.y,1.,s);',
    // the arrival walks down the room (uArr 0→1, d = uD): top rows first, the seam last; uArr = 1 → every row 1
    '  float sunY=clamp(uArr*(1.+uD)-uD*s,0.,1.)*uSun;',
    '  float light=(1.-occ)*sunY*ramp;',
    // THE POOL IS LIGHT, NOT A FILL: a creamier, brighter core deep inside the pool, a deeper rust towards its edge
    '  float inner=smoothstep(0.,1.,(xe-u)/uCoreD);',
    '  vec3 sunC=mix(vec3(1.,.70,.36),vec3(1.,.80,.50),inner);',
    '  float K=11.*mix(.90,1.10,inner);',
    '  vec3 E=vec3(.02217,.01370,.00749);',               // espresso #291F15, linear
    // lit wall; the only lift in shade is a warm (more saturated, never grey) bounce under open canopy
    '  vec3 L=E+E*sunC*light*K+vec3(.010,.006,.002)*light+E*sunC*(uWarm*sunY*ramp*(1.-wide));',
    // plaster: a static relief (mottling, trowel sweeps, grain) that only shows where the sun rakes it; never in shade
    '  vec2 pp=vec2(u,px.y);',
    '  float h0=plaster(pp), hx=plaster(pp+vec2(3.5,0.)), hy=plaster(pp+vec2(0.,3.5));',
    '  float tex=tanh(.95*((h0-.5)*3.2+((h0-hx)+(h0-hy))*8.+(hv(ivec2(floor(pp/1.4)))-.5)*.7));',
    '  L*=1.+uPl*tex*smoothstep(.04,.45,light);',
    // AA: cap the wall luminance under every text block (per-block cap from its text colour)
    '  float cap=1.;',
    '  for(int j=0;j<6;j++){ if(j>=uGN) break; cap=min(cap,mix(1.,uCap[j],rectMask(vec2(u,px.y),uG[j],26.))); }',
    '  float Y=dot(L,vec3(.2126,.7152,.0722)); if(Y>cap) L*=cap/Y;',
    '  vec3 col=clamp(srgb(L)+(h2(gl_FragCoord.xy)-.5)/255.,0.,1.);',   // static dither against banding (no grain, never animated)
    '  o=vec4(col*beam,beam);',                                      // premultiplied: alpha only in the pool
    '}'
  ].join('\n');

  var U = {}, tMask = null, vbo = null;
  function initGL() {
    glOK = false;
    if (!gl || gl.isContextLost()) return false;
    try {
      var sh = function (type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) || gl.isContextLost() ? s : null; };
      var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
      if (!vs || !fs) return false;
      P = gl.createProgram(); gl.attachShader(P, vs); gl.attachShader(P, fs); gl.linkProgram(P);
      if (!gl.getProgramParameter(P, gl.LINK_STATUS)) return false;
      gl.useProgram(P);
      vbo = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(P, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      ['uMask', 'uRes', 'uCss', 'uMaskH', 'uMs', 'uRtl', 'uSun', 'uArr', 'uD', 'uEdge', 'uPen', 'uFeather', 'uNoOcc', 'uG', 'uCap', 'uGN',
        'uTaps', 'uBB', 'uRad', 'uCrown', 'uLref', 'uOccW', 'uWarm', 'uPl', 'uCoreD', 'uSeam'].forEach(function (n) { U[n] = gl.getUniformLocation(P, n); });
      tMask = gl.createTexture(); gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tMask);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
      gl.uniform1i(U.uMask, 0);
      gl.disable(gl.BLEND);
      glOK = !gl.isContextLost();
    } catch (e) { glOK = false; }
    return glOK;
  }
  function glDraw(t, arr, haze, noOcc) {
    var W = G.W, H = G.H;
    gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tMask);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mask);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.viewport(0, 0, cv.width, cv.height);
    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform2f(U.uRes, cv.width, cv.height); gl.uniform2f(U.uCss, W, H);
    gl.uniform1f(U.uMaskH, maskH); gl.uniform1f(U.uMs, ms); gl.uniform1f(U.uRtl, G.rtl ? 1 : 0);
    gl.uniform1f(U.uSun, haze); gl.uniform1f(U.uArr, arr); gl.uniform1f(U.uD, ARR_D[G.narrow ? 1 : 0]);
    gl.uniform1fv(U.uEdge, edges); gl.uniform1f(U.uPen, G.pen); gl.uniform2f(U.uFeather, G.y0, G.y1);
    gl.uniform1f(U.uNoOcc, noOcc ? 1 : 0);
    var ga = new Float32Array(24), ca = new Float32Array(6);
    for (var i = 0; i < G.guards.length; i++) { for (var j = 0; j < 4; j++) ga[i * 4 + j] = G.guards[i][j]; ca[i] = G.caps[i]; }
    gl.uniform4fv(U.uG, ga); gl.uniform1fv(U.uCap, ca); gl.uniform1i(U.uGN, G.guards.length);
    var taps = LADDER[q][2], n = G.narrow ? 1 : 0, rad = RAD[n], cr = palms.length ? palms[0].crown : { x: 0, y: H };
    gl.uniform3i(U.uTaps, Math.max(6, Math.round(taps * 0.5)), taps, Math.max(6, Math.round(taps * 0.6)));
    gl.uniform1f(U.uBB, FAR_R[n]);
    gl.uniform4f(U.uRad, rad[0], rad[1], rad[2], rad[3]);
    gl.uniform2f(U.uCrown, cr.x, cr.y); gl.uniform1f(U.uLref, G.lref || 800);
    gl.uniform3f(U.uOccW, OCC_W[0], OCC_W[1], OCC_W[2]);
    gl.uniform1f(U.uPl, PLASTER_K); gl.uniform1f(U.uCoreD, n ? 170 : 340);
    gl.uniform2f(U.uSeam, SEAM_LIFT, SEAM_FROM);
    gl.uniform1f(U.uWarm, 0.55);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }

  /* ── the software tier: the same pool in Canvas2D ─────────────────────────────── */
  function rectMaskJs(u, y, r, sft) {
    var ax = sstep(r[0] - sft, r[0], u) * (1 - sstep(r[2], r[2] + sft, u));
    var ay = sstep(r[1] - sft, r[1], y) * (1 - sstep(r[3], r[3] + sft, y));
    return ax * ay;
  }
  /* ── static plaster, the JS twin of the shader's (same integer hash; the software tier needs it once per size) ── */
  function lbJ(x) { x ^= x >>> 16; x = Math.imul(x, 0x7feb352d); x ^= x >>> 15; x = Math.imul(x, 0x846ca68b); x ^= x >>> 16; return x >>> 0; }
  function hvJ(ix, iy) { return (lbJ((Math.imul(ix, 0x9e3779b1) ^ lbJ((iy + 0x85ebca6b) >>> 0)) >>> 0) & 0xffff) / 65535; }
  function vnJ(px, py) {
    var ix = Math.floor(px), iy = Math.floor(py), fx = px - ix, fy = py - iy;
    fx = fx * fx * (3 - 2 * fx); fy = fy * fy * (3 - 2 * fy);
    var a = hvJ(ix, iy), b = hvJ(ix + 1, iy), c = hvJ(ix, iy + 1), d = hvJ(ix + 1, iy + 1);
    return (a + (b - a) * fx) * (1 - fy) + (c + (d - c) * fx) * fy;
  }
  function plasterJ(x, y) {
    return 0.36 * vnJ(x / 170 + 3.7, y / 105 + 9.1) + 0.34 * vnJ(x / 46 + 17.3, y / 23 + 5.2) + 0.18 * vnJ(x / 21 + 41.1, y / 11 + 27.7) + 0.12 * vnJ(x / 3.4 + 11.9, y / 3.4 + 2.3);
  }
  // the plaster term −1…1 at a hero point (u-space css px); exactly the shader's `tex`
  function plasterTex(u, y) {
    var h0 = plasterJ(u, y), hx = plasterJ(u + 3.5, y), hy = plasterJ(u, y + 3.5);
    return Math.tanh(0.95 * ((h0 - 0.5) * 3.2 + ((h0 - hx) + (h0 - hy)) * 8 + (hvJ(Math.floor(u / 1.4), Math.floor(y / 1.4)) - 0.5) * 0.7));
  }
  var texBuf = null, texKey = '';
  function plasterBuf(w, h, s2) {
    var key = [w, h, G.rtl ? 1 : 0].join();
    if (texBuf && texKey === key) return texBuf;
    texBuf = new Float32Array(w * h); texKey = key;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { var cx = (x + 0.5) / s2; texBuf[y * w + x] = plasterTex(G.rtl ? cx : G.W - cx, (y + 0.5) / s2); }
    return texBuf;
  }
  function draw2D(arr, haze, noOcc, fresh) {
    var w = cv.width, h = cv.height, s2 = w / G.W, d = poolImg.data, n = G.narrow ? 1 : 0;
    // the lit pool (colour × beam, capped under the copy): rebuilt a few times a second (the edge drifts slowly)
    var sunK = Math.round(arr * 100) * 1000 + Math.round(haze * 100), dD = ARR_D[n], coreD = n ? 170 : 340;
    if (fresh || poolAge++ > 24 || !poolRows || poolRows.length !== h || poolRows.sunK !== sunK) {
      poolAge = 0;
      if (!poolRows || poolRows.length !== h) poolRows = new Array(h);
      poolRows.sunK = sunK;
      var tb = plasterBuf(w, h, s2);
      for (var y = 0; y < h; y++) {
        var cy = (y + 0.5) / s2, sy = clamp01(cy / G.H), ramp = 0.70 + 0.38 * sstep(0, 1, sy) + SEAM_LIFT * sstep(SEAM_FROM, 1, sy), sun = clamp01(arr * (1 + dD) - dD * sy) * haze;
        poolRows[y] = { ramp: ramp, sun: sun, light: ramp * sun, cy: cy, fe: sstep(G.y0, G.y1, cy), xe: edgeAtY(cy), vis: sstep(0.04, 0.45, ramp * sun) };
      }
      for (y = 0; y < h; y++) {
        var row = poolRows[y];
        for (var x = 0; x < w; x++) {
          var i = 4 * (y * w + x), cx = (x + 0.5) / s2, u = G.rtl ? cx : G.W - cx;
          var beam = row.fe ? (1 - sstep(row.xe - G.pen, row.xe + G.pen, u)) * row.fe : 0;
          if (beam < 0.002) { d[i + 3] = 0; continue; }
          // a creamier, brighter core deep inside the pool, a deeper rust towards its edge (the shader's `inner`)
          var inner = sstep(0, 1, (row.xe - u) / coreD), kk = row.light * 11 * (0.90 + 0.20 * inner);
          var L0 = E_LIN[0] * (1 + kk) + 0.010 * row.light, L1 = E_LIN[1] * (1 + (0.70 + 0.10 * inner) * kk) + 0.006 * row.light, L2 = E_LIN[2] * (1 + (0.36 + 0.14 * inner) * kk) + 0.002 * row.light;
          var pf = 1 + PLASTER_K * tb[y * w + x] * row.vis; L0 *= pf; L1 *= pf; L2 *= pf;
          var cap = 1;
          for (var j = 0; j < G.guards.length; j++) { var gm = rectMaskJs(u, row.cy, G.guards[j], 26); if (gm > 0) cap = Math.min(cap, 1 + (G.caps[j] - 1) * gm); }
          var Y = 0.2126 * L0 + 0.7152 * L1 + 0.0722 * L2;
          if (Y > cap) { var f = cap / Y; L0 *= f; L1 *= f; L2 *= f; }
          d[i] = srgb8(L0); d[i + 1] = srgb8(L1); d[i + 2] = srgb8(L2);
          d[i + 3] = Math.round(beam * 255);
        }
      }
    }
    pctx.setTransform(1, 0, 0, 1, 0, 0);
    pctx.putImageData(poolImg, 0, 0);
    if (noOcc) return;
    // the fronds take the light away (down to the espresso underneath). Near palm = the crisp core and the whole frond, each
    // blurred by its mean radius (the shader also grows the radius with the distance from the crown; the software tier
    // keeps the two layers and drops that refinement: it is a degraded tier and its budget is small); far palm 12px
    var rad = RAD[n];
    pctx.globalCompositeOperation = 'destination-out';
    pctx.filter = 'blur(' + (0.5 * (rad[0] + rad[1]) * s2).toFixed(2) + 'px)'; pctx.globalAlpha = OCC_W[0]; pctx.drawImage(coreC, 0, 0);
    pctx.filter = 'blur(' + (0.5 * (rad[2] + rad[3]) * s2).toFixed(2) + 'px)'; pctx.globalAlpha = OCC_W[1]; pctx.drawImage(nearC, 0, 0);
    pctx.filter = 'blur(' + (FAR_R[n] * s2).toFixed(2) + 'px)'; pctx.globalAlpha = OCC_W[2]; pctx.drawImage(farC, 0, 0);
    pctx.filter = 'none'; pctx.globalAlpha = 1; pctx.globalCompositeOperation = 'source-over';
  }

  /* ── the desk overlay ──────────────────────────────────────────────────────────── */
  function ovTransform() {
    // u-space (css px, hero coords) → overlay pixels; mirrored for LTR; y from the seam
    var s = os, dy = (OVPAD - G.featOff) * s;
    if (G.rtl) octx.setTransform(s, 0, 0, s, OVPAD * s, dy);
    else octx.setTransform(-s, 0, 0, s, (G.W + OVPAD) * s, dy);
  }
  function ovFades(k) {
    // alpha = k · (1 − smoothstep(.45·band, band, y)) · (1 − smoothstep(.30·W, .62·W, u))
    var w = ov.width, h = ov.height;
    if (!ovGrad || ovGradK !== k) {
      var v = octx.createLinearGradient(0, OVPAD * os, 0, h), hz, j, x;
      for (j = 0; j <= 12; j++) { x = j / 12; v.addColorStop(x, 'rgba(0,0,0,' + (k * (1 - sstep(0.45, 1, x))).toFixed(4) + ')'); }
      var u0 = OVPAD * os, u1 = (OVPAD + G.W) * os;
      hz = G.rtl ? octx.createLinearGradient(u0, 0, u1, 0) : octx.createLinearGradient(u1, 0, u0, 0);
      for (j = 0; j <= 12; j++) { x = j / 12; hz.addColorStop(x, 'rgba(0,0,0,' + (1 - sstep(0.30, 0.62, x)).toFixed(4) + ')'); }
      ovGrad = [v, hz]; ovGradK = k;
    }
    octx.setTransform(1, 0, 0, 1, 0, 0);
    octx.globalCompositeOperation = 'destination-in';
    octx.fillStyle = ovGrad[0]; octx.fillRect(0, 0, w, h);
    octx.fillStyle = ovGrad[1]; octx.fillRect(0, 0, w, h);
    octx.globalCompositeOperation = 'source-over';
  }

  // the frond fills as vertical gradients in hero coordinates (applied under the overlay transform): darkest at the seam,
  // pure today's-softness by DESK_RAMP. s(d) falls fast enough that the slips (122px+ under the seam) keep ink ≥ 7:1.
  var dgN = null, dgF = null, dgKey = '';
  function deskShadeAt(d, sc) { return Math.pow(1 - sstep(40 * sc, 210 * sc, d), 2.6); }
  function deskGrads() {
    var key = G.featOff + '|' + (G.narrow ? 1 : 0);
    if (dgN && dgKey === key) return;
    dgKey = key;
    var sc = G.narrow ? 0.8 : 1, ramp = DESK_RAMP * sc;
    dgN = octx.createLinearGradient(0, G.featOff, 0, G.featOff + ramp); dgF = octx.createLinearGradient(0, G.featOff, 0, G.featOff + ramp);
    var mix = function (a, b, t) { return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }).join(',') + ')'; };
    for (var j = 0; j <= 14; j++) { var x = j / 14, sv = deskShadeAt(x * ramp, sc); dgN.addColorStop(x, mix(NEAR_N, NEAR_D, sv)); dgF.addColorStop(x, mix(FAR_N, FAR_D, sv * 0.8)); }
  }
  // the pool edge's own slant where it meets the seam (u per px of y), damped: the lit patch on the desk keeps heading the way the light edge was heading
  function bottomSlope() {
    var sl = (edges[EDGE_N - 1] - edges[EDGE_N - 4]) / (G.H * 3 / (EDGE_N - 1));
    return Math.max(-0.45, Math.min(0.45, sl)) * 0.85;
  }

  /* HERO-3: the sun spills past the seam. The pool's light lands on the sand as an umber multiply tint under
     the pool's own footprint (palm edge → the pool edge at the seam row, the same penumbra), strongest at the
     seam and gone by SPILL_DEPTH below it (smoothstep, no bottom edge). It is drawn BEHIND the fronds
     (destination-over) so the shade still reads inside the light; it inherits the overlay's CSS blur,
     multiply, language fade and poster path. k = strength 0…1 (follows the lagging bottom-row sun; on
     desk:clear it only eases to ≈ .74: the shade leaves, the light stays). */
  function spillStops(xe, pen, k) {
    var us = [0, G.W], i, u;
    for (i = 0; i <= 18; i++) { u = xe - pen + (2 * pen) * i / 18; if (u > 0 && u < G.W) us.push(u); }
    us.sort(function (a, b) { return a - b; });
    return us.map(function (v) {
      var a = k * (1 - sstep(xe - pen, xe + pen, v));
      return [v / G.W, 'rgba(' + SPILL_C[0] + ',' + SPILL_C[1] + ',' + SPILL_C[2] + ',' + a.toFixed(4) + ')'];
    });
  }
  function paintSpill(k) {
    if (!spX) return;
    k = clamp01(k) * SPILL_K;
    if (k < 0.002) return;
    var w = spC.width, h = spC.height, u0 = OVPAD * os, u1 = (OVPAD + G.W) * os, y0 = OVPAD * os, depth = SPILL_DEPTH[G.narrow ? 1 : 0] * os;
    var vk = [w, h, os, depth].join();
    if (!spVG || spVK !== vk) {
      var vg = spX.createLinearGradient(0, y0, 0, y0 + depth);
      for (var j = 0; j <= 14; j++) { var x = j / 14; vg.addColorStop(x, 'rgba(0,0,0,' + Math.pow(1 - sstep(0, 1, x), 1.25).toFixed(4) + ')'); }
      spVG = vg; spVK = vk;
    }
    // the wash only changes when its strength or the pool edge moves (the edge drifts over minutes): repaint it then
    var xe0 = edgeAtY(G.H), sl = bottomSlope(), pk = [w, h, G.rtl ? 1 : 0, Math.round(k * 200), Math.round(xe0 * 2), Math.round(sl * 100), SPILL_K].join();
    if (pk !== spPK) {
      spPK = pk;
      var hz = G.rtl ? spX.createLinearGradient(u0, 0, u1, 0) : spX.createLinearGradient(u1, 0, u0, 0);
      spillStops(xe0, G.pen, k).forEach(function (s_) { hz.addColorStop(s_[0], s_[1]); });
      spX.setTransform(1, 0, 0, 1, 0, 0);
      spX.globalCompositeOperation = 'source-over';
      spX.clearRect(0, 0, w, h);
      var shx = G.rtl ? sl : -sl;                               // the edge keeps its heading below the seam (sheared about the seam row)
      spX.setTransform(1, 0, shx, 1, -shx * y0, 0);
      spX.fillStyle = hz; spX.fillRect(-w, 0, 3 * w, h);
      spX.setTransform(1, 0, 0, 1, 0, 0);
      spX.globalCompositeOperation = 'destination-in';
      spX.fillStyle = spVG; spX.fillRect(0, 0, w, h);          // above the seam the gradient keeps its first stop (1)
      spX.globalCompositeOperation = 'source-over';
    }
    octx.setTransform(1, 0, 0, 1, 0, 0);
    octx.globalCompositeOperation = 'destination-over';
    octx.drawImage(spC, 0, 0);
    octx.globalCompositeOperation = 'source-over';
  }

  /* ── one frame ─────────────────────────────────────────────────────────────────── */
  function tweenV(o, now) { if (!o.ms) return o.to; var x = clamp01((now - o.t0) / o.ms); return o.from + (o.to - o.from) * (o.ease || WF.T.fn.rise)(x); }
  function tweenTo(o, to, ms, now) { o.from = tweenV(o, now); o.to = to; o.t0 = now; o.ms = ms; }
  // the sun = arrival progress (0→1 over 2.6 s, smoothstep) × a thin high haze (.9–1, never a flicker).
  // The arrival is per row (HERO-4): see the shader; `arr` is the raw progress, `haze` the global factor.
  function arrAt(now) {
    if (fixedT != null) return 1;
    if (sunStart == null) return 0;
    var s = clamp01((now - sunStart) / 2600); return s * s * (3 - 2 * s);
  }
  function hazeAt(t) { return fixedT != null ? 1 : 0.9 + 0.1 * (0.5 + 0.5 * noise(t * 0.017 + 4.4)); }
  function sunAt(now, t) { return arrAt(now) * hazeAt(t); }
  // the desk is lit last: the lagging value at the bottom row of the room
  function arrBottom(arr) { return clamp01(arr * (1 + ARR_D[G.narrow ? 1 : 0]) - ARR_D[G.narrow ? 1 : 0]); }
  var heroIn = true, bandIn = true, visible = !document.hidden;
  function frame(now, o) {
    o = o || {};
    var w0 = performance.now();
    var t = o.t != null ? o.t : fixedT != null ? fixedT : (now - T0) / 1000 + tOffset;
    var arr = o.arr != null ? o.arr : o.sun != null ? 1 : arrAt(now), haze = o.sun != null ? o.sun : hazeAt(t), sunB = arrBottom(arr) * haze;
    var calmV = o.calm != null ? o.calm : tweenV(calm, now), dimV = o.dim != null ? o.dim : tweenV(dim, now);
    var doGL = heroReady() && !posterOn && (o.all || heroIn) && !o.ovOnly;
    var doOv = !!(ov && octx) && (o.all || bandIn) && !o.glOnly;
    if (!doGL && !doOv) return;
    edgesAt(t);
    if (doGL && mode === '2d') {
      var s2 = cv.width / G.W;
      [nearX, coreX, farX].forEach(function (x) {
        x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, cv.width, cv.height);
        if (G.rtl) x.setTransform(s2, 0, 0, s2, 0, 0); else x.setTransform(-s2, 0, 0, s2, G.W * s2, 0);
        x.fillStyle = '#000';
      });
    } else if (doGL) {
      mctx.setTransform(1, 0, 0, 1, 0, 0);
      mctx.globalCompositeOperation = 'source-over';
      mctx.fillStyle = '#000'; mctx.fillRect(0, 0, mask.width, mask.height);
      mctx.globalCompositeOperation = 'lighter';
      mctx.setTransform(ms, 0, 0, ms, 0, 0);
    }
    if (doOv) {
      octx.setTransform(1, 0, 0, 1, 0, 0);
      octx.globalCompositeOperation = 'source-over';
      octx.clearRect(0, 0, ov.width, ov.height);
      ovTransform();
    }
    var ovTop = G.featOff - OVPAD - 30, ovBot = G.featOff + G.band + 30;
    for (var p = palms.length - 1; p >= 0; p--) {         // far palm first, so the near palm sits on top on the desk
      var palm = palms[p], amp = palm.far ? 0.7 : 1;
      for (var f = 0; f < palm.fronds.length; f++) {
        frondGeom(palm.crown, palm.fronds[f], t, amp, calmV);
        if (doGL && geo.bb[1] < maskH) {
          if (mode === '2d') { if (palm.far) paintGeom(farX); else { paintGeom(nearX); paintGeom(coreX, true); } }
          else if (palm.far) { mctx.fillStyle = '#00ff00'; paintGeom(mctx); }
          else { mctx.fillStyle = '#0000ff'; paintGeom(mctx); mctx.fillStyle = '#ff0000'; paintGeom(mctx, true); }   // B = whole frond, R = crisp core
        }
        if (doOv && ovFronds && geo.bb[3] > ovTop && geo.bb[1] < ovBot) { deskGrads(); octx.fillStyle = palm.far ? dgF : dgN; paintGeom(octx); }
      }
    }
    if (doGL) { if (mode === '2d') draw2D(arr, haze, !!o.noOcc, o.t != null || !!o.noOcc); else glDraw(t, arr, haze, !!o.noOcc); st.glFrames++; }
    if (doOv) { ovFades(Math.round(sunB * dimV * 1000) / 1000); if (!o.noSpill) paintSpill(sunB * (0.6 + 0.4 * dimV)); st.ovFrames++; }
    st.frames++;
    var wk = performance.now() - w0; st.work += wk; st.workN++; st.lastWork = wk;
  }

  /* ── loop ──────────────────────────────────────────────────────────────────────── */
  var raf = 0, running = false, last = 0, acc = [], loopT0 = 0;
  function fpsCap() { return Math.min(LADDER[q][3], (G.narrow || G.coarse) ? 30 : 60); }
  function loop(now) {
    raf = 0;
    if (!running) return;
    var cap = fpsCap();
    if (cap < 60 && last && now - last < 1000 / cap - 4) { raf = requestAnimationFrame(loop); return; }
    if (last) { var dt = now - last; if (heroIn) acc.push(dt); if (st.dts.length >= 240) st.dts.shift(); st.dts.push(Math.round(dt * 10) / 10); }
    last = now;
    frame(now);
    // adapt: medians of 30 hero frames (after the first 1.5 s) running long → step down; past the last rung → still
    if (acc.length >= 30 && !Q_FORCE) {
      acc.sort(function (x, y) { return x - y; });
      var med = acc[acc.length >> 1]; acc = [];
      if (now - loopT0 > 1500 && med > (1000 / cap) * 1.35) {
        st.steps.push({ q: q, med: Math.round(med) });
        if (q < LADDER.length - 1) { q++; sizeTargets(); }
        else { frozen = true; stop(); WF.emit('ambient:ready', { tier: 'still', poster: false }); return; }
      }
    }
    raf = requestAnimationFrame(loop);
  }
  function start() {
    if (running || reduced || frozen || fixedT != null || posterOn || !booted) return;
    running = true; last = 0; acc = []; loopT0 = performance.now();
    raf = requestAnimationFrame(loop);
  }
  function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
  function sync() { if (visible && (heroIn || bandIn)) start(); else stop(); }
  function still() { frame(performance.now(), { all: true }); }

  /* ── the poster path ───────────────────────────────────────────────────────────── */
  function toPoster(lock) {
    posterOn = true; if (lock) posterLocked = true;
    root.classList.add('amb-poster');
    stop();
    // the desk shade: one static frame at the composed moment
    var keep = fixedT; fixedT = REDUCED_T; frame(performance.now(), { all: true, sun: 1 }); fixedT = keep;
  }
  function leavePoster() {
    if (posterLocked) return;
    posterOn = false; root.classList.remove('amb-poster');
  }

  /* ── boot ──────────────────────────────────────────────────────────────────────── */
  var booted = false, lostTimer = 0, tier = 'init';
  function tierName() { return posterOn ? 'poster' : (frozen || reduced || fixedT != null) ? 'still' : 'q' + q; }
  function makeOverlay() {
    if (!host) return;
    ov = document.createElement('canvas');
    ov.className = 'amb-shade';
    ov.setAttribute('aria-hidden', 'true');
    ov.setAttribute('data-gold-exempt', '');                 // the spill is umber light on sand, never a gold field
    // A-DESK owns the host's styles; if they are missing, give it the §1.3 contract inline
    var hs = getComputedStyle(host);
    if (hs.position === 'static') {
      host.style.position = 'absolute'; host.style.insetInline = '0'; host.style.top = '0';
      host.style.height = 'var(--amb-band)'; host.style.pointerEvents = 'none';
      host.style.mixBlendMode = 'multiply'; host.style.zIndex = 'calc(var(--z-content) + 1)';
      st.hostFallback = true;
    }
    host.appendChild(ov);
    octx = ov.getContext('2d');
    spC = document.createElement('canvas'); spX = spC.getContext('2d');
  }
  function boot() {
    if (booted) return;
    makeOverlay();
    var wantGL = !FORCE_POSTER;
    if (wantGL) {
      cv = document.createElement('canvas');
      cv.className = 'amb__gl';
      cv.setAttribute('aria-hidden', 'true');
      try { gl = cv.getContext('webgl2', { alpha: true, premultipliedAlpha: true, antialias: false, depth: false, stencil: false, preserveDrawingBuffer: false, powerPreference: 'low-power' }); } catch (e) { gl = null; }
      if (gl) {
        try { var ext = gl.getExtension('WEBGL_debug_renderer_info'); renderer = ext ? String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)) : ''; } catch (e) { renderer = ''; }
        software = /swiftshader|llvmpipe|software|basic render/i.test(renderer);
        if (software) {
          // never display a WebGL canvas on a software compositor: the q3 tier is drawn in 2D
          gl = null; mode = '2d';
          cv = document.createElement('canvas'); cv.className = 'amb__gl'; cv.setAttribute('aria-hidden', 'true');
          pctx = cv.getContext('2d', { willReadFrequently: true });
          nearC = document.createElement('canvas'); nearX = nearC.getContext('2d');
          coreC = document.createElement('canvas'); coreX = coreC.getContext('2d');
          farC = document.createElement('canvas'); farX = farC.getContext('2d');
        }
      }
      if (cv) root.appendChild(cv);
      if (gl) {
        cv.addEventListener('webglcontextlost', function (e) {
          e.preventDefault(); glOK = false; st.lost++;
          toPoster(false);                                   // within one frame
          clearTimeout(lostTimer);
          lostTimer = setTimeout(function () { posterLocked = true; tier = 'poster'; }, 4000);
        });
        cv.addEventListener('webglcontextrestored', function () {
          clearTimeout(lostTimer);
          if (posterLocked) return;
          if (initGL()) { st.restored++; leavePoster(); measure(); if (fixedT != null || reduced) still(); else sync(); }
          else toPoster(true);
        });
      }
    }
    // GPU: an accelerated 2D mask uploads GPU→GPU (≈1 ms). Software GL: a CPU-backed mask is cheaper and
    // avoids the driver's "GPU stall due to ReadPixels" on every upload.
    mctx = mask.getContext('2d', { willReadFrequently: software });
    q = mqNarrow.matches || mqCoarse.matches ? 1 : 0;
    if (software) q = 3;
    if (Q_FORCE) q = +Q_FORCE[1];
    measure();
    booted = true;
    if (reduced || POSTER_MODE) fixedT = REDUCED_T;
    if (mode === '2d' ? !pctx : (!gl || !initGL())) { toPoster(true); tier = 'poster'; }
    else if (fixedT != null) { still(); tier = 'still'; }
    else { tier = 'q' + q; frame(performance.now(), { all: true }); sync(); }
    WF.emit('ambient:ready', { tier: tierName(), poster: posterOn });
  }

  // the sun arrives 200ms after the H1 lands (HOLD, then light). M4's hand-off: #hero[data-landed="<ms>"]
  // + the DOM event "wf:hero-landed" {detail:{t}} (performance.now() of the landing). A 3 s safety net
  // covers a hero that never signals (it should always signal; the net only keeps the light from never coming).
  var sunArmed = false;
  function armSun() {
    if (reduced || sunArmed) return;
    var net = 0;
    var go = function (at) {
      if (sunArmed) return; sunArmed = true; clearTimeout(net);
      var t = +at; if (!isFinite(t) || t <= 0) t = performance.now();
      sunStart = Math.max(t + 200, performance.now() - 2400);   // late boot: never skip the whole arrival
      st.landedAt = Math.round(t); st.sunStart = Math.round(sunStart);
      setTimeout(function () { measureGuards(); }, 220); setTimeout(function () { measureGuards(); }, 900);
    };
    if (hero.hasAttribute('data-landed')) { go(hero.getAttribute('data-landed')); return; }
    hero.addEventListener('wf:hero-landed', function (e) { go(e && e.detail && e.detail.t); }, { once: true });
    net = setTimeout(function () { st.sunNet = true; go(performance.now()); }, 3000);
  }

  /* ── events ────────────────────────────────────────────────────────────────────── */
  WF.on('desk:clear', function () {
    var now = performance.now(), ms_ = (reduced || posterOn) ? 0 : 1400;
    tweenTo(dim, 0.35, ms_, now); tweenTo(calm, 1, ms_, now);
    if (!running && booted) frame(now, { ovOnly: true, all: true });
  });
  WF.on('desk:reset', function () {
    var now = performance.now(), ms_ = (reduced || posterOn) ? 0 : 1000;
    tweenTo(dim, 1, ms_, now); tweenTo(calm, 0, ms_, now);
    if (!running && booted) frame(now, { ovOnly: true, all: true });
  });
  WF.on('lang:before', function () {
    if (!booted) return;
    WF.motion.fade(root, 0, 200);
    if (ov) WF.motion.fade(ov, 0, 200);
  });
  WF.on('lang', function () {
    if (!booted) return;
    measure();                                  // the swap frame: final layout, no glides yet
    if (!running) frame(performance.now(), { all: true, sun: fixedT != null || posterOn ? 1 : undefined });
  });
  WF.on('lang:after', function () {
    if (!booted) return;
    WF.motion.fade(root, 1, 400);
    if (ov) WF.motion.fade(ov, 1, 400);
  });
  WF.on('env', function (d) {
    if (!booted) return;
    var wasReduced = reduced;
    reduced = !!(d && d.reduced);
    if (reduced && !wasReduced) { stop(); fixedT = REDUCED_T; measure(); still(); }
    else if (!reduced && wasReduced && !POSTER_MODE) { fixedT = null; sunStart = sunStart || performance.now(); measure(); sync(); }
  });
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (booted) sync(); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === hero) heroIn = e.isIntersecting; else bandIn = e.isIntersecting; });
      if (booted) sync();
    }, { rootMargin: '40px 0px' });
    io.observe(hero);
    if (host) io.observe(host); else bandIn = false;
  }
  var rzT = 0;
  function onResize() {
    clearTimeout(rzT);
    rzT = setTimeout(function () {
      if (!booted) return;
      measure();
      if (!running) frame(performance.now(), { all: true, sun: fixedT != null || posterOn ? 1 : undefined });
    }, 150);
  }
  window.addEventListener('resize', onResize);
  if ('ResizeObserver' in window) { var lastH = 0; new ResizeObserver(function () { var h = Math.round(hero.getBoundingClientRect().height); if (h !== lastH) { lastH = h; onResize(); } }).observe(hero); }

  // start after fonts (WF.ready) + first paint: a context made mid-parse was lost at first composite on SwiftShader
  WF.on('ready', function () {
    requestAnimationFrame(function () { setTimeout(function () { boot(); armSun(); }, 0); });
  });

  /* ── debug / acceptance surface ────────────────────────────────────────────────── */
  function readHero() {
    var b = new Uint8Array(cv.width * cv.height * 4);
    if (mode === 'gl') { gl.readPixels(0, 0, cv.width, cv.height, gl.RGBA, gl.UNSIGNED_BYTE, b); return b; }
    // 2D: bottom-up rows, premultiplied, like readPixels
    var d = pctx.getImageData(0, 0, cv.width, cv.height).data, w = cv.width, h = cv.height;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var i = 4 * (y * w + x), o = 4 * ((h - 1 - y) * w + x), a = d[i + 3] / 255;
      b[o] = d[i] * a; b[o + 1] = d[i + 1] * a; b[o + 2] = d[i + 2] * a; b[o + 3] = d[i + 3];
    }
    return b;
  }
  function composite(b, i) { var a = b[i + 3] / 255; return [b[i] + ESP[0] * (1 - a), b[i + 1] + ESP[1] * (1 - a), b[i + 2] + ESP[2] * (1 - a), a]; }
  function hsvSat(c) { var mx = Math.max(c[0], c[1], c[2]), mn = Math.min(c[0], c[1], c[2]); return mx ? (mx - mn) / mx : 0; }
  function hex(c) { return '#' + c.slice(0, 3).map(function (v) { return (Math.round(v) | 256).toString(16).slice(1); }).join(''); }
  function after() { if (!running && booted) frame(performance.now(), { all: true, sun: fixedT != null || posterOn ? 1 : undefined }); }

  // draw the overlay with the fronds only (no spill) and hand its alpha plane to fn; then restore the normal frame.
  // live = current sun/dim (shadeAt); otherwise the worst case: full sun, desk not cleared (shadeProbe)
  var rdC = null, rdX = null;
  function frondRead(fn, live) {
    var o = { ovOnly: true, all: true, noSpill: true };
    if (!live) { o.sun = 1; o.dim = 1; } else if (fixedT != null || posterOn) o.sun = 1;
    frame(performance.now(), o);
    if (!rdC) { rdC = document.createElement('canvas'); rdX = rdC.getContext('2d', { willReadFrequently: true }); }
    if (rdC.width !== ov.width) rdC.width = ov.width; if (rdC.height !== ov.height) rdC.height = ov.height;
    rdX.setTransform(1, 0, 0, 1, 0, 0); rdX.globalCompositeOperation = 'copy'; rdX.drawImage(ov, 0, 0); rdX.globalCompositeOperation = 'source-over';
    var res = fn(rdX.getImageData(0, 0, rdC.width, rdC.height).data, rdC.width);
    frame(performance.now(), { ovOnly: true, all: true, sun: fixedT != null || posterOn ? 1 : undefined });   // restore
    return res;
  }

  var API = {
    stats: function () {
      var d = st.dts.slice().sort(function (a, b) { return a - b; }), med = d.length ? d[d.length >> 1] : null;
      return { tier: tierName(), q: q, renderer: renderer, software: software, running: running, frozen: frozen, poster: posterOn,
        frames: st.frames, glFrames: st.glFrames, ovFrames: st.ovFrames, jsMs: st.workN ? +(st.work / st.workN).toFixed(2) : null,
        lastJsMs: st.lastWork != null ? +st.lastWork.toFixed(2) : null, medianDt: med, fps: med ? +(1000 / med).toFixed(1) : null,
        lost: st.lost, restored: st.restored, steps: st.steps, heroIn: heroIn, bandIn: bandIn, hostFallback: !!st.hostFallback,
        geom: { W: G.W, H: G.H, band: G.band, featOff: G.featOff, rtl: G.rtl, narrow: G.narrow, stacked: G.stacked, x0: Math.round(G.x0), y0: Math.round(G.y0), y1: Math.round(G.y1), pen: +G.pen.toFixed(1), guards: G.guards.length, caps: G.caps.map(function (c) { return +c.toFixed(4); }) },
        sun: sunStart == null ? 0 : +sunAt(performance.now(), 0).toFixed(3), dim: +tweenV(dim, performance.now()).toFixed(3),
        landedAt: st.landedAt == null ? null : st.landedAt, sunStart: st.sunStart == null ? null : st.sunStart, sunNet: !!st.sunNet };
    },
    tier: tierName,
    // debug / tuning: the spill's strength constant (0 = off, 1 = as designed); redraws at once
    fronds: function (on) { ovFronds = !!on; after(); return ovFronds; },
    spill: function (k) { if (k != null) { SPILL_K = +k; after(); } return { k: SPILL_K, colour: hex(SPILL_C), depth: SPILL_DEPTH[G.narrow ? 1 : 0] }; },
    running: function () { return running; },
    // AA: n wind states at full sun; the worst contrast of every text colour over the pixels behind each block
    probe: function (n) {
      if (!heroReady() || posterOn) return { min: null, why: 'no GL (poster path)' };
      n = n || 120; measureGuards();
      var hr = hero.getBoundingClientRect(), sx = cv.width / G.W, sy = cv.height / G.H, worst = {}, min = 99;
      var blocks = G.guardEls.map(function (el, i) {
        var r = el.getBoundingClientRect(), nm = (el.className && String(el.className).split(' ').filter(function (c) { return /^hero__/.test(c); })[0]) || el.tagName.toLowerCase();
        return { name: nm + '#' + i, cols: textColours(el), x0: r.left - hr.left, x1: r.right - hr.left, y0: r.top - hr.top, y1: r.bottom - hr.top };
      });
      for (var i = 0; i < n; i++) {
        var t = REDUCED_T + i * 7.31;
        frame(performance.now(), { t: t, sun: 1, glOnly: true, all: true });
        var b = readHero();
        blocks.forEach(function (bk) {
          for (var y = Math.max(0, bk.y0); y < Math.min(G.H, bk.y1); y += 3) {
            for (var x = Math.max(0, bk.x0); x < Math.min(G.W, bk.x1); x += 3) {
              var k = 4 * ((cv.height - 1 - Math.floor(y * sy)) * cv.width + Math.floor(x * sx));
              var bg = composite(b, k);
              for (var j = 0; j < bk.cols.length; j++) {
                var c = contrast(over(bk.cols[j], bg), bg);
                if (!worst[bk.name] || c < worst[bk.name].c) worst[bk.name] = { c: +c.toFixed(2), bg: hex(bg), t: +t.toFixed(2) };
                if (c < min) min = c;
              }
            }
          }
        });
      }
      after();
      return { min: +min.toFixed(2), n: n, blocks: worst };
    },
    // the pool's copy-side edge, measured on the drawn pixels (occlusion off): RMS residual from a best-fit line
    edge: function (n) {
      if (!heroReady() || posterOn) return { rms: null, why: 'no GL' };
      n = n || 10; var res = [], sx = cv.width / G.W, sy = cv.height / G.H;
      for (var m = 0; m < n; m++) {
        var t = tOffset + m * 17.3;
        frame(performance.now(), { t: t, sun: 1, noOcc: true, glOnly: true, all: true });
        var b = readHero(), pts = [];
        var yA = Math.max(G.y0 + 0.25 * (G.y1 - G.y0), 0);
        for (var y = yA; y < G.H - 2; y += 4) {
          var row = cv.height - 1 - Math.floor(y * sy), amax = 0, xs = [];
          for (var px = 0; px < cv.width; px++) { var a = b[4 * (row * cv.width + px) + 3]; xs.push(a); if (a > amax) amax = a; }
          if (amax < 20) continue;
          var half = amax / 2, hit = null;
          // walk from the inline-end edge towards the copy until alpha falls under half its row max
          for (var i = 0; i < cv.width; i++) {
            var ix = G.rtl ? i : cv.width - 1 - i;
            if (xs[ix] < half) { var ip = G.rtl ? ix - 1 : ix + 1; var a0 = xs[ip] == null ? half : xs[ip], a1 = xs[ix]; hit = (i - 1 + (a0 - half) / Math.max(1, a0 - a1)) / sx; break; }
          }
          if (hit != null) pts.push([y, hit]);
        }
        if (pts.length < 8) continue;
        var N = pts.length, sy_ = 0, su = 0, syy = 0, syu = 0;
        pts.forEach(function (p) { sy_ += p[0]; su += p[1]; syy += p[0] * p[0]; syu += p[0] * p[1]; });
        var slope = (N * syu - sy_ * su) / (N * syy - sy_ * sy_), icpt = (su - slope * sy_) / N, ss = 0;
        pts.forEach(function (p) { var r = p[1] - (icpt + slope * p[0]); ss += r * r; });
        res.push({ t: +t.toFixed(1), rms: +Math.sqrt(ss / N).toFixed(1), rows: N, slope: +slope.toFixed(3) });
      }
      after();
      var rmsMin = res.length ? Math.min.apply(null, res.map(function (r) { return r.rms; })) : null;
      return { rmsMin: rmsMin, samples: res };
    },
    // saturation of the wall inside the pool (composited over espresso): fully shaded pixels must stay ≥ .35
    poolSat: function (n) {
      if (!heroReady() || posterOn) return { min: null, why: 'no GL' };
      n = n || 12; var minShade = 1, minAll = 1, shadeN = 0, darkest = null;
      for (var m = 0; m < n; m++) {
        frame(performance.now(), { t: REDUCED_T + m * 11.7, sun: 1, glOnly: true, all: true });
        var b = readHero();
        for (var i = 0; i < b.length; i += 4 * 7) {
          if (b[i + 3] < 128) continue;                      // inside the pool (beam ≥ .5)
          var c = composite(b, i), s = hsvSat(c);
          if (s < minAll) minAll = s;
          if (c[0] < 70) { shadeN++; if (s < minShade) { minShade = s; darkest = hex(c); } }   // shaded (no direct sun)
        }
      }
      after();
      return { minShaded: +minShade.toFixed(3), minAll: +minAll.toFixed(3), shadedSamples: shadeN, worstShaded: darkest };
    },
    // the MONOLITH's glyph box vs the pool's box (max extent over 60 s of wind)
    mono: function () {
      measure();
      var pu = 0;
      for (var m = 0; m < 30; m++) { edgesAt(tOffset + m * 2); for (var k = 0; k < EDGE_N; k++) if ((k / (EDGE_N - 1)) * G.H >= G.y0) pu = Math.max(pu, edges[k] + G.pen); }
      edgesAt(tOffset);
      var pool = { u0: 0, u1: Math.round(pu), y0: Math.round(G.y0), y1: G.H }, mb = G.mono;
      var hit = !!(mb && mb.u0 < pool.u1 && mb.u1 > pool.u0 && mb.y0 < pool.y1 && mb.y1 > pool.y0);
      return { intersects: hit, mono: mb && { u0: Math.round(mb.u0), u1: Math.round(mb.u1), y0: Math.round(mb.y0), y1: Math.round(mb.y1) }, pool: pool };
    },
    // share of the pool covered by ≥ 2 near fronds, max over 20 moments across 60 s of wind
    overlap: function () {
      var sc = 0.25, w = Math.max(2, Math.ceil(G.W * sc)), h = Math.max(2, Math.ceil(G.H * sc));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true }), near = palms.filter(function (p) { return !p.far; })[0];
      var cnt = new Uint8Array(w * h), best = { share: 0, t: 0 }, coverMin = 1, coverMax = 0;
      for (var m = 0; m < 20; m++) {
        var t = tOffset + m * 3;
        edgesAt(t); cnt.fill(0);
        var poolN = 0, pool = new Uint8Array(w * h);
        for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) if (beamAt((xx + 0.5) / sc, (yy + 0.5) / sc) >= 0.5) { pool[yy * w + xx] = 1; poolN++; }
        near.fronds.forEach(function (f) {
          x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, w, h);
          x.setTransform(sc, 0, 0, sc, 0, 0); x.fillStyle = '#000';
          frondGeom(near.crown, f, t, 1, 0); paintGeom(x);
          var d = x.getImageData(0, 0, w, h).data;
          for (var i = 0; i < w * h; i++) if (d[4 * i + 3] > 127) cnt[i]++;
        });
        var two = 0, one = 0; for (var i2 = 0; i2 < w * h; i2++) if (pool[i2]) { if (cnt[i2] >= 2) two++; if (cnt[i2] >= 1) one++; }
        var share = poolN ? two / poolN : 0, cover = poolN ? one / poolN : 0;
        coverMin = Math.min(coverMin, cover); coverMax = Math.max(coverMax, cover);
        if (share > best.share) best = { share: share, t: t };
      }
      edgesAt(tOffset);
      // cover = share of the pool under ≥ 1 near frond (proves the measure is not vacuous)
      return { max: +(best.share * 100).toFixed(2), unit: '%', at: +best.t.toFixed(1), coverMin: +(coverMin * 100).toFixed(1), coverMax: +(coverMax * 100).toFixed(1) };
    },
    // The desk's legibility under the overlay (fronds + spill) at its WORST: full sun, desk not cleared, spill at full
    // strength. Measured on the real overlay pixels against the REAL text of #feature (every visible text-bearing element:
    // its own computed colour over its own ground, both multiplied by the overlay). min = the worst of all of them;
    // slipMin = ink on the slips, mutedMin = everything else (the lede, the hint, the kicker, the H2).
    // Also, for text that has not been placed yet: zoneSlip / zoneMuted = the worst contrast the overlay allows anywhere
    // below the text-free strip (solid ink on a bone slip; muted ink at 70% on sand, only where the desk's own column sits).
    shadeProbe: function () {
      if (!ov || !octx) return { min: null, why: 'no shade host' };
      frame(performance.now(), { ovOnly: true, all: true, sun: 1, dim: 1 });
      if (!rdC) { rdC = document.createElement('canvas'); rdX = rdC.getContext('2d', { willReadFrequently: true }); }
      if (rdC.width !== ov.width) rdC.width = ov.width; if (rdC.height !== ov.height) rdC.height = ov.height;
      rdX.setTransform(1, 0, 0, 1, 0, 0); rdX.globalCompositeOperation = 'copy'; rdX.drawImage(ov, 0, 0); rdX.globalCompositeOperation = 'source-over';
      var w = rdC.width, h = rdC.height, d = rdX.getImageData(0, 0, w, h).data;
      var r = ov.getBoundingClientRect(), sx = w / r.width, sy = h / r.height, seamY = host ? host.getBoundingClientRect().top : r.top + OVPAD;
      var mulAt = function (vx, vy) {
        var px = Math.max(0, Math.min(w - 1, Math.floor((vx - r.left) * sx))), py = Math.max(0, Math.min(h - 1, Math.floor((vy - r.top) * sy))), i = 4 * (py * w + px), a = d[i + 3] / 255;
        return [1 - a + a * d[i] / 255, 1 - a + a * d[i + 1] / 255, 1 - a + a * d[i + 2] / 255];
      };
      var scale3 = function (c, m) { return [c[0] * m[0], c[1] * m[1], c[2] * m[2]]; };
      var parse = function (str) { var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/.exec(str); return m ? [+m[1], +m[2], +m[3], m[4] === undefined ? 1 : +m[4]] : null; };
      var worst = [], slipMin = 99, mutedMin = 99, strip = 1e9, seen = 0;
      if (feature) {
        var els = feature.querySelectorAll('*');
        for (var e = 0; e < els.length; e++) {
          var el = els[e];
          if (ov.contains(el) || el === ov) continue;
          var own = false; for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) { own = true; break; }
          if (!own) continue;
          var er = el.getBoundingClientRect(); if (er.width < 2 || er.height < 2) continue;
          var cs = getComputedStyle(el); if (cs.visibility === 'hidden' || +cs.opacity === 0) continue;
          var x0 = Math.max(er.left, r.left), x1 = Math.min(er.right, r.right), y0 = Math.max(er.top, r.top), y1 = Math.min(er.bottom, r.bottom);
          if (x1 <= x0 || y1 <= y0) continue;
          var fg = parse(cs.color); if (!fg) continue;
          var bg = null; for (var p = el; p && p !== feature.parentElement; p = p.parentElement) { var b = parse(getComputedStyle(p).backgroundColor); if (b && b[3] >= 0.5) { bg = b; break; } }
          bg = bg ? [bg[0], bg[1], bg[2]] : SAND;
          var txt = over(fg, bg), cmin = 99;
          for (var yy = y0; yy < y1; yy += 5) for (var xx = x0; xx < x1; xx += 5) { var m = mulAt(xx, yy), cc = contrast(scale3(txt, m), scale3(bg, m)); if (cc < cmin) cmin = cc; }
          seen++; strip = Math.min(strip, er.top - seamY);
          var isSlip = !!(el.closest && el.closest('.slip, [data-slip]'));
          if (isSlip) slipMin = Math.min(slipMin, cmin); else mutedMin = Math.min(mutedMin, cmin);
          worst.push({ t: (el.textContent || '').trim().slice(0, 18), c: +cmin.toFixed(2), slip: isSlip });
        }
      }
      worst.sort(function (a, b) { return a.c - b.c; });
      var stripPx = seen ? Math.max(0, strip - 8) : 100, zs = 99, zm = 99, ink70 = [INK[0], INK[1], INK[2], 0.7], inkOnBone = BONE;
      for (var py = Math.floor(stripPx * sy + OVPAD * sy); py < h; py += 2) for (var px2 = 0; px2 < w; px2 += 2) {
        var i2 = 4 * (py * w + px2), a2 = d[i2 + 3] / 255; if (a2 < 0.01) continue;
        var mm = [1 - a2 + a2 * d[i2] / 255, 1 - a2 + a2 * d[i2 + 1] / 255, 1 - a2 + a2 * d[i2 + 2] / 255];
        var cb = contrast(scale3(INK, mm), scale3(BONE, mm)); if (cb < zs) zs = cb;
        var uu = G.rtl ? (px2 / sx - OVPAD) : (G.W - (px2 / sx - OVPAD));
        if (uu >= 0.5 * G.W) { var cm_ = contrast(scale3(over(ink70, SAND), mm), scale3(SAND, mm)); if (cm_ < zm) zm = cm_; }
      }
      frame(performance.now(), { ovOnly: true, all: true, sun: fixedT != null || posterOn ? 1 : undefined });   // restore
      var f2 = function (v) { return v >= 99 ? null : +v.toFixed(2); };
      var real = Math.min(slipMin, mutedMin);
      return { min: f2(real), slipMin: f2(slipMin), mutedMin: f2(mutedMin), texts: seen, worst: worst.slice(0, 5), strip: Math.round(stripPx),
        zoneSlip: f2(zs), zoneMuted: f2(zm), spill: hex(SPILL_C), nearDark: hex(NEAR_D) };
    },
    // C4. The overlay's current frond-shade strength 0…1 at a VIEWPORT point (x, y): the vertical × horizontal fades ×
    // the frond alpha at that pixel (what the CSS blur then softens). 0 outside the band, 0 if the overlay is not drawn.
    // (The spill is excluded: it is light, not shade.) shadeAt(x, y) or shadeAt([[x, y], …]) → one number or an array.
    shadeAt: function (x, y) {
      if (!ov || !octx || !booted) return Array.isArray(x) ? x.map(function () { return 0; }) : 0;
      var r = ov.getBoundingClientRect(), pts = Array.isArray(x) ? x : [[x, y]], sx = ov.width / r.width, sy = ov.height / r.height;
      var out = frondRead(function (d, w) {
        return pts.map(function (p) {
          if (!r.width || p[0] < r.left || p[0] >= r.right || p[1] < r.top || p[1] >= r.bottom) return 0;
          var px = Math.min(w - 1, Math.floor((p[0] - r.left) * sx)), py = Math.min(ov.height - 1, Math.floor((p[1] - r.top) * sy));
          return +(d[4 * (py * w + px) + 3] / 255).toFixed(3);
        });
      }, true);
      return Array.isArray(x) ? out : out[0];
    },
    loseContext: function (restoreAfter) {
      var ext = gl && gl.getExtension('WEBGL_lose_context');
      if (!ext) return false;
      ext.loseContext();
      if (restoreAfter != null) setTimeout(function () { ext.restoreContext(); }, restoreAfter);
      return true;
    },
    // ?poster=1: the composed moment at full resolution, exported (alpha WebP) for assets/ambient/
    poster: function (quality) {
      if (!glOK) return null;
      measure();
      frame(performance.now(), { t: REDUCED_T, sun: 1, glOnly: true, all: true });
      return cv.toDataURL('image/webp', quality == null ? 0.9 : quality);
    },
    // DEPTH (round 2): the penumbra the shader really draws, measured on a synthetic straight edge. A bar is painted into the
    // mask (R = the crisp core layer, B = the whole-frond layer) with its edge at three sites that sit at growing distances
    // from the crown; the light's occlusion profile across that edge gives the 10–90% width, and r = width / 1.46 is the
    // equivalent disc radius (the unit of RAD). GL path only.
    depthProbe: function () {
      if (!heroReady() || posterOn || mode !== 'gl') return { why: 'no GL' };
      var sites = [{ u: 24, y: Math.round(G.H * 0.96) }].concat([0.06, 0.2, 0.34].map(function (f) { return { u: Math.round(f * G.W), y: Math.round(G.H * (0.74 - f * 0.9)) }; }));
      var cr = palms[0].crown, out = [], sx = cv.width / G.W, sy = cv.height / G.H;
      var render = function (kind, u0) {            // kind: 'none' | 'full' | 'core' | 'whole'
        mctx.setTransform(1, 0, 0, 1, 0, 0); mctx.globalCompositeOperation = 'source-over'; mctx.fillStyle = '#000'; mctx.fillRect(0, 0, mask.width, mask.height);
        if (kind !== 'none') {
          mctx.globalCompositeOperation = 'lighter'; mctx.setTransform(ms, 0, 0, ms, 0, 0);
          var x1 = kind === 'full' ? G.W + 50 : u0;
          if (kind !== 'whole') { mctx.fillStyle = '#ff0000'; mctx.fillRect(-50, -50, x1 + 50, maskH + 100); }
          if (kind !== 'core') { mctx.fillStyle = '#0000ff'; mctx.fillRect(-50, -50, x1 + 50, maskH + 100); }
        }
        glDraw(REDUCED_T, 1, 1, false);
        return readHero();
      };
      var Yat = function (b, u, y) {
        var xx = Math.max(0, Math.min(cv.width - 1, Math.round((G.rtl ? u : G.W - u) * sx))), yy = Math.max(0, Math.min(cv.height - 1, Math.round(y * sy)));
        var k = 4 * ((cv.height - 1 - yy) * cv.width + xx), c = composite(b, k); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
      };
      edgesAt(REDUCED_T);
      sites.forEach(function (s) {
        var rho = Math.hypot(s.u - cr.x, s.y - cr.y) / G.lref, r = { site: [s.u, s.y], rho: +rho.toFixed(2) };
        var none = render('none', 0), full = render('full', 0);
        ['core', 'whole'].forEach(function (kind) {
          var e = render(kind, s.u), prof = [];
          for (var du = -70; du <= 70; du += 0.5) {
            var u = s.u + du, yn = 0, yf = 0, ye = 0;
            for (var dy = -6; dy <= 6; dy += 3) { yn += Yat(none, u, s.y + dy); yf += Yat(full, u, s.y + dy); ye += Yat(e, u, s.y + dy); }
            prof.push([du, (yn - ye) / Math.max(1e-6, yn - yf)]);          // occlusion 0…1
          }
          var cross = function (lv) { for (var i = 1; i < prof.length; i++) if ((prof[i - 1][1] - lv) * (prof[i][1] - lv) <= 0) { var a = prof[i - 1], b = prof[i]; return a[0] + (b[0] - a[0]) * (lv - a[1]) / ((b[1] - a[1]) || 1e-6); } return null; };
          var p0 = prof[0][1], p1 = prof[prof.length - 1][1], lo = cross(p1 + 0.9 * (p0 - p1)), hi = cross(p1 + 0.1 * (p0 - p1)), wd = lo != null && hi != null ? Math.abs(hi - lo) : null;
          r[kind] = { width: wd == null ? null : +wd.toFixed(1), radius: wd == null ? null : +(wd / 1.46).toFixed(1) };
        });
        out.push(r);
      });
      frame(performance.now(), { all: true, sun: fixedT != null || posterOn ? 1 : undefined });   // restore the real frame
      return { sites: out, designRadii: { core: [RAD[0][0], RAD[0][1]], whole: [RAD[0][2], RAD[0][3]], far: FAR_R[0] }, note: 'width = 10–90% edge width in css px; radius = width / 1.46 (disc radius)' };
    },
    // WIND (round 2): the near fronds' chord angle (crown → tip) away from rest, in degrees, sampled every `step` s for `sec` s
    // from wind time t0 (default: this visit's start). p50/p95/p99/max of |dev| over every near frond, the gust events in
    // the window, and frond 1's series (for a loop / autocorrelation check).
    windStats: function (sec, step, t0, series) {
      sec = sec || 180; step = step || 0.25; t0 = t0 == null ? tOffset : t0;
      var near = palms.filter(function (p) { return !p.far; })[0], devs = [], ser = [];
      var rest = near.fronds.map(function (f) { frondGeom(near.crown, f, 0, 0, 0); return Math.atan2(geo.p2y - near.crown.y, geo.p2x - near.crown.x); });
      for (var t = t0; t < t0 + sec; t += step) {
        near.fronds.forEach(function (f, i) {
          frondGeom(near.crown, f, t, 1, 0);
          var dv = (Math.atan2(geo.p2y - near.crown.y, geo.p2x - near.crown.x) - rest[i]) * 180 / Math.PI;
          devs.push(Math.abs(dv)); if (i === 1 && series) ser.push(+dv.toFixed(3));
        });
      }
      devs.sort(function (a, b) { return a - b; });
      var pc = function (p) { return +devs[Math.min(devs.length - 1, Math.floor(p * devs.length))].toFixed(2); };
      var ev = []; for (var k = Math.floor(t0 / GUST_P) - 1; k <= Math.floor((t0 + sec) / GUST_P) + 1; k++) { var e = gustAt(k); if (e.T >= t0 && e.T <= t0 + sec) ev.push(+(e.T - t0).toFixed(1)); }
      return { t0: +t0.toFixed(1), sec: sec, p50: pc(0.5), p95: pc(0.95), p99: pc(0.99), max: +devs[devs.length - 1].toFixed(2), events: ev,
        spacing: ev.slice(1).map(function (v, i) { return +(v - ev[i]).toFixed(1); }), series: series ? ser : undefined };
    },
    // freeze the whole thing at wind time t (hero + desk shade, full sun; no loop) for time sheets; release() lets it run again
    hold: function (t) { stop(); fixedT = t == null ? REDUCED_T : t; frame(performance.now(), { all: true }); return fixedT; },
    release: function () { fixedT = (reduced || POSTER_MODE) ? REDUCED_T : null; if (fixedT == null) sync(); return fixedT; },
    plaster: function (k) { if (k != null) { PLASTER_K = +k; after(); } return PLASTER_K; },
    // a still at wind time t; arr (0…1) freezes the arrival at that progress (HERO-4 acceptance), default: full sun
    frame: function (t, arr) { frame(performance.now(), { t: t, all: true, sun: 1, arr: arr }); },
    // the hero canvas's pixels (premultiplied over espresso), for acceptance probes: {w, h, cssW, cssH, rgba: Uint8ClampedArray top-down}
    heroPixels: function () {
      if (!heroReady() || posterOn) return null;
      var b = readHero(), w = cv.width, h = cv.height, out = new Uint8ClampedArray(w * h * 4);
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var i = 4 * ((h - 1 - y) * w + x), c = composite(b, i), o = 4 * (y * w + x);
        out[o] = c[0]; out[o + 1] = c[1]; out[o + 2] = c[2]; out[o + 3] = 255;
      }
      return { w: w, h: h, cssW: G.W, cssH: G.H, rgba: out };
    },
  };
  window.__ambient = API;
  WF.debug.expose('ambient', function () { return { tier: tierName(), running: running, poster: posterOn, q: q }; });
});

})();
/* ── feature ── */
;(function(){
/* ==========================================================================
   feature.js — Concept A «سلّمها» THE HANDOVER DESK (SPEC-V2 §1.4 + REFINE-A §5). Owner: A-DESK.
   A sand desk under the palm's shade, covered in real jobs (every slip is a line of a real WF
   service, on its own paper stock). The visitor hands them over (drag down, click, tap, Enter/Space,
   or «سلّمنا الكل»); each one is tossed into its service's pocket on the espresso tray (which sits
   exactly over its plate), stands in the slot behind the lip, and a flat gold hallmark strikes it and
   cools into an impression. What stays on the desk is the reveal: «منتجك. عملاؤك.» and, once the last
   paper has landed, «والقرار الأخير.» rising into open light (desk:clear fires AT that landing: the
   shade is already leaving when the words arrive, 700ms later). Phones: the slip flies into a
   sticky follow-chip instead of below the fold.
   Motion is WAAPI only; nothing runs at rest (no rAF anywhere in this file).
   ========================================================================== */
WF.module('feature', function (root) {
  'use strict';
  if (!root) return;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  var pile = $('[data-desk-pile]'), group = $('[data-desk-slips]'), reveal = $('[data-desk-reveal]');
  var revealH = $('.reveal__h', reveal), partA = [$('.reveal__label', reveal), $('.reveal__a', reveal)];
  var lineB = $('.reveal__b', reveal), endRow = $('.reveal__end', reveal);
  var allBtn = $('[data-desk-all]'), resetBtn = $('[data-desk-reset]'), hint = $('#feature-hint');
  var chip = $('[data-desk-chip]'), chipBase = $('.desk__chipt', chip), chipFiled = $('[data-desk-chipf]', chip);
  if (!pile || !group || !reveal) return;

  var mqNarrow = matchMedia('(max-width: 767px)');
  var mqFine = matchMedia('(hover: hover) and (pointer: fine)');
  var SVC = ['manage', 'launch', 'social'];
  var HOLD = 1200, LIFT_MS = 180, LIFT_PX = 14, RESET_STAGGER = 60;
  // the sweep is dealt, not metronomed: launch intervals shorten, a breath before the last paper (which flies longer)
  var SWEEP = [340, 300, 260, 230, 210, 200, 200, 200], SWEEP_PAUSE = 180, LAST_EXTRA = 120, SWEEP_CAP = 3400;
  var BEAT = 700, SLIDE = 90, DROP = 10, CHIP_STAMP = 700;

  /* ── state ─────────────────────────────────────────────────────────────── */
  var slips = $$('.slip', group).map(function (el, i) {
    var m = /slip--(form|card|note|strip)/.exec(el.className);
    return { el: el, id: el.getAttribute('data-slip'), svc: el.getAttribute('data-svc'), key: 'feature.s.' + el.getAttribute('data-slip'),
      stock: m ? m[1] : 'form', wide: el.classList.contains('slip--wide'), src: i, x: 0, y: 0, r: 0, w: 0, h: 0, nx: 0, ny: 0, z: 1,
      gone: false, moved: false, held: false, card: null, flight: null, ghost: null, k: 0.9, cr: 0, over: 0, staging: false };
  });
  var pockets = {};
  $$('.pocket').forEach(function (li) {
    var id = li.getAttribute('data-pocket');
    pockets[id] = { li: li, paper: $('.pocket__paper', li), stack: $('.pocket__stack', li) };
  });
  var st = { a: false, b: false, sweeping: false, timers: [], zTop: 20, busy: 0, order: [], goldStamp: null, goldTimer: 0,
    chipTimer: 0, resetting: false, lastW: 0, handed: [], beat: 0, launches: [], launchIds: [], stageP: null, sweepId: 0, chipStamp: null };

  var narrow = function () { return mqNarrow.matches; };
  var active = function () { return slips.filter(function (s) { return !(s.wide && narrow()); }); };
  var remaining = function () { return active().filter(function (s) { return !s.gone; }); };
  var rtl = function () { return WF.lang !== 'en'; };
  var svcName = function (id) { return WF.t('core.svc.' + id + '.name'); };
  // «وش ننزل هالأسبوع؟» inside «…: {slip}. …» must not read «؟.»
  var tidy = function (str) { return str.replace(/([؟?])\./g, '$1'); };

  /* ── geometry: rotated rects and a separating-axis test ────────────────── */
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  // corners of a local box [x0,y0,x1,y1] (origin = slip centre) rotated by deg and moved to (cx, cy)
  function quad(b, cx, cy, deg) {
    var a = deg * Math.PI / 180, c = Math.cos(a), s = Math.sin(a);
    return [[b[0], b[1]], [b[2], b[1]], [b[2], b[3]], [b[0], b[3]]].map(function (p) {
      return [cx + p[0] * c - p[1] * s, cy + p[0] * s + p[1] * c];
    });
  }
  function overlap(P, Q) {
    var polys = [P, Q];
    for (var k = 0; k < 2; k++) {
      var poly = polys[k];
      for (var i = 0; i < 4; i++) {
        var p1 = poly[i], p2 = poly[(i + 1) % 4], nx = p2[1] - p1[1], ny = p1[0] - p2[0];
        var a0 = Infinity, a1 = -Infinity, b0 = Infinity, b1 = -Infinity, j, d;
        for (j = 0; j < 4; j++) { d = P[j][0] * nx + P[j][1] * ny; if (d < a0) a0 = d; if (d > a1) a1 = d; }
        for (j = 0; j < 4; j++) { d = Q[j][0] * nx + Q[j][1] * ny; if (d < b0) b0 = d; if (d > b1) b1 = d; }
        if (a1 <= b0 || b1 <= a0) return false;
      }
    }
    return true;
  }
  function measure(s) {
    // sub-pixel sizes (offsetWidth rounds down, and a clone 0.4px too narrow wraps its words)
    var cs = getComputedStyle(s.el);
    s.w = parseFloat(cs.width) || s.el.offsetWidth; s.h = parseFloat(cs.height) || s.el.offsetHeight;
    var t = s.el.firstElementChild;
    s.tb = [t.offsetLeft - s.w / 2, t.offsetTop - s.h / 2, t.offsetLeft + t.offsetWidth - s.w / 2, t.offsetTop + t.offsetHeight - s.h / 2];
  }
  var fullQ = function (s, x, y, r, pad) { pad = pad || 0; return quad([-s.w / 2 - pad, -s.h / 2 - pad, s.w / 2 + pad, s.h / 2 + pad], x, y, r); };
  var textQ = function (s, x, y, r) { return quad([s.tb[0] - 2, s.tb[1] - 2, s.tb[2] + 2, s.tb[3] + 2], x, y, r); };
  // half extents of the rotated box (its axis-aligned bounds)
  function ext(s, r) {
    var a = Math.abs(r) * Math.PI / 180, c = Math.cos(a), n = Math.sin(a);
    return [(s.w * c + s.h * n) / 2, (s.w * n + s.h * c) / 2];
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var smooth = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
  var sstep = function (a, b, x) { return smooth((x - a) / (b - a)); };

  /* ── where the palm's shade lives (the closed form of SPEC §1.3's fades; compose() uses only this) ── */
  function shadeFade(x, y) {
    var fr = root.getBoundingClientRect(), pr = pile.getBoundingClientRect();
    var band = parseFloat(getComputedStyle(root).getPropertyValue('--amb-band')) || 560;
    var yTop = pr.top - fr.top + y, px = pr.left - fr.left + x, u = rtl() ? px : fr.width - px;
    return (1 - sstep(0.45 * band, band, yTop)) * (1 - sstep(0.30 * fr.width, 0.62 * fr.width, u));
  }

  /* ── the composed mess: mulberry32(1447), every slip's text fully uncovered ── */
  // Desktop: a best-candidate scatter (each slip takes the spot farthest from the paper already down,
  // leaning toward the palm's shade, so the pile reaches the desk's edges and the afternoon falls on it);
  // paper may lap paper, never another slip's words.
  var layoutCache = {};
  var layoutKey = function () { return pile.clientWidth + 'x' + pile.clientHeight + '|' + (WF.lang || 'ar') + '|' + (narrow() ? 'm' : 'd'); };
  function compose(force) {
    var act = active(), R = mulberry32(1447);
    act.forEach(measure);
    if (narrow()) composePhone(act, R);
    else {
      // the same room, the same desk: a layout is composed once and kept (the reset, a language round-trip) until the room changes
      var key = layoutKey(), hit = !force && layoutCache[key];
      if (hit && act.every(function (s) { return hit[s.id]; })) {
        pile.style.minHeight = '';
        var W = pile.clientWidth, H = pile.clientHeight;
        act.forEach(function (s, i) { var p = hit[s.id]; s.x = p.x; s.y = p.y; s.r = p.r; s.z = i + 1; s.moved = false; s.nx = s.x / W; s.ny = s.y / H; });
      } else {
        composeDesk(act, R);
        var snap = {}; act.forEach(function (s) { snap[s.id] = { x: s.x, y: s.y, r: s.r }; });
        layoutCache[key] = snap;
      }
    }
    st.zTop = act.length + 1;
    readingOrder();
    act.forEach(place);
  }
  // Where the palm's shade really falls on the pile (the hero's overlay, read back through __ambient.shadeAt), as a lookup on an 8px
  // grid. The fronds drift and sway, so one instant's shade says little: once several samples have been taken (sampleShade) the map
  // is their per-cell MEAN, i.e. how much of the time a spot is under a frond. Null while the overlay is not drawn; only trusted
  // once the sun is fully up (max ≥ .8). Until then the closed form of SPEC §1.3 stands in.
  var acc = { key: '', sum: null, n: 0 };
  function shadeGrid(W, H) {
    var A = window.__ambient;
    if (!A || typeof A.shadeAt !== 'function') return null;
    var pr = pile.getBoundingClientRect(), G = 8, cols = Math.ceil(W / G) + 1, rows = Math.ceil(H / G) + 1, pts = [], i, j;
    for (j = 0; j < rows; j++) for (i = 0; i < cols; i++) pts.push([pr.left + i * G, pr.top + j * G]);
    var v;
    try { v = A.shadeAt(pts); } catch (e) { return null; }
    var mx = 0; for (i = 0; i < v.length; i++) if (v[i] > mx) mx = v[i];
    return { v: v, max: mx, cols: cols, rows: rows, G: G };
  }
  function sampleShade() {
    var g = shadeGrid(pile.clientWidth, pile.clientHeight);
    if (!g || g.max < 0.8) return false;
    var key = layoutKey();
    if (acc.key !== key || !acc.sum || acc.sum.length !== g.v.length) acc = { key: key, sum: g.v.slice(), n: 1 };
    else { for (var i = 0; i < g.v.length; i++) acc.sum[i] += g.v[i]; acc.n++; }
    return true;
  }
  function shadeMap(W, H) {
    var g = shadeGrid(W, H);
    if (!g || g.max < 0.1) return null;
    var persistent = acc.key === layoutKey() && acc.n >= 8 && acc.sum && acc.sum.length === g.v.length;
    var v = g.v, cols = g.cols, rows = g.rows, G = g.G, i, j;
    if (persistent) { v = new Array(g.v.length); for (i = 0; i < v.length; i++) v[i] = acc.sum[i] / acc.n; }
    var at = function (x, y) { var c = clamp(Math.round(x / G), 0, cols - 1), r = clamp(Math.round(y / G), 0, rows - 1); return v[r * cols + c]; };
    // the centre and four points 14px around it: a paper sits in shade when its middle does, not by one lucky pixel
    var smooth5 = function (x, y) { return 0.5 * at(x, y) + 0.125 * (at(x - 14, y) + at(x + 14, y) + at(x, y - 14) + at(x, y + 14)); };
    var hot = [], cut = persistent ? 0.4 : 0.5;
    for (j = 0; j < rows; j += 2) for (i = 0; i < cols; i += 2) if (smooth5(i * G, j * G) >= cut) hot.push([i * G, j * G]);
    return { max: g.max, at: smooth5, hot: hot, persistent: persistent };
  }
  function composeDesk(act, R) {
    pile.style.minHeight = '';
    var W = pile.clientWidth, H = pile.clientHeight, placed = [];
    var sm = shadeMap(W, H), real = sm && sm.max >= 0.8 ? sm.at : null, shadeOf = real || shadeFade, hot = real && sm.hot.length > 12 ? sm.hot : null;
    var bx = rtl() ? 0.40 : 0.60, by = 0.38, PULL = 0.35, CAP = 1.55, SEEK = 8;
    // the six smallest papers go looking for the shade (where the afternoon already is: small ones fit its cramped corners); the big
    // ones spread out to the desk's edges. Placement order is by size; the stacking order stays the page's own.
    var order = act.slice().sort(function (a, b) { return a.w * a.h - b.w * b.h; });
    order.forEach(function (s, i) {
      var best = null, bestScore = -Infinity, seek = i < SEEK, SHW = real ? (seek ? 1.5 : 0.15) : (seek ? 0.9 : 0.12);
      for (var k = 0; k < (seek ? 480 : 220); k++) {
        var r = (R() < 0.5 ? -1 : 1) * (0.8 + R() * 4), e = ext(s, r);
        var u = e[0] + 6 + R() * Math.max(1, W - 2 * e[0] - 12), v = e[1] + 6 + R() * Math.max(1, H - 2 * e[1] - 12), x, rr = rtl() ? -r : r;
        if (hot && seek && k % 5 < 4) {
          // most of a shade-seeker's tries are around the deepest shade (inside the shaded cells, jittered)
          var hp = hot[Math.floor(R() * hot.length)];
          x = clamp(hp[0] + (R() - 0.5) * 24, e[0] + 6, W - e[0] - 6); v = clamp(hp[1] + (R() - 0.5) * 24, e[1] + 6, H - e[1] - 6);
        } else x = rtl() ? W - u : u;
        var P = fullQ(s, x, v, rr, 3), ok = true, dmin = Infinity;
        for (var j = 0; j < placed.length && ok; j++) {
          var q = placed[j];
          if (overlap(P, q.tq)) ok = false;
          var dx = (x - q.x) / ((s.w + q.s.w) / 2), dy = (v - q.y) / ((s.h + q.s.h) / 2 + 26);
          dmin = Math.min(dmin, Math.hypot(dx, dy));
        }
        if (!ok) continue;
        var mid = Math.hypot((x - bx * W) / W, (v - by * H) / H);
        var score = (placed.length ? (seek ? -Math.abs(Math.min(dmin, 3) - 0.8) * 0.6 : Math.min(dmin, CAP)) : 0) + SHW * shadeOf(x, v) - mid * PULL * (seek ? 0.3 : 1) + R() * 0.04;
        if (score > bestScore) { bestScore = score; best = { x: x, y: v, r: rr }; }
      }
      if (!best) best = { x: W / 2, y: H / 2, r: 0 };
      s.x = best.x; s.y = best.y; s.r = best.r; s.z = act.indexOf(s) + 1; s.moved = false;
      s.nx = s.x / W; s.ny = s.y / H;
      placed.push({ s: s, x: s.x, y: s.y, tq: textQ(s, s.x, s.y, s.r) });
    });
    stretchY(act, H);
  }
  // the pile reaches the desk's floor: if the lowest paper stops short, open the rows out (vertical gaps only grow,
  // so no word is ever covered; the result is checked and abandoned if one is)
  function stretchY(act, H) {
    var y0 = Infinity, y1 = -Infinity, TOP = 8, BOT = 34;
    act.forEach(function (s) { fullQ(s, s.x, s.y, s.r, 0).forEach(function (q) { y0 = Math.min(y0, q[1]); y1 = Math.max(y1, q[1]); }); });
    var k = (H - TOP - BOT) / (y1 - y0);
    if (!(k > 1.02)) return;
    var keep = act.map(function (s) { return s.y; });
    act.forEach(function (s) { s.y = TOP + (s.y - y0) * k; });
    var bad = act.some(function (s) { return act.some(function (o) { return o !== s && s.z > o.z && overlap(fullQ(s, s.x, s.y, s.r, 0), textQ(o, o.x, o.y, o.r)); }); });
    if (bad) act.forEach(function (s, i) { s.y = keep[i]; });
    act.forEach(function (s) { s.ny = s.y / H; });
  }
  // Phone: a two-up staggered scatter on a jittered grid (one column below ~300px); the pile is as tall as its rows
  function composePhone(act, R) {
    var W = pile.clientWidth, cols = W < 300 ? 1 : 2, rows = [], y = 12, GAP = 10, i;
    for (i = 0; i < act.length; i += cols) rows.push(act.slice(i, i + cols));
    rows.forEach(function (row, ri) {
      var rh = Math.max.apply(null, row.map(function (s) { return s.h; }));
      row.forEach(function (s, ci) {
        var r = (R() < 0.5 ? -1 : 1) * (0.7 + R() * 1.7), e = ext(s, r);
        var colW = W / cols, cx = (ci + 0.5) * colW + (cols > 1 ? (ri % 2 ? 1 : -1) * 7 : 0) + (R() - 0.5) * 8;
        cx = clamp(cx, e[0] + 4, W - e[0] - 4);
        var cy = y + rh / 2 + (R() - 0.5) * 8;
        s.x = rtl() ? W - cx : cx; s.y = cy; s.r = rtl() ? -r : r; s.moved = false; s.z = ri * cols + ci + 1;
        s.nx = s.x / W;
      });
      y += rh + GAP;
    });
    var need = Math.ceil(y + 6);
    pile.style.minHeight = Math.max(300, need) + 'px';
    var H = pile.clientHeight;
    act.forEach(function (s) { s.ny = s.y / H; });
  }
  // reading order = rows top to bottom, then inline-start first; the DOM (tab order) follows it
  function readingOrder() {
    var act = active().slice().sort(function (a, b) { return a.y - b.y; }), rows = [];
    act.forEach(function (s) {
      var row = rows[rows.length - 1];
      if (row && Math.abs(s.y - row[0].y) < s.h * 0.75) row.push(s); else rows.push([s]);
    });
    st.order = [];
    rows.forEach(function (row) {
      row.sort(function (a, b) { return rtl() ? b.x - a.x : a.x - b.x; });
      st.order = st.order.concat(row);
    });
    var focused = group.contains(document.activeElement) ? document.activeElement : null;
    st.order.forEach(function (s) { group.appendChild(s.el); });
    slips.forEach(function (s) { if (st.order.indexOf(s) < 0) group.appendChild(s.el); });
    if (focused && document.activeElement !== focused) focused.focus({ preventScroll: true });
  }
  function place(s) {
    s.el.style.zIndex = String(s.z);
    s.el.style.transform = 'translate(' + (s.x - s.w / 2).toFixed(1) + 'px,' + (s.y - s.h / 2).toFixed(1) + 'px) rotate(' + s.r.toFixed(2) + 'deg)' + (s.held ? ' scale(1.03)' : '');
  }
  function relayout(force) {
    if (!root.classList.contains('is-desk')) return;
    var keep = active().filter(function (s) { return s.moved; });
    var saved = keep.map(function (s) { return { s: s, nx: s.nx, ny: s.ny, r: s.r, z: s.z }; });
    compose(force === true);
    var W = pile.clientWidth, H = pile.clientHeight;
    saved.forEach(function (k) { var s = k.s, e = ext(s, k.r); s.moved = true; s.r = k.r; s.z = k.z;
      s.x = clamp(k.nx * W, e[0], W - e[0]); s.y = clamp(k.ny * H, e[1], H - e[1]); s.nx = k.nx; s.ny = k.ny; place(s); });
    if (st.a) keepOut(false);
    st.lastW = W; st.lastH = H;
  }

  /* ── the reveal's keep-out: never painted under a slip ─────────────────── */
  function keepRect() {
    var pr = pile.getBoundingClientRect(), box = null;
    partA.concat([lineB.parentNode, endRow]).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      box = box ? [Math.min(box[0], r.left), Math.min(box[1], r.top), Math.max(box[2], r.right), Math.max(box[3], r.bottom)] : [r.left, r.top, r.right, r.bottom];
    });
    if (!box) return null;
    var m = 12;
    return [[box[0] - pr.left - m, box[1] - pr.top - m], [box[2] - pr.left + m, box[1] - pr.top - m],
      [box[2] - pr.left + m, box[3] - pr.top + m], [box[0] - pr.left - m, box[3] - pr.top + m]];
  }
  var covering = function (K) { return remaining().filter(function (s) { return !s.flight && overlap(fullQ(s, s.x, s.y, s.r, 2), K); }); };
  // move the slips that sit on the reveal to the nearest free spots (a short glide), then resolve
  function keepOut(animate) {
    var K = keepRect();
    if (!K) return Promise.resolve();
    var cover = covering(K);
    if (!cover.length) return Promise.resolve();
    var W = pile.clientWidth, H = pile.clientHeight, R = mulberry32(2026), moves = [];
    var others = remaining().filter(function (s) { return cover.indexOf(s) < 0; });
    cover.forEach(function (s) {
      var best = null, bestD = Infinity;
      for (var k = 0; k < 160; k++) {
        var r = (R() < 0.5 ? -1 : 1) * (0.8 + R() * 2.6), e = ext(s, r);
        var x = e[0] + 6 + R() * Math.max(1, W - 2 * e[0] - 12), y = e[1] + 6 + R() * Math.max(1, H - 2 * e[1] - 12);
        var P = fullQ(s, x, y, r, 3);
        if (overlap(P, K)) continue;
        var clash = others.some(function (o) { return overlap(P, textQ(o, o.x, o.y, o.r)); });
        if (clash) continue;
        var d = Math.hypot(x - s.x, y - s.y);
        if (d < bestD) { bestD = d; best = { x: x, y: y, r: r }; }
      }
      if (!best) return;
      var from = s.el.style.transform;
      s.x = best.x; s.y = best.y; s.r = best.r; s.z = ++st.zTop; s.moved = true; s.nx = s.x / W; s.ny = s.y / H;
      others.push(s);
      place(s);
      if (animate && !WF.reduced) moves.push(s.el.animate([{ transform: from }, { transform: s.el.style.transform }], { duration: 420, easing: WF.T.ease.slide }).finished.catch(function () {}));
    });
    return Promise.all(moves);
  }

  /* ── the sun-bleached patches where papers were ─────────────────────────── */
  function ghostOf(s) {
    if (s.ghost) return;
    var g = document.createElement('div');
    g.className = 'ghost'; g.setAttribute('aria-hidden', 'true');
    g.style.width = s.w + 'px'; g.style.height = s.h + 'px';
    g.style.transform = 'translate(' + (s.x - s.w / 2).toFixed(1) + 'px,' + (s.y - s.h / 2).toFixed(1) + 'px) rotate(' + s.r.toFixed(2) + 'deg)';
    pile.insertBefore(g, pile.firstChild);
    s.ghost = g;
    void g.offsetWidth;                               // commit opacity 0, then fade in (no rAF)
    g.classList.add('is-in');
  }
  function clearGhosts() {
    slips.forEach(function (s) { if (s.ghost) { s.ghost.remove(); s.ghost = null; } });
    root.classList.remove('is-dim');
  }

  /* ── the tray: papers, stacks, the hallmark ────────────────────────────── */
  function makeCard(s) {
    var li = document.createElement('li');
    li.className = 'card';
    li.setAttribute('data-card', s.id);
    li.setAttribute('data-stock', s.stock);
    var t = document.createElement('span');
    t.className = 'card__t'; t.setAttribute('data-i18n', s.key); t.textContent = WF.t(s.key);
    var mk = document.createElement('span');
    mk.className = 'card__stamp'; mk.setAttribute('aria-hidden', 'true');
    li.appendChild(t); li.appendChild(mk);
    return li;
  }
  // the filed paper is the slip's own paper: about .9 of it, never narrower than its words, never past slip + 16px,
  // a little off-centre (±8px) and a little askew (±1.2°), seeded by the slip so it is the same every time
  function sizeCard(s, card) {
    var R = mulberry32(900 + s.src * 7);
    card.style.width = 'max-content';
    var nat = Math.ceil(card.getBoundingClientRect().width) + 1;
    card.style.width = '';
    var cap = s.w + 16, w = Math.min(Math.max(s.w * 0.9, nat), cap);
    card.classList.toggle('is-wrap', nat > cap);
    s.k = w / s.w; s.cr = (R() * 2.4 - 1.2);
    card.style.setProperty('--cw', w.toFixed(1) + 'px');
    card.style.setProperty('--ch', (s.h * s.k).toFixed(1) + 'px');
    card.style.setProperty('--jx', (R() * 16 - 8).toFixed(1) + 'px');
    card.style.setProperty('--jr', s.cr.toFixed(2) + 'deg');
    card.style.setProperty('--up', '0px');
  }
  // newest in front; each older paper stands 4px higher, at most 3 edges drawn
  function restack(p) {
    var cards = $$('.card', p.stack).filter(function (c) { return !c.classList.contains('is-pending'); }), n = cards.length;
    cards.forEach(function (c, i) {
      var d = n - 1 - i;
      c.style.setProperty('--up', Math.min(d, 3) * 4 + 'px');
      c.classList.toggle('is-under', d > 0);
      c.classList.toggle('is-deep', d > 3);
    });
    p.li.classList.toggle('has-cards', n > 0);
  }
  var lipPx = function (p) { return parseFloat(getComputedStyle(p.paper).getPropertyValue('--lip')) || 22; };
  // how far (px) the bottom of a paper centred at (cy) with height h hangs below the top of the pocket's lip
  var overhang = function (p, cy, h) { return cy + h / 2 - (p.paper.getBoundingClientRect().bottom - lipPx(p)); };
  function cool(mk, snap) {
    if (!mk) return;
    if (snap) mk.classList.add('is-snap');
    mk.classList.add('is-cool');
    if (snap) { mk.removeAttribute('data-gold'); void mk.offsetWidth; mk.classList.remove('is-snap'); }
    else setTimeout(function () { mk.removeAttribute('data-gold'); }, WF.T.fade + 20);
  }
  // contact: the hallmark strikes (1.5 → 1 in 110ms), the lip dips 2px for 70ms and returns, the paper settles with a 4px
  // overshoot, a bone ring pulses on the pocket (no second gold). ≤ 1 gold stamp exists at any time.
  function strike(card, p) {
    var mk = $('.card__stamp', card);
    // one gold stamp at a time: the one before cools on this frame
    if (st.goldStamp && st.goldStamp !== mk) cool(st.goldStamp, true);
    clearTimeout(st.goldTimer);
    if (WF.reduced) { cool(mk, true); st.goldStamp = null; return; }
    mk.classList.remove('is-cool');
    mk.setAttribute('data-gold', 'event');
    st.goldStamp = mk;
    mk.animate([{ transform: 'scale(1.5) rotate(-6deg)', opacity: 0 }, { transform: 'scale(1.2) rotate(-4deg)', opacity: 1, offset: 0.45 },
      { transform: 'scale(1) rotate(-2deg)', opacity: 1 }], { duration: 110, easing: WF.T.ease.strike });
    try {
      p.paper.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(2px)', offset: 0.5 }, { transform: 'translateY(0)' }],
        { duration: 140, easing: 'ease-out', pseudoElement: '::after' });
      p.paper.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 460, easing: 'ease-out', pseudoElement: '::before' });
    } catch (e) { /* no pseudo-element animation: the contact simply has no lip dip */ }
    card.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(4px)', offset: 0.4 }, { transform: 'translateY(0)' }],
      { duration: 140, easing: 'ease-out', composite: 'add' });
    st.goldTimer = setTimeout(function () { if (st.goldStamp === mk) { cool(mk, false); st.goldStamp = null; } }, HOLD);
  }

  /* ── flights (WAAPI keyframes sampled along an arc) ────────────────────── */
  function cubic(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    var sx = function (t) { return ((ax * t + bx) * t + cx) * t; }, sy = function (t) { return ((ay * t + by) * t + cy) * t; };
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var lo = 0, hi = 1, t = x;
      for (var i = 0; i < 30; i++) { if (sx(t) < x) lo = t; else hi = t; t = (lo + hi) / 2; }
      return sy(t);
    };
  }
  var easeIn = cubic(0.55, 0, 0.9, 0.4);
  // the toss: the first 62% of the time ease-out (it lifts and carries: 45% of the way), the last 38% ease-in
  // (it falls the other 55%, accelerating, and stops dead on contact)
  function toss(u) {
    if (u <= 0.62) { var a = u / 0.62; return 0.45 * (1 - (1 - a) * (1 - a)); }
    return 0.45 + 0.55 * easeIn((u - 0.62) / 0.38);
  }
  function bez(p0, p1, p2, t) { var m = 1 - t; return [m * m * p0[0] + 2 * m * t * p1[0] + t * t * p2[0], m * m * p0[1] + 2 * m * t * p1[1] + t * t * p2[1]]; }
  function makeClone(s) {
    var c = s.el.cloneNode(true);
    c.removeAttribute('data-lift'); c.removeAttribute('data-slip'); c.removeAttribute('aria-label');
    c.classList.remove('is-gone', 'is-held', 'is-in');
    c.classList.add('slip--fly');
    c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1');
    c.style.cssText = 'width:' + s.w + 'px;opacity:1';
    $$('[data-i18n]', c).forEach(function (n) { n.removeAttribute('data-i18n'); });
    root.appendChild(c);
    return c;
  }
  // The paper stays paper the whole way: same colour, same width; it only scales (from.s → to.s) and turns.
  // from/to: {cx, cy, r, s, h, over}  (over = px of the paper that hangs below the pocket's lip at that rest spot)
  // o: {lift, ms, map: 'toss'|'glide', drop (px: land that far above, then slide down behind the lip), rise (the reverse)}
  function fly(el, from, to, o) {
    var lift = o.lift ? LIFT_MS : 0, dur = o.ms, slideIn = o.drop ? SLIDE : 0, slideOut = o.rise ? SLIDE : 0;
    var total = slideOut + lift + dur + slideIn, kf = [], h = from.h, drop = o.drop || 0, rise = o.rise || 0;
    var clipOf = function (over, s) { return Math.max(0, over) / s; };
    var push = function (t, f) {
      kf.push({ offset: Math.min(1, t / total), transform: 'translate(' + (f.cx - el._w / 2).toFixed(1) + 'px,' + (f.cy - h / 2).toFixed(1) + 'px) rotate(' + f.r.toFixed(2) + 'deg) scale(' + f.s.toFixed(4) + ')',
        clipPath: 'inset(-80px -80px ' + (f.clip - 80 * Math.max(0, 1 - f.clip / 8)).toFixed(1) + 'px -80px)', opacity: f.o == null ? 1 : f.o });
    };
    el._w = from.w;
    var t = 0, i, n, q;
    // 1. the reverse: slide up out of the slot, clipped by the lip
    if (slideOut) {
      var c0 = clipOf(from.over, from.s), c1 = clipOf(from.over - rise, from.s);
      n = 4;
      for (i = 0; i <= n; i++) { q = WF.T.fn.slide(i / n); push(i / n * SLIDE, { cx: from.cx, cy: from.cy - rise * q, r: from.r, s: from.s, clip: lerp(c0, c1, q) }); }
      t = SLIDE;
    }
    var y0 = from.cy - rise, outClip = slideOut ? clipOf(from.over - rise, from.s) : 0;
    // 2. the lift (a resisted 14px, a quarter-turn toward square)
    if (lift) {
      n = Math.max(4, Math.round(lift / 28));
      for (i = 1; i <= n; i++) {
        q = WF.T.fn.lift(i / n);
        push(t + (i / n) * lift, { cx: from.cx, cy: y0 - LIFT_PX * q, r: lerp(from.r, from.r * 0.7, q), s: lerp(from.s, from.s * 1.02, q), clip: outClip * (1 - q) });
      }
      t += lift;
    }
    // 3. the flight
    var p0 = [from.cx, y0 - (lift ? LIFT_PX : 0)], p2 = [to.cx, to.cy - drop];
    var dist = Math.hypot(p2[0] - p0[0], p2[1] - p0[1]);
    var p1 = [lerp(p0[0], p2[0], 0.3), Math.min(p0[1], p2[1]) - Math.min(140, 40 + dist * 0.14)];
    var s0 = from.s * (lift ? 1.02 : 1), r0 = from.r * (lift ? 0.7 : 1);
    var landClip = drop ? clipOf(to.over - drop, to.s) : 0;
    n = Math.max(12, Math.round(dur / 28));
    for (i = 1; i <= n; i++) {
      var u = i / n, k = o.map === 'glide' ? WF.T.fn.glide(u) : toss(u), pt = bez(p0, p1, p2, k);
      push(t + u * dur, { cx: pt[0], cy: pt[1], r: lerp(r0, to.r, k), s: lerp(s0, to.s, k), clip: slideOut ? 0 : landClip * smooth((u - 0.8) / 0.2),
        o: to.o == null ? 1 : lerp(1, to.o, smooth((k - 0.7) / 0.3)) });
    }
    t += dur;
    // 4. the landing: 10px above its spot, it slides down behind the lip (the lip clips what goes in)
    if (slideIn) {
      var d0 = landClip, d1 = clipOf(to.over, to.s);
      n = 4;
      for (i = 1; i <= n; i++) { q = WF.T.fn.slide(i / n); push(t + i / n * SLIDE, { cx: to.cx, cy: to.cy - drop * (1 - q), r: to.r, s: to.s, clip: lerp(d0, d1, q) }); }
    }
    kf[0].offset = 0; kf[kf.length - 1].offset = 1;
    return el.animate(kf, { duration: total, easing: 'linear', fill: 'forwards' });
  }
  var flightMs = function (d) { return Math.round(clamp(520 + d * 0.2, 520, 700)); };

  /* ── keeping the payoff in frame ───────────────────────────────────────── */
  // Once, only when the pocket is below the fold, never under a gesture, never on a short screen, never > 240px:
  // a smooth nudge so the paper lands where the eye is. Resolves when the scroll settles (scrollend, or 520ms).
  var headerH = function () { var h = document.getElementById('wf-header'); return h ? h.getBoundingClientRect().height : 64; };
  function stage(p, topY) {
    if (WF.reduced || narrow() || window.innerHeight < 600 || held) return null;
    if (st.stageP) return st.stageP;
    var pb = p.paper.getBoundingClientRect().bottom, limit = window.innerHeight - 20;
    if (pb <= limit) return null;
    var delta = Math.min(pb - limit, Math.max(0, topY - (headerH() + 16)), 240);
    if (delta <= 12) return null;
    st.stageP = new Promise(function (resolve) {
      var done = false, fin = function () { if (done) return; done = true; window.removeEventListener('scrollend', fin); st.stageP = null; resolve(); };
      window.addEventListener('scrollend', fin);
      setTimeout(fin, 520);
      window.scrollBy({ top: delta, behavior: 'smooth' });
    });
    return st.stageP;
  }

  /* ── hand over ─────────────────────────────────────────────────────────── */
  function handOver(s, o) {
    o = o || {};
    if (s.gone || s.staging || st.resetting) return;
    var p = pockets[s.svc], text = WF.t(s.key), name = svcName(s.svc);
    if (!o.staged) {
      var pre = stage(p, s.el.getBoundingClientRect().top);
      if (pre) {
        s.staging = true;
        pre.then(function () { s.staging = false; o.staged = true; handOver(s, o); });
        return;
      }
    }
    var pr = pile.getBoundingClientRect(), from = { cx: pr.left + s.x, cy: pr.top + s.y, r: s.r, w: s.w, h: s.h, s: 1 };
    var focusIn = document.activeElement === s.el;
    s.gone = true; s.held = false;
    st.handed.push(s);
    st.launches.push(Math.round(performance.now())); st.launchIds.push(s.id + ":" + s.svc);
    s.el.classList.remove('is-held');
    s.el.classList.add('is-gone');
    ghostOf(s);
    var card = makeCard(s);
    s.card = card;
    p.stack.appendChild(card);
    sizeCard(s, card);
    WF.live(tidy(WF.t('feature.live', { slip: text, service: name })));
    if (o.keyboard || focusIn) focusNext(s);

    var phone = narrow(), animate = !WF.reduced;
    if (phone || !animate) {
      // phones file the paper without animation (the chip carries the motion); reduced: instant, already cooled
      restack(p);
      cool($('.card__stamp', card), true);
      if (phone && animate) toChip(s, from, o);
      else if (phone) chipSays(text);
      update();
      return;
    }
    card.classList.add('is-pending');
    var cr = card.getBoundingClientRect(), k = s.k, ch = s.h * k;
    s.over = overhang(p, cr.top + cr.height / 2, ch);
    var to = { cx: cr.left + cr.width / 2, cy: cr.top + cr.height / 2, r: s.cr, s: k, over: s.over };
    var d = Math.hypot(to.cx - from.cx, to.cy - from.cy);
    var c = makeClone(s), a = fly(c, from, to, { lift: !o.pointer, ms: flightMs(d) + (o.extra || 0), map: 'toss', drop: DROP });
    s.flight = a; st.busy++;
    update();
    a.finished.then(function () {
      s.flight = null; st.busy--;
      card.classList.remove('is-pending');
      restack(p);
      strike(card, p);
      c.remove();
      update();
    }).catch(function () { s.flight = null; st.busy--; c.remove(); });
  }
  // phone: the slip flies into the follow-chip (never below the fold); the chip takes IMPACT and a gold stamp, then speaks
  function toChip(s, from, o) {
    var r = chip.getBoundingClientRect();
    if (!r.width) { chipSays(WF.t(s.key)); update(); return; }
    var to = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, r: 0, s: 0.6, o: 0.85 };
    var c = makeClone(s), a = fly(c, from, to, { lift: !o.pointer, ms: flightMs(Math.hypot(to.cx - from.cx, to.cy - from.cy)), map: 'toss' });
    s.flight = a; st.busy++;
    a.finished.then(function () { s.flight = null; st.busy--; c.remove(); chipStamps(WF.t(s.key)); update(); })
      .catch(function () { s.flight = null; st.busy--; c.remove(); });
  }
  // the chip takes IMPACT and a 22×16 gold stamp for 700ms (event-tagged, ≤ 1), and only then says what was filed
  function chipStamps(text) {
    if (!chip) return;
    clearTimeout(st.chipTimer);
    var mk = st.chipStamp;
    if (!mk) { mk = st.chipStamp = document.createElement('span'); mk.className = 'desk__stamp'; mk.setAttribute('aria-hidden', 'true'); mk.hidden = true; chip.appendChild(mk); }
    if (st.goldStamp && st.goldStamp !== mk) { cool(st.goldStamp, true); st.goldStamp = null; }
    chipFiled.textContent = WF.t('feature.chip.filed', { slip: text });
    WF.motion.impact(chip);
    if (WF.reduced) { chipFiled.hidden = false; chipBase.hidden = true; st.chipTimer = setTimeout(function () { chipFiled.hidden = true; chipBase.hidden = false; }, 1600); return; }
    mk.hidden = false; mk.setAttribute('data-gold', 'event'); st.goldStamp = mk;
    mk.animate([{ transform: 'scale(1.5) rotate(-6deg)', opacity: 0 }, { opacity: 1, offset: 0.45 }, { transform: 'scale(1) rotate(-2deg)', opacity: 1 }], { duration: 110, easing: WF.T.ease.strike });
    st.chipTimer = setTimeout(function () {
      mk.hidden = true; mk.removeAttribute('data-gold'); if (st.goldStamp === mk) st.goldStamp = null;
      chipFiled.hidden = false; chipBase.hidden = true;
      st.chipTimer = setTimeout(function () { chipFiled.hidden = true; chipBase.hidden = false; }, 1600);
    }, CHIP_STAMP);
  }
  function chipSays(text) {
    if (!chip) return;
    clearTimeout(st.chipTimer);
    chipFiled.textContent = WF.t('feature.chip.filed', { slip: text });
    chipFiled.hidden = false; chipBase.hidden = true;
    st.chipTimer = setTimeout(function () { chipFiled.hidden = true; chipBase.hidden = false; }, 1600);
  }
  function focusNext(s) {
    var order = st.order.filter(function (x) { return !x.gone && active().indexOf(x) > -1; });
    var i = st.order.indexOf(s), next = null;
    for (var j = 1; j <= st.order.length && !next; j++) { var c = st.order[(i + j) % st.order.length]; if (order.indexOf(c) > -1) next = c; }
    if (next) next.el.focus({ preventScroll: true });
    // none left: showB() moves focus to the reveal heading
  }

  /* ── thresholds: ≥ 60% handed → part A; last paper landed → desk:clear, then a beat, then part B ── */
  function update() {
    var act = active(), left = remaining().length, handed = act.length - left;
    if (allBtn) {
      var off = left === 0 || st.sweeping;
      allBtn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }
    if (!st.a && act.length && handed >= Math.ceil(act.length * 0.6)) tryA();
    // only when nothing is still in the air: the reveal never upstages the last landing
    if (!st.b && left === 0 && act.length && st.busy === 0) showB();
  }
  var pendingA = false;
  function tryA() {
    if (st.a || pendingA) return;
    var K = keepRect();
    var cover = K ? covering(K) : [];
    if (cover.length && st.sweeping) return;          // the sweep is taking them anyway: wait for the desk to clear the spot
    pendingA = true;
    keepOut(true).then(function () { pendingA = false; if (!st.a && !st.resetting) showA(); });
  }
  function showA() {
    st.a = true;
    reveal.classList.add('is-a');
    root.classList.add('is-dim');
    WF.motion.lift(partA, { stagger: 90, force: true });
  }
  function showB() {
    st.b = true;
    if (!st.a) showA();
    // C3: the shade leaves AT the last landing (the sun on the words arrives with it) ...
    root.classList.add('is-lit');
    WF.emit('desk:clear');
    // ... and the words rise into light that is already opening, one beat later
    var go = function () {
      st.beat = 0;
      if (!st.b || st.resetting) return;
      reveal.classList.add('is-b');
      root.classList.add('is-done');
      WF.motion.rise(lineB, { force: true });
      WF.motion.lift(endRow, { delay: 420, force: true });
      revealH.focus({ preventScroll: true });
      if (narrow()) centerReveal();
    };
    if (WF.reduced) go(); else st.beat = setTimeout(go, BEAT);
  }
  // phone: bring the payoff to the middle of the screen once, unless the reader's finger takes over
  function centerReveal() {
    if (WF.reduced) return;
    var a = revealH.getBoundingClientRect(), e = endRow.getBoundingClientRect(), hh = headerH();
    var r = { top: a.top, bottom: Math.max(a.bottom, e.bottom) }; r.height = r.bottom - r.top;
    if (r.top >= hh + 8 && r.bottom <= window.innerHeight - 8) return;
    var cancel = function () { window.removeEventListener('touchstart', cancel, true); try { window.scrollTo({ top: window.scrollY, behavior: 'instant' }); } catch (e) { /* ignore */ } };
    window.addEventListener('touchstart', cancel, { capture: true, once: true, passive: true });
    window.scrollTo({ top: window.scrollY + r.top + r.height / 2 - window.innerHeight / 2, behavior: 'smooth' });
  }

  /* ── «سلّمنا الكل»: every remaining slip, pocket by pocket, dealt (accelerando, a breath before the last) ── */
  function sweep() {
    if (st.sweeping || st.resetting) return;
    var left = st.order.filter(function (s) { return !s.gone && active().indexOf(s) > -1; });
    // each pocket fills in a run (reading order inside it)
    var list = [];
    SVC.forEach(function (id) { left.forEach(function (s) { if (s.svc === id) list.push(s); }); });
    if (!list.length) return;
    st.sweeping = true; update();
    if (WF.reduced) { list.forEach(function (s) { handOver(s, { sweep: true }); }); st.sweeping = false; update(); return; }
    var id = ++st.sweepId;
    // the cadence: cumulative launch times from the table, +180ms before the last; clamped so the whole deal stays ≤ 3.4s
    var at = [0], i;
    for (i = 1; i < list.length; i++) at.push(at[i - 1] + SWEEP[Math.min(i - 1, SWEEP.length - 1)] + (i === list.length - 1 && list.length > 2 ? SWEEP_PAUSE : 0));
    var last = at[at.length - 1] + 700 + LAST_EXTRA, f = last > SWEEP_CAP ? SWEEP_CAP / last : 1;
    var run = function () {
      if (id !== st.sweepId || st.resetting) return;
      var t0 = performance.now();
      // launch times are absolute (t0 + the table), so a heavy frame never squeezes the next interval
      var step = function (i) {
        if (id !== st.sweepId) return;
        if (i === list.length - 1) st.sweeping = false;
        handOver(list[i], { sweep: true, staged: true, extra: i === list.length - 1 && list.length > 1 ? LAST_EXTRA : 0 });
        if (!st.a) tryA();
        if (i + 1 < list.length) st.timers.push(setTimeout(function () { step(i + 1); }, Math.max(0, t0 + at[i + 1] * f - performance.now())));
      };
      step(0);
    };
    // one nudge before the first launch, so the whole deal lands in frame
    var topY = Math.min.apply(null, list.map(function (s) { return s.el.getBoundingClientRect().top; }));
    var pre = stage(pockets[list[0].svc], topY);
    if (pre) pre.then(run); else run();
  }

  /* ── «رجّع الأوراق»: papers come back out of their pockets (60ms stagger), desk:reset ── */
  function reset() {
    if (st.resetting) return;
    st.timers.forEach(clearTimeout); st.timers = []; st.sweeping = false; st.sweepId++;
    clearTimeout(st.beat); st.beat = 0;
    clearTimeout(st.goldTimer); st.goldStamp = null;
    st.resetting = true;
    var back = st.handed.slice(), phone = narrow(), animate = !WF.reduced;
    // where each paper is now, measured before anything moves
    var fromGeo = back.map(function (s) {
      var c = s.card, p = pockets[s.svc];
      if (!c || !animate || phone) return null;
      var r = c.getBoundingClientRect();
      return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, over: overhang(p, r.top + r.height / 2, s.h * s.k) };
    });
    back.forEach(function (s) { if (s.flight) { try { s.flight.finish(); } catch (e) { /* ignore */ } } });
    WF.emit('desk:reset');
    var fadeOut = animate ? reveal.animate([{ opacity: 1 }, { opacity: 0 }], { duration: WF.T.fade, easing: 'linear', fill: 'forwards' }).finished.catch(function () {}) : Promise.resolve();
    fadeOut.then(function () {
      reveal.classList.remove('is-a', 'is-b'); root.classList.remove('is-done', 'is-lit');
      st.a = st.b = false;
      reveal.getAnimations().forEach(function (a) { a.cancel(); });
      clearGhosts();
      st.handed = [];
      var keepCards = animate && !phone;
      if (!keepCards) { SVC.forEach(function (id) { pockets[id].stack.textContent = ''; restack(pockets[id]); }); slips.forEach(function (s) { s.card = null; }); }
      compose();
      var order = st.order.filter(function (s) { return back.indexOf(s) > -1; }), done = [];
      active().forEach(function (s) { if (back.indexOf(s) < 0) { s.gone = false; s.el.classList.remove('is-gone'); } });
      order.forEach(function (s, i) {
        var g = fromGeo[back.indexOf(s)];
        var finish = function () { s.gone = false; s.el.classList.remove('is-gone'); if (i === 0) s.el.focus({ preventScroll: true }); };
        if (!animate) { finish(); return; }
        if (phone || !g) {
          done.push(new Promise(function (res) { st.timers.push(setTimeout(function () { finish(); WF.motion.lift(s.el, { force: true }).then(res); }, i * RESET_STAGGER)); }));
          return;
        }
        var pr = pile.getBoundingClientRect();
        var from = { cx: g.cx, cy: g.cy, r: s.cr, w: s.w, h: s.h, s: s.k, over: g.over };
        var to = { cx: pr.left + s.x, cy: pr.top + s.y, r: s.r, s: 1 };
        done.push(new Promise(function (res) {
          st.timers.push(setTimeout(function () {
            // the paper leaves its pocket (the ones behind it close up) and rises out from behind the lip
            var p = pockets[s.svc], cd = s.card;
            if (cd) { cd.remove(); s.card = null; restack(p); }
            var c = makeClone(s), a = fly(c, from, to, { lift: false, rise: DROP, ms: flightMs(Math.hypot(to.cx - from.cx, to.cy - from.cy)), map: 'glide' });
            a.finished.then(function () { finish(); c.remove(); res(); }).catch(function () { finish(); c.remove(); res(); });
          }, i * RESET_STAGGER));
        }));
      });
      Promise.all(done).then(function () {
        st.resetting = false; st.timers = [];
        SVC.forEach(function (id) { pockets[id].stack.textContent = ''; restack(pockets[id]); });
        slips.forEach(function (s) { s.card = null; });
        update();
      });
    });
  }

  /* ── drag (mouse / pen only; touch is tap-only so the page always scrolls) ── */
  var held = null;
  function pocketAt(x, y) {
    for (var i = 0; i < SVC.length; i++) {
      var r = pockets[SVC[i]].li.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return pockets[SVC[i]];
    }
    return null;
  }
  var inZone = function (e) { return e.clientY > pile.getBoundingClientRect().bottom || !!pocketAt(e.clientX, e.clientY); };
  function target(s, on) { SVC.forEach(function (id) { pockets[id].li.classList.toggle('is-target', !!on && id === s.svc); }); }
  function onDown(e) {
    var s = this._slip;
    if (e.pointerType === 'touch' || e.button !== 0 || s.gone || st.resetting || !root.classList.contains('is-desk')) return;
    held = { s: s, id: e.pointerId, px: e.clientX, py: e.clientY, sx: s.x, sy: s.y, sr: s.r, drag: false, vx: 0, lx: e.clientX, lt: performance.now(), tilt: 0 };
    try { s.el.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
  }
  function onMove(e) {
    if (!held || e.pointerId !== held.id) return;
    var s = held.s, dx = e.clientX - held.px, dy = e.clientY - held.py;
    if (!held.drag) {
      if (Math.hypot(dx, dy) < 6) return;
      held.drag = true; s.held = true; s.el.classList.add('is-held'); s.z = ++st.zTop;
    }
    var now = performance.now(), dt = Math.max(8, now - held.lt);
    held.vx = held.vx * 0.7 + ((e.clientX - held.lx) / dt) * 0.3; held.lx = e.clientX; held.lt = now;
    // heavy paper: it leans a little into the pull, never swings
    held.tilt += (clamp(held.vx * 6, -8, 8) - held.tilt) * 0.35;
    s.x = held.sx + dx; s.y = held.sy + dy; s.r = held.sr * 0.5 + held.tilt;
    place(s);
    target(s, inZone(e));
  }
  function onUp(e, cancel) {
    if (!held || e.pointerId !== held.id) return;
    var h = held, s = h.s; held = null;
    target(s, false);
    if (!h.drag) return;                                 // a plain press is a click: it hands over
    s.suppress = true; setTimeout(function () { s.suppress = false; }, 0);
    s.held = false; s.el.classList.remove('is-held');
    if (!cancel && inZone(e)) { handOver(s, { pointer: true }); return; }
    // dropped on the desk: it stays where it lands (only pulled back inside the desk's edges)
    var W = pile.clientWidth, H = pile.clientHeight, ex;
    s.r = h.sr * 0.5 + h.tilt * 0.3; ex = ext(s, s.r);
    s.x = clamp(s.x, ex[0], W - ex[0]); s.y = clamp(s.y, ex[1], H - ex[1]);
    s.moved = true; s.nx = s.x / W; s.ny = s.y / H;
    place(s);
    if (st.a) keepOut(true);
  }

  /* ── wiring ────────────────────────────────────────────────────────────── */
  function label(s) {
    s.el.setAttribute('aria-label', tidy(WF.t('feature.slip.aria', { slip: WF.t(s.key), service: svcName(s.svc) })));
  }
  function setHint() {
    if (!hint) return;
    var key = mqFine.matches ? 'feature.hint.mouse' : 'feature.hint.touch';
    hint.setAttribute('data-i18n', key); hint.textContent = WF.t(key);
  }
  slips.forEach(function (s) {
    s.el._slip = s;
    label(s);
    s.el.addEventListener('click', function (e) {
      if (s.suppress) { s.suppress = false; return; }
      if (!root.classList.contains('is-desk')) return;
      handOver(s, { keyboard: e.detail === 0 });
    });
    s.el.addEventListener('pointerdown', onDown);
    s.el.addEventListener('pointermove', onMove);
    s.el.addEventListener('pointerup', function (e) { onUp(e, false); });
    s.el.addEventListener('pointercancel', function (e) { onUp(e, true); });
    s.el.addEventListener('lostpointercapture', function (e) { if (held && held.s === s) onUp(e, true); });
  });
  if (allBtn) allBtn.addEventListener('click', sweep);
  if (resetBtn) resetBtn.addEventListener('click', reset);

  // the follow-chip rides above the phone cart bar while it shows
  var bar = document.querySelector('#cartbar [data-cartbar-bar]');
  function chipLift() {
    if (!chip) return;
    var show = bar && !bar.hidden && narrow();
    chip.style.bottom = show ? (16 + bar.getBoundingClientRect().height) + 'px' : '';
  }
  if (bar && 'MutationObserver' in window) new MutationObserver(chipLift).observe(bar, { attributes: true, attributeFilter: ['hidden'] });

  var rt = 0;
  function onResize() {
    clearTimeout(rt);
    rt = setTimeout(function () { if (pile.clientWidth !== st.lastW) relayout(); chipLift(); }, 140);
  }
  window.addEventListener('resize', onResize);
  // the pile's height follows the words beside it (fonts, language): re-compose when it really changes
  if ('ResizeObserver' in window) new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(function () { if (Math.abs(pile.clientHeight - st.lastH) > 6 || pile.clientWidth !== st.lastW) relayout(); }, 140); }).observe(pile);
  var onNarrow = function () {
    // the phone shows six slips: re-count and re-compose; slips that crossed out of the set keep their state
    relayout(); chipLift(); update();
  };
  (mqNarrow.addEventListener ? mqNarrow.addEventListener('change', onNarrow) : mqNarrow.addListener(onNarrow));
  (mqFine.addEventListener ? mqFine.addEventListener('change', setHint) : mqFine.addListener(setHint));

  WF.on('lang', function () {
    slips.forEach(label);
    setHint();
    if (!chipFiled.hidden) chipFiled.hidden = true, chipBase.hidden = false;
    relayout();
  });

  root.classList.add('is-desk');
  setHint();
  compose();
  st.lastW = pile.clientWidth; st.lastH = pile.clientHeight;
  chipLift();
  update();
  WF.motion.reveal(root);

  // The pile is composed once against the closed form of the shade; as soon as the hero has drawn the real fronds, it is
  // composed again against them: once, silently, before anyone has touched the desk or has it on screen.
  var settled = false, settleTries = 0;
  var touched = function () { return st.handed.length > 0 || active().some(function (s) { return s.moved; }) || st.resetting || !!held; };
  var inView = function () { var r = pile.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; };
  function settle() {
    if (settled || touched() || narrow() || ++settleTries > 120) return;
    // the sun rises over ~4s after load; then a few seconds of sway are sampled; and never move paper that is on screen
    var up = sampleShade();
    if (!up || acc.n < 10 || inView()) { setTimeout(settle, 600); return; }
    settled = true; relayout(true);
  }
  WF.on('ambient:ready', function () { setTimeout(settle, 600); });
  setTimeout(settle, 1500);

  /* ── test surface (harmless) ───────────────────────────────────────────── */
  var api = {
    state: function () {
      return { active: active().length, left: remaining().length, a: st.a, b: st.b, sweeping: st.sweeping, resetting: st.resetting,
        order: st.order.map(function (s) { return s.id; }), gold: $$('.card__stamp[data-gold],.desk__stamp[data-gold]').length,
        cards: SVC.map(function (id) { return $$('.card', pockets[id].stack).length; }) };
    },
    give: function (n) { remaining().slice(0, n == null ? 1 : n).forEach(function (s) { handOver(s); }); },
    all: sweep, reset: reset, layout: relayout,
    slip: function (id) { var s = slips.filter(function (x) { return x.id === id; })[0]; return s ? { x: s.x, y: s.y, r: s.r, w: s.w, h: s.h, gone: s.gone, stock: s.stock } : null; },
    settled: function () { return settled; },
    launches: function () { return st.launches.slice(); }, launchIds: function () { return st.launchIds.slice(); },
    // composition numbers for the acceptance checks: bbox coverage, empties, text overlaps, closed-form shade at each centre
    metrics: function () {
      var act = active(), W = pile.clientWidth, H = pile.clientHeight, x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity, bad = 0;
      act.forEach(function (s) {
        var b = fullQ(s, s.x, s.y, s.r, 0);
        b.forEach(function (q) { x0 = Math.min(x0, q[0]); x1 = Math.max(x1, q[0]); y0 = Math.min(y0, q[1]); y1 = Math.max(y1, q[1]); });
        act.forEach(function (o) { if (o !== s && s.z > o.z && overlap(fullQ(s, s.x, s.y, s.r, 0), textQ(o, o.x, o.y, o.r))) bad++; });
      });
      return { W: W, H: H, covW: +((x1 - x0) / W).toFixed(3), covH: +((y1 - y0) / H).toFixed(3), emptyB: Math.round(H - y1), emptyT: Math.round(y0),
        emptyL: Math.round(x0), emptyR: Math.round(W - x1), textOverlaps: bad,
        shade: act.map(function (s) { return +shadeFade(s.x, s.y).toFixed(2); }), ids: act.map(function (s) { return s.id; }) };
    },
  };
  window.__desk = api;
  WF.debug.expose('feature', api.state);
});

})();
/* ── services ── */
;(function(){
/* ==========================================================================
   services.js — THE TRAVELLING HALLMARK (SPEC §3.3; round 2: SPEC-V2 §3.6)
   One gold Seal rests on the price of the plate you are looking at. It travels
   with WF.seal.strike (lift → near-stop → drop → contact → HOLD); «أضف للسلة»
   IS a strike: WF.cart.add runs on the contact frame, so the header count takes
   its IMPACT on that same frame. Plates it leaves keep a cooled (never gold) mark.
   Round 2: every strike runs at TEMPO 1.8 (slower travel, lift, near-stop and
   HOLD; the drop stays fast), hover dwell 260ms, phone stillness 400ms, and the
   `recommend` hand-off: WF.emit('recommend', {service}) makes that plate active
   and the Seal strikes it (no cart change); on contact the plate gains a cooled
   tag «من فحصك» for the rest of the visit.
   Plates are #svc-<id> (the features link and scroll to them).
   The detail overlay (slot `detail`) talks to the plates through two DOM events
   on the plate element: `wf-svc-variant` and `wf-svc-add` {variant}.
   ========================================================================== */
WF.module('services', function (root) {
  'use strict';
  var T = WF.T;
  // SPEC-V2 §3.6: the founder's one ask for his favourite section, "make the animation slower".
  // TEMPO scales lift/travel, near-stop and HOLD in core (the drop takes min(TEMPO, 1.6): still a fast,
  // accelerating fall; landing and IMPACT unchanged). DWELL / STILL: how long a hover (desktop) or a
  // centred plate (phone) must hold before the Seal sets off.
  var TEMPO = 1.8, DWELL = 260, STILL = 400;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var shelf = $('.svc'), layer = $('.svc__seals');
  if (!shelf || !layer) { WF.motion.reveal(root); return; }

  /* ── plates ─────────────────────────────────────────────────────────── */
  var P = {};
  var ids = ['manage', 'launch', 'social', 'custom'].filter(function (id) {
    var el = $('.svc__plate[data-svc="' + id + '"]');
    if (!el) return false;
    P[id] = {
      id: id, el: el, anchor: $('[data-seal-anchor]', el), ptext: $('.svc__ptext', el), was: $('.svc__was', el), cooled: $('.svc__cooled', el),
      add: $('.svc__add', el), details: $('.svc__details', el), check: null,
    };
    return true;
  });
  if (!ids.length) return;

  function variantFor(id) {
    var it = WF.cart.get(id);
    if (it) return it.variant;
    var v = P[id].el.getAttribute('data-variant');
    return v || WF.STORE.get(id).defaultVariant || null;
  }
  function name(id) { return WF.t('core.svc.' + id + '.name'); }

  /* price on the plate (Archivo numerals, Almarai units) */
  function priceHTML(id) {
    var p = WF.fmt.priceParts(id, variantFor(id));
    if (p.kind === 'quote') return '<span class="svc__pquote">' + esc(p.unit) + '</span>';
    var h = p.pre ? '<span class="svc__ppre">' + esc(p.pre) + '</span> ' : '';
    h += '<bdi class="num svc__pnum">' + p.num + '</bdi>';
    if (p.unit) h += ' <span class="svc__punit">' + esc(p.unit) + '</span>';
    return h;
  }
  /* the struck anchor ("was") before the price: stays in view beside the Seal / cooled mark; never gold.
     Empty for by-quote prices (custom, launch on Zid / Shopify). */
  function paintPrice(id) {
    var p = P[id], v = variantFor(id);
    p.ptext.innerHTML = priceHTML(id);
    if (p.was) p.was.innerHTML = WF.fmt.was ? WF.fmt.was(id, v) : '';
  }
  /* the hallmark face: the Seal and the cooled mark print the same words (the NEW price, no anchor) */
  function faceHTML(id, inCart) {
    var p = WF.fmt.priceParts(id, variantFor(id));
    var h = inCart ? '<span class="svc__fin">' + esc(WF.t('services.seal.inCart')) + '</span>' : '';
    if (p.kind === 'quote') return h + '<span class="svc__fq">' + esc(p.unit) + '</span>';
    var num = '<b class="svc__fn num">' + p.num + '</b>';
    var small = function (s) { return '<span class="svc__fu">' + esc(s) + '</span>'; };
    if (WF.lang === 'ar') {
      if (p.kind === 'monthly') return h + num + small(p.unit);
      return h + small(p.pre) + '<span class="svc__frow">' + num + small(p.unit) + '</span>';
    }
    if (p.kind === 'monthly') return h + '<span class="svc__frow">' + small(p.pre) + num + '</span>' + small(p.unit);
    return h + small(p.pre) + num;
  }

  /* ── the Seal ───────────────────────────────────────────────────────── */
  // cur = the strike in flight {to, job, contacted}: an add for the same plate joins it instead of queuing
  var S = { sealAt: ids[0], active: ids[0], running: false, pendingAdd: null, relayout: false, cur: null };
  var seal = WF.seal.make({ face: 'text', html: faceHTML(S.sealAt, WF.cart.has(S.sealAt)), className: 'svc__seal' });
  seal.setAttribute('data-flip', 'svc-seal');
  layer.appendChild(seal);

  // Resting centre in layer coordinates, from layout offsets (immune to LIFT / IMPACT transforms).
  function anchorBox(id) {
    var a = P[id].anchor, x = 0, y = 0, n = a;
    while (n && n !== shelf) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; }
    if (n !== shelf) {   // unexpected offset chain: fall back to rects
      var r = a.getBoundingClientRect(), b = layer.getBoundingClientRect();
      return { x: r.left - b.left, y: r.top - b.top, w: r.width, h: r.height };
    }
    return { x: x, y: y, w: a.offsetWidth, h: a.offsetHeight };
  }
  function point(id) {
    var b = anchorBox(id), w = seal.offsetWidth;
    return { x: WF.lang === 'ar' ? b.x + b.w - w / 2 : b.x + w / 2, y: b.y + b.h / 2 };
  }
  function placeSeal() { if (S.sealAt) WF.seal.place(seal, point(S.sealAt), { layer: layer }); }
  // re-commit the rest after anything that can move an anchor box (a language swap, a resize, the struck
  // anchor appearing / going when the launch platform changes); mid-strike it waits for the strike to end
  function settleSeal() { if (S.running) S.relayout = true; else placeSeal(); }
  function setFace(id) { if (id) WF.seal.face(seal, { html: faceHTML(id, WF.cart.has(id)) }); }
  // The face only ever reads the price it is standing on: it fades out as the Seal lifts off (the gold
  // body stays) and the new words appear on the contact frame, under the IMPACT.
  var faceEl = seal.querySelector('.seal__face'), faceAnim = null;
  function faceOut() {
    if (WF.reduced || !faceEl) return;
    if (faceAnim) faceAnim.cancel();
    faceAnim = faceEl.animate([{ opacity: 1 }, { opacity: 0 }], { duration: T.near * TEMPO, easing: 'linear', fill: 'forwards' });
  }
  function faceIn() { if (faceAnim) { faceAnim.cancel(); faceAnim = null; } }

  /* ── plate state: price text, cooled mark, buttons ──────────────────── */
  function fadeIn(el, ms) { if (!WF.reduced && ms) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: ms, easing: 'linear' }); }
  function fadeOut(el, ms) { if (!WF.reduced && ms) el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: ms, easing: 'linear' }); }
  function buttons(id) {
    var p = P[id], inCart = WF.cart.has(id);
    // one route to the cart: once added, the same button opens it (the Seal / cooled mark says «في سلتك»)
    var label = WF.t(inCart ? 'services.openCart' : 'services.add');
    if (p.add.textContent !== label) p.add.textContent = label;
    if (inCart) p.add.setAttribute('aria-label', WF.t('services.inCart.aria')); else p.add.removeAttribute('aria-label');
    p.add.classList.toggle('is-in', inCart);
  }
  // anim: ms for the visibility change (0 = instant). The Seal arriving always hides the price at once.
  function setState(id, anim) {
    var p = P[id], el = p.el, here = S.sealAt === id, inCart = WF.cart.has(id);
    var wasHidden = el.classList.contains('is-sealed') || el.classList.contains('is-cooled');
    var wasCooled = el.classList.contains('is-cooled');
    var cooled = !here && inCart, hidden = here || cooled;
    if (inCart) p.cooled.innerHTML = faceHTML(id, true);
    el.classList.toggle('is-sealed', here);
    el.classList.toggle('is-cooled', cooled);
    if (anim) {
      if (cooled && !wasCooled) fadeIn(p.cooled, anim);
      if (!cooled && wasCooled && !here) fadeOut(p.cooled, anim);
      if (!hidden && wasHidden) fadeIn(p.ptext, anim);
      if (hidden && !wasHidden && !here) fadeOut(p.ptext, anim);
    }
    buttons(id);
  }
  function renderAll() {
    ids.forEach(function (id) { paintPrice(id); setState(id, 0); });
    setFace(S.sealAt);
  }

  /* ── travel / add: one job at a time; adds are never dropped ────────── */
  function isFar(to) {
    var c = WF.seal.center(seal); if (!c) return false;
    var dy = Math.abs(point(to).y - c.y);
    if (!WF.mobile) return dy > 1.2 * innerHeight;
    // phone: a Seal you can't see (or one a long way off) lands on the new price instead of
    // falling in from off-screen across the plates in between
    var r = seal.getBoundingClientRect(), hdr = document.getElementById('wf-header');
    var top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0, mid = r.top + r.height / 2;
    return mid < top || mid > innerHeight || dy > 0.4 * innerHeight;
  }
  function doAdd(id, variant) {
    var ok = WF.cart.add(id, { variant: variant, source: 'services' });   // → header count + IMPACT, this frame
    if (ok) WF.live(WF.t('services.added', { name: name(id) }));
    return ok;
  }
  function run(to, job, rec) {
    S.running = true;
    var cur = S.cur = { to: to, job: job, contacted: false, rec: !!rec };
    var from = S.sealAt, same = from === to, left = false;
    function leave() {
      if (left || same) return;
      left = true; S.sealAt = null;
      if (from && P[from]) setState(from, T.quick);   // cooled mark / price text: 120ms opacity
    }
    function arrive() {   // the contact frame: cart, face and plate state all change together
      leave();
      cur.contacted = true;
      S.sealAt = to;
      if (cur.job) doAdd(to, cur.job.variant);
      setFace(to);
      faceIn();
      setState(to, 0);
      if (cur.rec) markFromCheck(to);
    }
    function done() {
      if (!cur.contacted) faceIn();
      S.running = false; S.cur = null;
      if (S.relayout) { S.relayout = false; placeSeal(); }
      pump();
    }
    if (!same && !WF.reduced && isFar(to)) {   // too far to watch (isFar): commit, then STRIKE.land
      leave();
      WF.seal.place(seal, point(to), { layer: layer });
      arrive();
      WF.motion.land(seal).then(done, done);
      return;
    }
    WF.seal.strike(seal, {
      layer: layer,
      tempo: TEMPO,
      target: function () { return point(to); },
      lift: same ? T.liftPx.restrike : T.liftPx.services,
      impactEl: P[to].el,
      onLift: function () {
        leave();
        if (!same) faceOut();   // a re-strike in place keeps its price; a travel goes blank until contact
      },
      onContact: arrive,
    }).then(done, done);
  }
  function pump() {
    if (S.running) return;
    if (S.pendingAdd) {
      var j = S.pendingAdd; S.pendingAdd = null;
      if (!WF.cart.has(j.id)) { run(j.id, j); return; }
    }
    if (S.pendingRec) {   // a recommendation strikes even when the Seal already rests there (in place)
      var r = S.pendingRec; S.pendingRec = null;
      if (P[r]) { S.active = r; run(r, null, true); return; }
    }
    if (S.active && S.active !== S.sealAt && P[S.active]) run(S.active, null);
  }
  function setActive(id) { if (!P[id] || S.active === id && (S.sealAt === id || S.running)) return; S.active = id; pump(); }
  function requestAdd(id, variant) {
    if (WF.cart.has(id)) { WF.drawer.open(1); return; }
    var job = { id: id, variant: variant !== undefined ? variant : variantFor(id) };
    S.active = id;
    if (S.cur && S.cur.to === id && !S.cur.contacted) { S.cur.job = job; S.pendingAdd = null; return; }   // this travel IS the add
    S.pendingAdd = job;
    pump();
  }

  /* ── the detail overlay holds the Seal still ───────────────────────────
     From «التفاصيل» until the detail has closed, hover / focus / centring don't move the Seal (it would
     travel unseen under the growing or shrinking slab). The latest request waits and plays on
     overlay:close, so the travel is seen. Adds are never held. */
  var hold = { on: false, pending: null, t: 0 };
  function release() {
    clearTimeout(hold.t);
    if (!hold.on) return;
    hold.on = false;
    var id = hold.pending; hold.pending = null;
    if (id) setActive(id);
  }
  function holdFor(ms) {   // armed by the click; overlay:open keeps it, a detail that never opens frees it
    hold.on = true; clearTimeout(hold.t);
    hold.t = setTimeout(function () { var d = WF.overlay.top(); if (!d || d.id !== 'detail') release(); }, ms);
  }
  function requestActive(id) {
    if (rec.wait && rec.wait.id === id) return;   // the recommendation is about to strike it
    if (hold.on) { hold.pending = id; return; }
    setActive(id);
  }
  WF.on('overlay:open', function (d) { if (d && d.id === 'detail') { clearTimeout(hold.t); hold.on = true; } });
  WF.on('overlay:close', function (d) { if (d && d.id === 'detail') release(); });

  /* ── input: hover 180ms / focus (desktop), centred plate (phone) ────── */
  ids.forEach(function (id) {
    var p = P[id], el = p.el, hoverT = 0, viaPointer = false, vpT = 0;
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || WF.mobile) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { if (!rec.lock) requestActive(id); }, DWELL);
    });
    el.addEventListener('pointerleave', function () { clearTimeout(hoverT); });
    el.addEventListener('pointerdown', function () { viaPointer = true; clearTimeout(vpT); vpT = setTimeout(function () { viaPointer = false; }, 600); }, true);
    el.addEventListener('focusin', function () { if (!viaPointer) requestActive(id); });
    el.addEventListener('click', function (e) { if (!e.target.closest('.svc__add')) requestActive(id); });
    p.add.addEventListener('click', function () { requestAdd(id); });
    p.details.addEventListener('click', function () {
      holdFor(T.drawerIn);
      WF.emit('detail:open', { id: id, opener: p.details, source: 'plate' });
    });
    el.addEventListener('wf-svc-add', function (e) { requestAdd(id, e.detail && e.detail.variant !== undefined ? e.detail.variant : undefined); });
    el.addEventListener('wf-svc-variant', function () {
      paintPrice(id);
      setState(id, 0);
      if (S.sealAt === id) setFace(id);
      settleSeal();
    });
  });

  // phone: the plate whose centre is nearest the viewport centre (middle 40% band), after 400ms of stillness
  var scrollT = 0;
  function pickCentered() {
    if (!WF.mobile || WF.autoSized || WF.overlay.top() || rec.lock) return;
    var vh = innerHeight, best = null, bd = Infinity;
    ids.forEach(function (id) {
      var r = P[id].el.getBoundingClientRect(), c = r.top + r.height / 2;
      if (c < vh * 0.3 || c > vh * 0.7) return;
      var d = Math.abs(c - vh / 2);
      if (d < bd) { bd = d; best = id; }
    });
    if (best) requestActive(best);
  }
  function onScroll() { clearTimeout(scrollT); scrollT = setTimeout(pickCentered, STILL); }
  var scrolling = false;
  WF.io.watch(shelf, function (e) {
    if (e.isIntersecting && !scrolling) { scrolling = true; window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
    else if (!e.isIntersecting && scrolling) { scrolling = false; window.removeEventListener('scroll', onScroll); clearTimeout(scrollT); }
  }, { threshold: [0] });

  /* ── recommend: a feature hands a service over (B's road check: «شوف الخدمة») ───
     The feature emits, then scrolls to #svc-<id>. The strike waits until that plate's price is on
     screen and the page has been still for 140ms, so the visitor sees the Seal travel and land
     (fallback: it strikes after 4s wherever the page is). It is add-free: no cart change.
     On contact the plate gains the cooled tag «من فحصك» (one plate at a time: a newer check moves it),
     kept for the visit. Until the visitor's own next input after that contact, hover (the pointer
     resting where the scroll left it) and phone centring don't move the Seal off the recommendation. */
  // M0-EXT (SPEC-CD §3.1 item 2): the tag's key comes with the recommendation (detail.tag, e.g. C's
  // 'services.forSeason' «لموسمك»); no tag → 'services.fromCheck' «من فحصك» (B).
  var rec = { wait: null, lock: false, contactAt: 0, from: null, tag: 'services.fromCheck' };
  function onScreen(id) {
    var r = P[id].anchor.getBoundingClientRect(), hdr = document.getElementById('wf-header');
    var top = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    return r.width > 0 && r.top >= top - 1 && r.bottom <= innerHeight + 1;
  }
  function recommend(id, tag) {
    if (!P[id]) return;
    if (rec.wait) rec.wait.cancel();
    rec.tag = tag || 'services.fromCheck';
    rec.lock = true; rec.contactAt = 0; rec.from = null;
    S.active = id;
    var w = rec.wait = { id: id }, t = 0, t0 = Date.now(), dead = false;
    function finish() {
      if (dead) return;
      dead = true; clearTimeout(t); clearTimeout(w.fallback);
      removeEventListener('scroll', onS);
      if (rec.wait === w) rec.wait = null;
    }
    function go() { if (dead) return; finish(); S.pendingRec = id; S.active = id; pump(); }
    function check() { if (!dead && (WF.reduced || onScreen(id) || Date.now() - t0 > 4000)) go(); }
    function onS() { clearTimeout(t); t = setTimeout(check, 140); }
    w.cancel = finish;
    addEventListener('scroll', onS, { passive: true });
    t = setTimeout(check, 140);
    w.fallback = setTimeout(go, 4000);
  }
  // the visitor's own next input after the contact frees hover / centring again
  // A scroll under a resting cursor re-sends the same client point; only a hand on the mouse moves it,
  // so a pointermove unlocks once it is 8px from where the cursor was at the contact frame.
  var cursor = null;
  function unlock(e) {
    var move = e.type === 'pointermove';
    if (move && e.pointerType !== 'touch') {
      var at = cursor; cursor = { x: e.clientX, y: e.clientY };
      if (rec.lock && rec.contactAt && !rec.from) rec.from = at || cursor;
    }
    if (!rec.lock || !rec.contactAt) return;
    if (move) {
      if (e.pointerType === 'touch' || !rec.from) return;
      if (Math.abs(e.clientX - rec.from.x) + Math.abs(e.clientY - rec.from.y) < 8) return;
    }
    rec.lock = false; rec.from = null;
  }
  ['pointermove', 'pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (type) { addEventListener(type, unlock, { passive: true }); });
  function markFromCheck(id) {
    rec.contactAt = performance.now(); rec.from = cursor;
    ids.forEach(function (k) {
      var p = P[k];
      if (k !== id) { if (p.check) { p.check.remove(); p.check = null; p.el.classList.remove('has-check'); } return; }
      var fresh = !p.check;
      if (fresh) {
        p.check = document.createElement('p');
        p.check.className = 'stamp--cooled svc__check';
        p.el.insertBefore(p.check, p.el.querySelector('.svc__body'));
      }
      p.checkKey = rec.tag;
      p.check.textContent = WF.t(p.checkKey);
      p.el.classList.add('has-check');
      if (fresh) fadeIn(p.check, T.quick);
    });
  }
  WF.on('recommend', function (d) { if (d && d.service) recommend(d.service, d.tag); });

  /* ── cart changes made elsewhere: repaint, no motion (a removal fades 120ms) ─ */
  WF.on('cart:change', function (d) {
    if (d.reason === 'load') { renderAll(); settleSeal(); return; }
    if (d.source === 'services') return;   // our strike paints on its own contact frame
    var id = d.id;
    if (!P[id]) return;
    if (d.reason === 'variant') paintPrice(id);
    setState(id, d.reason === 'remove' ? T.quick : 0);
    if (S.sealAt === id) setFace(id);
    if (d.reason === 'variant') settleSeal();
  });

  /* ── the Mirror: re-render in the swap frame, commit the Seal's new rest ─ */
  WF.on('lang', function () {
    renderAll();
    ids.forEach(function (id) { if (P[id].check) P[id].check.textContent = WF.t(P[id].checkKey || 'services.fromCheck'); });
    settleSeal();
  });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(settleSeal);
    ro.observe(shelf);
  }
  WF.on('env', settleSeal);

  /* ── entrance: H2 RISE, lede LIFT, plates LIFT (60ms), glyphs DRAW ──── */
  var head = $('.section-head');
  var plates = ids.map(function (id) { return P[id].el; });
  if (WF.reduced || WF.autoSized) {
    $$('[data-rise],[data-lift],[data-draw],[data-svc-lift]').concat([seal]).forEach(function (el) { el.classList.add('is-in'); });
  } else {
    WF.io.once(head, function () {
      WF.motion.rise($$('[data-rise]', head));
      WF.motion.lift($$('[data-lift]', head), { delay: 200 });
    }, { threshold: 0.3 });
    WF.io.once(shelf, function () {
      var base = 120;
      WF.motion.lift(plates, { delay: base });
      WF.motion.lift(seal, { delay: base + Math.max(0, ids.indexOf(S.sealAt)) * T.liftStagger });
      ids.forEach(function (id, i) {
        WF.motion.draw($$('.svc__glyph i', P[id].el), { delay: base + i * T.liftStagger + 380 });
      });
    }, { threshold: 0.2 });
  }

  renderAll();
  placeSeal();

  WF.debug.expose('services', function () {
    return { sealAt: S.sealAt, active: S.active, running: S.running, busy: WF.seal.busy(seal), face: seal.textContent.replace(/\s+/g, ' ').trim(),
      tempo: TEMPO, fromCheck: ids.filter(function (id) { return !!P[id].check; }), recWaiting: rec.wait ? rec.wait.id : null, recLock: rec.lock };
  });
});

})();
/* ── start ── */
;(function(){
/* start.js — How we start (SPEC-V2 §3.8, M2).
   Three steps side by side, «وين وصلت تجارتك؟» (radiogroup → WF.setWhere), the next move (add to cart,
   a live wa.me link; always visible), and the sample «عرض سعر»: a clean quotation that re-sets itself for
   the recommended service, with the gold Seal «نموذج» resting over its bottom inline-end corner.
   A chip change: the values that change fade out (120ms), the new ones LIFT in, the blocks below slide
   (translate-only FLIP), then the Seal re-strikes in place (tempo 1.6) and the sheet takes the IMPACT.
   The quote never shows a struck or "was" price. */
WF.module('start', function (root) {
  'use strict';
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var T = WF.T;

  var KEYED = ['service', 'inc', 'term', 'exc', 'foot'];   // values keyed per service: start.q.<svc>.<row>
  var MAX_INC = 5;

  var head = $('.start-head');
  var stepsEl = $('.start-steps');
  var whereEl = $('#start-where');
  var desk = $('.start-desk');
  var q = $('.start-q');
  var paper = $('.start-q__paper');
  var chips = $$('.start-chip');
  var rec = $('#start-rec');
  var addBtn = $('.start-add');
  var waA = $('.start-wa');
  var dateEl = $('.start-q__date');
  var vals = {};
  KEYED.concat('price', 'total', 'pay').forEach(function (r) { vals[r] = $('[data-q="' + r + '"]'); });
  var allVals = $$('[data-q]');
  var SLIDE = 240;           // = WF.motion.flip's default: the blocks below and the Seal slide together

  var shown = 'manage';      // the service whose quote is in the DOM right now
  var resetToken = 0;
  var needPlace = false;
  var restrikes = 0;

  function svcFor(where) { return (where && WF.STORE.where[where]) || 'manage'; }
  function current() { return svcFor(WF.state.where); }
  function key(row, svc) { return 'start.q.' + svc + '.' + row; }
  function nameOf(svc) { return WF.t('core.svc.' + svc + '.name'); }

  // [pre] [number + unit] — the number and its unit never part. No struck price here, ever.
  function priceHTML(svc) {
    var p = WF.fmt.priceParts(svc);
    if (!p) return '';
    if (p.kind === 'quote') return '<span class="start-q__unit">' + esc(p.unit) + '</span>';
    return (p.pre ? '<span class="start-q__pre">' + esc(p.pre) + '</span> ' : '') +
      '<span class="start-q__fig"><bdi class="num start-q__num">' + esc(p.num) + '</bdi>' +
      (p.unit ? ' <span class="start-q__unit">' + esc(p.unit) + '</span>' : '') + '</span>';
  }

  /* ── the Seal «نموذج» (decorative: the quote reads as a sample from its own «رقم العرض») ── */
  var seal = WF.seal.make({ face: 'text', text: WF.t('start.seal.face'), className: 'start-seal' });
  desk.appendChild(seal);

  // Its centre rests 24px in from the sheet's inline-end edge and 28px up from its bottom, so it hangs
  // over the corner like a real stamp. Where the page gutter is too narrow for that overhang (phones),
  // the Seal moves in just enough to stay 8px clear of the viewport edge.
  function corner() {
    var rtl = WF.lang === 'ar';
    var r = q.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var half = seal.offsetWidth / 2;
    var room = rtl ? r.left : vw - r.right;
    var inset = Math.max(24, half - Math.max(0, room - 8));
    return { el: q, ax: rtl ? 0 : 1, ay: 1, dx: rtl ? inset : -inset, dy: -28 };
  }
  function place() {
    if (WF.seal.busy(seal)) { needPlace = true; return; }
    needPlace = false;
    WF.seal.place(seal, corner());
  }
  function flushPlace() { if (needPlace && !WF.seal.busy(seal)) place(); }

  /* ── the quote ────────────────────────────────────────────────────────── */
  // The strings keep their «·»-joined form (that is the no-JS page). With JS, the includes become a
  // <ul> (max 5, one per line with an ink dash); a joined value elsewhere (the launch service name, the
  // exclusions) may break only BEFORE a separator, never inside an item.
  function group(el, row) {
    var parts = el.innerHTML.split(' · ');
    if (row === 'inc') {
      el.innerHTML = '<ul class="start-q__list">' + parts.slice(0, MAX_INC).map(function (p) { return '<li>' + p + '</li>'; }).join('') + '</ul>';
      return;
    }
    if (parts.length < 2) return;
    // a name keeps its « · » (service · platform); a list of things reads as a sentence, comma-joined
    var sep = row === 'exc' ? (WF.lang === 'ar' ? '، ' : ', ') : ' · ';
    el.innerHTML = parts.map(function (p, i) { return '<span class="start-q__part">' + p + (i < parts.length - 1 ? sep.replace(/ $/, '') : '') + '</span>'; }).join(' ');
  }
  function writeQuote(svc) {
    KEYED.forEach(function (r) {
      var el = vals[r], k = key(r, svc);
      el.setAttribute('data-i18n-html', k);
      el.innerHTML = WF.tHTML(k);
      group(el, r);
    });
    vals.price.innerHTML = priceHTML(svc);
    vals.total.innerHTML = priceHTML(svc);
    shown = svc;
  }
  function writeDate() {
    var d = new Date();
    dateEl.textContent = WF.fmt.date(d);
    dateEl.setAttribute('datetime', d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'));
  }

  // the swap frame: new text in, the Seal re-seated, and every block that moved slides from where it was
  // while the paper layer eases to its new height (scaleY), so nothing jumps.
  var moving = $$('.start-q__item, .start-q__row, .start-q__total, .start-q__foot').concat(seal);
  function swapQuote(svc) {
    var h0 = q.offsetHeight;
    WF.motion.flip(moving, function () { writeQuote(svc); place(); }, { ms: SLIDE });
    var h1 = q.offsetHeight;
    if (Math.abs(h1 - h0) > 0.5 && h1 > 0) {
      paper.animate([{ transform: 'scaleY(' + (h0 / h1).toFixed(4) + ')' }, { transform: 'none' }], { duration: SLIDE, easing: T.ease.slide });
    }
  }
  function changedEls(svc) {
    var out = [];
    KEYED.forEach(function (r) { if (WF.tHTML(key(r, svc)) !== WF.tHTML(key(r, shown))) out.push(vals[r]); });
    if (priceHTML(svc) !== priceHTML(shown)) out.push(vals.price, vals.total);
    return out;
  }
  function settle() {
    allVals.forEach(function (el) { el.getAnimations().forEach(function (a) { a.cancel(); }); el.style.opacity = ''; });
    moving.concat(paper).forEach(function (el) { el.getAnimations().forEach(function (a) { a.cancel(); }); });
  }

  function resetTo(svc) {
    var token = ++resetToken;
    settle();                                   // never measure a rect caught mid-slide
    if (svc === shown) { place(); return; }
    var els = changedEls(svc);
    var animate = !WF.reduced && WF.booted && !WF.overlay.top() && WF.io.inView(q);
    if (!animate) { writeQuote(svc); place(); if (WF.booted && !WF.reduced) arm(); return; }
    Promise.all(els.map(function (el) { return WF.motion.fade(el, 0, T.quick); })).then(function () {
      if (token !== resetToken) return false;
      swapQuote(svc);
      els.forEach(function (el) { el.style.opacity = ''; });
      // the Seal leaves while the last values are still settling, so its contact lands as they do
      return new Promise(function (res) { WF.motion.lift(els, { stagger: 40 }); setTimeout(function () { res(true); }, 360); });
    }).then(function (ok) {
      if (ok && token === resetToken) restrike();
    });
  }

  // once the quote has re-set, the Seal re-strikes in place and the sheet takes the IMPACT. If the Seal
  // is not on screen (a phone: the chips sit above the quote), the strike waits until it is fully in view,
  // so the stamp lands where it is seen, once, never off-screen.
  var pendingOff = null;
  function seen() {
    var r = seal.getBoundingClientRect(), top = WF.root.querySelector('#wf-header');
    var hb = top ? top.getBoundingClientRect().bottom : 0;
    return r.width > 0 && r.top >= hb && r.bottom <= innerHeight;
  }
  function disarm() { if (pendingOff) { pendingOff(); pendingOff = null; } }
  function arm() {
    if (pendingOff || WF.reduced) return;
    pendingOff = WF.io.watch(seal, function (e) {
      if (!e.isIntersecting || e.intersectionRatio < 0.99) return;
      disarm();
      var token = resetToken;
      setTimeout(function () { if (token === resetToken && seen()) restrike(); else if (token === resetToken) arm(); }, 240);
    }, { threshold: [0, 1], rootMargin: '-64px 0px 0px 0px' });
  }
  function restrike() {
    if (WF.reduced || WF.overlay.top()) { place(); return; }
    if (!seen()) { place(); arm(); return; }
    disarm();
    WF.seal.strike(seal, { target: corner(), lift: T.liftPx.restrike, impactEl: q, tempo: 1.6,
      onContact: function () { restrikes++; } }).then(flushPlace);
  }

  /* ── where are you? (radiogroup, roving tabindex, arrows move and select) ─ */
  function syncChips(where) {
    var any = false;
    chips.forEach(function (c) {
      var on = c.getAttribute('data-where') === where;
      if (on) any = true;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });
    if (!any && chips[0]) chips[0].tabIndex = 0;
  }
  function renderRec() {
    var w = WF.state.where;
    rec.textContent = w ? WF.t('start.fits', { name: nameOf(svcFor(w)) }) : '';
    rec.classList.toggle('is-on', !!w);
  }
  function choose(where) {
    if (where === WF.state.where) return;
    WF.setWhere(where);                         // → where:change → onWhere (synchronous)
    WF.live(rec.textContent);
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function () { choose(c.getAttribute('data-where')); });
    c.addEventListener('keydown', function (e) {
      var i = chips.indexOf(c), n = chips.length, rtl = WF.lang === 'ar', j = null;
      if (e.key === 'ArrowDown') j = i + 1;
      else if (e.key === 'ArrowUp') j = i - 1;
      else if (e.key === 'ArrowLeft') j = rtl ? i + 1 : i - 1;
      else if (e.key === 'ArrowRight') j = rtl ? i - 1 : i + 1;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      else return;
      e.preventDefault();
      j = (j + n) % n;
      chips[j].focus();
      choose(chips[j].getAttribute('data-where'));
    });
  });

  function onWhere(animate) {
    var w = WF.state.where;
    var wasOn = rec.classList.contains('is-on');
    syncChips(w);
    renderRec();
    if (w && !wasOn && animate && !WF.reduced && WF.booted && WF.io.inView(whereEl)) WF.motion.lift(rec);
    resetTo(svcFor(w));
    updateAdd();
    updateWA();
  }
  WF.on('where:change', function () { onWhere(true); });

  /* ── the next move: add to cart, ask on WhatsApp ──────────────────────── */
  function updateAdd() {
    var inCart = WF.cart.has(current());
    var k = inCart ? 'start.inCart' : 'start.add';
    addBtn.classList.toggle('btn--ink', !inCart);
    addBtn.classList.toggle('btn--line-ink', inCart);
    if (addBtn.getAttribute('data-i18n') !== k) { addBtn.setAttribute('data-i18n', k); addBtn.textContent = WF.t(k); }
  }
  function updateWA() { waA.href = WF.wa.link('start', { id: current() }); }
  function addedMsg(svc) {
    var d = WF.dict && WF.dict[WF.lang];
    var k = d && Object.prototype.hasOwnProperty.call(d, 'services.added') ? 'services.added' : 'start.added';
    return WF.t(k, { name: nameOf(svc) });
  }
  addBtn.addEventListener('click', function () {
    var svc = current();
    if (WF.cart.has(svc)) { WF.drawer.open(1); return; }
    if (WF.cart.add(svc, { source: 'start' })) WF.live(addedMsg(svc));   // header IMPACT runs inside the emit
  });
  WF.on('cart:change', updateAdd);

  /* ── language swap: commit text and positions on the swap frame, no animation ─ */
  WF.on('lang', function () {
    ++resetToken;                               // a re-set caught mid-fade simply lands, in the new language
    settle();
    writeQuote(current());                      // core has just re-applied the joined strings: re-list them
    writeDate();
    WF.seal.face(seal, { text: WF.t('start.seal.face') });
    renderRec();
    updateAdd();
    updateWA();
    place();
  });

  /* ── layout changes: re-seat the Seal (width changes only) ─────────────── */
  var lastW = -1, rq = 0;
  function relayout() { rq = 0; place(); }
  if ('ResizeObserver' in window) {
    new ResizeObserver(function (entries) {
      var w = entries[0].contentRect.width;
      if (Math.abs(w - lastW) < 0.5) return;
      lastW = w;
      if (!rq) rq = requestAnimationFrame(relayout);
    }).observe(desk);
  } else {
    window.addEventListener('resize', function () { if (!rq) rq = requestAnimationFrame(relayout); });
  }

  /* ── first render ─────────────────────────────────────────────────────── */
  syncChips(WF.state.where);
  renderRec();
  writeQuote(current());
  writeDate();
  updateAdd();
  updateWA();
  place();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);

  /* ── entrance (IO once per block, so a tall phone column reveals as it arrives) ─ */
  var nums = $$('.start-step__num');
  var markAll = function (els) { els.forEach(function (el) { el.classList.add('is-in'); }); };
  if (WF.autoSized) {
    markAll($$('[data-rise],[data-lift],[data-draw]').concat(nums));
  } else {
    WF.io.once(head, function () { WF.motion.rise(head.querySelectorAll('[data-rise]')); });
    WF.io.once(stepsEl, function () {
      WF.motion.rise(nums, { delay: 60 });
      WF.motion.lift(stepsEl.querySelectorAll('[data-lift]'), { delay: 180, stagger: 50 });
    });
    WF.io.once(whereEl, function () {
      WF.motion.rise(whereEl.querySelectorAll('[data-rise]'), { delay: 40 });
      WF.motion.lift(whereEl.querySelectorAll('.start-chipwrap, .start-act'), { delay: 220 });
    });
    WF.io.once(q, function () {
      WF.motion.draw($$('.start-q [data-draw]'), { delay: 140, stagger: 60 });
      WF.motion.lift(allVals, { delay: 200, stagger: 50 });
    }, { threshold: 0.25 });
  }

  /* ── verification surface ─────────────────────────────────────────────── */
  function textHits(box) {
    var hits = [], w = document.createTreeWalker(q, NodeFilter.SHOW_TEXT), n, rg = document.createRange();
    while ((n = w.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      rg.selectNodeContents(n);
      Array.prototype.forEach.call(rg.getClientRects(), function (r) {
        if (r.width && r.right > box.left && r.left < box.right && r.bottom > box.top && r.top < box.bottom) hits.push(n.nodeValue.trim().slice(0, 40));
      });
    }
    return hits;
  }
  WF.debug.expose('start', function () {
    var qr = q.getBoundingClientRect(), s = seal.querySelector('.seal__body').getBoundingClientRect();
    var rtl = WF.lang === 'ar';
    return {
      shown: shown, current: current(), restrikes: restrikes, busy: WF.seal.busy(seal),
      sealInset: { inline: Math.round(((rtl ? (s.left + s.right) / 2 - qr.left : qr.right - (s.left + s.right) / 2)) * 10) / 10,
        block: Math.round((qr.bottom - (s.top + s.bottom) / 2) * 10) / 10 },
      sealOverText: textHits(s),
      sealInViewport: s.left >= 0 && s.right <= (document.documentElement.clientWidth || window.innerWidth),
      wa: decodeURIComponent((waA.getAttribute('href') || '').split('?text=')[1] || ''),
      service: vals.service.textContent.replace(/\s+/g, ' ').trim(),
      price: vals.price.textContent.replace(/\s+/g, ' ').trim(),
      total: vals.total.textContent.replace(/\s+/g, ' ').trim(),
      includes: $$('.start-q__list > li').map(function (li) { return li.textContent.trim(); }),
      date: dateEl.textContent, datetime: dateEl.getAttribute('datetime'),
      strikes: root.querySelectorAll('s, del, .was').length,
      actions: !!(addBtn.getClientRects().length && waA.getClientRects().length),
    };
  });
});

})();
/* ── library ── */
;(function(){
/* library.js — slot library (SPEC §3.7; SPEC-V2 §3.9; owner M4).
   Three free guides. Each card is a native <a target="_blank" rel="noopener">; this file only
   keeps the href in the page's language, registers the touch for the bench, tags the gold accent set
   (B), and runs the entrance. */
WF.module('library', function (root) {
  // SPEC-V2 §2.2 / §3.10: on a dark ground whose --lib-rule resolves to gold (B), the three 2px × 40px
  // title marks are ONE accent set: the tag sits on the list (the outermost element), so the gold
  // sweep counts it once. On sand/bone (A) there is no mark and no tag (an accent may never sit on paper).
  var grid = root.querySelector('.library__grid');
  var t0 = root.querySelector('.library__t');
  if (grid && t0) {
    var mark = getComputedStyle(t0, '::after');
    if (mark.content !== 'none' && mark.content !== 'normal' && mark.backgroundColor === 'rgb(198, 164, 90)') grid.setAttribute('data-gold', 'accent');
  }

  var BASE = 'https://winnersforge.com';
  var PATHS = { g1: '/pages/store-readiness', g2: '/pages/product-page-guide', g3: '/pages/content-planner' };
  var cards = Array.prototype.slice.call(root.querySelectorAll('.library__card[data-guide]'));

  // hrefs follow the language: /pages/… in Arabic, /en/pages/… in English (committed in the swap frame)
  function setHrefs() {
    var pre = WF.lang === 'en' ? '/en' : '';
    cards.forEach(function (a) {
      var p = PATHS[a.getAttribute('data-guide')];
      if (p) a.setAttribute('href', BASE + pre + p);
    });
  }
  setHrefs();
  WF.on('lang', setHrefs);

  // a guide you opened becomes a booklet on the bench. The native link does the opening.
  function onOpen(e) {
    if (e.type === 'auxclick' && e.button !== 1) return;
    var a = e.target.closest && e.target.closest('.library__card[data-guide]');
    if (!a || !root.contains(a)) return;
    WF.touch.add({ kind: 'booklet', id: a.getAttribute('data-guide'), source: 'booklet' });
  }
  root.addEventListener('click', onOpen);
  root.addEventListener('auxclick', onOpen);

  // entrance: H2 RISE, lede LIFT, cards LIFT (60ms stagger). On a phone the cards stack far
  // below the heading, so each one LIFTs when it actually arrives instead of off-screen.
  var head = root.querySelector('.library__head');
  var cells = Array.prototype.slice.call(root.querySelectorAll('.library__cell'));
  if (WF.mobile && !WF.reduced && !WF.autoSized && head) {
    WF.motion.reveal(head);
    cells.forEach(function (c) { WF.io.once(c, function () { WF.motion.lift(c); }, { threshold: 0.3 }); });
  } else {
    WF.motion.reveal(root);
  }
});

})();
/* ── faq ── */
;(function(){
/* faq.js — slot faq (SPEC §3.8; SPEC-V2 §3.9; owner M4). q7/a7 (ownership) lives in <!--flag:faqOwnership-->.
   The six questions are native <details> (they open with JS off). With JS, opening LIFTs the
   answer (opacity + translate, 280ms); closing is instant. No height is ever animated or written:
   the only writes are WAAPI transform/opacity on the answer, and the WhatsApp href. */
WF.module('faq', function (root) {
  // SPEC-V2 §2.2: two bone rooms never touch. If the section before the FAQ paints the same ground
  // (e.g. flags.library:false puts How-we-start's bone right above it), the FAQ turns sand.
  var prev = root.previousElementSibling;
  while (prev && !prev.classList.contains('section')) prev = prev.previousElementSibling;
  if (prev && prev.classList.contains('section--bone') && root.classList.contains('section--bone')) {
    root.classList.remove('section--bone'); root.classList.add('section--sand');
  }
  var ANSWER_MS = 280;   // SPEC §3.8: the answer's LIFT on open
  var running = new WeakMap();

  // open → LIFT. Started inside the summary's click, before the native toggle runs, so the very
  // first frame that shows the answer is already at the start of the LIFT (no flash).
  root.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('summary.qa__q');
    if (!sum || !root.contains(sum) || e.defaultPrevented) return;
    var qa = sum.parentElement;
    var ans = qa && qa.querySelector('.qa__a');
    if (!ans) return;
    var prev = running.get(ans);
    if (prev) { prev.cancel(); running.delete(ans); }
    if (qa.open || WF.reduced) return;      // closing, or reduced motion: instant
    var a = ans.animate(
      [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
      { duration: ANSWER_MS, easing: WF.T.ease.rise, fill: 'backwards' });
    running.set(ans, a);
    a.finished.then(function () { if (running.get(ans) === a) running.delete(ans); }, function () {});
  });

  // «سؤالك مو هنا؟» → a prefilled WhatsApp message, in the page's language
  var wa = root.querySelector('#faq-wa');
  function setWa() { if (wa) wa.setAttribute('href', WF.wa.link('faq')); }
  setWa();
  WF.on('lang', setWa);

  // entrance: H2 RISE, rows LIFT
  WF.motion.reveal(root);
});

})();
/* ── footer ── */
;(function(){
/* footer.js — slot footer (round-1 SPEC §3.9, SPEC-V2 §3.11).
   Everything here is static markup that reads with JS off. This file keeps the two WhatsApp
   anchors' prefilled message and the icon links' accessible names in the page's language, and
   runs the entrance. */
WF.module('footer', function (root) {
  // both WhatsApp controls (the CTA and the number in «تواصل») open core.wa.hello
  var was = Array.prototype.slice.call(root.querySelectorAll('#footer-wa, #footer-wa-num'));
  function setWa() {
    var href = WF.wa.link('hello');
    was.forEach(function (a) { a.setAttribute('href', href); });
  }
  setWa();
  WF.on('lang', setWa);

  // the «تابعنا» links are icon + handle: their accessible name says whose account it is
  // («وينرز فورج على إنستقرام»); the platform name is never typed out as the icon
  var soc = Array.prototype.slice.call(root.querySelectorAll('.footer__soc[data-platform-key]'));
  function setSocial() {
    soc.forEach(function (a) {
      a.setAttribute('aria-label', WF.t('footer.social.aria', { platform: WF.t(a.getAttribute('data-platform-key')) }));
    });
  }
  setSocial();
  WF.on('lang', setSocial);

  // entrance: H2 RISE, the rest LIFT. On a phone the four groups stack far below the line,
  // so each LIFTs as it arrives rather than off-screen.
  var cta = root.querySelector('.footer__cta');
  var cols = Array.prototype.slice.call(root.querySelectorAll('.footer__col'));
  if (WF.mobile && !WF.reduced && !WF.autoSized && cta) {
    WF.motion.reveal(cta);
    cols.forEach(function (c) { WF.io.once(c, function () { WF.motion.lift(c); }, { threshold: 0.3 }); });
  } else {
    WF.motion.reveal(root);
  }
});

})();
/* ── bench ── */
;(function(){
/* ==========================================================================
   bench.js — THE FOOTER THROWABLES (round-1 SPEC §3.10, §4.7, §6.7; SPEC-V2 §3.12)
   The visit as heavy, made objects; the brand sentence struck true in front of
   you; contact as tags you can pick up.

   Paths:
   · physics  — Matter 0.20 (lazy), a silent pre-settle, the scripted turn once
                per page view, a pointer constraint per grab, our own rAF runner
                that stops when everything sleeps (a true HOLD). The world is the
                stage box: ceiling at the stage top, walls at the world edges, and a
                body that comes to rest partly outside it is nudged back in, so no
                object can ever cover the static footer or the controls row.
   · still    — reduced motion, or Matter unavailable: no engine; a composed
                still life (STILL tables). Taps still work.
   · static   — JS off / module failed: CSS lays the brand objects in a row.

   M0-EXT hooks (SPEC-CD §3.1): the 'variant' touch kind spawns one PAPER object (sand, 1px ink .14
   hairline, 200×120 / 150×90 on phones, the booklet's physics); its face is the entry's render(),
   called on spawn and on every language swap; a newer entry replaces it. Just before the scripted
   turn's Seal lifts, the bench awaits WF.hooks.run('bench:preturn', {line, pieces:{mo, sadfa, najah},
   reduced}, 1400) (viewport rects); with no hook registered it goes on synchronously, as before.
   ========================================================================== */
WF.module('bench', function (root) {
  'use strict';
  var q = function (s, sc) { return (sc || root).querySelector(s); };
  var qa = function (s, sc) { return Array.prototype.slice.call((sc || root).querySelectorAll(s)); };
  var T = WF.T, EZ = T.fn;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var now = function () { return performance.now(); };

  var stage = q('.bench__stage'), wrap = q('.bench__wrap'), layer = q('.bench__layer'), linebox = q('.bench__linebox');
  var line = q('#bench-line'), probe = q('.bench__probe'), world = q('.bench__world'), table = q('.bench__table');
  var enBlock = q('.bench__en'), gloss = q('.bench__gloss'), caption = q('.bench__caption');
  var btnTidy = q('.bench__tidy'), colophon = q('.bench__colophon'), floorEl = q('.bench__floor');
  if (!stage || !line || !world || !table || !layer || !linebox) return;
  root.classList.add('is-live');   // the live layout (independent of the bootstrap's .js failsafe)
  // a host that sizes the frame to its content (SPEC §4.8): the stage takes a fixed height (bench.css)
  if (WF.autoSized) root.classList.add('is-autosized');

  /* ── data ──────────────────────────────────────────────────────────────── */
  var SEED = 1447;
  var SVCS = ['manage', 'launch', 'social', 'custom'];
  // the key tags present in the markup (Snapchat only while flags.snapchat is on)
  var TAGS = ['wa', 'ig', 'tt', 'x', 'sc'].filter(function (t) { return !!q('[data-obj="' + t + '"]'); });
  var GUIDE = { g1: 'store-readiness', g2: 'product-page-guide', g3: 'content-planner' };
  var TAG_KEY = { wa: 'bench.tag.wa', ig: 'bench.tag.ig', tt: 'bench.tag.tt', x: 'bench.tag.x', sc: 'footer.snapchat' };
  // SPEC §3.10 object table: density, restitution, grab stiffness, friction, air drag.
  // g6-02: heavy things fall like heavy things (gravity .0032, thin air); the broad flat pieces
  // (plates, tags) catch a little more air. Restitution stays ≤ .15 (BRIEF §3a).
  var GRAVITY = .0032, AIR_SETTLE = .08;
  var PHYS = {
    seal: { d: .012, e: .02, k: .06, f: .8, air: .004 },
    sort: { d: .006, e: .06, k: .10, f: .8, air: .004 },
    mark: { d: .008, e: .04, k: .10, f: .8, air: .004 },
    plate: { d: .003, e: .08, k: .16, f: .6, air: .006 },
    booklet: { d: .002, e: .06, k: .18, f: .8, air: .004 },
    paper: { d: .002, e: .06, k: .18, f: .8, air: .004 },     // M0-EXT: the variant's paper = the booklet's physics
    slip: { d: .0015, e: .06, k: .20, f: .8, air: .004 },
    tag: { d: .0015, e: .12, k: .22, f: .6, air: .006 },
  };
  // the mark: hand-traced convex parts of the W-anvil, in the SVG's own units.
  // Legs, the middle block (with the bridge above the anvil) and the two bulges of
  // the anvil's waist. The anvil hollow stays open: small things can lodge in it.
  var MARK_BOX = [270.75, 545.99, 1530.82, 1007.97];
  var MARK_PARTS = [
    [[270.75, 546.12], [655.10, 546.23], [760.91, 965.35], [788.66, 1163.89], [827.46, 1496.36], [827.35, 1553.62], [545.82, 1553.74]],
    [[869.14, 546.19], [1205.72, 546.30], [1305.31, 965.47], [1303.91, 1070.98], [763.10, 1071.12], [760.91, 965.35]],
    [[1414.82, 546.30], [1801.57, 546.30], [1521.48, 1553.65], [1238.97, 1553.61], [1239.10, 1496.39], [1277.38, 1164.02], [1305.31, 965.47]],
    [[788.66, 1163.89], [940.64, 1221.32], [960.0, 1270.0], [955.42, 1325.94], [920.0, 1410.0], [827.46, 1496.36]],
    [[1277.38, 1164.02], [1174.55, 1182.55], [1125.0, 1215.0], [1107.54, 1292.65], [1125.0, 1380.0], [1186.67, 1455.33], [1239.10, 1496.39]],
  ];
  // knolling order (SPEC: tags → booklets → slip → service plates → mark → «مو», «صد»)
  var KNOLL = ['tag', 'booklet', 'paper', 'slip', 'plate', 'mark', 'sort'];

  /* The still life (reduced motion, and the fallback when Matter fails).
     Each item: {id, x (0–1 of world width, the object's centre), y (px up from the floor
     to the object's bottom, or from the top of `on`), a (rad), on?}. Slots for visit
     objects (booklet-1…2, slip) and the optional Snapchat tag fill only when they exist.
     Physical coordinates: the bench never mirrors. «مو» and «صد» lie together near the
     line's inline-end (the left); the Seal rests on the mark. */
  var STILL = {
    desktop: [
      { id: 'svc-launch', x: .925, y: 0, a: .012 },
      { id: 'svc-manage', x: .918, y: 0, a: -.035, on: 'svc-launch' },
      { id: 'slip', x: .93, y: 0, a: .05, on: 'svc-manage' },
      { id: 'svc-social', x: .775, y: 0, a: .006 },
      { id: 'svc-custom', x: .782, y: 0, a: .03, on: 'svc-social' },
      { id: 'wa', x: .64, y: 0, a: 0 },
      { id: 'ig', x: .646, y: 0, a: -.026, on: 'wa' },
      { id: 'tt', x: .636, y: 0, a: .02, on: 'ig' },
      { id: 'x', x: .642, y: 0, a: -.012, on: 'tt' },
      { id: 'sc', x: .638, y: 0, a: .016, on: 'x' },
      { id: 'mark', x: .505, y: 0, a: 0 },
      { id: 'seal', x: .503, y: 0, a: .03, on: 'mark' },
      { id: 'booklet-1', x: .385, y: 0, a: .06 },
      { id: 'booklet-2', x: .302, y: 0, a: -.045 },
      { id: 'paper', x: .215, y: 0, a: -.03 },        // M0-EXT: the variant's paper (when there is one)
      { id: 'sad', x: .10, y: 0, a: .008 },
      { id: 'mo', x: .115, y: 0, a: -.045, on: 'sad' },
    ],
    mobile: [
      { id: 'wa', x: .815, y: 0, a: 0 },
      { id: 'ig', x: .824, y: 0, a: -.03, on: 'wa' },
      { id: 'tt', x: .806, y: 0, a: .024, on: 'ig' },
      { id: 'svc-manage', x: .80, y: 0, a: -.02, on: 'tt' },
      { id: 'svc-social', x: .818, y: 0, a: .03, on: 'svc-manage' },
      { id: 'svc-custom', x: .80, y: 0, a: -.015, on: 'svc-social' },
      { id: 'mark', x: .455, y: 0, a: 0 },
      { id: 'paper', x: .455, y: 0, a: -.025, on: 'mark' },   // M0-EXT: absent → the Seal rests on the mark, as before
      { id: 'seal', x: .452, y: 0, a: .035, on: 'paper' },
      { id: 'sad', x: .14, y: 0, a: .012 },
      { id: 'mo', x: .156, y: 0, a: -.05, on: 'sad' },
      { id: 'slip', x: .16, y: 0, a: -.03, on: 'mo' },
      { id: 'svc-launch', x: .17, y: 0, a: .02, on: 'slip' },
      { id: 'booklet-1', x: .14, y: 0, a: -.04, on: 'svc-launch' },
      { id: 'booklet-2', x: .82, y: 0, a: .03, on: 'svc-custom' },
    ],
  };

  /* ── state ─────────────────────────────────────────────────────────────── */
  var M = null;                    // Matter namespace once loaded
  var mode = 'wait';               // 'wait' | 'physics' | 'still'
  var engine = null, walls = [], floorBody = null;
  var objs = {};                   // id → object record
  var order = 0;                   // arrival counter (for "oldest of the same kind")
  var geo = { W: 0, H: 0 };        // world width, floor y (world coords)
  var turnState = 'none';          // 'none' (static line) | 'pending' | 'running' | 'done'
  var sealHome = 'world';          // 'line' (waiting on the rule) | 'world'
  var turnedLive = false;          // the turn ran in front of the visitor (the line keeps its size)
  var lineMode = 'beside';         // 'beside' (Seal on the rule after «.») | 'top' (phones: on the type)
  var F = 0;                       // the line's fitted font size
  var grab = null, lastTap = null, grabbedOnce = false, captionShown = false, turnPress = null;
  var visible = false, inView20 = false, overlayOpen = false;
  var queue = [], dropping = false, tween = null;
  var raf = 0, running = false, lastActive = 0, silent = false, sealLanded = true;
  var hits = [], zTop = 10, contactInfo = null, turnT0 = 0, stillWhy = '';
  var rng = mulberry32(SEED);
  var brandHTML = {};   // the authored markup of every brand object (phones prune some; they can come back)

  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  /* ── text on objects (re-rendered on every language swap; no animation) ── */
  function renderFaces() {
    qa('.bench__plate', table).forEach(function (el) {
      var id = el.getAttribute('data-svc');
      // the struck anchor sits on its own small line above the new price (reading order: was, then now);
      // a quote-priced plate (custom, launch on Zid/Shopify) has none. Same face size either way.
      var v = (WF.cart.get(id) || {}).variant;
      var p = el.querySelector('.bench__pprice'); if (p) { p.innerHTML = WF.fmt.was(id, v) + '<span class="bench__pnow">' + WF.fmt.price(id, v) + '</span>'; fitAnchor(el, p); }
      el.classList.toggle('is-in-cart', WF.cart.has(id));
    });
    var wa = q('[data-obj="wa"]', table); if (wa) wa.href = WF.wa.link('hello');
    // key tags: icon + handle; the name says whose account it is (the world is aria-hidden, the links
    // are repeated in the static footer, but the tag still carries a true name)
    qa('.bench__tag[data-obj]', table).forEach(function (el) {
      var k = TAG_KEY[el.getAttribute('data-obj')];
      if (k) el.setAttribute('aria-label', WF.t('footer.social.aria', { platform: WF.t(k) }));
    });
    Object.keys(objs).forEach(function (id) {
      var o = objs[id];
      if (o.kind === 'booklet') o.el.href = guideHref(o.g);
      if (o.kind === 'slip') renderSlip(o.el);
      if (o.kind === 'paper') renderPaper(o);
    });
    if (turnState === 'done' && gloss) { gloss.setAttribute('data-i18n', 'bench.gloss.after'); gloss.textContent = WF.t('bench.gloss.after'); }
    var sb = objs.seal && objs.seal.el;
    if (sb && sb.tagName === 'BUTTON') sb.setAttribute('aria-label', WF.t('bench.strike'));
    var sl = q('.bench__strike'); if (sl) sl.textContent = WF.t('bench.strike');
  }
  // The anchor only where it fits. A name that takes three lines on a phone plate (EN "Store & social
  // media management") leaves no room under it, and then that plate shows the new price alone: the
  // body never grows. Runs only after build() (renderFaces is never called at boot), so the read is cheap.
  function fitAnchor(el, p) {
    el.classList.remove('is-tight');
    if (!p.querySelector('.was')) return;
    var nm = el.querySelector('.bench__pname'), cs = getComputedStyle(el);
    var room = el.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
    if (nm && nm.offsetHeight + p.offsetHeight + 2 > room) el.classList.add('is-tight');
  }
  function guideHref(g) { return 'https://winnersforge.com/' + (WF.lang === 'en' ? 'en/' : '') + 'pages/' + GUIDE[g]; }
  function renderSlip(el) {
    var list = el.querySelector('.bench__sl'); if (!list) return;
    var head = el.querySelector('.bench__sh'); if (head) head.textContent = WF.t('bench.slip');
    list.innerHTML = '';
    WF.cart.items().slice(0, 3).forEach(function (it) {
      var li = document.createElement('li'); li.textContent = WF.t('core.svc.' + it.id + '.name'); list.appendChild(li);
    });
  }


  /* ── Kufi metrics (canvas, the loaded face) ────────────────────────────── */
  var cv = null;   // made on first use (g6-12: nothing is measured at boot)
  function kufi(t, px) {
    if (!cv) cv = document.createElement('canvas').getContext('2d');
    cv.font = '700 ' + px + 'px "Noto Kufi Arabic"';
    try { cv.direction = 'rtl'; } catch (e) { /* older engines */ }
    var m = cv.measureText(t);
    return { adv: m.width, asc: m.actualBoundingBoxAscent, desc: m.actualBoundingBoxDescent, fA: m.fontBoundingBoxAscent || px * 1.28, fD: m.fontBoundingBoxDescent || px * .62 };
  }
  // printer's sort geometry for «مو» / «صد» at font size px: one body height for both
  // (the type body of this line), the glyph's own advance for the width
  function sortGeo(piece, px) {
    var mo = kufi('مو', px), sad = kufi('صد', px), m = piece === 'mo' ? mo : sad;
    var A = Math.max(mo.asc, sad.asc), D = Math.max(mo.desc, sad.desc);
    var padY = .06 * px, padX = .12 * px;
    var h = Math.max(A + D + 2 * padY, 44), extra = (h - (A + D + 2 * padY)) / 2;
    var w = Math.max(m.adv + 2 * padX, 44);
    var padTop = padY + extra;
    var baseInBlock = (px - (m.fA + m.fD)) / 2 + m.fA;   // baseline inside a line-height:1 block
    return { w: w, h: h, A: A, padTop: padTop, padX: (w - m.adv) / 2, glyphTop: padTop + A - baseInBlock, fA: m.fA };
  }

  /* ── line fitting, the Seal's rest, the stage height ───────────────────── */
  function sealSize() { return WF.mobile ? 80 : 112; }
  function fsXl() {   // the --fs-xl token in px at this width: the line never exceeds the type scale
    var keep = probe.style.fontSize; probe.style.fontSize = '';
    var v = parseFloat(getComputedStyle(probe).fontSize) || 144;
    probe.style.fontSize = keep; return Math.min(144, v);
  }
  function sealOnLine() { return sealHome === 'line' && (turnState === 'pending' || turnState === 'running'); }
  function headerH() { var h = document.getElementById('wf-header'); return h ? h.offsetHeight : 0; }
  function headerBottom() { var h = document.getElementById('wf-header'); return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0; }
  // how far the lifted Seal reaches above its own resting top: the near-stop's 4px, plus the
  // corners of a 112px block at −8° and ×1.06
  function sealExtra() { var S = sealSize(), k = Math.PI / 180 * 8; return T.nearRise + S / 2 * (1.06 * (Math.cos(k) + Math.sin(k)) - 1); }
  // the ink top of the line (viewport y): every piece shares one baseline
  function inkTopNow() {
    var n = line.querySelector('[data-piece="najah"]') || line; var r = n.getBoundingClientRect();
    return r.top + kufi('النجاح', F).fA - Math.max(kufi('مو', F).asc, kufi('صد', F).asc);
  }
  function setLz() {   // the line zone: everything above the pile room (line, rule, EN gloss, caption)
    var lz = Math.ceil(caption.offsetTop + caption.offsetHeight);
    root.style.setProperty('--bench-lz', lz + 'px');
    return lz;
  }
  var head = 0;   // extra room above the line so the strike clears the sticky header at the page end
  function fit() {
    var S = sealSize();
    // the line is sized for the whole sentence plus the Seal beside it, and keeps that size
    // after the turn (the rule's end simply frees up); still life sizes it for the sentence alone
    var reserve = turnState === 'pending' || turnState === 'running' || (turnState === 'done' && turnedLive);
    linebox.style.paddingInlineEnd = '';
    layer.style.paddingTop = '';
    // g6-01: on short screens the line gives way (≤ 12% of the viewport height), so the line zone shrinks
    var min = 30, max = Math.max(min, Math.min(fsXl(), WF.autoSized ? 1e4 : .12 * innerHeight));
    var base = 0;
    if (reserve) {
      linebox.style.paddingInlineEnd = (S + 32) + 'px';
      F = WF.fitLine(probe, { min: min, max: max });
      lineMode = 'beside';
      if (F < 40) {           // phones: the sentence needs the whole rule; the Seal waits on the type
        lineMode = 'top';
        linebox.style.paddingInlineEnd = '';
        F = WF.fitLine(probe, { min: min, max: max });
      }
      if (lineMode === 'top') base = Math.round(S * .62);
      if (turnState === 'done') linebox.style.paddingInlineEnd = '';
    } else {
      F = WF.fitLine(probe, { min: min, max: max });
    }
    line.style.fontSize = F + 'px';
    if (colophon) root.style.setProperty('--bench-colo', Math.ceil(colophon.offsetHeight) + 'px');
    layer.style.paddingTop = base ? base + 'px' : '';
    setLz();
    head = reserve ? headroom(base) : 0;
    if (sealOnLine() && objs.seal && turnState !== 'running') placeSealOnLine();
  }
  // The turn plays where the visitor stops, and most visitors stop at the very end of the page. There,
  // the stage sits right under the header; if the Seal could not lift over «مو صد» without passing
  // under the header, the line steps down just enough (never eating the pile's room below minRoom).
  function headroom(base) {
    var de = document.documentElement, S = sealSize(), hb = headerH(), extra = sealExtra();
    // aim for a 48px lift at the page end (40 on phones, where the full lift is 56); the pile keeps
    // the room its objects need (at least 180px; a fuller bench gets more), and the gate settles for
    // a shorter lift where that is all the screen allows
    var Lwant = WF.mobile ? 40 : 48, minRoom = WF.mobile ? 300 : clamp(expectedArea() / (Math.max(1, world.clientWidth) * .75), 180, 280);
    var gap = parseFloat(getComputedStyle(root).getPropertyValue('--bench-gap')) || 72;
    var h = 0;
    for (var i = 0; i < 6; i++) {
      var maxScroll = Math.max(0, de.scrollHeight - innerHeight);   // (a page that does not scroll: where it is)
      var sr = stage.getBoundingClientRect();
      var atMax = sr.top + scrollY - maxScroll;                                   // stage top at the page end
      var inStage = (inkTopNow() - sr.top) - S - 3 - Lwant - extra;                // the lifted Seal's top, from the stage top
      var reach = atMax + inStage;                                                 // … and in the viewport at the page end
      // SPEC-V2 §3.12: the stage top clips (#bench overflow:clip), so the full lift always fits inside
      // the stage; that part is small and always taken. Clearing the header is taken while the pile
      // keeps its room.
      var dStage = 4 - inStage, dHead = WF.autoSized ? 0 : hb + 8 - reach;
      var deficit = Math.max(dStage, dHead);
      if (deficit <= .5) break;
      var room = stage.offsetHeight - (caption.offsetTop + caption.offsetHeight) - gap;
      var add = Math.max(dStage > .5 ? Math.ceil(dStage) : 0, Math.min(Math.ceil(deficit), Math.floor(room - minRoom)));
      if (add <= 0) break;
      h += add;
      layer.style.paddingTop = (base + h) + 'px';
      setLz();
    }
    return h;
  }
  function lineRects() {
    var pick = function (p) { return line.querySelector('[data-piece="' + p + '"]'); };
    return { mo: pick('mo'), sad: pick('sad'), dot: pick('dot'), fa: pick('fa'), slot: line.querySelector('.turn__slot') };
  }
  function toLayer(x, y) { var b = layer.getBoundingClientRect(); return { x: x - b.left, y: y - b.top }; }
  function placeSealOnLine() {
    var o = objs.seal; if (!o) return;
    var S = sealSize(), r = lineRects(); if (!r.dot || !r.fa) return;
    var dot = r.dot.getBoundingClientRect(), lb = linebox.getBoundingClientRect();
    var p;
    if (lineMode === 'beside') {
      p = toLayer(dot.left - 32 - S / 2, lb.bottom - 2 - S / 2 - 3);
    } else {
      var fa = r.fa.getBoundingClientRect(), m = kufi('فة', F);
      var inkTop = fa.top + m.fA - m.asc;
      p = toLayer(dot.left + S / 2 - 2, inkTop - S / 2 - 3);
    }
    WF.seal.place(o.el, p, { layer: layer });
    placeStrikeLabel();
  }
  function placeStrikeLabel() {
    var sl = q('.bench__strike'); if (!sl || !objs.seal) return;
    var c = WF.seal.center(objs.seal.el); if (!c) return;
    var S = sealSize();
    // under the Seal, and always under the rule (on phones the Seal waits on the type, so a label
    // straight under it would sit on the glyphs)
    var lb = linebox.getBoundingClientRect(), under = toLayer(0, lb.bottom).y + 12;
    var x = clamp(c.x - sl.offsetWidth / 2, 0, Math.max(0, layer.clientWidth - sl.offsetWidth));
    sl.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(Math.max(c.y + S / 2 + 14, under)) + 'px)';
  }
  function ruleBottomWorld() { return linebox.getBoundingClientRect().bottom - world.getBoundingClientRect().top; }
  // strike target: over the slot, the Seal's face landing on the ink tops of «مو صد»
  function strikeTarget() {
    var r = lineRects(), S = sealSize();
    var a = r.mo.getBoundingClientRect(), b = r.sad.getBoundingClientRect();
    var left = Math.min(a.left, b.left), right = Math.max(a.right, b.right);
    var mo = kufi('مو', F), sad = kufi('صد', F);
    var base = a.top + mo.fA;
    var inkTop = base - Math.max(mo.asc, sad.asc);
    return toLayer((left + right) / 2, inkTop - S / 2 + 2);
  }
  function measureGeo() {
    geo.W = world.clientWidth;
    geo.H = world.clientHeight;
  }

  /* ── object records ────────────────────────────────────────────────────── */
  function rec(id, kind, el, extra) {
    var o = Object.assign({ id: id, kind: kind, el: el, body: null, visit: false, order: order++, x: 0, y: 0, a: 0, rx: NaN, ry: NaN, ra: NaN, awake: false }, extra || {});
    o.w = el.offsetWidth; o.h = el.offsetHeight;
    o.ox = o.w / 2; o.oy = o.h / 2;
    if (kind === 'mark') { var c = markCentroid(o.w); o.ox = c.x; o.oy = c.y; }
    el.style.transformOrigin = o.ox + 'px ' + o.oy + 'px';
    objs[id] = o;
    wire(o);
    return o;
  }
  function markScale(w) { return w / MARK_BOX[2]; }
  function markLocalParts(w) {
    var k = markScale(w);
    return MARK_PARTS.map(function (part) { return part.map(function (p) { return { x: (p[0] - MARK_BOX[0]) * k, y: (p[1] - MARK_BOX[1]) * k }; }); });
  }
  function markCentroid(w) {   // area-weighted centroid of the parts (what Matter will use)
    var parts = markLocalParts(w), A = 0, cx = 0, cy = 0;
    parts.forEach(function (v) {
      var a = 0, x = 0, y = 0;
      for (var i = 0; i < v.length; i++) {
        var p = v[i], n = v[(i + 1) % v.length], c = p.x * n.y - n.x * p.y;
        a += c; x += (p.x + n.x) * c; y += (p.y + n.y) * c;
      }
      a /= 2; if (!a) return;
      cx += x / 6; cy += y / 6; A += a;
    });
    return { x: cx / A, y: cy / A };
  }

  // visit-object factories
  function makeBooklet(g) {
    var el = document.createElement('a');
    el.className = 'bench__obj bench__book';
    el.setAttribute('data-obj', 'book-' + g);
    el.href = guideHref(g); el.target = '_blank'; el.rel = 'noopener'; el.tabIndex = -1; el.draggable = false;
    var t = document.createElement('span'); t.className = 'bench__bt'; t.setAttribute('data-i18n', 'bench.book.' + g); t.textContent = WF.t('bench.book.' + g);
    el.appendChild(t);
    table.appendChild(el);
    return rec('book-' + g, 'booklet', el, { visit: true, g: g, link: true });
  }
  function makeSlip() {
    var el = document.createElement('div');
    el.className = 'bench__obj bench__slip';
    el.setAttribute('data-obj', 'slip');
    var h = document.createElement('b'); h.className = 'bench__sh'; h.setAttribute('data-i18n', 'bench.slip'); h.textContent = WF.t('bench.slip');
    var ul = document.createElement('ul'); ul.className = 'bench__sl';
    el.appendChild(h); el.appendChild(ul);
    renderSlip(el);
    table.appendChild(el);
    return rec('slip', 'slip', el, { visit: true });
  }
  // M0-EXT: the variant's visit object — a sheet of paper whose face is the variant's render()
  function renderPaper(o) {
    var face = o.el.querySelector('.bench__pface'); if (!face) return;
    var html = '';
    try { html = String(o.render() || ''); } catch (e) { console.error('[wf:bench] variant render', e); }
    face.innerHTML = html;
  }
  function makePaper(d) {
    var el = document.createElement('div');
    el.className = 'bench__obj bench__paper';
    el.setAttribute('data-obj', d.id); el.setAttribute('data-variant-obj', d.vid); el.setAttribute('aria-hidden', 'true');
    var face = document.createElement('div'); face.className = 'bench__pface';
    el.appendChild(face);
    table.appendChild(el);
    var o = rec(d.id, 'paper', el, { visit: true, render: d.render, vid: d.vid });
    renderPaper(o);
    return o;
  }
  function makeSortEl(piece, px) {
    var g = sortGeo(piece, px);
    var el = document.createElement('div');
    el.className = 'bench__obj bench__sort';
    el.setAttribute('data-obj', piece);
    el.setAttribute('lang', 'ar'); el.setAttribute('dir', 'rtl');
    el.style.width = g.w.toFixed(2) + 'px'; el.style.height = g.h.toFixed(2) + 'px';
    var s = document.createElement('span'); s.className = 'bench__glyph';
    s.textContent = piece === 'mo' ? 'مو' : 'صد';
    s.style.fontSize = px + 'px'; s.style.top = g.glyphTop.toFixed(2) + 'px';
    el.appendChild(s);
    table.appendChild(el);
    return { el: el, g: g };
  }
  function makeSort(piece, px) { var m = makeSortEl(piece, px); var o = rec(piece, 'sort', m.el); o.g = m.g; return o; }

  /* ── which objects belong on the bench now (SPEC "Sets" + caps) ────────── */
  // SPEC-V2 §3.12: no work plates, no screenshots. The visit set is the guides opened and the cart.
  function visitBooklets() {
    var seen = {}, out = [];
    WF.touch.list().forEach(function (t) { if (t.kind === 'booklet' && GUIDE[t.id] && !seen[t.id]) { seen[t.id] = 1; out.push(t.id); } });
    return out;
  }
  // M0-EXT: the one variant visit object (the latest 'variant' touch entry), or null
  function visitVariant() {
    var t = WF.touch.list().filter(function (x) { return x.kind === 'variant'; })[0];
    return t ? { id: 'var-' + t.seq, kind: 'paper', render: t.render, vid: t.id } : null;
  }
  // desired set, highest priority first; the cap trims from the end
  function wantedSet(withSorts) {
    var vv = visitVariant();
    var mob = WF.mobile, list = [];
    list.push({ id: 'seal', kind: 'seal' });
    if (withSorts) { list.push({ id: 'mo', kind: 'sort' }); list.push({ id: 'sad', kind: 'sort' }); }
    list.push({ id: 'mark', kind: 'mark' });
    if (mob) {
      ['wa', 'ig', 'tt'].forEach(function (t) { list.push({ id: t, kind: 'tag' }); });
      if (WF.cart.count()) list.push({ id: 'slip', kind: 'slip' });
      if (vv) list.push(vv);
      SVCS.forEach(function (s) { if (WF.cart.has(s)) list.push({ id: 'svc-' + s, kind: 'plate' }); });
      visitBooklets().slice(0, 2).forEach(function (g) { list.push({ id: 'book-' + g, kind: 'booklet', g: g }); });
    } else {
      SVCS.forEach(function (s) { list.push({ id: 'svc-' + s, kind: 'plate' }); });
      TAGS.forEach(function (t) { list.push({ id: t, kind: 'tag' }); });
      if (WF.cart.count()) list.push({ id: 'slip', kind: 'slip' });
      if (vv) list.push(vv);
      visitBooklets().slice(0, 2).forEach(function (g) { list.push({ id: 'book-' + g, kind: 'booklet', g: g }); });
    }
    var cap = mob ? 11 : 18;
    if (!withSorts) cap -= 2;   // «مو» and «صد» are coming
    list = list.slice(0, cap);
    // g6-01: a short screen also caps the pile by area (the room is measured): the guides give way
    // first; the brand set and the slip always stay
    var budget = capacity();
    if (budget < Infinity) {
      var total = 0;
      list.forEach(function (d) { total += areaOf(d); });
      if (!withSorts) total += areaOf({ id: 'mo', kind: 'sort' }) + areaOf({ id: 'sad', kind: 'sort' });
      var drop = function (kind, keep) {
        for (var i = list.length - 1; i >= 0 && total > budget; i--) {
          if (list[i].kind !== kind) continue;
          if (keep && list.filter(function (x) { return x.kind === kind; }).length <= keep) break;
          total -= areaOf(list[i]); list.splice(i, 1);
        }
      };
      drop('booklet', 0);
    }
    return list;
  }
  // the pile's area budget on desktop: three quarters of the measured room (phones have their own caps)
  var SIZE = { booklet: [90, 120], paper: [200, 120], slip: [140, 90], plate: [168, 104], tag: [136, 56], mark: [180, 118], seal: [112, 112] };
  // the area of what always stays on a desktop bench (the brand set, the sorts, the slip); the
  // guides take what room is left (the area budget in wantedSet)
  function expectedArea() {
    var z = function (k) { return SIZE[k][0] * SIZE[k][1]; };
    var sorts = F ? areaOf({ id: 'mo', kind: 'sort' }) + areaOf({ id: 'sad', kind: 'sort' }) : 2 * 9000;
    return z('seal') + z('mark') + 4 * z('plate') + TAGS.length * z('tag') + sorts + (WF.cart.count() ? z('slip') : 0);
  }
  function capacity() {
    if (WF.mobile || !geo.W) return Infinity;
    var room = geo.H - (caption.offsetTop + caption.offsetHeight);
    return room > 0 ? geo.W * room * .75 : Infinity;
  }
  function areaOf(d) {
    var o = objs[d.id]; if (o && !o.leaving) return o.w * o.h;
    if (d.kind === 'sort') { var g = sortGeo(d.id, F || 40); return g.w * g.h; }
    var z = SIZE[d.kind]; return z ? z[0] * z[1] : 0;
  }
  function pileArea() {
    var t = 0; Object.keys(objs).forEach(function (k) { var o = objs[k]; if (!o.leaving && (o.id !== 'seal' || sealHome === 'world')) t += o.w * o.h; });
    if (!objs.mo) t += areaOf({ id: 'mo', kind: 'sort' }) + areaOf({ id: 'sad', kind: 'sort' });
    if (sealHome === 'line') t += areaOf({ id: 'seal', kind: 'seal' });
    return t;
  }
  // make sure the record for a descriptor exists (brand objects are in the HTML)
  function ensure(d) {
    if (objs[d.id]) return objs[d.id];
    if (d.kind === 'booklet') return makeBooklet(d.g);
    if (d.kind === 'slip') return makeSlip();
    if (d.kind === 'paper') return makePaper(d);
    if (d.kind === 'sort') return makeSort(d.id, F);
    var el = q('[data-obj="' + d.id + '"]', table) || q('[data-obj="' + d.id + '"]');
    if (!el && brandHTML[d.id]) { var tpl = document.createElement('div'); tpl.innerHTML = brandHTML[d.id]; el = tpl.firstChild; table.appendChild(el); renderFaces(); }
    if (!el) return null;
    var extra = {};
    if (d.kind === 'plate') extra.svc = el.getAttribute('data-svc');
    if (d.kind === 'tag') extra.link = true;
    return rec(d.id, d.kind, el, extra);
  }
  // brand objects not wanted on this bench (phones) leave the DOM; visit ones never get made
  function prune(wanted) {
    var keep = {}; wanted.forEach(function (d) { keep[d.id] = 1; });
    qa('.bench__obj', table).forEach(function (el) {
      var id = el.getAttribute('data-obj');
      if (id === 'seal' || keep[id] || id === 'mo' || id === 'sad') return;
      if (objs[id]) { removeBody(objs[id]); delete objs[id]; }
      el.remove();
    });
  }

  /* ── transforms ────────────────────────────────────────────────────────── */
  function write(o, x, y, a) {
    o.x = x; o.y = y; o.a = a;
    if (Math.abs(x - o.rx) < .01 && Math.abs(y - o.ry) < .01 && Math.abs(a - o.ra) < .00005) return;
    o.rx = x; o.ry = y; o.ra = a;
    o.el.style.transform = 'translate3d(' + (x - o.ox).toFixed(2) + 'px,' + (y - o.oy).toFixed(2) + 'px,0) rotate(' + a.toFixed(5) + 'rad)';
  }
  // box centre (AABB centre at angle a) → the object's pose point (its body centre)
  function boxToPose(o, cx, cy, a) {
    var dx = o.ox - o.w / 2, dy = o.oy - o.h / 2, c = Math.cos(a), s = Math.sin(a);
    return { x: cx + dx * c - dy * s, y: cy + dx * s + dy * c };
  }
  function placed(o) { o.el.classList.add('is-placed'); }

  /* ── Matter world ──────────────────────────────────────────────────────── */
  function makeEngine() {
    var E = M.Engine.create({ enableSleeping: true, positionIterations: 8, velocityIterations: 6 });
    E.gravity.x = 0; E.gravity.y = 1; E.gravity.scale = GRAVITY;
    M.Events.on(E, 'beforeUpdate', clampSpeeds);
    M.Events.on(E, 'collisionStart', onCollide);
    return E;
  }
  function buildWalls() {
    walls.forEach(function (w) { M.Composite.remove(engine.world, w); });
    var W = geo.W, H = geo.H, t = 200, opt = { isStatic: true, friction: .8, frictionStatic: 1.2, restitution: 0 };
    floorBody = M.Bodies.rectangle(W / 2, H + t / 2, W + 2 * t + 400, t, opt);
    // SPEC-V2 §3.12: the ceiling is the stage top (round 1 had it 240px above, so a throw could fly
    // over the static footer and sit on its links while it fell); #bench also clips there
    var top = 0, tall = H - top + 2 * t;
    var left = M.Bodies.rectangle(-t / 2, top + tall / 2 - t, t, tall, opt);
    var right = M.Bodies.rectangle(W + t / 2, top + tall / 2 - t, t, tall, opt);
    var ceil = M.Bodies.rectangle(W / 2, top - t / 2, W + 2 * t, t, opt);
    walls = [floorBody, left, right, ceil];
    walls.forEach(function (w) { w.plugin = { wall: true }; });
    M.Composite.add(engine.world, walls);
  }
  function bodyOpts(o) {
    var p = PHYS[o.kind];
    return { density: p.d, restitution: p.e, friction: p.f, frictionStatic: 1.2, frictionAir: p.air, slop: .12, sleepThreshold: 12 };
  }
  function makeBody(o, x, y, a) {
    var b, opts = bodyOpts(o);
    if (o.kind === 'mark') {
      var parts = markLocalParts(o.w).map(function (v) {
        M.Vertices.clockwiseSort(v);
        var c = M.Vertices.centre(v);
        return M.Body.create({ position: c, vertices: v });
      });
      b = M.Body.create(Object.assign({ parts: parts }, opts));
      // the compound's centre (in element coords) must match our pose point
      o.ox = b.position.x; o.oy = b.position.y;
      o.el.style.transformOrigin = o.ox + 'px ' + o.oy + 'px';
      M.Body.setPosition(b, { x: x, y: y });
    } else {
      b = M.Bodies.rectangle(x, y, o.w, o.h, Object.assign({ chamfer: { radius: 4 } }, opts));
    }
    M.Body.setAngle(b, a || 0);
    b.plugin = { o: o };
    o.body = b;
    M.Composite.add(engine.world, b);
    return b;
  }
  function removeBody(o) {
    if (o.body && engine) { M.Composite.remove(engine.world, o.body); }
    o.body = null;
  }
  function wakeAll() { if (!engine) return; Object.keys(objs).forEach(function (id) { var b = objs[id].body; if (b && !b.isStatic) M.Sleeping.set(b, false); }); }
  function clampSpeeds() {
    Object.keys(objs).forEach(function (id) {
      var b = objs[id].body; if (!b || b.isStatic || b.isSleeping) return;
      var v = M.Body.getVelocity(b), s = Math.sqrt(v.x * v.x + v.y * v.y);
      if (s > 38) M.Body.setVelocity(b, { x: v.x * 38 / s, y: v.y * 38 / s });
      var w0 = M.Body.getAngularVelocity(b), w = w0;
      if (Math.abs(w) > .25) w = w > 0 ? .25 : -.25;
      // thin air lets a slow body keep rocking; a slow body loses its spin (flight is untouched)
      if (s < 2) w *= .94;
      // a piece in the hand swings once and hangs; it never whirls round the grip
      if (grab && grab.o.body === b) w *= .9;
      if (w !== w0) M.Body.setAngularVelocity(b, w);
    });
  }
  function onCollide(ev) {
    if (silent) return;
    var t = now();
    ev.pairs.forEach(function (pair) {
      var A = pair.bodyA.parent || pair.bodyA, B = pair.bodyB.parent || pair.bodyB;
      var oa = A.plugin && A.plugin.o, ob = B.plugin && B.plugin.o;
      if (!oa && !ob) return;
      if ((A.isSleeping || A.isStatic) && (B.isSleeping || B.isStatic)) return;
      var va = M.Body.getVelocity(A), vb = M.Body.getVelocity(B), n = pair.collision.normal;
      var rel = Math.abs((va.x - vb.x) * n.x + (va.y - vb.y) * n.y);
      var floorish = A === floorBody || B === floorBody || (oa && ob);
      // the Seal: the heaviest thing lands last; the world takes IMPACT on its first contact
      if (!sealLanded && ((oa && oa.id === 'seal') || (ob && ob.id === 'seal')) && floorish) {
        sealLanded = true; WF.motion.impact(table);
      } else if (rel > 6 && floorish) WF.motion.impact(table);
    });
  }

  /* ── the runner: fixed step, two 1000/120 updates per frame, stops when all sleep ── */
  function isStill() { return mode === 'still' || mode === 'prestill'; }
  function canRun() { return !!engine && mode === 'physics' && visible && !document.hidden && !overlayOpen; }
  function kick() {
    lastActive = now();
    if (running || !canRun()) return;
    running = true;
    raf = requestAnimationFrame(tick);
  }
  function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }
  function tick(ts) {
    raf = 0;
    if (!canRun()) { running = false; return; }
    // the hand is held inside the world box: however far the pointer goes (over the footer, past the
    // page edge), the constraint never drags a body through the ceiling or a wall (SPEC-V2 §3.12)
    if (grab && grab.c) { grab.c.pointA.x = clamp(grab.px, 0, geo.W); grab.c.pointA.y = clamp(grab.py, 0, geo.H); M.Sleeping.set(grab.o.body, false); }
    M.Engine.update(engine, 1000 / 120);
    M.Engine.update(engine, 1000 / 120);
    settleAssist();
    var awake = renderAll();
    if (awake || grab || tween || dropping) lastActive = ts;
    if (ts - lastActive > 1200) {
      if (nudgeIn()) { lastActive = ts; raf = requestAnimationFrame(tick); return; }
      running = false; onRest(); return;
    }
    raf = requestAnimationFrame(tick);
  }
  // heavy things settle: once a body has been slow for ~¼s (resting-contact creep, a slow
  // rock), damp it toward rest so it sleeps. Flight and real bounces are never touched.
  function settleAssist() {
    // bodies in contact this step (a body in flight is never touched: no floaty apex)
    var touching = {};
    engine.pairs.list.forEach(function (pr) {
      if (!pr.isActive) return;
      var A = pr.bodyA.parent || pr.bodyA, B = pr.bodyB.parent || pr.bodyB;
      touching[A.id] = 1; touching[B.id] = 1;
    });
    Object.keys(objs).forEach(function (id) {
      var o = objs[id], b = o.body;
      if (!b || b.isStatic || b.isSleeping || (grab && grab.o === o) || !touching[b.id]) { if (o) { o.slow = 0; o.ref = null; } return; }
      var v = M.Body.getVelocity(b), w = M.Body.getAngularVelocity(b), sp = Math.sqrt(v.x * v.x + v.y * v.y);
      if (sp < 3 && Math.abs(w) < .05) o.slow = (o.slow || 0) + 1; else { o.slow = 0; o.ref = null; return; }
      if (o.slow > 8) { var k = o.slow > 20 ? .6 : .82; M.Body.setVelocity(b, { x: v.x * k, y: v.y * k }); M.Body.setAngularVelocity(b, w * k); }
      if (o.slow > 26) { M.Sleeping.set(b, true); o.slow = 0; o.ref = null; if (outsideBy(b)) nudgeIn(); return; }   // settles within ~½s of going slow on something
      // a body that is "moving" without going anywhere is contact jitter: it sleeps
      if (!o.ref) { o.ref = { x: b.position.x, y: b.position.y, a: b.angle, n: 0 }; return; }
      if (++o.ref.n < 10) return;
      var d = Math.hypot(b.position.x - o.ref.x, b.position.y - o.ref.y), da = Math.abs(b.angle - o.ref.a);
      if (d < 2.5 && da < .01) { M.Sleeping.set(b, true); o.slow = 0; o.ref = null; }
      else o.ref = { x: b.position.x, y: b.position.y, a: b.angle, n: 0 };
    });
  }
  function renderAll() {
    var any = false;
    Object.keys(objs).forEach(function (id) {
      var o = objs[id], b = o.body; if (!b) return;
      var aw = !b.isSleeping && !b.isStatic;
      if (tween && b.isStatic) aw = true;
      if (aw) any = true;
      if (aw !== o.awake) { o.awake = aw; o.el.style.willChange = aw ? 'transform' : ''; }
      write(o, b.position.x, b.position.y, b.angle);
    });
    return any;
  }
  // SPEC-V2 §3.12: bodies stay inside [0, W] × [0, floor]. A body that has come to rest partly
  // outside the world (a tunnelled throw, a knolled row that ran out of room, a body squeezed past a
  // wall by the hand) is nudged back in and allowed to settle again. Tolerance 2px (resting contact).
  function outsideBy(b) {
    var m = b.bounds, dx = 0, dy = 0;
    if (m.min.x < -2) dx = -m.min.x + 1; else if (m.max.x > geo.W + 2) dx = geo.W - m.max.x - 1;
    if (m.min.y < -2) dy = -m.min.y + 1; else if (m.max.y > geo.H + 2) dy = geo.H - m.max.y - 1;
    return dx || dy ? { x: dx, y: dy } : null;
  }
  var nudged = 0, nudgeLog = [];
  function nudgeIn() {
    if (!engine || mode !== 'physics' || tween) return false;
    var moved = false;
    Object.keys(objs).forEach(function (id) {
      var o = objs[id], b = o.body;
      if (!b || b.isStatic || (grab && grab.o === o)) return;
      var d = outsideBy(b); if (!d) { o.nudges = 0; return; }
      o.nudges = (o.nudges || 0) + 1;
      if (o.nudges > 3) {   // wedged: it is set down afresh over the lowest part of the pile
        o.nudges = 0; M.Body.setAngle(b, 0);
        var ex = o.w / 2, x = clamp(b.position.x, ex + 2, geo.W - ex - 2);
        M.Body.setPosition(b, { x: x, y: Math.max(o.h / 2 + 2, ruleBottomWorld() + 24 + o.h / 2) });
      } else M.Body.setPosition(b, { x: b.position.x + d.x, y: b.position.y + d.y });
      M.Body.setVelocity(b, { x: 0, y: 0 }); M.Body.setAngularVelocity(b, 0);
      M.Sleeping.set(b, false);
      moved = true; nudged++; nudgeLog.push(o.id + ':' + Math.round(d.x) + ',' + Math.round(d.y));
    });
    return moved;
  }
  // the runner has stopped: a true HOLD
  function onRest() {
    Object.keys(objs).forEach(function (id) { var o = objs[id]; if (o.awake) { o.awake = false; o.el.style.willChange = ''; } });
    if (turnState === 'done') showCaption();
  }

  /* ── spawning & the silent pre-settle ──────────────────────────────────── */
  function spawnAll(list) {
    var W = geo.W, H = geo.H, placedBoxes = [];
    var roomTop = caption.offsetTop + caption.offsetHeight;   // the line zone's bottom, in world coords
    var tight = H - roomTop < 280;
    // g6-03: what the turn knocks off the line (the sorts, then the Seal) falls straight down from
    // «مو صد». On desktop the pile leaves the floor under them clear, so they land low and nothing
    // comes to rest against the finished line (on phones the room is tall and the bench narrow).
    var valley = null;
    if (!WF.mobile && turnState === 'pending') {
      var lr = lineRects();
      if (lr.mo && lr.sad) {
        var ra = lr.mo.getBoundingClientRect(), rb = lr.sad.getBoundingClientRect(), wl = world.getBoundingClientRect().left;
        // the gap takes the sorts and the Seal (they fall almost straight down from the slot)
        var vl = Math.min(ra.left, rb.left) - wl, vr = Math.max(ra.right, rb.right) - wl, vc = (vl + vr) / 2 - 6;
        var half = Math.max((vr - vl) / 2 + 12, sealSize() / 2 + 14);
        valley = { l: vc - half, r: vc + half };
      }
    }
    var inValley = function (cx, ex) { return !!valley && cx + ex > valley.l && cx - ex < valley.r; };
    // bigger and heavier things go down first; the rest is seeded
    // (on a short screen the tall guides take the floor right after the mark: they are the ones
    // that could not rest on anything without reaching the line)
    var tall = function (o) { return tight && o.kind === 'booklet' ? 1 : 0; };
    var ranked = list.slice().sort(function (a, b) { return (b.kind === 'mark') - (a.kind === 'mark') || tall(b) - tall(a) || (b.w * b.h * PHYS[b.kind].d) - (a.w * a.h * PHYS[a.kind].d) + (rng() - .5) * 60; });
    ranked.forEach(function (o) {
      // composition hints: the mark lies flat near the middle; plates lean a little; the rest is seeded
      // a short screen sets the pieces down flatter, so one layer and the tags on top fit the room
      var spread = o.kind === 'mark' ? .03 : o.kind === 'plate' ? (tight ? .05 : .16) : o.kind === 'tag' ? (tight ? .12 : .3) : (tight ? .1 : .3);
      var a = (rng() * 2 - 1) * spread;
      var ex = (Math.abs(Math.cos(a)) * o.w + Math.abs(Math.sin(a)) * o.h) / 2 + 4;
      var ey = (Math.abs(Math.sin(a)) * o.w + Math.abs(Math.cos(a)) * o.h) / 2 + 4;
      // each object is set down over the lowest part of the heap among a few seeded spots
      // (drawn around the middle), so the pile spreads along the bench instead of towering
      var surface = function (cx) {
        var top = H;
        placedBoxes.forEach(function (p) { if (Math.abs(p.x - cx) < p.ex + ex) top = Math.min(top, p.y - p.ey); });
        return top;
      };
      var x, y;
      // a spot under «مو صد» counts as 400px higher: taken only when nowhere else is free
      var score = function (cx) { return surface(cx) - (inValley(cx, ex) ? 400 : 0); };
      if (o.kind === 'mark') {
        x = W * (.44 + .12 * rng());
        if (inValley(x, ex)) {   // the mark lies beside the gap, on its roomier side
          var leftRoom = valley.l, rightRoom = W - valley.r;
          var off = tight ? 2 : 8 + 40 * rng();
          x = leftRoom >= rightRoom ? clamp(valley.l - ex - off, ex, W - ex) : clamp(valley.r + ex + off, ex, W - ex);
        }
        y = surface(x) - ey - 2;
      } else {
        var best = null;
        for (var c = 0; c < 7; c++) {
          var cx = clamp(W * (.5 + (rng() + rng() - 1) * .5), ex, W - ex), top = score(cx);
          if (!best || top > best.top + 6) best = { x: cx, top: top };
        }
        // g6-01: the pile room is measured (stage − line zone − controls), not assumed. On a short
        // screen every piece takes one of the lowest places along the whole bench (seeded among
        // equals), so the heap stays one layer deep with the light things on top.
        if (tight) {
          // set down against a neighbour or a wall (the ends of each free run), so the floor row packs.
          // The gap under «مو صد» stays free: whatever lands on the finished line is worse than a
          // piece that rests a little high at the side.
          var lowest = function (penalty) {
            var lows = [], hi = -Infinity;
            for (var sx = ex; sx <= W - ex; sx += 6) {
              var st = penalty ? score(sx) : surface(sx);
              if (st > hi + 2) { hi = st; lows = [sx]; } else if (st >= hi - 2) lows.push(sx);
            }
            // floor pieces pack against their neighbours; a piece set on top of others goes to the
            // middle of its free run, so it is supported and never tips over an edge
            var runs = [], cur = null;
            lows.forEach(function (v) { if (cur && v === cur[cur.length - 1] + 6) cur.push(v); else { cur = [v]; runs.push(cur); } });
            var cands = [];
            runs.forEach(function (rn) { if (hi >= H - 2) { cands.push(rn[0]); if (rn.length > 1) cands.push(rn[rn.length - 1]); } else cands.push(rn[Math.floor(rn.length / 2)]); });
            return cands.length ? { x: cands[Math.floor(rng() * cands.length)], top: hi } : null;
          };
          best = lowest(true) || best;
        } else if (best.top - 2 * ey - 2 < roomTop + 8 || (valley && best.top < H - 1)) {
          // where the heap would reach into the line zone (or, with the gap under the slot taking the
          // middle, would stack beside it), look along the whole bench for a lower place
          for (var c2 = 0; c2 < 16; c2++) {
            var cx2 = ex + rng() * Math.max(0, W - 2 * ex), top2 = score(cx2);
            if (top2 > best.top + 6) best = { x: cx2, top: top2 };
          }
        }
        best.top = surface(best.x);
        x = best.x; y = best.top - ey - 2 - rng() * Math.min(30, Math.max(0, best.top - 2 * ey - 2 - roomTop));
      }
      placedBoxes.push({ x: x, y: y, ex: ex, ey: ey });
      var p = boxToPose(o, x, y, a);
      makeBody(o, p.x, p.y, a);
    });
  }
  function allAsleep() { return Object.keys(objs).every(function (id) { var b = objs[id].body; return !b || b.isSleeping || b.isStatic; }); }
  function presettle(done) {
    silent = true;
    // the arrival pile is authored, not watched: things are set down, not dropped (air drag
    // stops tumbling), then the real material values come back before anyone can touch them
    var bodies = Object.keys(objs).map(function (id) { return objs[id].body; }).filter(Boolean);
    bodies.forEach(function (b) { b.frictionAir = AIR_SETTLE; });
    var steps = 0;
    var chunk = function () {
      var t0 = now();
      while (steps < 600 && now() - t0 < 7) {
        M.Engine.update(engine, 1000 / 60);
        steps++;
        if (steps > 30 && allAsleep()) { steps = 600; break; }
      }
      if (steps < 600) { requestAnimationFrame(chunk); return; }
      bodies.forEach(function (b) { var o = b.plugin && b.plugin.o; b.frictionAir = o ? PHYS[o.kind].air : .004; });
      Object.keys(objs).forEach(function (id) { var b = objs[id].body; if (b && !b.isStatic) M.Sleeping.set(b, true); });
      silent = false;
      renderAll();
      Object.keys(objs).forEach(function (id) { if (objs[id].body) placed(objs[id]); });
      done();
    };
    chunk();
  }

  /* ── build the physics bench ───────────────────────────────────────────── */
  function buildPhysics(seed) {
    mode = 'physics';
    measureGeo();
    engine = makeEngine();
    buildWalls();
    var withSorts = turnState === 'done';
    var wanted = wantedSet(withSorts);
    prune(wanted);
    var list = [];
    wanted.forEach(function (d) {
      if (d.id === 'seal' && sealHome === 'line') return;   // it waits on the rule
      var o = ensure(d); if (o) list.push(o);
    });
    if (seed) {
      // g6-09: the visitor has been looking at the still life while Matter came late: the bodies
      // start exactly where the objects already lie, so nothing jumps
      var fresh = [];
      list.forEach(function (o) { if (o.el.classList.contains('is-placed') && isFinite(o.x)) makeBody(o, o.x, o.y, o.a); else fresh.push(o); });
      if (fresh.length) spawnAll(fresh);
    } else spawnAll(list);
    presettle(function () {
      pileReady = true;
      armTurn();
      pumpQueue();
      if (turnState === 'done' || turnState === 'none') showCaptionSoon();
    });
  }
  var pileReady = false;

  /* ── the grab: a pointer constraint, never a MouseConstraint ───────────── */
  function worldPoint(e) { var b = world.getBoundingClientRect(); return { x: e.clientX - b.left, y: e.clientY - b.top }; }
  function wire(o) {
    var el = o.el;
    el.addEventListener('pointerdown', function (e) { onDown(o, e); });
    el.addEventListener('pointermove', function (e) { if (grab && grab.id === e.pointerId && grab.o === o) onMove(e); });
    el.addEventListener('pointerup', function (e) { if (grab && grab.id === e.pointerId && grab.o === o) onUp(e, false); });
    el.addEventListener('pointercancel', function (e) { if (grab && grab.id === e.pointerId && grab.o === o) onUp(e, true); });
    el.addEventListener('lostpointercapture', function (e) { if (grab && grab.id === e.pointerId && grab.o === o) onUp(e, true); });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('contextmenu', function (e) { if (grab) e.preventDefault(); });
    if (o.link) el.addEventListener('click', function (e) { if (!e.defaultPrevented) lastTap = o.id; });
  }
  function onDown(o, e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (grab) return;
    if (o.id === 'seal' && sealHome === 'line') return;
    var p = worldPoint(e);
    grab = { o: o, id: e.pointerId, x0: e.clientX, y0: e.clientY, t0: now(), travel: 0, px: p.x, py: p.y, c: null };
    try { o.el.setPointerCapture(e.pointerId); } catch (err) { /* synthetic */ }
    o.el.classList.add('is-grabbed');
    o.el.style.zIndex = String(++zTop);
    if (!grabbedOnce) { grabbedOnce = true; hideCaption(); }
    if (mode !== 'physics' || !o.body) return;
    if (tween) cancelTween(o);
    var b = o.body;
    if (b.isStatic) M.Body.setStatic(b, false);
    M.Sleeping.set(b, false);
    grab.c = M.Constraint.create({
      pointA: { x: p.x, y: p.y }, bodyB: b,
      pointB: { x: p.x - b.position.x, y: p.y - b.position.y },
      length: 0, stiffness: PHYS[o.kind].k, damping: .1,
    });
    M.Composite.add(engine.world, grab.c);
    kick();
  }
  function onMove(e) {
    var p = worldPoint(e);
    grab.px = p.x; grab.py = p.y;
    grab.travel = Math.max(grab.travel, Math.hypot(e.clientX - grab.x0, e.clientY - grab.y0));
    if (grab.c) kick();
  }
  function onUp(e, cancelled) {
    var g = grab; grab = null;
    g.o.el.classList.remove('is-grabbed');
    try { g.o.el.releasePointerCapture(g.id); } catch (err) { /* ignore */ }
    if (g.c) {
      M.Composite.remove(engine.world, g.c);
      // Matter keeps a warm-start impulse on the body and wakes it every step until that decays
      // to exactly zero (seconds). The hand has let go: clear it, so the body can come to rest.
      var ci = g.o.body && g.o.body.constraintImpulse; if (ci) { ci.x = 0; ci.y = 0; ci.angle = 0; }
      kick();
    }
    var tap = !cancelled && g.travel < 6 && now() - g.t0 < 300;
    if (tap) { runTap(g.o); return; }
    // after a drag or a long hold the next click is cancelled (a throw never opens a tab)
    var el = g.o.el, kill = function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); };
    el.addEventListener('click', kill, { capture: true, once: true });
    setTimeout(function () { el.removeEventListener('click', kill, { capture: true }); }, 450);
  }
  function runTap(o) {
    if (o.link) return;                      // native <a> click opens the link (lastTap set there)
    var act = null;
    if (o.kind === 'plate') act = function () { WF.emit('detail:open', { id: o.svc }); };
    else if (o.kind === 'slip') act = function () { WF.drawer.open(1); };
    else if (o.kind === 'mark') act = function () {
      var h = document.getElementById('hero');
      if (h) h.scrollIntoView({ behavior: WF.reduced ? 'auto' : 'smooth', block: 'start' });
      else window.scrollTo({ top: 0, behavior: WF.reduced ? 'auto' : 'smooth' });
    };
    if (!act) return;                        // the Seal and the sorts do nothing
    lastTap = o.id;
    act();
  }

  /* ── the line turn (scripted, once per page view) ──────────────────────── */
  var PRE = '<span data-piece="mo">مو</span><span class="turn__sp"> </span><span data-piece="sad">صد</span>';
  var POST = '<span class="turn__mask"><span data-piece="hir">حِر</span></span>';
  function setPreTurn() {
    var slot = line.querySelector('.turn__slot'); if (!slot) return;
    slot.innerHTML = PRE;
    turnState = 'pending';
    if (gloss) { gloss.setAttribute('data-i18n', 'bench.gloss.before'); gloss.textContent = WF.t('bench.gloss.before'); }
  }
  function setPostTurn() {
    var slot = line.querySelector('.turn__slot'); if (slot) slot.innerHTML = POST;
  }
  // g6-01: the turn plays only in full view. All of these must hold for 600ms, sampled every 300ms
  // while the stage intersects, and any scroll starts the 600ms over:
  //   · the Seal's whole strike (lift, near-stop, the corners of the tilted block) stays under the
  //     header with at least a 24px lift (20px on phones): the apex clamp below does the rest
  //   · the line is below the header, and the floor hairline is on screen (bottom ≤ innerHeight − 8)
  //   · the page has not scrolled for 600ms, and no overlay, menu or hidden tab covers the bench
  var armed = false, gateIO = null, gatePoll = 0, gateT = 0, lastScroll = -1e9, lastBad = 0;
  function armTurn() {
    if (armed || turnState !== 'pending' || !pileReady) return;
    armed = true;
    if (WF.autoSized) { makeStrikeButton(); return; }   // the host sized the frame: the turn waits for the visitor
    window.addEventListener('scroll', onGateScroll, { passive: true });
    gateIO = WF.io.watch(stage, function (e) { if (e.isIntersecting) gateOn(); else gateOff(); }, { threshold: [0] });
  }
  function onGateScroll() {
    lastScroll = now();
    clearTimeout(gateT); gateT = 0;
    if (gatePoll) gateT = setTimeout(checkGate, 620);
  }
  function gateOn() { if (gatePoll || turnState !== 'pending') return; lastBad = now(); gatePoll = setInterval(checkGate, 300); checkGate(); }
  function gateOff() { clearInterval(gatePoll); gatePoll = 0; clearTimeout(gateT); gateT = 0; }
  function disarmGate() { gateOff(); if (gateIO) { gateIO(); gateIO = null; } window.removeEventListener('scroll', onGateScroll); }
  function covered() { return overlayOpen || !!(WF.menu && WF.menu.isOpen && WF.menu.isOpen()) || document.hidden; }
  function checkGate() {
    if (turnState !== 'pending') { disarmGate(); return; }
    var t = now();
    if (covered() || !geomOk()) { lastBad = t; return; }
    var since = Math.max(lastScroll, lastBad);
    if (t - since >= 600) { disarmGate(); runTurn(); return; }
    clearTimeout(gateT); gateT = setTimeout(checkGate, 600 - (t - since) + 20);
  }
  // where the strike can reach: the highest point of the lifted Seal with no lift at all, against the header
  // SPEC-V2 §3.12: #bench clips at the stage top, so the lift is also held under the stage top
  function strikeGeom() {
    var S = sealSize(), hb = headerBottom();
    var rest = objs.seal.el.getBoundingClientRect(), lr = layer.getBoundingClientRect(), P = strikeTarget();
    var top = Math.min(rest.top, lr.top + P.y - S / 2) - sealExtra();
    var room = top - (stage.getBoundingClientRect().top + 2);
    return { top: top, hb: hb, room: room, avail: Math.min(top - (hb + 8), room) };
  }
  function minLift() { return WF.mobile ? 14 : 16; }
  function geomOk() {
    var g = strikeGeom();
    if (g.avail < minLift()) return false;
    if (line.getBoundingClientRect().top < g.hb) return false;
    var fb = (floorEl || world).getBoundingClientRect().bottom;
    if (fb > innerHeight - 8) {
      // a screen too short to ever show the strike and the floor together: the strike wins
      var span = fb - (g.top - minLift()) + 16;
      if (span <= innerHeight - g.hb) return false;
    }
    return true;
  }
  // g6-01 apex clamp: the lift never takes the Seal under the header. A short lift gets a longer
  // near-stop, so the strike still reads as resisted weight.
  function turnLift() {
    var mf = WF.mobile ? T.mobileLift : 1, full = T.liftPx.turn * mf;
    var g = strikeGeom();
    var px = Math.max(0, Math.min(full, WF.autoSized ? g.room : g.avail));
    return { lift: px / mf, near: px < 48 ? 220 : T.nearTurn, px: px };
  }
  function turnOpts(k) {
    k = k || { lift: T.liftPx.turn, near: T.nearTurn };
    return {
      triggers: [objs.seal.el], layer: layer, target: strikeTarget,
      lift: k.lift, near: k.near, drop: T.dropTurn, hold: 120,
      impactEl: linebox,
      onContact: onTurnContact,
    };
  }
  function runTurn() {
    if (turnState !== 'pending' || !objs.seal) return;
    disarmGate();
    turnState = 'running';
    // M0-EXT: a variant may dress the moment before the lift (D's pen through «صدفة»); ≤ 1400ms
    if (WF.hooks && WF.hooks.count('bench:preturn')) {
      WF.hooks.run('bench:preturn', preturnCtx(), 1400).then(function () { if (turnState === 'running' && objs.seal) strikeTurn(); });
      return;
    }
    strikeTurn();
  }
  function preturnCtx() {
    var r = lineRects(), box = function (el) { if (!el) return null; var b = el.getBoundingClientRect(); return { left: b.left, top: b.top, right: b.right, bottom: b.bottom, width: b.width, height: b.height }; };
    var sad = box(r.sad), fa = box(r.fa), najah = line.querySelector('[data-piece="najah"]');
    var sadfa = sad && fa ? { left: Math.min(sad.left, fa.left), top: Math.min(sad.top, fa.top), right: Math.max(sad.right, fa.right), bottom: Math.max(sad.bottom, fa.bottom) } : (sad || fa);
    if (sadfa) { sadfa.width = sadfa.right - sadfa.left; sadfa.height = sadfa.bottom - sadfa.top; }
    return { line: line, pieces: { mo: box(r.mo), sadfa: sadfa, najah: box(najah) }, reduced: WF.reduced };
  }
  function strikeTurn() {
    turnT0 = now();
    kick();
    var el = objs.seal.el, k = turnLift();
    turnLiftUsed = Math.round(k.px);
    el.classList.add('is-striking');
    turnPress = WF.seal.press(el, turnOpts(k));
    // the resisted lift: a 700ms hold through the one implementation of the strike
    var r = el.getBoundingClientRect();
    var init = { bubbles: true, cancelable: true, composed: true, pointerId: 7447, pointerType: 'mouse', isPrimary: true, button: 0, buttons: 1, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
    el.dispatchEvent(new PointerEvent('pointerdown', init));
    setTimeout(function () {
      el.dispatchEvent(new PointerEvent('pointerup', Object.assign({}, init, { buttons: 0 })));
      turnPress.settled().then(afterHold);
    }, 700);
  }
  var turnLiftUsed = null;
  function makeStrikeButton() {
    var old = objs.seal.el;
    var btn = WF.seal.make({ face: 'mark', tag: 'button', label: WF.t('bench.strike'), className: 'bench__obj bench__seal' });
    btn.setAttribute('data-obj', 'seal');
    var c = WF.seal.center(old);
    layer.replaceChild(btn, old);
    objs.seal.el = btn;
    btn.style.transformOrigin = objs.seal.ox + 'px ' + objs.seal.oy + 'px';
    wire(objs.seal);
    placed(objs.seal);
    if (c) WF.seal.place(btn, c, { layer: layer });
    var sl = document.createElement('span'); sl.className = 'bench__strike is-on'; sl.setAttribute('aria-hidden', 'true'); sl.textContent = WF.t('bench.strike');
    layer.appendChild(sl);
    placeStrikeLabel();
    turnPress = WF.seal.press(btn, Object.assign(turnOpts(), { triggers: [btn] }));
    var go = function () {
      if (turnState !== 'pending') return;
      turnState = 'running';
      turnT0 = now();
      btn.classList.add('is-striking');
      sl.remove();
      turnPress.settled().then(function (res) { if (res && res.contact) afterHold(); else { turnState = 'pending'; btn.classList.remove('is-striking'); } });
    };
    var up = function () { btn.classList.add('is-striking'); };
    btn.addEventListener('pointerdown', up);
    btn.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') up(); });
    btn.addEventListener('pointerup', function () { setTimeout(go, 0); });
    btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') setTimeout(go, 0); });
    btn.addEventListener('click', function (e) { if (e.detail === 0) setTimeout(go, 0); });
  }
  // CONTACT FRAME: the words become bone printer's sorts and drop into the pile
  function onTurnContact() {
    var r = lineRects(), wb = world.getBoundingClientRect();
    var sealC = objs.seal.el.getBoundingClientRect(), sx = sealC.left + sealC.width / 2;
    var mr = r.mo.getBoundingClientRect(), mk = kufi('مو', F);
    contactInfo = { t: Math.round(now() - turnT0), lift: turnLiftUsed, sealTop: Math.round(sealC.top), headerBottom: Math.round(headerBottom()), sealBottom: Math.round(objs.seal.el.querySelector('.seal__body').getBoundingClientRect().bottom), inkTop: Math.round(mr.top + mk.fA - Math.max(mk.asc, kufi('صد', F).asc)) };
    ['mo', 'sad'].forEach(function (piece) {
      var span = r[piece]; if (!span) return;
      var sr = span.getBoundingClientRect();
      var o = makeSort(piece, F), g = o.g;
      var left = sr.left - g.padX - wb.left, top = sr.top + g.fA - g.A - g.padTop - wb.top;
      var cx = left + o.w / 2, cy = top + o.h / 2;
      span.style.visibility = 'hidden';
      if (mode === 'physics') {
        makeBody(o, cx, cy, 0);
        var side = (sr.left + sr.width / 2) < sx ? -1 : 1;
        M.Body.setVelocity(o.body, { x: 1.5 * side, y: 3 });
        M.Body.setAngularVelocity(o.body, .02 * side);   // ±.04 per 1000/120 step
        write(o, cx, cy, 0);
      } else write(o, cx, cy, 0);
      placed(o);
    });
    if (gloss && WF.lang === 'en') {
      gloss.setAttribute('data-i18n', 'bench.gloss.after'); gloss.textContent = WF.t('bench.gloss.after');
      gloss.classList.remove('is-in'); WF.motion.lift(gloss);
    } else if (gloss) { gloss.setAttribute('data-i18n', 'bench.gloss.after'); gloss.textContent = WF.t('bench.gloss.after'); }
    kick();
    // g6-03: the Seal follows through. 60ms after contact it is a body, still moving down through
    // the words (and a touch toward the line's end), so it never parks on «فة» while «حِر» rises.
    if (mode === 'physics') setTimeout(function () { sealToWorld(true); }, 60);
  }
  // the Seal leaves the line layer for the world, where it is an object like the others
  function sealToWorld(fling) {
    var o = objs.seal; if (!o || sealHome !== 'line') return;
    var el = o.el, wb = world.getBoundingClientRect(), r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2 - wb.left, cy = r.top + r.height / 2 - wb.top;
    var hadFocus = document.activeElement === el;
    if (el.tagName === 'BUTTON') {   // auto-sized path: the object is a plain div from here on
      var div = document.createElement('div');
      div.className = el.className; div.setAttribute('data-obj', 'seal'); div.setAttribute('aria-hidden', 'true');
      div.innerHTML = el.innerHTML;
      el.remove(); el = div; o.el = div; wire(o);
    }
    table.appendChild(el);
    el.style.left = '0px'; el.style.top = '0px'; el.style.transform = ''; el.style.willChange = '';
    el.classList.remove('is-lifted', 'is-striking');
    el.style.transformOrigin = o.ox + 'px ' + o.oy + 'px';
    o.rx = NaN;
    sealHome = 'world';
    if (mode === 'physics' && engine) {
      sealLanded = false;
      makeBody(o, cx, cy, 0);
      // follow-through: ~6px/step down, .8 toward the line's end (the line is Arabic: its end is the left)
      if (fling) M.Body.setVelocity(o.body, { x: -.8, y: 6 });
      write(o, cx, cy, 0);
      kick();
      if (fling) closeWhenClear();
    } else write(o, cx, cy, 0);
    placed(o);
    if (hadFocus && btnTidy) { try { btnTidy.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  // «حِر» rises onto a clean line: once the Seal's top has passed below the rule (600ms at most)
  function closeWhenClear() {
    var rb = ruleBottomWorld(), t0 = now();
    var chk = function () {
      var b = objs.seal && objs.seal.body;
      if (!b || b.bounds.min.y >= rb || now() - t0 >= 600) { closeUp(); return; }
      requestAnimationFrame(chk);
    };
    requestAnimationFrame(chk);
  }
  // the HOLD is over (contact + 120ms)
  function afterHold() {
    if (turnPress) { turnPress.destroy(); turnPress = null; }
    if (mode === 'physics') { if (sealHome === 'line') { sealToWorld(true); } return; }
    // no engine (Matter never came): the Seal steps down onto its place in the still life, the
    // sorts land in theirs, and the line closes up
    sealToWorld(false);
    stillTurnSettle();
    closeUp();
  }
  var closed = false;
  function closeUp() {
    if (closed) return;
    closed = true;
    var r = lineRects();
    var movers = [r.fa, r.dot].filter(Boolean);
    var before = movers.map(function (el) { return el.getBoundingClientRect().left; });
    setPostTurn();
    var hir = line.querySelector('[data-piece="hir"]');
    if (hir) hir.classList.remove('is-in');
    movers.forEach(function (el, i) {
      var dx = before[i] - el.getBoundingClientRect().left;
      if (Math.abs(dx) < .5 || WF.reduced) return;
      el.style.display = 'inline-block';
      el.animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'translateX(0)' }], { duration: 240, easing: T.ease.glide })
        .finished.then(function () { el.style.display = ''; }, function () { el.style.display = ''; });
    });
    if (hir) WF.motion.rise(hir, { delay: 80, force: true });
    turnState = 'done';
    turnedLive = true;
    WF.live(WF.t('bench.turned'));
    linebox.style.paddingInlineEnd = '';   // the line keeps its size for the visit; the rule's end is free now
  }

  /* ── caption: after the turn settles, the visit or the hint; out on the first grab ── */
  function didSomething() { return WF.cart.count() > 0 || WF.touch.list().some(function (t) { return t.source !== 'page'; }); }
  var capTimer = 0;
  function showCaptionSoon() { clearTimeout(capTimer); capTimer = setTimeout(showCaption, isStill() ? 0 : 400); }
  function showCaption() {
    if (captionShown || grabbedOnce || !caption) return;
    captionShown = true;
    var k = didSomething() ? 'bench.visit' : 'bench.hint';
    caption.setAttribute('data-i18n', k); caption.textContent = WF.t(k);
    caption.classList.add('is-on');
    WF.motion.lift(caption);
  }
  function hideCaption() {
    clearTimeout(capTimer);
    if (!caption || !captionShown) { captionShown = true; return; }
    if (WF.reduced) { caption.classList.remove('is-on'); return; }
    caption.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-14px)' }],
      { duration: T.liftc * .6, easing: T.ease.rise, fill: 'forwards' }).finished.then(function () { caption.classList.remove('is-on'); caption.getAnimations().forEach(function (a) { a.cancel(); }); }, function () {});
  }

  /* ── late arrivals from the touch registry and the cart (§4.7) ─────────── */
  function capOf() { return WF.mobile ? 11 : 18; }
  function count() { return Object.keys(objs).length + (objs.mo ? 0 : 2); }
  function enqueue(d) {
    if (objs[d.id] || queue.some(function (x) { return x.id === d.id; })) return;
    queue.push(d);
    pumpQueue();
  }
  function pumpQueue() {
    if (!queue.length || dropping || !pileReady) return;
    if (isStill()) { if (turnState === 'running') return; queue.length = 0; buildStill(mode === 'prestill'); return; }
    if (!inView20) return;
    dropping = true;
    var next = function () {
      var d = queue.shift();
      if (!d) { dropping = false; return; }
      if (!objs[d.id] && roomFor(d)) arrive(d);
      if (queue.length) setTimeout(next, 120); else { dropping = false; }
    };
    next();
  }
  function roomFor(d) {
    // audit: the visit set's per-kind cap (booklets max 2) holds for late arrivals too — the oldest
    // of the same kind fades out, so the pile never outgrows its set
    var kindCap = d.kind === 'booklet' ? 2 : 0;
    if (kindCap) {
      var mine = Object.keys(objs).map(function (k) { return objs[k]; }).filter(function (o) { return o.kind === d.kind && !o.leaving && o.id !== d.id; });
      if (mine.length >= kindCap) { mine.sort(function (a, b) { return a.order - b.order; }); leave(mine[0]); return true; }
    }
    if (count() < capOf() && pileArea() + areaOf(d) <= capacity()) return true;
    // evict the oldest visit object of the same kind (else the oldest lower-priority visit object)
    var same = Object.keys(objs).map(function (k) { return objs[k]; }).filter(function (o) { return o.visit && o.kind === d.kind && !o.leaving; });
    if (!same.length && (d.kind === 'plate' || d.kind === 'slip' || d.kind === 'paper')) {
      same = Object.keys(objs).map(function (k) { return objs[k]; }).filter(function (o) { return o.visit && o.kind === 'booklet' && !o.leaving; });
      if (!same.length) return count() < capOf();
    }
    if (!same.length) return false;
    same.sort(function (a, b) { return a.order - b.order; });
    leave(same[0]);
    return true;
  }
  function leave(o) {
    o.leaving = true;
    var done = function () { removeBody(o); o.el.remove(); delete objs[o.id]; if (isStill()) layoutStill(); else { wakeAll(); kick(); } };
    if (WF.reduced || mode !== 'physics') { done(); return; }
    WF.motion.fade(o.el, 0, T.fade).then(done);
  }
  function arrive(d) {
    var o = ensure(d); if (!o) return;
    o.visit = o.visit || d.kind === 'plate';
    var W = geo.W, a = (rng() * 2 - 1) * .3;
    // seeded x within the middle 60%, over the lowest part of the pile there (things find the gap)
    var best = null;
    for (var c = 0; c < 5; c++) {
      var cx = W * (.2 + .6 * rng()), top = geo.H;
      Object.keys(objs).forEach(function (k) {
        var b = objs[k].body; if (!b || objs[k] === o) return;
        if (b.bounds.max.x > cx - o.w / 2 && b.bounds.min.x < cx + o.w / 2) top = Math.min(top, b.bounds.min.y);
      });
      if (!best || top > best.top) best = { x: cx, top: top };
    }
    // g6-04: arrivals come in under the line, never through it: just below the rule, over the
    // chosen gap. Where the heap there already reaches that high, the piece slides in low from the
    // bench's end instead.
    var ex = (Math.abs(Math.cos(a)) * o.w + Math.abs(Math.sin(a)) * o.h) / 2;
    var ey = (Math.abs(Math.sin(a)) * o.w + Math.abs(Math.cos(a)) * o.h) / 2;
    var x = best.x, y = ruleBottomWorld() + 24 + ey, vx = 0;
    if (best.top < y + ey + 4) {
      var endLeft = WF.lang !== 'en';          // the page's inline end: left in Arabic, right in English
      x = endLeft ? ex + 2 : W - ex - 2;
      y = geo.H - 200; vx = endLeft ? 2.5 : -2.5;
    }
    var p = boxToPose(o, x, y, a);
    makeBody(o, p.x, p.y, a);
    if (vx) M.Body.setVelocity(o.body, { x: vx, y: 0 });
    write(o, p.x, p.y, a);
    placed(o);
    kick();
  }
  function onTouch(d) {
    if (d.kind === 'booklet' && GUIDE[d.id]) enqueue({ id: 'book-' + d.id, kind: 'booklet', g: d.id });
    if (d.kind === 'variant') {   // M0-EXT: the newest replaces the last (queued or on the bench)
      var nid = 'var-' + d.seq;
      queue = queue.filter(function (x) { return x.kind !== 'paper'; });
      Object.keys(objs).forEach(function (k) { var o = objs[k]; if (o.kind === 'paper' && o.id !== nid && !o.leaving) leave(o); });
      enqueue({ id: nid, kind: 'paper', render: d.render, vid: d.id });
    }
    // kind 'service': nothing new; it counts towards the visit caption
  }
  function onCart(d) {
    renderFaces();
    if (mode === 'wait') return;
    var n = WF.cart.count();
    if (n > 0 && !objs.slip) enqueue({ id: 'slip', kind: 'slip' });
    if (n === 0 && objs.slip) leave(objs.slip);
    if (WF.mobile && d && d.reason === 'add' && d.id && !objs['svc-' + d.id]) enqueue({ id: 'svc-' + d.id, kind: 'plate' });
  }

  /* ── «رتّبها لي»: knolling ─────────────────────────────────────────────── */
  function knollLayout() {
    var W = geo.W, H = geo.H, rtl = WF.lang !== 'en';
    var list = Object.keys(objs).map(function (k) { return objs[k]; }).filter(function (o) { return o.id !== 'seal' && !o.leaving && (mode !== 'physics' || o.body); });
    list.sort(function (a, b) {
      var ka = KNOLL.indexOf(a.kind), kb = KNOLL.indexOf(b.kind);
      if (ka !== kb) return ka - kb;
      if (a.kind === 'sort') return a.id === 'mo' ? -1 : 1;
      return a.order - b.order;
    });
    var out = {}, cur = 0, base = 0, rowMax = 0;
    list.forEach(function (o) {
      if (cur > 0 && cur + o.w > W) { base += rowMax + 8; cur = 0; rowMax = 0; }
      var cx = rtl ? W - cur - o.w / 2 : cur + o.w / 2;
      var cy = H - base - o.h / 2;
      out[o.id] = { cx: cx, cy: cy };
      cur += o.w + 16; rowMax = Math.max(rowMax, o.h);
    });
    if (objs.seal && sealHome === 'world' && out.mark) {
      var m = objs.mark;
      out.seal = { cx: out.mark.cx, cy: out.mark.cy - m.h / 2 - objs.seal.h / 2 };
    }
    return out;
  }
  function tidy() {
    if (mode === 'wait') return;
    if (grab) return;
    var L = knollLayout();
    var ids = Object.keys(L).filter(function (id) { return id !== 'seal'; });
    if (L.seal) ids.push('seal');
    if (isStill()) { tidyStill(L, ids); return; }
    if (WF.reduced) {
      ids.forEach(function (id) { var o = objs[id]; var p = boxToPose(o, L[id].cx, L[id].cy, 0); if (o.body) { M.Body.setPosition(o.body, p); M.Body.setAngle(o.body, 0); } write(o, p.x, p.y, 0); });
      return;
    }
    if (tween) finishTween(true);
    var items = ids.map(function (id, i) {
      var o = objs[id], b = o.body;
      M.Body.setStatic(b, true);
      var to = boxToPose(o, L[id].cx, L[id].cy, 0);
      var a0 = b.angle, a1 = 0;
      a0 = Math.atan2(Math.sin(a0), Math.cos(a0));
      return { o: o, from: { x: b.position.x, y: b.position.y, a: a0 }, to: { x: to.x, y: to.y, a: a1 }, delay: i * 30, done: false, seal: id === 'seal' };
    });
    var t0 = null;
    tween = { items: items };
    var step = function (ts) {
      if (!tween || tween.items !== items) return;
      if (t0 === null) t0 = ts;
      var all = true;
      items.forEach(function (it) {
        if (it.done || it.cancelled) return;
        var s = it.seal ? sealLeg(it, ts - t0 - it.delay) : glideLeg(it, ts - t0 - it.delay);
        M.Body.setPosition(it.o.body, { x: s.x, y: s.y }); M.Body.setAngle(it.o.body, s.a);
        write(it.o, s.x, s.y, s.a);   // painted on this frame, so the IMPACT below lands with it
        if (s.done) { it.done = true; if (it.seal) sealContact(); }
        else all = false;
      });
      if (all) { finishTween(false); return; }
      tween.raf = requestAnimationFrame(step);
    };
    tween.raf = requestAnimationFrame(step);
    kick();
  }
  // the still life has no bodies: the same knolling, as a transform glide (instant when reduced)
  var stillTween = 0;
  function tidyStill(L, ids) {
    knolled = true;
    cancelAnimationFrame(stillTween);
    var items = ids.map(function (id, i) {
      var o = objs[id], to = boxToPose(o, L[id].cx, L[id].cy, 0);
      return { o: o, from: { x: o.x, y: o.y, a: Math.atan2(Math.sin(o.a), Math.cos(o.a)) }, to: to, delay: i * 30, seal: id === 'seal' };
    });
    if (stillFit) fitStillStage(items.map(function (it) { return { o: it.o, cy: L[it.o.id].cy, a: 0 }; }));
    if (WF.reduced) { items.forEach(function (it) { write(it.o, it.to.x, it.to.y, 0); }); return; }
    items.forEach(function (it) { it.to.a = 0; });
    runStillTween(items);
  }
  function runStillTween(items, onDone) {
    cancelAnimationFrame(stillTween);
    var t0 = null;
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var all = true;
      items.forEach(function (it) {
        if (it.landed) return;
        var tt = ts - t0 - it.delay;
        var s = it.seal ? sealLeg(it, tt) : it.fall ? fallLeg(it, tt) : glideLeg(it, tt);
        write(it.o, s.x, s.y, s.a);
        if (!s.done) { all = false; return; }
        it.landed = true;
        if (it.seal) sealContact(); else if (it.fall && !items.hit) { items.hit = true; WF.motion.impact(table); }
      });
      if (!all) stillTween = requestAnimationFrame(step);
      else if (onDone) onDone();
    };
    stillTween = requestAnimationFrame(step);
  }
  /* The legs of a scripted move (rAF time tt in ms since the item's start; before its start it stays
     at `from`). glide: 520ms --ease-rise with a 30px lift arc (knolling). fall: a sort dropping to
     its place, 420ms --ease-drop. seal (g6-07): the Seal glides to 40px above its place, near-stops
     90ms, then drops 160ms on --ease-drop: a real strike, and the world takes IMPACT on contact. */
  var GLIDE = 520;
  function glideLeg(it, tt) {
    var p = clamp(tt / GLIDE, 0, 1), e = EZ.rise(p);
    return { x: lerp(it.from.x, it.to.x, e), y: lerp(it.from.y, it.to.y, e) - 30 * Math.sin(Math.PI * e), a: lerp(it.from.a, it.to.a, e), done: p >= 1 };
  }
  function fallLeg(it, tt) {
    var p = clamp(tt / 420, 0, 1), e = EZ.drop(p);
    return { x: lerp(it.from.x, it.to.x, EZ.rise(p)), y: lerp(it.from.y, it.to.y, e), a: lerp(it.from.a, it.to.a, EZ.rise(p)), done: p >= 1 };
  }
  function sealLeg(it, tt) {
    var hx = it.to.x, hy = it.to.y - 40, N = T.near, D = T.drop;
    if (tt < GLIDE) {
      var e = EZ.rise(clamp(tt / GLIDE, 0, 1));
      return { x: lerp(it.from.x, hx, e), y: lerp(it.from.y, hy, e) - 30 * Math.sin(Math.PI * e), a: lerp(it.from.a, it.to.a, e) };
    }
    tt -= GLIDE;
    if (tt < N) return { x: hx, y: hy - T.nearRise * EZ.slide(tt / N), a: it.to.a };
    tt -= N;
    if (tt < D) return { x: hx, y: lerp(hy - T.nearRise, it.to.y, EZ.drop(tt / D)), a: it.to.a };
    return { x: it.to.x, y: it.to.y, a: it.to.a, done: true };
  }
  function sealContact() { WF.motion.impact(table); }
  var knolled = false;
  function finishTween(abort) {
    if (!tween) return;
    cancelAnimationFrame(tween.raf);
    tween.items.forEach(function (it) {
      var b = it.o.body; if (!b) return;
      if (abort && !it.done && !it.cancelled) { M.Body.setPosition(b, it.to); M.Body.setAngle(b, 0); }
      if (b.isStatic) M.Body.setStatic(b, false);
      if (!it.cancelled) M.Sleeping.set(b, true);   // then everything sleeps
    });
    tween = null;
    nudgeIn();
    renderAll();
    kick();
  }
  function cancelTween(o) {
    if (!tween) return;
    tween.items.forEach(function (it) { if (it.o === o) it.cancelled = true; });
  }

  /* ── the still life ────────────────────────────────────────────────────── */
  // pre = the pre-turn still life (g6-09): Matter is not here yet, the line still reads «مو صدفة»
  // and the Seal waits on the rule; «مو» and «صد» do not exist yet, and the stage keeps its
  // physics height (Matter may still come, and the turn will play over this still life if not)
  var stillFit = true;
  function buildStill(pre) {
    mode = pre ? 'prestill' : 'still';
    if (pre) stillFit = false;
    var turning = turnState === 'pending';   // the turn is still to come: no sorts yet, the Seal stays on the rule
    measureGeo();
    var wanted = wantedSet(!turning);
    prune(wanted);
    // «مو» «صد» need the sort geometry; the line reads «النجاح حِرفة.»
    wanted.forEach(function (d) { if (d.id === 'seal' && turning) return; ensure(d); });
    if (!turning && sealHome === 'line' && objs.seal) {   // the Seal comes down to the bench
      var el = objs.seal.el; table.appendChild(el);
      el.style.left = '0px'; el.style.top = '0px'; el.style.transform = '';
      sealHome = 'world';
    }
    layoutStill();
    pileReady = true;
    if (!turning) showCaptionSoon();
  }
  function layoutStill() {
    var poses = computeStill();
    Object.keys(poses).forEach(function (id) {
      var o = objs[id]; if (!o) return;
      var p = boxToPose(o, poses[id].cx, poses[id].cy, poses[id].a);
      write(o, p.x, p.y, poses[id].a);
      placed(o);
    });
    if (stillFit) fitStillStage(Object.keys(poses).map(function (id) { return { o: objs[id], cy: poses[id].cy, a: poses[id].a }; }), true);
  }
  // the still-mode turn (Matter never came): the Seal and the new sorts move to their places in the
  // still life (a knolled bench keeps its knolling); anything the new pieces displace glides aside
  function stillTurnSettle() {
    var P;
    if (knolled) { var L = knollLayout(); P = {}; Object.keys(L).forEach(function (id) { P[id] = { cx: L[id].cx, cy: L[id].cy, a: 0 }; }); }
    else P = computeStill();
    var items = [];
    Object.keys(P).forEach(function (id) {
      var o = objs[id]; if (!o) return;
      var to = boxToPose(o, P[id].cx, P[id].cy, P[id].a); to.a = P[id].a;
      var from = { x: o.x, y: o.y, a: Math.atan2(Math.sin(o.a), Math.cos(o.a)) };
      var mover = id === 'seal' || id === 'mo' || id === 'sad';
      if (!mover && Math.hypot(to.x - from.x, to.y - from.y) < 1 && Math.abs(to.a - from.a) < .002) return;
      items.push({ o: o, from: from, to: to, delay: id === 'sad' ? 40 : id === 'seal' ? 60 : 0, fall: id === 'mo' || id === 'sad', seal: id === 'seal' });
    });
    if (WF.reduced) { items.forEach(function (it) { write(it.o, it.to.x, it.to.y, it.to.a); }); showCaptionSoon(); return; }
    runStillTween(items, function () { showCaptionSoon(); pumpQueue(); });
  }
  function computeStill() {
    var W = geo.W, H = geo.H;
    var table_ = WF.mobile ? STILL.mobile : STILL.desktop;
    var slots = visitSlots();
    var entry = {}; table_.forEach(function (it) { entry[it.id] = it; });
    var poses = {}, ok = true;
    stillWhy = '';
    // an item whose base is absent rests on that base's own base (and so on down to the floor)
    var baseOf = function (it) {
      var on = it.on;
      while (on) {
        var id = slots[on] || on;
        if (poses[id]) return poses[id];
        on = entry[on] && entry[on].on;
      }
      return null;
    };
    var sealWaits = sealHome === 'line';   // the Seal on the rule has no place in the still life yet
    table_.forEach(function (it) {
      var id = slots[it.id] || it.id, o = objs[id]; if (!o || poses[id] || (id === 'seal' && sealWaits)) return;
      var base = baseOf(it);
      var baseY = base ? base.top : H;
      var ha = (Math.abs(Math.sin(it.a)) * o.w + Math.abs(Math.cos(it.a)) * o.h);
      var wa = (Math.abs(Math.cos(it.a)) * o.w + Math.abs(Math.sin(it.a)) * o.h);
      var cx = clamp(it.x * W, wa / 2, W - wa / 2);
      var cy = baseY - it.y - ha / 2;
      poses[id] = { id: id, cx: cx, cy: cy, a: it.a, top: cy - ha / 2, left: cx - wa / 2, right: cx + wa / 2, floor: !base, root: base ? base.root : id };
    });
    // relax: floor stacks keep their authored order; overlaps push whole stacks apart (12px),
    // and the arrangement slides back inside the world
    var roots = Object.keys(poses).filter(function (k) { return poses[k].floor; }).map(function (k) { return poses[k]; }).sort(function (p, q) { return p.cx - q.cx; });
    var span = function (r) {   // a stack's horizontal extent (its widest member)
      var l = Infinity, rr = -Infinity;
      Object.keys(poses).forEach(function (k) { var p = poses[k]; if (p.root === r.id) { l = Math.min(l, p.left); rr = Math.max(rr, p.right); } });
      return { l: l, r: rr };
    };
    var shift = function (r, dx) { Object.keys(poses).forEach(function (k) { var p = poses[k]; if (p.root === r.id) { p.cx += dx; p.left += dx; p.right += dx; } }); };
    for (var j = 1; j < roots.length; j++) {
      var prev = span(roots[j - 1]), me = span(roots[j]);
      if (me.l < prev.r + 12) shift(roots[j], prev.r + 12 - me.l);
    }
    if (roots.length) {   // then from the far wall back: nothing leaves the world, order kept
      var last = span(roots[roots.length - 1]);
      if (last.r > W) shift(roots[roots.length - 1], W - last.r);
      for (var k2 = roots.length - 2; k2 >= 0; k2--) {
        var nx = span(roots[k2 + 1]), cur = span(roots[k2]);
        if (cur.r > nx.l - 12) shift(roots[k2], nx.l - 12 - cur.r);
      }
      if (span(roots[0]).l < -1) { ok = false; stillWhy = 'too wide'; }
    }
    // the table must fit: floor stacks may not overlap and nothing may rise into the line zone
    var lz = parseFloat(getComputedStyle(root).getPropertyValue('--bench-lz')) || 0;
    Object.keys(poses).forEach(function (k) { if (poses[k].top < lz - world.offsetTop - 8) { ok = false; stillWhy = 'too tall ' + k; } });
    // some object without a slot (should not happen) also falls back to the knolled layout
    Object.keys(objs).forEach(function (id) { if (!poses[id] && !(id === 'seal' && sealWaits)) { ok = false; stillWhy = 'no slot ' + id; } });
    if (!ok) {   // narrow desktop widths: the knolled layout is the composed fallback
      var L = knollLayout();
      poses = {};
      Object.keys(L).forEach(function (id) { poses[id] = { cx: L[id].cx, cy: L[id].cy, a: 0 }; });
    }
    return poses;
  }
  // nothing will be thrown: the stage fits the composition (no empty room above a still life)
  var stillPile = 0;
  function fitStillStage(list, relayout) {
    var H = geo.H, top = H;
    list.forEach(function (it) { if (!it.o) return; var ha = Math.abs(Math.sin(it.a)) * it.o.w + Math.abs(Math.cos(it.a)) * it.o.h; top = Math.min(top, it.cy - ha / 2); });
    var want = Math.ceil(H - top + (WF.mobile ? 40 : 56));
    root.classList.add('is-still');
    if (Math.abs(want - stillPile) <= 2) return;
    stillPile = want; root.style.setProperty('--bench-pile', want + 'px');
    measureGeo();
    if (Math.abs(geo.H - H) > 1) {
      if (relayout) layoutStill();
      else Object.keys(objs).forEach(function (id) { var o = objs[id]; write(o, o.x, o.y + (geo.H - H), o.a); });
    }
  }
  function visitSlots() {
    var s = {}, b = 1;
    Object.keys(objs).map(function (k) { return objs[k]; }).sort(function (a, c) { return a.order - c.order; }).forEach(function (o) {
      if (o.kind === 'booklet') s['booklet-' + (b++)] = o.id;
      if (o.kind === 'paper' && !o.leaving) s.paper = o.id;
    });
    return s;
  }

  /* ── geometry changes: resize, language, breakpoints ───────────────────── */
  var resizeT = 0, lastW = innerWidth, lastMobile = WF.mobile;
  function refit(keepPile) {
    var oldH = geo.H, oldW = geo.W;
    fit();
    measureGeo();
    if (mode === 'physics' && engine) {
      buildWalls();
      var dy = geo.H - oldH, sx = oldW ? geo.W / oldW : 1;
      Object.keys(objs).forEach(function (id) {
        var o = objs[id], b = o.body; if (!b) return;
        var x = b.position.x * (keepPile && Math.abs(sx - 1) < .001 ? 1 : sx), y = b.position.y + dy;
        var e = Math.max(o.w, o.h) / 2;
        M.Body.setPosition(b, { x: clamp(x, e, geo.W - e), y: Math.min(y, geo.H - o.h / 2) });
      });
      if (Math.abs(sx - 1) > .001) { wakeAll(); kick(); }
      renderAll();
    } else if (isStill()) { if (knolled) { var L = knollLayout(); tidyStill(L, Object.keys(L)); } else layoutStill(); }
    if (sealOnLine()) placeSealOnLine();
  }
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      if (WF.mobile !== lastMobile) { rebuild(); return; }
      if (Math.abs(innerWidth - lastW) < 1 && mode !== 'wait') { refit(true); return; }
      lastW = innerWidth;
      refit(false);
    }, 160);
  }
  function rebuild() {   // a breakpoint change: object sizes differ, so the bench is set out again
    lastMobile = WF.mobile;
    stop();
    if (tween) { cancelAnimationFrame(tween.raf); tween = null; }
    Object.keys(objs).forEach(function (id) { var o = objs[id]; if (o.body) o.body = null; o.el.classList.remove('is-placed'); o.el.style.transform = ''; o.rx = NaN; });
    engine = null; walls = [];
    // records keep their elements; sizes are re-read
    Object.keys(objs).forEach(function (id) {
      var o = objs[id]; o.w = o.el.offsetWidth; o.h = o.el.offsetHeight; o.ox = o.w / 2; o.oy = o.h / 2;
      if (o.kind === 'sort') { o.el.remove(); delete objs[id]; }
    });
    if (objs.mark) { var c = markCentroid(objs.mark.w); objs.mark.ox = c.x; objs.mark.oy = c.y; objs.mark.el.style.transformOrigin = c.x + 'px ' + c.y + 'px'; }
    // brand objects removed on phones come back from the markup
    restoreBrand();
    fit();
    if (mode === 'physics') { pileReady = false; buildPhysics(); }
    else if (isStill()) buildStill(mode === 'prestill');
    if (sealOnLine()) placeSealOnLine();
  }
  function restoreBrand() {
    Object.keys(brandHTML).forEach(function (id) {
      if (id === 'seal' || q('[data-obj="' + id + '"]', table)) return;
      var tpl = document.createElement('div'); tpl.innerHTML = brandHTML[id];
      table.appendChild(tpl.firstChild);
    });
    renderFaces();
  }

  /* ── wiring ────────────────────────────────────────────────────────────── */
  // g6-12: boot registers listeners only. The object records, the line fitting (canvas metrics)
  // and any layout wait for build(), 2000px before the stage. Nothing is lost meanwhile: build()
  // reads the touch registry, the cart and the language as they are then, so events that arrive
  // before it are simply folded in.
  var built = false;
  if (btnTidy) btnTidy.addEventListener('click', tidy);

  WF.on('lang', function () { if (!built) return; renderFaces(); if (mode !== 'wait' || sealOnLine()) refit(true); else fit(); });
  WF.on('cart:change', function (d) { if (built) onCart(d); });
  WF.on('touch:add', function (d) { if (built) onTouch(d); });
  WF.on('overlay:open', function () { overlayOpen = true; stop(); });
  WF.on('overlay:close', function () { overlayOpen = false; if (running || !allAsleep()) kick(); });
  WF.on('env', function (d) {
    if (!built) return;
    var live = mode === 'physics' || mode === 'prestill' || (mode === 'still' && turnState === 'pending');
    if (d.reduced && live) {   // motion turned off mid-visit: stop the engine, compose the still life
      stop(); disarmGate(); if (tween) { cancelAnimationFrame(tween.raf); tween = null; }
      if (turnState !== 'done') { setPostTurn(); turnState = 'done'; }
      Object.keys(objs).forEach(function (id) { removeBody(objs[id]); });
      engine = null; stillFit = true; buildStill(false); return;
    }
    if (d.mobile !== lastMobile) rebuild();
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !allAsleep()) kick(); else if (document.hidden) stop(); });
  window.addEventListener('resize', function () { lastScroll = now(); if (built) onResize(); });
  var stillSeen = false;   // the visitor has seen the pre-turn still life (Matter came late)
  WF.io.watch(stage, function (e) {
    visible = e.isIntersecting;
    inView20 = e.isIntersecting && (e.intersectionRatio >= .2 || e.intersectionRect.height >= innerHeight * .2);
    if (visible && mode === 'prestill') stillSeen = true;
    if (!visible) stop(); else if (engine && (!allAsleep() || grab || tween)) kick();
    if (inView20) pumpQueue();
  }, { threshold: [0, .05, .1, .2, .3, .5] });

  WF.io.once(stage, build, { threshold: 0, rootMargin: '2000px 0px 2000px 0px' });

  function build() {
    if (built) return;
    built = true;
    lastW = innerWidth; lastMobile = WF.mobile;
    qa('.bench__obj', table).forEach(function (el) { brandHTML[el.getAttribute('data-obj')] = el.outerHTML; });
    renderFaces();
    // the Seal record (it waits on the rule when the turn will run)
    var sealEl = q('[data-obj="seal"]', table);
    if (sealEl) rec('seal', 'seal', sealEl);
    var willTurn = !WF.reduced && !!objs.seal;
    if (willTurn) {
      setPreTurn();
      layer.appendChild(objs.seal.el);
      sealHome = 'line';
    }
    fit();
    if (willTurn) { placeSealOnLine(); placed(objs.seal); }
    measureGeo();
    if (WF.reduced) buildStill(false);
    else WF.io.once(stage, nearStage, { threshold: 0, rootMargin: '1500px 0px 1500px 0px' });
  }
  // 1500px out: Matter is asked for. g6-09: if it is not here at once, the still life goes down
  // straight away (the line keeps its turn), so the bench is never an empty stage while it loads.
  function nearStage() {
    var settled = false;
    WF.load('matter').then(function (ok) { settled = true; onMatter(ok); });
    Promise.resolve().then(function () { if (!settled && mode === 'wait') buildStill(true); });
  }
  function onMatter(ok) {
    if (mode === 'physics' || (mode === 'still' && turnState !== 'pending')) return;   // reduced motion came first
    var seen = mode === 'prestill' && (stillSeen || visible);
    if (ok && window.Matter && !WF.reduced) { M = window.Matter; buildPhysics(seen); return; }
    if (seen && turnState === 'pending') {
      // Matter timed out while the visitor was looking: the still life stays exactly as it is, and
      // the scripted turn still plays once (the sorts land in the still life's own slots)
      mode = 'still';
      armTurn();
      return;
    }
    // no engine, and nothing seen yet: the line is the finished turn, the objects a still life
    if (turnState === 'pending') { setPostTurn(); turnState = 'none'; if (gloss) { gloss.setAttribute('data-i18n', 'bench.gloss.after'); gloss.textContent = WF.t('bench.gloss.after'); } }
    stillFit = true;
    fit();
    buildStill(false);
  }

  /* ── verification (SPEC §6.7) ──────────────────────────────────────────── */
  WF.debug.expose('bench', function () {
    var list = Object.keys(objs).map(function (k) { return objs[k]; });
    var bodies = list.filter(function (o) { return !!o.body; });
    var area = list.filter(function (o) { return o.el.classList.contains('is-placed') && (o.id !== 'seal' || sealHome === 'world'); })
      .reduce(function (s, o) { return s + (o.body ? o.body.area : o.w * o.h); }, 0);
    return {
      mode: mode,
      bodies: mode === 'physics' ? bodies.length : list.filter(function (o) { return o.el.classList.contains('is-placed'); }).length,
      awake: bodies.filter(function (o) { return !o.body.isSleeping && !o.body.isStatic; }).length,
      running: running,
      turned: turnState === 'done' || turnState === 'none' && mode === 'still',
      turnState: turnState,
      coverage: geo.W && geo.H ? Math.round(area / (geo.W * geo.H) * 1000) / 1000 : 0,
      lastTap: lastTap,
      line: line.textContent,
      fontSize: F,
      lineMode: lineMode,
      ids: list.map(function (o) { return o.id; }),
      contact: contactInfo,
      stillWhy: stillWhy,
      head: head,
      gate: turnState === 'pending' && objs.seal && sealHome === 'line' && objs.seal.el.isConnected ? (function () {
        var g = strikeGeom(), fb = (floorEl || world).getBoundingClientRect().bottom;
        return { avail: Math.round(g.avail), minLift: minLift(), floorBottom: Math.round(fb), lineTop: Math.round(line.getBoundingClientRect().top), ok: geomOk() };
      })() : null,
      room: Math.round(geo.H - (caption.offsetTop + caption.offsetHeight)),
      nudged: nudged,
      nudgeLog: nudgeLog.slice(-12),
      outside: bodies.filter(function (o) { return !!outsideBy(o.body); }).map(function (o) { return o.id; }),
      awakeIds: bodies.filter(function (o) { return !o.body.isSleeping && !o.body.isStatic; }).map(function (o) { return o.id + ':' + o.body.speed.toFixed(3); }),
    };
  });
});

})();
/* ── detail ── */
;(function(){
/* ==========================================================================
   detail.js — the service detail overlay (SPEC §3.4), owned by module `services`.
   Opens from anywhere via WF.emit('detail:open', {id}). From an on-screen plate
   (desktop) the espresso-lift background grows out of the plate's rect (380ms,
   --ease-slide; it starts see-through so the plate's own words are never covered
   by an empty slab), content LIFTs at 60% of the grow and the ledger leaders
   DRAW. Closing fades content (120ms) while the background shrinks back into the
   plate (320ms) and thins out over its last 120ms; the scrim fades with it
   (scrimOut), so the page is never undimmed under a moving slab.
   Talks to the plates with DOM events: `wf-svc-variant`, `wf-svc-add` {variant}.
   Round 2 (SPEC-V2 §3.7): no related-work strip (no client images anywhere); includes follow the
   founder's switches through WF.inc(); the struck anchor and discount line only while flags.strikes.
   ========================================================================== */
WF.module('detail', function (root) {
  'use strict';
  var T = WF.T;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var t = WF.t;

  // motion (tokens only): the grow borrows the drawer's 380ms on --ease-slide; content LIFTs at 60%
  var GROW = T.drawerIn, LIFT_AT = Math.round(T.drawerIn * 0.6);

  var frame = $('.detail__frame'), bg = $('.detail__bg');
  var el = {
    name: $('#detail-h'), tag: $('.detail__tag'), glyph: $('.detail__glyph'), glabel: $('.detail__glabel'),
    variant: $('.detail__variant'), vlabel: $('#detail-vlabel'), chips: $('.detail__chips'),
    custom: $('.detail__custom'), scope: $('.detail__scope'), inc: $('.detail__inc'), exc: $('.detail__exc'),
    termRow: $('.detail__trow--term'), term: $('.detail__term'), price: $('.detail__price'), off: $('.detail__off'), lnote: $('.detail__lnote'),
    ledger: $('.detail__ledger'), side: $('.detail__side'),
    add: $('.detail__add'), ask: $('.detail__ask'), close: $('.detail__close'),
  };
  var cur = null;          // { id, plate, grow, back }
  var chosen = {};         // variant memory when the plates are not on the page

  function plateOf(id) { return document.querySelector('#services .svc__plate[data-svc="' + id + '"]'); }
  function variantOf(id) {
    var it = WF.cart.get(id); if (it) return it.variant;
    var pl = plateOf(id);
    var v = pl ? pl.getAttribute('data-variant') : chosen[id];
    return v || WF.STORE.get(id).defaultVariant || null;
  }
  // a plate is "on screen" when its price anchor is fully visible under the header
  function onScreen(pl) {
    if (!pl) return false;
    var a = pl.querySelector('[data-seal-anchor]') || pl, r = a.getBoundingClientRect();
    var hdr = document.getElementById('wf-header'), top = hdr ? hdr.getBoundingClientRect().bottom : 0;
    return r.width > 0 && r.top >= top - 1 && r.bottom <= innerHeight + 1;
  }
  function isOpen() { return WF.overlay.top() === root; }
  var animating = function () { return !WF.reduced && !WF.mobile; };

  /* ── render ─────────────────────────────────────────────────────────── */
  function row(text) {
    var li = document.createElement('li');
    li.className = 'detail__row';
    li.innerHTML = '<span class="detail__rtext">' + esc(text) + '</span><span class="detail__rule" data-draw aria-hidden="true"></span>';
    return li;
  }
  // the WhatsApp question names what the visitor picked: «… إطلاق متجر متكامل · زد.»
  function askHref() {
    var id = cur.id, v = variantOf(id), name = t('core.svc.' + id + '.name');
    if (v) name += ' · ' + WF.fmt.variant(id, v);
    return WF.wa.link('ask', { id: id, name: name });
  }
  // the ledger's price line: [pre] ~~anchor~~ new price [unit]. The struck anchor sits right before the
  // number it was replaced by, in reading order, in both languages; by-quote prices carry none.
  function offHTML(n) {
    var s = t('core.u.off'), parts = s.split(s.indexOf('{n}%') > -1 ? '{n}%' : '{n}');
    var num = '<bdi class="num">' + n + (s.indexOf('{n}%') > -1 ? '%' : '') + '</bdi>';
    return parts.length === 2 ? esc(parts[0]) + num + esc(parts[1]) : esc(s.replace('{n}', n));
  }
  function renderPrice() {
    var id = cur.id, v = variantOf(id), p = WF.fmt.priceParts(id, v);
    var was = WF.fmt.was ? WF.fmt.was(id, v) : '', off = was && WF.fmt.off ? WF.fmt.off(id, v) : 0;
    if (p.kind === 'quote') el.price.innerHTML = '<span class="detail__pquote">' + esc(p.unit) + '</span>';
    else {
      el.price.innerHTML = (p.pre ? '<span class="detail__punit">' + esc(p.pre) + '</span>' : '') +
        (was ? '<span class="detail__was">' + was + '</span>' : '') +
        '<bdi class="num detail__pnum">' + p.num + '</bdi>' + (p.unit ? '<span class="detail__punit">' + esc(p.unit) + '</span>' : '');
    }
    // one plain discount line under the price (ink, never gold, never a badge); gone with the anchor
    el.off.hidden = !off;
    el.off.innerHTML = off ? offHTML(off) : '';
    var s = WF.STORE.get(id);
    el.lnote.hidden = !(id === 'launch' && s.quoteVariants && s.quoteVariants.indexOf(v) > -1);
    el.ask.href = askHref();
  }
  function renderChips() {
    var id = cur.id, s = WF.STORE.get(id);
    el.variant.hidden = !s.variants;
    el.chips.innerHTML = '';
    if (!s.variants) return;
    el.vlabel.textContent = t(id === 'launch' ? 'detail.platform' : 'detail.need');
    var v = variantOf(id);
    s.variants.forEach(function (x, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'chip'; b.setAttribute('role', 'radio'); b.dataset.v = x;
      var on = x === v;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on || (!v && i === 0) ? 0 : -1;
      var label = WF.fmt.variant(id, x);
      b.innerHTML = /[A-Za-z]/.test(label) && WF.lang === 'ar' ? '<bdi>' + esc(label) + '</bdi>' : esc(label);
      el.chips.appendChild(b);
    });
  }
  function renderCTA() {
    var inCart = WF.cart.has(cur.id);
    el.add.classList.toggle('btn--gold', !inCart);
    el.add.classList.toggle('btn--line-ink', inCart);
    // the gold CTA is the dialog's one gold event (SPEC-V2 §3.10); in the cart it is ink and untagged
    if (inCart) el.add.removeAttribute('data-gold'); else el.add.setAttribute('data-gold', 'event');
    el.add.textContent = t(inCart ? 'detail.inCart' : 'detail.add');
  }

  function render(id, reveal) {
    var s = WF.STORE.get(id);
    root.setAttribute('data-svc', id);
    // Arabic names break before their last phrase, never inside it: «إدارة / السوشل ميديا»,
    // «إدارة المتجر / والسوشل ميديا», «إطلاق / متجر متكامل»
    var nm = t('core.svc.' + id + '.name');
    el.name.textContent = WF.lang === 'ar' ? nm.replace(/ (\S+)$/, ' $1') : nm;
    el.tag.textContent = t('core.svc.' + id + '.tagline');
    el.glyph.className = 'detail__glyph detail__glyph--' + s.glyph;
    el.glyph.innerHTML = new Array(s.glyph === 'monthly' ? 4 : s.glyph === 'launch' ? 3 : 2).join('<i></i>');
    el.glabel.textContent = t('core.svc.' + id + '.glyph');
    // custom work has no fixed scope, exclusions or term: the ledger asks, and the price row says «بعرض سعر»
    var custom = id === 'custom';
    el.custom.hidden = !custom;
    el.scope.hidden = custom;
    el.termRow.hidden = custom;
    el.inc.innerHTML = ''; el.exc.innerHTML = '';
    if (!custom) {
      // only the lines the founder's switches keep (WF.FLAGS, applied by the build; see WF.inc)
      WF.inc(id).forEach(function (k) { el.inc.appendChild(row(t(k))); });
      [1, 2].forEach(function (n) { el.exc.appendChild(row(t('core.svc.' + id + '.exc.' + n))); });
      el.term.textContent = t('core.svc.' + id + '.term');
    } else el.term.textContent = '';
    renderPrice(); renderChips(); renderCTA();
    // leaders: drawn by the entrance, or simply there
    $$('[data-draw]').forEach(function (d) { d.classList.toggle('is-in', !reveal); });
  }

  /* ── motion ─────────────────────────────────────────────────────────── */
  // what LIFTs, in the order the eye needs it: name first, then the ledger, then the close
  // (first in the DOM for the tab order, last to arrive)
  function parts() {
    var list = $$('[data-part]').filter(function (p) { return !p.hidden; });
    return list.filter(function (p) { return !p.classList.contains('detail__bar'); }).concat(list.filter(function (p) { return p.classList.contains('detail__bar'); }));
  }
  function rectTransform(from, to) {
    return 'translate(' + (from.left - to.left).toFixed(2) + 'px,' + (from.top - to.top).toFixed(2) + 'px) scale(' +
      (from.width / to.width).toFixed(4) + ',' + (from.height / to.height).toFixed(4) + ')';
  }
  function drawLeaders(delay) {
    return WF.motion.draw($$('[data-draw]').filter(function (d) { return d.offsetParent; }), { delay: delay, stagger: T.drawStagger, force: true });
  }
  function enter() {
    if (WF.mobile) return frame.animate([{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: T.drawerIn, easing: T.ease.slide }).finished;
    var list = parts();
    if (cur.grow && cur.plate) {
      var D = frame.getBoundingClientRect(), R = cur.plate.getBoundingClientRect();
      // frame 1: the slab sits on the plate but is see-through, so the plate still reads; it is opaque
      // by 120ms, when the fast start of --ease-slide has already carried it most of the way out
      var g = bg.animate([{ transform: rectTransform(R, D) }, { transform: 'none' }], { duration: GROW, easing: T.ease.slide });
      bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: T.quick, easing: 'linear' });
      return Promise.all([g.finished, WF.motion.lift(list, { delay: LIFT_AT, force: true }), drawLeaders(LIFT_AT + 160)]);
    }
    var f = bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: T.scrim, easing: 'linear' });
    return Promise.all([f.finished, WF.motion.lift(list, { delay: 60, force: true }), drawLeaders(260)]);
  }
  // the slab goes back into the plate only when the plate is there to receive it (desktop, on screen)
  function canReturn(pl) { return !WF.mobile && !!pl && onScreen(pl); }
  function leave() {
    if (WF.mobile) return frame.animate([{ transform: 'none' }, { transform: 'translateY(100%)' }], { duration: T.drawerOut, easing: T.ease.slide, fill: 'forwards' }).finished;
    var done = parts().map(function (p) { return p.animate([{ opacity: 1 }, { opacity: 0 }], { duration: T.quick, easing: 'linear', fill: 'forwards' }).finished; });
    var pl = cur && cur.plate;
    if (cur && cur.back && canReturn(pl)) {
      var D = frame.getBoundingClientRect(), R = pl.getBoundingClientRect();
      done.push(bg.animate([{ transform: 'none' }, { transform: rectTransform(R, D) }], { duration: T.shrink, easing: T.ease.glide, fill: 'forwards' }).finished);
      // it thins out over its last 120ms, so the plate's own words are back on the frame it lands
      bg.animate([{ opacity: 1 }, { opacity: 1, offset: (T.shrink - T.quick) / T.shrink }, { opacity: 0 }], { duration: T.shrink, easing: 'linear', fill: 'forwards' });
    } else {
      done.push(bg.animate([{ opacity: 1 }, { opacity: 0 }], { duration: T.fade, easing: 'linear', fill: 'forwards' }).finished);
    }
    return Promise.all(done);
  }
  function clearMotion() { root.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); }); }

  /* ── open / close ───────────────────────────────────────────────────── */
  function open(id, o) {
    o = o || {};
    if (!WF.STORE.get(id)) return;
    var pl = plateOf(id);
    WF.touch.add({ kind: 'service', id: id, source: 'detail' });
    if (isOpen()) { cur = { id: id, plate: pl, grow: false, back: cur && cur.back && cur.plate === pl }; render(id, false); return; }
    clearMotion();
    var back = canReturn(pl);
    cur = { id: id, plate: pl, grow: o.source === 'plate' && back, back: back };
    // audit: opened from the bench (focus on <body>, bench controls in view) → return focus there,
    // not to a plate button two rooms up
    var ae = document.activeElement, tidy = document.querySelector('#bench .bench__tidy');
    var fromBench = (!ae || ae === document.body) && tidy && WF.io.inView(tidy, 0) ? tidy : null;
    var opener = o.opener || fromBench || (pl && pl.querySelector('.svc__details')) || null;
    WF.overlay.open(root, {
      opener: opener,
      initialFocus: el.name,
      // the scrim fades with whatever the close does (core g1-08; ignored by an older core)
      scrimOut: WF.mobile ? T.drawerOut : back ? T.shrink : T.fade,
      onOpen: function () {
        render(id, animating());
        el.ledger.scrollTop = 0; el.side.scrollTop = 0;
        var panel = $('.detail__panel'); if (panel) panel.scrollTop = 0;
      },
      enter: enter,
      leave: leave,
      onClose: function () { clearMotion(); },
    });
  }
  WF.on('detail:open', function (d) { if (d && d.id) open(d.id, d); });
  el.close.addEventListener('click', function () { WF.overlay.close(root); });

  /* ── variant chips: a real radiogroup (arrows follow reading direction) ─ */
  function choose(v) {
    if (!cur) return;
    var id = cur.id, pl = plateOf(id);
    if (pl) { pl.setAttribute('data-variant', v || ''); pl.dispatchEvent(new CustomEvent('wf-svc-variant')); }
    else chosen[id] = v;
    if (WF.cart.has(id)) WF.cart.setVariant(id, v, { source: 'detail' });
    syncChips();
    renderPrice();   // also rebuilds the WhatsApp question with the chosen platform / need
  }
  function syncChips() {
    if (!cur) return;
    var v = variantOf(cur.id), chips = $$('.chip', el.chips);
    chips.forEach(function (c, i) {
      var on = c.dataset.v === v;
      if (c.getAttribute('aria-checked') !== String(on)) c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on || (!v && i === 0) ? 0 : -1;
    });
  }
  el.chips.addEventListener('click', function (e) { var c = e.target.closest('.chip'); if (c) choose(c.dataset.v); });
  el.chips.addEventListener('keydown', function (e) {
    var chips = $$('.chip', el.chips), i = chips.indexOf(document.activeElement);
    if (i < 0) return;
    var rtl = WF.lang === 'ar', n = chips.length, next = null;
    if (e.key === 'ArrowDown') next = i + 1;
    else if (e.key === 'ArrowUp') next = i - 1;
    else if (e.key === 'ArrowLeft') next = rtl ? i + 1 : i - 1;
    else if (e.key === 'ArrowRight') next = rtl ? i - 1 : i + 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next === null) return;
    e.preventDefault();
    next = (next + n) % n;
    chips[next].focus();
    choose(chips[next].dataset.v);
  });

  /* ── the CTA ────────────────────────────────────────────────────────── */
  el.add.addEventListener('click', function () {
    if (!cur) return;
    var id = cur.id, pl = plateOf(id), v = variantOf(id);
    if (WF.cart.has(id)) { WF.overlay.close(root).then(function () { WF.drawer.open(1); }); return; }
    if (pl && onScreen(pl)) {
      // close first, then the plate's own strike adds it (the stamp is seen)
      WF.overlay.close(root).then(function () { pl.dispatchEvent(new CustomEvent('wf-svc-add', { detail: { variant: v } })); });
      return;
    }
    if (WF.cart.add(id, { variant: v, source: 'detail' })) WF.live(t('services.added', { name: t('core.svc.' + id + '.name') }));
  });

  WF.on('cart:change', function () { if (cur && isOpen()) { renderCTA(); renderPrice(); syncChips(); } });
  WF.on('lang', function () { if (cur && isOpen()) render(cur.id, false); });

  WF.debug.expose('detail', function () {
    return { open: isOpen(), id: cur ? cur.id : null, variant: cur ? variantOf(cur.id) : null, ask: cur ? decodeURIComponent(el.ask.href.split('text=')[1] || '') : null };
  });
});

})();
/* ── cart ── */
;(function(){
/* ==========================================================================
   cart.js — the drawer's contents (SPEC §3.6b the ledger, §3.6c the desk).
   The shell (#cart, scrim, focus trap, Escape, date) is core's WF.drawer.
   Step 1: the honest ledger — one block per service, merged exclusions,
   overlap notes, totals that are never summed across rows, the fine print.
   Step 2: the desk — a few optional lines, a live preview of the exact
   message, a live wa.me anchor, and the gold handed from the button to a
   Seal on the document. Nothing here ever says the message was sent.
   ========================================================================== */
WF.module('cart', function (root) {
  'use strict';
  var T = WF.T, E = T.ease;
  var q = function (s, sc) { return (sc || root).querySelector(s); };
  var qa = function (s, sc) { return Array.prototype.slice.call((sc || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var drawer = document.getElementById('cart');
  var scroller = root.parentElement;               // .drawer__body — the element that scrolls
  var el = {
    s1: q('[data-cart-step="1"]'), s2: q('[data-cart-step="2"]'),
    empty: q('[data-cart-empty]'), browse: q('[data-cart-browse]'),
    sheet: q('[data-cart-sheet]'), items: q('[data-cart-items]'),
    ex: q('[data-cart-ex]'), exV: q('[data-cart-ex-v]'),
    notes: q('[data-cart-notes]'), noteMs: q('[data-cart-note="ms"]'), noteLm: q('[data-cart-note="lm"]'),
    keep: q('[data-cart-keep]'), both: q('[data-cart-both]'),
    totals: q('[data-cart-totals]'), save: q('[data-cart-save]'), fine: q('[data-cart-fine]'), renew: q('[data-cart-renew]'),
    foot1: q('[data-cart-foot]'), go: q('[data-cart-go]'),
    back: q('[data-cart-back]'), deskH: q('#cart-desk-h'), form: q('[data-cart-form]'),
    where: q('[data-cart-where]'), platField: q('[data-cart-platform-field]'), plat: q('[data-cart-platform]'),
    link: q('[data-cart-in="link"]'), need: q('[data-cart-in="need"]'), name: q('[data-cart-in="name"]'),
    count: q('[data-cart-count]'), doc: q('[data-cart-doc]'), preview: q('[data-cart-preview]'),
    after: q('[data-cart-after]'), copy: q('[data-cart-copy]'), wa: q('[data-cart-wa]'),
  };
  var row = {
    monthly: q('[data-cart-total="monthly"]'), oneoff: q('[data-cart-total="oneoff"]'), quote: q('[data-cart-total="quote"]'),
  };
  var st = {
    step: 1, open: false,
    shown: {},            // service id → its block has appeared in an open drawer (first-appearance motion ran)
    sheetShown: false,    // the sheet's lower rows have had their one entrance
    chain: Promise.resolve(),
    removing: null,
    stepAnim: null,
    handed: false, handing: false, seal: null, tok: 0, afterT: 0,
    copy: 'copy', lastMsg: '',
  };
  var canDetail = !!document.getElementById('detail');   // item names open the service detail when it exists
  var fieldSizing = !!(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'));

  /* ── helpers ──────────────────────────────────────────────────────────── */
  function svcName(id) { return WF.t('core.svc.' + id + '.name'); }
  function isMonthly(id) { var s = WF.STORE.get(id); return !!(s && s.cadence === 'monthly'); }
  function visible(n) { return !!(n && !n.hidden && n.getClientRects().length); }
  function focus(n) { if (!n) return; try { n.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  function setText(n, s) { if (n && n.textContent !== s) n.textContent = s; }
  function setHTML(n, s) { if (n && n._h !== s) { n.innerHTML = s; n._h = s; } }
  // withWas: the struck anchor sits right before the number it was replaced by
  // («~~3,360~~ 2,349 ر.س / شهر», «يبدأ من ~~2,999~~ 2,099 ر.س», "SAR ~~3,360~~ 2,349 / month").
  // Item rows only; the totals carry the new prices alone. By-quote variants have no anchor.
  function priceHTML(id, variant, withWas) {
    var p = WF.fmt.priceParts(id, variant);
    if (!p) return '';
    if (p.kind === 'quote') return '<span class="cart-q">' + esc(p.unit) + '</span>';
    return (p.pre ? '<span class="cart-u">' + esc(p.pre) + '</span>' : '') +
      (withWas ? WF.fmt.was(id, variant) : '') +
      '<bdi class="num">' + p.num + '</bdi>' + (p.unit ? '<span class="cart-u">' + esc(p.unit) + '</span>' : '');
  }
  function numHTML(n) { return '<bdi class="num">' + WF.fmt.num(n) + '</bdi>'; }
  // what the anchors add up to, per period (never summed across periods, like the totals)
  function savings() {
    var s = { monthly: 0, oneoff: 0 };
    WF.cart.items().forEach(function (it) {
      var svc = WF.STORE.get(it.id), p = WF.fmt.priceParts(it.id, it.variant);
      if (!svc || !p || !p.was || !svc.was || svc.price == null) return;
      if (svc.cadence === 'monthly') s.monthly += svc.was - svc.price;
      else if (svc.cadence === 'oneoff') s.oneoff += svc.was - svc.price;
    });
    return s;
  }
  function itemLabel(it) {
    var v = WF.fmt.variant(it.id, it.variant);
    return svcName(it.id) + (v ? ' · ' + v : '');
  }

  /* ── step 1 · the ledger ──────────────────────────────────────────────── */
  function blockHTML(it) {
    var name = svcName(it.id);
    var v = WF.fmt.variant(it.id, it.variant);
    var term = WF.t('core.svc.' + it.id + '.term');
    var nameEl = canDetail
      ? '<button class="cart-item__name" type="button" data-detail="' + it.id + '">' + esc(name) + '</button>'
      : '<span class="cart-item__name">' + esc(name) + '</span>';
    return '<div class="ledger__row cart-item__row">' + nameEl +
        '<span class="cart-item__tail"><span class="ledger__lead" aria-hidden="true"></span>' +
        '<span class="cart-item__price">' + priceHTML(it.id, it.variant, true) + '</span></span></div>' +
      '<div class="cart-item__meta"><span class="cart-item__term">' + (v ? '<bdi>' + esc(v) + '</bdi> · ' : '') + esc(term) + '</span>' +
        '<button class="btn btn--text cart-item__rm" type="button" data-rm="' + it.id + '" aria-label="' +
        esc(WF.t('cart.remove.aria', { name: name })) + '">' + esc(WF.t('cart.remove')) + '</button></div>' +
      '<span class="cart-item__strike" aria-hidden="true"></span>';
  }
  function liveItems() { return qa('.cart-item', el.items).filter(function (li) { return !li._removing; }); }
  function renderItems() {
    var items = WF.cart.items();
    var have = {};
    qa('.cart-item', el.items).forEach(function (li) { have[li.getAttribute('data-id')] = li; });
    var prev = null;
    items.forEach(function (it) {
      var li = have[it.id];
      if (!li) { li = document.createElement('li'); li.className = 'cart-item'; li.setAttribute('data-id', it.id); }
      setHTML(li, blockHTML(it));
      delete have[it.id];
      var want = prev ? prev.nextElementSibling : el.items.firstElementChild;
      while (want && want._removing) want = want.nextElementSibling;
      if (li !== want) el.items.insertBefore(li, want);
      prev = li;
    });
    Object.keys(have).forEach(function (id) { if (!have[id]._removing) have[id].remove(); });
  }
  function totalHTML(kind, t) {
    if (kind === 'monthly') {
      var n = '<bdi class="num">' + WF.fmt.num(t.monthly) + '</bdi>', u = '<span class="cart-u">' + esc(WF.t('core.u.sar')) + '</span>';
      return WF.lang === 'ar' ? n + u : u + n;
    }
    if (kind === 'oneoff') {
      var l = WF.cart.get('launch');
      return priceHTML('launch', l ? l.variant : 'salla');
    }
    return t.quote.map(function (it) { return '<span>' + esc(itemLabel(it)) + '</span>'; }).join('');
  }
  function renderRest() {
    var n = WF.cart.count();
    // merged exclusions: de-duplicated, «ops» suppressed by manage (core); one item per line, the
    // way a quote lists them, so no « · » can dangle at a line end
    var ex = WF.cart.exclusions();
    el.ex.hidden = !ex.length;
    setHTML(el.exV, ex.length ? '<ul class="cart-ex__list">' + ex.map(function (k) { return '<li>' + esc(WF.t('core.ex.' + k)) + '</li>'; }).join('') + '</ul>' : '');
    // overlap notes
    var ov = WF.cart.overlaps();
    el.noteMs.hidden = ov.indexOf('ms') < 0;
    el.noteLm.hidden = ov.indexOf('lm') < 0;
    el.notes.hidden = !ov.length;
    // totals, each row only if non-empty
    var t = WF.cart.totals();
    var on = { monthly: t.monthly > 0, oneoff: !!t.oneOff, quote: t.quote.length > 0 };
    Object.keys(row).forEach(function (k) {
      row[k].hidden = !on[k];
      if (on[k]) setHTML(row[k].querySelector('[data-cart-v]'), totalHTML(k, t));
    });
    // one quiet line under the totals: the saving against the struck anchors, per period
    var sv = savings();
    var sk = sv.monthly && sv.oneoff ? 'cart.save.mo' : sv.monthly ? 'cart.save.m' : sv.oneoff ? 'cart.save.o' : '';
    el.save.hidden = !sk;
    setHTML(el.save, sk ? esc(WF.t(sk)).replace('{m}', numHTML(sv.monthly)).replace('{o}', numHTML(sv.oneoff)) : '');
    el.renew.hidden = !WF.cart.items().some(function (i) { return isMonthly(i.id); });
    // empty ↔ sheet
    el.empty.hidden = n > 0;
    el.sheet.hidden = n === 0;
    el.foot1.hidden = n === 0;
  }

  // first time a block appears in an open drawer: its leader DRAWs, then its text LIFTs
  function revealNew(delay) {
    var fresh = liveItems().filter(function (li) { return !st.shown[li.getAttribute('data-id')]; });
    fresh.forEach(function (li) { st.shown[li.getAttribute('data-id')] = true; });
    var firstSheet = !st.sheetShown && WF.cart.count() > 0;
    if (WF.cart.count() > 0) st.sheetShown = true;
    if (WF.reduced || (!fresh.length && !firstSheet)) return;
    fresh.forEach(function (li, k) {
      var d = delay + k * T.liftStagger;
      WF.motion.draw(li.querySelector('.ledger__lead'), { delay: d });
      WF.motion.lift([li.querySelector('.cart-item__name'), li.querySelector('.cart-item__price'), li.querySelector('.cart-item__meta')],
        { delay: d + T.draw, stagger: 40 });
    });
    if (firstSheet) {
      var d2 = delay + fresh.length * T.liftStagger + T.draw + 120;
      var rest = [el.ex, el.notes, el.totals, el.fine].filter(visible);
      WF.motion.draw(qa('.ledger__lead', el.totals).filter(visible), { delay: d2 + 60 });
      WF.motion.lift(rest, { delay: d2 });
    }
  }

  /* remove: state first, then a taupe line DRAWs through the block, it fades,
     it is removed, and what sits below glides up (translate-only FLIP) */
  function removeItem(id, focusTo) {
    if (!WF.cart.has(id)) return;
    var li = el.items.querySelector('.cart-item[data-id="' + id + '"]');
    var name = svcName(id);
    // where focus lands afterwards (decided before anything becomes inert)
    var target = focusTo;
    if (!target && li) {
      var others = liveItems().filter(function (x) { return x !== li; });
      var idx = liveItems().indexOf(li);
      var next = others[idx] || others[idx - 1];
      target = next ? next.querySelector('.cart-item__rm') : null;
    }
    st.removing = id;
    WF.cart.remove(id, { source: 'cart' });
    st.removing = null;
    delete st.shown[id];
    WF.live(WF.t('cart.removed', { name: name }));
    var empty = WF.cart.count() === 0;
    if (!li || WF.reduced) {
      if (li) li.remove();
      renderAll();
      focus(empty ? el.browse : (target || el.go));
      return;
    }
    focus(empty ? el.sheet : (target || el.go));
    li._removing = true;
    li.inert = true;
    // state first: the exclusions, notes and totals take the new cart on this frame and glide to their
    // new places while the block is struck through, so the lower ledger is never blank
    if (!empty) WF.motion.flip([el.ex, el.noteMs, el.noteLm, el.totals, el.fine].filter(visible), renderRest, { ms: 240 });
    var strike = li.querySelector('.cart-item__strike');
    var price = li.querySelector('.cart-item__price');
    if (strike && price) {
      var lr = li.getBoundingClientRect(), pr = price.getBoundingClientRect();
      strike.style.top = (pr.top + pr.height * 0.56 - lr.top).toFixed(1) + 'px';
    }
    st.chain = st.chain.then(function () {
      var a = strike ? strike.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: T.hover, easing: E.rise, fill: 'forwards' }) : null;
      return (a ? a.finished : Promise.resolve()).catch(function () {}).then(function () {
        return li.animate([{ opacity: 1 }, { opacity: 0 }], { duration: T.fade, easing: 'linear', fill: 'forwards' }).finished.catch(function () {});
      }).then(function () {
        if (WF.cart.count() === 0) {
          li.remove();
          renderAll();
          if (st.open && !WF.reduced) WF.motion.lift([q('.cart-empty__text'), el.browse], { stagger: T.liftStagger });
          if (!st.open || document.activeElement === el.sheet || !root.contains(document.activeElement)) focus(el.browse);
          return;
        }
        var below = [];
        for (var n = li.nextElementSibling; n; n = n.nextElementSibling) below.push(n);
        below = below.concat([el.ex, el.notes, el.totals, el.fine]).filter(visible);
        return WF.motion.flip(below, function () { li.remove(); renderAll(); }, { ms: 240 });
      });
    });
  }

  function dismissMs() {
    WF.cart.dismiss('ms');
    focus(el.go);
    if (WF.reduced) { renderRest(); return; }
    var note = el.noteMs;
    st.chain = st.chain.then(function () {
      return note.animate([{ opacity: 1 }, { opacity: 0 }], { duration: T.fade, easing: 'linear', fill: 'forwards' }).finished.catch(function () {})
        .then(function () {
          var below = [el.noteLm, el.totals, el.fine].filter(visible);
          return WF.motion.flip(below, function () {
            renderRest();
            note.getAnimations().forEach(function (a) { a.cancel(); });
          }, { ms: 240 });
        });
    });
  }

  /* ── step 2 · the desk ────────────────────────────────────────────────── */
  function radios(group) { return qa('[role="radio"]', group); }
  function setRadio(group, v) {
    var list = radios(group), any = false;
    list.forEach(function (r) {
      var on = r.getAttribute('data-v') === v;
      if (on) any = true;
      r.setAttribute('aria-checked', on ? 'true' : 'false');
      r.tabIndex = on ? 0 : -1;
    });
    if (!any && list[0]) list[0].tabIndex = 0;
  }
  function radioGroup(group, pick) {
    group.addEventListener('click', function (e) {
      var b = e.target.closest('[role="radio"]');
      if (b && group.contains(b)) pick(b.getAttribute('data-v'));
    });
    group.addEventListener('keydown', function (e) {
      var k = e.key, rtl = WF.lang === 'ar';
      var next = k === 'ArrowDown' || k === (rtl ? 'ArrowLeft' : 'ArrowRight');
      var prev = k === 'ArrowUp' || k === (rtl ? 'ArrowRight' : 'ArrowLeft');
      if (!next && !prev && k !== 'Home' && k !== 'End') return;
      e.preventDefault();
      var list = radios(group), i = list.indexOf(document.activeElement);
      if (i < 0) i = 0;
      var j = k === 'Home' ? 0 : k === 'End' ? list.length - 1 : (i + (next ? 1 : -1) + list.length) % list.length;
      focus(list[j]);
      pick(list[j].getAttribute('data-v'));
    });
  }
  function message() {
    return WF.wa.msg('desk', { link: el.link.value, need: el.need.value, name: el.name.value });
  }
  function fitPreview() {
    if (fieldSizing) return;
    el.preview.style.height = 'auto';
    el.preview.style.height = el.preview.scrollHeight + 'px';
  }
  function updateCounter() {
    var len = el.need.value.length, near = 280 - len <= 20;
    setText(el.count, len + ' / 280');
    var p = el.count.parentElement;
    p.classList.toggle('is-near', near);
    if (near) p.setAttribute('aria-live', 'polite'); else p.removeAttribute('aria-live');
  }
  function updatePreview() {
    var m = message();
    el.preview.dir = WF.lang === 'ar' ? 'rtl' : 'ltr';
    if (el.preview.value !== m) { el.preview.value = m; fitPreview(); }
    var href = WF.wa.href(m);
    if (el.wa.getAttribute('href') !== href) el.wa.setAttribute('href', href);
    if (m !== st.lastMsg) { st.lastMsg = m; if (st.copy !== 'copy') setCopy('copy'); }
    updateCounter();
    if (st.seal && !WF.seal.busy(st.seal)) WF.seal.place(st.seal, sealTarget(), { layer: el.doc });
  }
  function renderDesk() {
    setRadio(el.where, WF.state.where);
    var launch = WF.cart.get('launch');
    el.platField.hidden = !launch;
    if (launch) setRadio(el.plat, launch.variant || 'salla');
    updatePreview();
  }
  function setCopy(k) {
    st.copy = k;
    var key = k === 'copied' ? 'cart.copied' : k === 'fail' ? 'cart.copyFail' : 'cart.copy';
    el.copy.setAttribute('data-i18n', key);
    setText(el.copy, WF.t(key));
  }
  function copyText() {
    var text = el.preview.value;
    var fallback = function () {
      var ok = false;
      try { el.preview.focus({ preventScroll: true }); el.preview.select(); ok = document.execCommand('copy'); } catch (e) { ok = false; }
      if (ok) { focus(el.copy); setCopy('copied'); WF.live(WF.t('cart.copied')); }
      else { try { el.preview.focus({ preventScroll: true }); el.preview.select(); } catch (e) { /* ignore */ } setCopy('fail'); }
    };
    // a frame without clipboard-write (the Artifact sandbox) would log a policy violation before
    // rejecting: ask the policy first and go straight to the fallback
    var pp = document.permissionsPolicy || document.featurePolicy, allowed = true;
    try { if (pp && pp.allowsFeature && !pp.allowsFeature('clipboard-write')) allowed = false; } catch (e) { /* ignore */ }
    try {
      if (allowed && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { setCopy('copied'); WF.live(WF.t('cart.copied')); }, fallback);
        return;
      }
    } catch (e) { /* fall through */ }
    fallback();
  }

  /* the handoff: on the CTA's click (the native navigation proceeds untouched),
     the gold leaves the button on that frame and a Seal carries it to the document */
  function sealTarget() {
    var ar = WF.lang === 'ar';
    return { el: el.preview, ax: ar ? 0 : 1, ay: 1, dx: ar ? 52 : -52, dy: -24 };
  }
  // The drawer body's camera: a rAF tween of scrollTop on --ease-slide (never a snap, never the
  // page's own smooth scroll). A wheel, touch or key from the visitor hands the camera back at once.
  var cam = null;
  function camStop() {
    if (!cam) return;
    cancelAnimationFrame(cam.raf);
    var done = cam.done; cam = null; done();
  }
  function camTo(top, ms) {
    camStop();
    var from = scroller.scrollTop, to = Math.max(0, Math.min(top, scroller.scrollHeight - scroller.clientHeight));
    if (WF.reduced || Math.abs(to - from) < 1) { scroller.scrollTop = to; return Promise.resolve(); }
    return new Promise(function (done) {
      var me = cam = { raf: 0, done: done }, t0 = -1;
      var step = function (now) {
        if (cam !== me) return;
        if (t0 < 0) t0 = now;
        var k = Math.min(1, (now - t0) / ms);
        scroller.scrollTop = from + (to - from) * T.fn.slide(k);
        if (k < 1) me.raf = requestAnimationFrame(step); else { cam = null; done(); }
      };
      me.raf = requestAnimationFrame(step);
    });
  }
  ['wheel', 'touchstart', 'keydown'].forEach(function (t) { scroller.addEventListener(t, camStop, { passive: true }); });
  // how far a block's bottom sits under the sticky foot (> 0 = covered)
  function underFoot(n) {
    var sr = scroller.getBoundingClientRect(), r = n.getBoundingClientRect();
    var foot = q('.cart-foot--desk'), fh = foot ? foot.getBoundingClientRect().height : 0;
    return r.bottom - (sr.bottom - fh - 16);
  }
  // the preview must be on screen before the Seal travels to it: glide there (220ms), then strike
  function docInView() {
    var sr = scroller.getBoundingClientRect(), dr = el.preview.getBoundingClientRect();
    var over = underFoot(el.preview), d = 0;
    if (over > 0) d = over;
    else if (dr.top < sr.top + 16) d = dr.top - (sr.top + 16);
    return d ? camTo(scroller.scrollTop + d, 220) : Promise.resolve();
  }
  function handoff() {
    if (st.handed || st.handing) return;
    var tok = ++st.tok;
    st.handing = true;
    docInView().then(function () {
      if (tok !== st.tok) return;
      // one frame: the CTA cools to ink outline (it stays a working link) …
      el.wa.classList.remove('btn--gold');
      el.wa.classList.add('btn--line-ink');
      el.wa.removeAttribute('data-gold');   // the gold EVENT moves to the Seal (SPEC-V2 §3.10: one per viewport)
      // … and the gold appears as a Seal where the button is
      var seal = WF.seal.make({ face: 'mark', size: 72, className: 'cart-seal' });
      el.doc.appendChild(seal);
      st.seal = seal;
      WF.seal.place(seal, el.wa, { layer: el.doc });
      WF.seal.strike(seal, {
        target: sealTarget, layer: el.doc, lift: T.liftPx.drawer, impactEl: el.preview,
        onContact: function () { if (tok !== st.tok) return; seal.classList.add('is-set'); st.handed = true; },
      }).then(function () {
        if (tok !== st.tok) return;
        st.handing = false;
        showAfter(tok);
      });
    });
  }
  function showAfter(tok) {
    el.after.hidden = false;
    var parts = qa('.cart-after__line, .cart-copy', el.after);
    if (!WF.reduced) WF.motion.lift(parts, { stagger: T.liftStagger });
    // only if the lines landed under the sticky foot: let the Seal's HOLD finish and the lines
    // settle, then glide the camera to them (420ms). A visitor who scrolled meanwhile is left alone.
    if (underFoot(el.after) <= 0) return;
    if (WF.reduced) { scroller.scrollTop += underFoot(el.after); return; }
    clearTimeout(st.afterT);
    st.afterT = setTimeout(function () {
      if (tok !== st.tok || !st.open) return;
      var over = underFoot(el.after);
      if (over > 0) camTo(scroller.scrollTop + over, 420);
    }, T.hold + 400);
  }
  function resetHandoff() {
    st.tok++;
    clearTimeout(st.afterT);
    camStop();
    if (st.seal) { st.seal.remove(); st.seal = null; }
    st.handed = false; st.handing = false;
    el.wa.classList.add('btn--gold');
    el.wa.setAttribute('data-gold', 'event');
    el.wa.classList.remove('btn--line-ink');
    el.after.hidden = true;
    setCopy('copy');
  }

  /* ── steps ────────────────────────────────────────────────────────────── */
  function clearStepAnim() {
    if (st.stepAnim) { try { st.stepAnim.cancel(); } catch (e) { /* ignore */ } st.stepAnim = null; }
  }
  function enterStep(n) {
    if (WF.reduced) return;
    if (n === 2) {
      WF.motion.rise(el.deskH);
      var lifts = [el.back].concat(qa('.cart-form > .cart-field:not([hidden]), .cart-field--doc, .cart-privacy', el.s2), [q('.cart-foot--desk')]);
      WF.motion.lift(lifts, { delay: 60, stagger: T.liftStagger });
    } else {
      WF.motion.lift([el.empty, el.sheet, el.foot1].filter(visible), { stagger: T.liftStagger });
    }
  }
  function showStep(n, o) {
    o = o || {};
    if (n === 2 && WF.cart.count() === 0) n = 1;
    if (drawer) drawer.setAttribute('data-step', String(n));
    var from = n === 2 ? el.s1 : el.s2, to = n === 2 ? el.s2 : el.s1;
    var prev = st.step;
    st.step = n;
    if (prev === 2 && n === 1) resetHandoff();
    clearStepAnim();
    var run = function () {
      from.hidden = true;
      to.hidden = false;
      scroller.scrollTop = 0;
      if (n === 2) renderDesk();
      if (o.animate) enterStep(n);
      if (o.focus) focus(n === 2 ? el.deskH : (visible(el.go) ? el.go : el.browse));
    };
    if (o.animate && !WF.reduced && !from.hidden && prev !== n) {
      // step 1 leaves 24px toward inline-start with a fade (back: mirrored), then step 2 comes in
      var toward = (WF.lang === 'ar' ? 1 : -1) * 24 * (n === 2 ? 1 : -1);
      var a = st.stepAnim = from.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + toward + 'px)', opacity: 0 }],
        { duration: T.sink, easing: E.sink, fill: 'forwards' });
      a.finished.then(function () { if (st.stepAnim !== a) return; st.stepAnim = null; run(); a.cancel(); }).catch(function () {});
    } else run();
  }

  /* ── render all ───────────────────────────────────────────────────────── */
  function renderAll() {
    renderItems();
    renderRest();
    renderDesk();
    if (st.step === 2 && WF.cart.count() === 0 && st.open) showStep(1, { animate: false, focus: true });
  }

  /* ── wiring ───────────────────────────────────────────────────────────── */
  el.items.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]');
    if (rm) { removeItem(rm.getAttribute('data-rm')); return; }
    var d = e.target.closest('[data-detail]');
    if (d) WF.emit('detail:open', { id: d.getAttribute('data-detail') });
  });
  el.keep.addEventListener('click', function () { removeItem('social', el.go); });
  el.both.addEventListener('click', dismissMs);
  el.go.addEventListener('click', function () { WF.drawer.open(2); });
  el.back.addEventListener('click', function () { WF.drawer.open(1); });
  el.browse.addEventListener('click', function () {
    WF.drawer.close().then(function () {
      var s = document.getElementById('services');
      if (s) s.scrollIntoView({ behavior: WF.reduced ? 'auto' : 'smooth', block: 'start' });
    });
  });
  radioGroup(el.where, function (v) { WF.setWhere(v); });
  radioGroup(el.plat, function (v) { WF.cart.setVariant('launch', v, { source: 'cart' }); });
  el.form.addEventListener('submit', function (e) { e.preventDefault(); });
  el.form.addEventListener('input', updatePreview);
  el.form.addEventListener('change', updatePreview);
  el.wa.addEventListener('click', handoff);          // never preventDefault: the link opens WhatsApp itself
  // Focus lands on the step 2 heading (tabindex -1). Core's focus trap treats an element outside its
  // focusable list as "outside" and sends Tab to the dialog's first control (the close button), which
  // would throw a keyboard user back to the top. From the heading, Tab continues into the form and
  // Shift+Tab returns to «رجوع للسلة». Window capture runs before core's document-capture trap.
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || document.activeElement !== el.deskH || !st.open) return;
    var t = e.shiftKey ? el.back : WF.focusables(el.s2).filter(function (n) {
      return el.deskH.compareDocumentPosition(n) & Node.DOCUMENT_POSITION_FOLLOWING;
    })[0];
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    focus(t);
  }, true);
  el.copy.addEventListener('click', copyText);

  WF.on('cart:change', function (d) {
    if (d.reason === 'remove' && d.source === 'cart' && st.removing === d.id) return;   // the animated path renders
    renderAll();
    if (st.open && st.step === 1 && d.reason === 'add') revealNew(0);
  });
  WF.on('where:change', function () { renderDesk(); });
  WF.on('drawer:open', function (d) {
    var fresh = !st.open;
    st.open = true;
    if (fresh) {
      renderAll();
      scroller.scrollTop = 0;
      showStep(d.step || 1, { animate: false, focus: false });
      if (st.step === 1) revealNew(WF.reduced ? 0 : 180);
      else enterStep(2);
    } else {
      showStep(d.step || 1, { animate: true, focus: true });
    }
  });
  WF.on('drawer:close', function () {
    st.open = false;
    clearStepAnim();
    resetHandoff();
  });
  WF.on('lang', function () {
    renderAll();
    if (st.copy !== 'copy') setCopy(st.copy);
    // core writes the drawer date only on open; keep it in the page's language across a swap
    var date = document.getElementById('cart-date');
    if (date && date.textContent) date.textContent = WF.fmt.date(new Date());
  });

  WF.debug.expose('cart', function () {
    return {
      step: st.step, open: st.open, blocks: liveItems().length, handed: st.handed, seal: !!st.seal,
      href: el.wa.getAttribute('href'), cta: el.wa.className,
    };
  });

  renderAll();
  setRadio(el.where, WF.state.where);
});

})();
/* ── cartbar ── */
;(function(){
/* ==========================================================================
   cartbar.js — the mobile cart bar and the first-add slip (SPEC §3.6d).
   Bar: ≤767px, cart has ≥1 item, no overlay open, and the bench controls row
   is not in view (so it never covers them). #wf gets a matching padding-bottom.
   Slip: once per page view, on the first add, hung under the header cart button;
   hides after 4s unless hovered/focused. Never on phones (≤767px, SPEC §7.1 cut #2):
   there the bar sliding up, the header IMPACT and #wf-live already confirm the add,
   and a slip would sit over the plate's own buttons. It is not a live region either:
   #wf-live carries the one, richer announcement.
   ========================================================================== */
WF.module('cartbar', function (root) {
  'use strict';
  var T = WF.T, E = T.ease;
  var q = function (s) { return root.querySelector(s); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var bar = q('[data-cartbar-bar]'), label = q('[data-cartbar-label]'), cta = q('[data-cartbar-cta]');
  var slip = q('[data-cartbar-slip]'), slipMsg = q('[data-cartbar-slipmsg]'), slipOpen = q('[data-cartbar-open]');
  var SLIP_MS = 4000;
  var st = {
    everShown: false, overlay: !!WF.overlay.top(), bench: false, barH: 64, barAnim: null,
    slipDone: false, slipPending: false, slipTimer: 0, slipHover: false, slipFocus: false, slipAnim: null,
  };

  /* ── the bar ──────────────────────────────────────────────────────────── */
  function renderLabel() {
    var tpl = WF.t('cartbar.label'), i = tpl.indexOf('{n}'), n = WF.cart.count();
    var html = i < 0 ? esc(tpl) : esc(tpl.slice(0, i)) + '<bdi class="num">' + n + '</bdi>' + esc(tpl.slice(i + 3));
    if (label._h !== html) { label.innerHTML = html; label._h = html; }
  }
  function want() { return WF.mobile && WF.cart.count() > 0 && !st.overlay && !st.bench; }
  function setPad() {
    var on = WF.mobile && WF.cart.count() > 0;
    var v = on ? st.barH + 'px' : '';
    if (WF.root.style.paddingBottom !== v) WF.root.style.paddingBottom = v;
  }
  function cancelBarAnim() { if (st.barAnim) { try { st.barAnim.cancel(); } catch (e) { /* ignore */ } st.barAnim = null; } }
  function updateBar(o) {
    o = o || {};
    renderLabel();
    var show = want();
    var slide = !WF.reduced && WF.booted && o.slide !== false;
    if (show && (bar.hidden || bar._leaving)) {
      cancelBarAnim();
      bar._leaving = false;
      bar.hidden = false;
      st.barH = bar.offsetHeight || st.barH;
      // the first appearance slides up; re-appearing next to the bench slides too (it left the same way)
      if (slide && (!st.everShown || o.fromBench)) {
        st.barAnim = bar.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: T.drawerOut, easing: E.slide });
      }
      st.everShown = true;
    } else if (!show && !bar.hidden && !bar._leaving) {
      cancelBarAnim();
      if (slide && o.fromBench) {
        bar._leaving = true;
        var a = st.barAnim = bar.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(100%)' }], { duration: T.drawerOut, easing: E.slide, fill: 'forwards' });
        a.finished.then(function () { if (st.barAnim !== a) return; bar.hidden = true; bar._leaving = false; a.cancel(); st.barAnim = null; }).catch(function () {});
      } else {
        bar.hidden = true;
      }
    }
    setPad();
  }

  // the bench controls row: never covered. Found lazily (the bench builds its own markup).
  var benchCtl = null, benchEl = null, raf = 0;
  function findBench() {
    if (benchCtl && benchCtl.isConnected) return benchCtl;
    benchCtl = document.querySelector('#bench .bench__controls, #bench [data-bench-controls], #bench .bench__ctrls, #bench .bench-controls');
    benchEl = document.getElementById('bench');
    return benchCtl;
  }
  function checkBench() {
    raf = 0;
    if (!WF.mobile || !WF.cart.count()) { if (st.bench) { st.bench = false; updateBar({ fromBench: true }); } return; }
    var ctl = findBench(), vis = false, vh = innerHeight;
    if (ctl) { var r = ctl.getBoundingClientRect(); vis = r.height > 0 && r.top < vh && r.bottom > 0; }
    else if (benchEl) { var b = benchEl.getBoundingClientRect(); vis = b.height > 0 && b.bottom - 220 < vh && b.bottom > 0; }
    if (vis !== st.bench) {
      st.bench = vis;
      updateBar({ fromBench: true });
      if (vis && !slip.hidden) hideSlip();   // the slip belongs above the bar; the bar just stepped aside
    }
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(checkBench); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ── the slip ─────────────────────────────────────────────────────────── */
  function placeSlip() {
    if (slip.hidden) return;
    if (WF.mobile) {
      slip.classList.add('is-m');
      slip.style.left = ''; slip.style.top = '';
      return;
    }
    slip.classList.remove('is-m');
    var btn = document.getElementById('wf-cart-btn'), hdr = document.getElementById('wf-header');
    if (!btn) { slip.style.top = '72px'; slip.style.left = '16px'; return; }
    var r = btn.getBoundingClientRect();
    var top = hdr ? hdr.getBoundingClientRect().bottom : r.bottom + 8;
    var w = slip.offsetWidth, gut = 16;
    var left = r.left + r.width / 2 - w / 2;
    left = Math.max(gut, Math.min(innerWidth - gut - w, left));
    slip.style.top = Math.max(0, Math.round(top)) + 'px';
    slip.style.left = Math.round(left) + 'px';
  }
  function armSlip() {
    clearTimeout(st.slipTimer);
    if (st.slipHover || st.slipFocus) return;
    st.slipTimer = setTimeout(function () { hideSlip(); }, SLIP_MS);
  }
  function onDocKey(e) { if (e.key === 'Escape' && !slip.hidden) hideSlip(); }
  function onDocDown(e) { if (!slip.hidden && !slip.contains(e.target)) hideSlip(); }
  function showSlip() {
    st.slipDone = true;
    st.slipPending = false;
    if (WF.mobile) return;
    if (st.slipAnim) { st.slipAnim.cancel(); st.slipAnim = null; }
    slipMsg.textContent = '';
    slip.hidden = false;
    slipMsg.textContent = WF.t('cartbar.slip');
    placeSlip();                                  // measured with its text in place
    if (!WF.reduced) WF.motion.lift(slip);
    document.addEventListener('keydown', onDocKey, true);
    document.addEventListener('pointerdown', onDocDown, true);
    armSlip();
  }
  function hideSlip(instant) {
    clearTimeout(st.slipTimer);
    document.removeEventListener('keydown', onDocKey, true);
    document.removeEventListener('pointerdown', onDocDown, true);
    if (slip.hidden) return;
    var hadFocus = slip.contains(document.activeElement);
    var done = function () {
      slip.hidden = true;
      if (hadFocus && !WF.overlay.top()) { var b = document.getElementById('wf-cart-btn'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) { /* ignore */ } } }
    };
    if (instant || WF.reduced) { done(); return; }
    var a = st.slipAnim = slip.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(14px)' }],
      { duration: T.hover, easing: E.sink, fill: 'forwards' });
    a.finished.then(function () { if (st.slipAnim !== a) return; st.slipAnim = null; done(); a.cancel(); }).catch(function () {});
  }
  slip.addEventListener('pointerenter', function () { st.slipHover = true; clearTimeout(st.slipTimer); });
  slip.addEventListener('pointerleave', function () { st.slipHover = false; armSlip(); });
  slip.addEventListener('focusin', function () { st.slipFocus = true; clearTimeout(st.slipTimer); });
  slip.addEventListener('focusout', function (e) { if (slip.contains(e.relatedTarget)) return; st.slipFocus = false; armSlip(); });
  // The bar and the slip are hidden while an overlay is open, so core's focus return to them would
  // land on nothing. Remember who opened it and put focus back ourselves once the overlay closes.
  var focusBack = null;
  slipOpen.addEventListener('click', function () { focusBack = 'slip'; hideSlip(true); WF.drawer.open(1); });
  cta.addEventListener('click', function () { focusBack = 'bar'; WF.drawer.open(1); });
  function restoreFocus() {
    var who = focusBack; focusBack = null;
    if (!who) return;
    var a = document.activeElement;
    // an element inside the just-hidden overlay still reports as active until focus fix-up: that is lost focus too
    if (a && a !== document.body && a !== document.documentElement && WF.root.contains(a) && !a.closest('[hidden]') && a.getClientRects().length) return;
    var t = who === 'bar' && !bar.hidden ? cta : document.getElementById('wf-cart-btn');
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }

  /* ── events ───────────────────────────────────────────────────────────── */
  WF.on('cart:change', function (d) {
    updateBar({ slide: d.reason !== 'load' });   // a cart restored on load is simply there
    checkBench();
    if (d.reason === 'add' && !st.slipDone) {
      if (WF.mobile) st.slipDone = true;             // phones: no slip, this page view
      else if (WF.overlay.top()) st.slipPending = true;   // under a scrim nobody would see it: show it when the overlay closes
      else showSlip();
    }
  });
  WF.on('overlay:open', function () { st.overlay = true; hideSlip(true); updateBar({ slide: false }); });
  WF.on('overlay:close', function () {
    st.overlay = !!WF.overlay.top();
    updateBar({ slide: false });
    if (!st.overlay) restoreFocus();
    if (st.slipPending && !st.slipDone && !st.overlay) showSlip();
  });
  WF.on('env', function () { updateBar({ slide: false }); checkBench(); placeSlip(); });
  WF.on('lang', function () {
    renderLabel();
    if (!slip.hidden) { slipMsg.textContent = WF.t('cartbar.slip'); placeSlip(); }
  });
  window.addEventListener('resize', function () { placeSlip(); }, { passive: true });

  WF.debug.expose('cartbar', function () {
    return { bar: !bar.hidden, slip: !slip.hidden, slipDone: st.slipDone, bench: st.bench, pad: WF.root.style.paddingBottom };
  });

  updateBar({ slide: false });
});

})();
/* ── art ── */
;(function(){
/* ==========================================================================
   art.js — Concept A «الظل» THE SHADE: the afternoon carried past the desk. Owner: A-ART.
   WF.module('art') inits LAST, root = #wf.
   · ART-1  the palm's shade, STATIC, on #start / #library / #faq (one canvas each, painted on init,
            on a debounced resize and on the Mirror; frond geometry copied from ambient.js frondGeom
            with the wind at 0: the lanes never import each other's code).
   · ART-3  desk:clear → .a-cleared on #wf (CSS lowers the shades; no loop, no timer).
   · ART-6  the last light on the bench floor: one decorative layer, CSS only.
   · window.__art { probe(), stats() }: the worst text contrast behind each shade.
   No rAF, no scroll listener. See review/refine-a/REFINE-A.md, lane A-ART.
   ========================================================================== */
WF.module('art', function (root) {
  'use strict';
  if (!root || root.getAttribute('data-variant') !== 'a') return;

  var SCALE = 0.5;                      // backing scale: the shade is blurred anyway
  var CAN_FILTER = (function () { try { return 'filter' in CanvasRenderingContext2D.prototype; } catch (e) { return false; } })();

  /* ── the stations: the afternoon advances (C6: strength, blur and warmth never go back up) ── */
  //   w/h = box as a share of the section (desktop / phone), cap = max css px height,
  //   op = shade opacity (also --a-op), blur = css px, seed = leaflet seed, warm = gold mix of the section's glow
  var STATIONS = [
    { id: 'start',   w: .52, wm: .84, h: .62, hm: .40, cap: 720, capm: 380, fy: .55, op: .10, blur: 4, seed: 11, warm: .05 },
    { id: 'library', w: .50, wm: .84, h: .60, hm: .30, cap: 620, capm: 300, op: .08, blur: 5, seed: 23, warm: .08 },
    { id: 'faq',     w: .60, wm: .84, h: .78, hm: .40, cap: 620, capm: 380, op: .07, blur: 7, seed: 37, warm: .09 }
  ];

  /* ── small maths ─────────────────────────────────────────────────────────────── */
  function rnd(seed) { seed = seed % 2147483647; if (seed <= 0) seed += 2147483646; return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  function bz(a, b, c, t) { var u = 1 - t; return u * u * a + 2 * u * t * b + t * t * c; }
  function bzd(a, b, c, t) { var u = 1 - t; return 2 * u * (b - a) + 2 * t * (c - b); }
  function sstep(a, b, x) { var t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); }

  /* ── ONE static frond: ambient.js frondGeom with amp = 0 (sway, bob, flutter, twist all 0) ── */
  function frond(c, crown, f) {
    var a = f.ang, L = f.len, dx = Math.cos(a), dy = Math.sin(a);
    var p0x = crown.x, p0y = crown.y;
    var p1x = crown.x + dx * L * 0.52, p1y = crown.y + dy * L * 0.52 - L * f.arch;
    var p2x = crown.x + dx * L, p2y = crown.y + dy * L + L * f.droop;
    var N = 14, k, RL = [], RR = [];
    c.beginPath();
    for (k = 0; k <= N; k++) {                       // the rachis: a tapered polygon, both edges
      var tt = k / N, x = bz(p0x, p1x, p2x, tt), y = bz(p0y, p1y, p2y, tt);
      var tx = bzd(p0x, p1x, p2x, tt), ty = bzd(p0y, p1y, p2y, tt), tl = Math.hypot(tx, ty) || 1;
      var hw = Math.max(0.6, (9 - 7.5 * tt) * f.width) / 2, nx = -ty / tl * hw, ny = tx / tl * hw;
      RL.push(x + nx, y + ny); RR.push(x - nx, y - ny);
    }
    c.moveTo(RL[0], RL[1]);
    for (k = 1; k <= N; k++) c.lineTo(RL[2 * k], RL[2 * k + 1]);
    for (k = N; k >= 0; k--) c.lineTo(RR[2 * k], RR[2 * k + 1]);
    c.closePath();
    var n = f.nL, R = rnd(f.iseed);
    for (var i = 0; i < n; i++) {                    // leaflets: two ranks, date-palm proportions
      var rj = R(), rsk = R(), rpl = R(), rl1 = R(), rl2 = R(); R(); R(); var rp1 = R(), rp2 = R();
      if (rsk < 0.12) continue;                      // 12% missing: no regular comb survives
      var tpos = 0.08 + 0.90 * (i + 0.5 + (rj - 0.5) * 0.7) / n;   // ±35% pitch jitter
      var s0 = (tpos - 0.17) / 0.81, spine = s0 <= 0;
      var shape = spine ? 0 : Math.pow(Math.sin(Math.PI * Math.pow(Math.min(1, s0), 0.72)), 0.75);
      var q0 = bz(p0x, p1x, p2x, tpos), q1 = bz(p0y, p1y, p2y, tpos);
      var d0 = bzd(p0x, p1x, p2x, tpos), d1 = bzd(p0y, p1y, p2y, tpos), dl = Math.hypot(d0, d1) || 1;
      d0 /= dl; d1 /= dl;
      for (var side = -1; side <= 1; side += 2) {
        var rl = side > 0 ? rl1 : rl2, rp = side > 0 ? rp1 : rp2, len, phi, wd;
        if (spine) { len = L * 0.03 * (0.6 + 0.4 * rl); phi = 0.95 + (rp - 0.5) * 0.2; wd = 0.12; }
        else {
          len = L * 0.155 * shape * (0.80 + rl * 0.35) * (side > 0 ? 1 : 0.9);
          phi = (side > 0 ? 0.52 : 0.76) + (rpl - 0.5) * 0.30 + (rp - 0.5) * 0.12;
          wd = 0.075;
        }
        if (len < 2) continue;
        var ang = side * phi, ca = Math.cos(ang), sa = Math.sin(ang);
        var lx = d0 * ca - d1 * sa, ly = d0 * sa + d1 * ca, w = len * wd * f.width;
        var tipx = q0 + lx * len, tipy = q1 + ly * len + len * 0.06;
        var cx = q0 + lx * len * 0.5, cy = q1 + ly * len * 0.5 + len * 0.015, nx2 = -ly * w, ny2 = lx * w;
        c.moveTo(q0, q1);
        c.quadraticCurveTo(cx + nx2, cy + ny2, tipx, tipy);
        c.quadraticCurveTo(cx - nx2, cy - ny2, q0, q1);
      }
    }
    c.fill();                                        // one nonzero fill: leaflets never double-darken
  }

  /* the shade: four fronds from a crown just outside the palm's side, then the fade-out the desk uses
     (down: smoothstep .45H→H; across: .35W→W), so no frond ever ends in a ruler line at the box edge */
  function paintShade(cv, W, H, st, rtl, color) {
    var s = SCALE, c = cv.getContext('2d');
    cv.width = Math.max(2, Math.round(W * s)); cv.height = Math.max(2, Math.round(H * s));
    c.setTransform(s, 0, 0, s, 0, 0);
    c.clearRect(0, 0, W, H);
    c.fillStyle = color;
    if (CAN_FILTER) c.filter = 'blur(' + (st.blur * s).toFixed(2) + 'px)';       // drawn pre-blurred: no compositor filter on a page-sized layer
    var R = rnd(st.seed), crown = { x: rtl ? -0.10 * W : 1.10 * W, y: -0.06 * H };
    [0.2, 0.62, 1.0, 1.38].forEach(function (b) {
      frond(c, crown, { ang: rtl ? b : Math.PI - b, len: W * (0.95 + R() * 0.25), arch: 0.05 + R() * 0.04,
        droop: 0.12 + R() * 0.07, width: 1.1, nL: 56, iseed: Math.floor(R() * 1e5) + 7 });
    });
    if (CAN_FILTER) c.filter = 'none';
    c.globalCompositeOperation = 'destination-in';
    var g = c.createLinearGradient(0, 0, 0, H), i, t;
    for (i = 0; i <= 10; i++) { t = i / 10; g.addColorStop(t, 'rgba(0,0,0,' + (1 - sstep(st.fy || 0.45, 1, t)).toFixed(3) + ')'); }
    c.fillStyle = g; c.fillRect(0, 0, W, H);
    var g2 = c.createLinearGradient(rtl ? 0 : W, 0, rtl ? W : 0, 0);
    for (i = 0; i <= 10; i++) { t = i / 10; g2.addColorStop(t, 'rgba(0,0,0,' + (1 - sstep(0.35, 1, t)).toFixed(3) + ')'); }
    c.fillStyle = g2; c.fillRect(0, 0, W, H);
    c.globalCompositeOperation = 'source-over';
  }

  /* ── the layers ──────────────────────────────────────────────────────────────── */
  var layers = [];
  STATIONS.forEach(function (st) {
    var sec = document.getElementById(st.id);
    if (!sec) return;
    var d = document.createElement('div'), cv = document.createElement('canvas');
    d.className = 'a-frond'; d.setAttribute('aria-hidden', 'true'); d.setAttribute('data-gold-exempt', '');
    cv.setAttribute('aria-hidden', 'true');
    d.appendChild(cv);
    sec.insertBefore(d, sec.firstChild);
    layers.push({ st: st, sec: sec, box: d, cv: cv, W: 0, H: 0, rtl: null, css: !CAN_FILTER });
    if (!CAN_FILTER) d.style.filter = 'blur(' + st.blur + 'px)';
  });

  function isRtl() { return root.getAttribute('dir') !== 'ltr'; }
  function measure(L, force) {
    var r = L.sec.getBoundingClientRect(), phone = r.width < 768, st = L.st;
    var W = Math.round(r.width * (phone ? st.wm : st.w));
    var H = Math.min(r.height * (phone ? st.hm : st.h), phone ? st.capm : st.cap);
    H = Math.max(96, Math.round(H / 48) * 48);                   // quantised: opening a FAQ answer never re-draws the palm
    var rtl = isRtl();
    if (!force && Math.abs(W - L.W) < 6 && H === L.H && rtl === L.rtl) return false;
    L.W = W; L.H = H; L.rtl = rtl;
    L.box.style.width = W + 'px'; L.box.style.height = H + 'px';
    L.painted = false;
    return true;
  }
  var color = '#291F15';
  function readColor() {
    var v = getComputedStyle(root).getPropertyValue('--espresso').trim();
    if (v) color = v;
  }
  function paint(L) {
    if (!L.W || !L.H) return;
    paintShade(L.cv, L.W, L.H, L.st, L.rtl, color);
    L.painted = true;
  }
  function paintAll(force) {
    layers.forEach(function (L) { if (measure(L, force) || !L.painted) paint(L); });
  }

  // first paint when the main thread is idle; the layers sit invisible (opacity 0 → --a-op) until then
  function idle(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 900 }); else setTimeout(fn, 120); }
  readColor();
  idle(function () {
    paintAll(true);
    layers.forEach(function (L) { L.box.classList.add('is-ready'); });
    watch();
  });

  var rzT = 0, ro = null;
  function onResize() { clearTimeout(rzT); rzT = setTimeout(function () { paintAll(false); }, 180); }
  function watch() {
    if (ro) return;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(onResize);
      layers.forEach(function (L) { ro.observe(L.sec); });
    } else window.addEventListener('resize', onResize);
  }

  /* ── the Mirror: the shade leaves with the old direction, comes back from the new one ── */
  var backT = 0;
  WF.on('lang:before', function () {
    clearTimeout(backT);
    layers.forEach(function (L) { L.box.classList.remove('is-back'); L.box.classList.add('is-swap'); });
  });
  WF.on('lang', function () { paintAll(true); });             // the swap frame: mirrored while invisible
  WF.on('lang:after', function () {
    layers.forEach(function (L) { L.box.classList.add('is-back'); L.box.classList.remove('is-swap'); });
    clearTimeout(backT);
    backT = setTimeout(function () { layers.forEach(function (L) { L.box.classList.remove('is-back'); }); }, 480);
  });

  /* ── ART-3: the desk emptied; the shade leaves (CSS does the easing, same numbers as the hero) ── */
  WF.on('desk:clear', function () { root.classList.add('a-cleared'); });
  WF.on('desk:reset', function () { root.classList.remove('a-cleared'); });

  /* ── ART-6: the last light on the floor (decorative, static, under the throwables) ── */
  var stage = document.querySelector('#bench .bench__stage');
  if (stage && !stage.querySelector('.a-last')) {
    var last = document.createElement('div');
    last.className = 'a-last'; last.setAttribute('aria-hidden', 'true'); last.setAttribute('data-gold-exempt', '');
    last.appendChild(document.createElement('i'));
    stage.insertBefore(last, stage.firstChild);
  }

  /* ── the probe: worst text contrast behind every shade (alpha read from the painted canvas) ── */
  function rgbOf(str) {
    var hx = /^[ ]*#([0-9a-f]{6})[ ]*$/i.exec(String(str));
    if (hx) { var n = parseInt(hx[1], 16); return { r: n >> 16, g: (n >> 8) & 255, b: n & 255, a: 1 }; }
    var m = String(str).match(/[\d.]+(?:e-?\d+)?/g) || [];
    if (!m.length) return null;
    var v = m.map(Number), scale = /^color\(/.test(str) ? 255 : 1;
    return { r: v[0] * scale, g: v[1] * scale, b: v[2] * scale, a: v.length > 3 ? v[3] : 1 };
  }
  function lin(u) { u /= 255; return u <= 0.03928 ? u / 12.92 : Math.pow((u + 0.055) / 1.055, 2.4); }
  function lum(c) { return 0.2126 * lin(c.r) + 0.7152 * lin(c.g) + 0.0722 * lin(c.b); }
  function contrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function mix(a, b, t) { return { r: a.r + (b.r - a.r) * t, g: a.g + (b.g - a.g) * t, b: a.b + (b.b - a.b) * t, a: 1 }; }
  function over(fg, bg) { var a = fg.a == null ? 1 : fg.a; return mix(bg, fg, a); }

  function probe() {
    var esp = rgbOf(getComputedStyle(root).getPropertyValue('--espresso').trim()) || { r: 41, g: 31, b: 21 };
    var gold = rgbOf(getComputedStyle(root).getPropertyValue('--gold').trim()) || { r: 198, g: 164, b: 90 };
    var out = { min: 99, minAt: null, sections: {} };
    layers.forEach(function (L) {
      var info = { min: 99, at: null, n: 0, maxAlpha: 0 };
      out.sections[L.st.id] = info;
      if (!L.painted) return;
      var op = parseFloat(getComputedStyle(L.box).getPropertyValue('--a-op')) || L.st.op;
      var data;
      try { data = L.cv.getContext('2d').getImageData(0, 0, L.cv.width, L.cv.height).data; } catch (e) { return; }
      var br = L.box.getBoundingClientRect(), secBg = rgbOf(getComputedStyle(L.sec).backgroundColor) || { r: 244, g: 242, b: 238, a: 1 };
      var aboveContent = L.st.id === 'start';                   // only #start's shade sits above the text
      var els = L.sec.querySelectorAll('*');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (L.box.contains(el)) continue;
        var own = false;
        for (var k = 0; k < el.childNodes.length; k++) if (el.childNodes[k].nodeType === 3 && el.childNodes[k].nodeValue.trim()) { own = true; break; }
        if (!own) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) continue;
        var cs = getComputedStyle(el);
        if (cs.visibility === 'hidden' || cs.display === 'none') continue;
        // the ground it sits on: its own opaque ancestor, the quote paper, or the section
        var ground = secBg, covered = false, p = el;
        if (el.closest('.start-q')) ground = rgbOf(getComputedStyle(root).getPropertyValue('--sand').trim()) || { r: 233, g: 225, b: 210, a: 1 };
        else while (p && p !== L.sec) {
          var bg = rgbOf(getComputedStyle(p).backgroundColor);
          if (bg && bg.a > 0.95) { ground = bg; covered = true; break; }
          p = p.parentElement;
        }
        if (covered && !aboveContent) continue;                 // the shade sits behind an opaque card
        // strongest shade under the text rect (sampled on a 7×3 grid)
        var amax = 0;
        for (var gx = 0; gx <= 6; gx++) for (var gy = 0; gy <= 2; gy++) {
          var px = r.left + r.width * gx / 6 - br.left, py = r.top + r.height * (gy + 0.5) / 3 - br.top;
          var ix = Math.floor(px * SCALE), iy = Math.floor(py * SCALE);
          if (ix < 0 || iy < 0 || ix >= L.cv.width || iy >= L.cv.height) continue;
          var al = data[(iy * L.cv.width + ix) * 4 + 3] / 255;
          if (al > amax) amax = al;
        }
        if (amax * op > info.maxAlpha) info.maxAlpha = amax * op;
        // ground × (1 − shade) + (ground × espresso) × shade (multiply), then the section's glow at full strength (conservative)
        var mul = { r: ground.r * esp.r / 255, g: ground.g * esp.g / 255, b: ground.b * esp.b / 255, a: 1 };
        var bgEff = mix(ground, mul, amax * op);
        bgEff = mix(bgEff, gold, L.st.warm);
        var fg = rgbOf(cs.color) || { r: 17, g: 17, b: 17, a: 1 };
        fg = over(fg, bgEff);
        var cr = contrast(fg, bgEff);
        info.n++;
        if (cr < info.min) { info.min = cr; info.at = (el.className && el.className.baseVal == null ? '.' + String(el.className).split(' ')[0] : el.tagName.toLowerCase()) + ' «' + el.textContent.trim().slice(0, 18) + '»'; }
      }
      if (info.min < out.min) { out.min = info.min; out.minAt = L.st.id + ' ' + info.at; }
    });
    return out;
  }
  window.__art = {
    probe: probe,
    stats: function () {
      return layers.map(function (L) {
        var cs = getComputedStyle(L.box);
        return { id: L.st.id, W: L.W, H: L.H, rtl: L.rtl, painted: !!L.painted, opacity: parseFloat(cs.opacity), op: L.st.op, css: L.css };
      }).concat([{ cleared: root.classList.contains('a-cleared') }]);
    }
  };
});

})();
